/*! jQuery v3.5.1 | (c) JS Foundation and other contributors | jquery.org/license */ function wasTouched() {
  (window.isTouch = !0),
    document.removeEventListener("touchstart", wasTouched, { passive: !0 }),
    (document.documentElement.className =
      document.documentElement.className.replace("no-touch", "touch")),
    document.dispatchEvent(new CustomEvent("theme:touch", { bubbles: !0 }));
}
!(function (e, t) {
  "use strict";
  "object" == typeof module && "object" == typeof module.exports
    ? (module.exports = e.document
        ? t(e, !0)
        : function (e) {
            if (!e.document)
              throw Error("jQuery requires a window with a document");
            return t(e);
          })
    : t(e);
})("undefined" != typeof window ? window : this, function (e, t) {
  "use strict";
  var i = [],
    n = Object.getPrototypeOf,
    o = i.slice,
    s = i.flat
      ? function (e) {
          return i.flat.call(e);
        }
      : function (e) {
          return i.concat.apply([], e);
        },
    r = i.push,
    a = i.indexOf,
    l = {},
    c = l.toString,
    d = l.hasOwnProperty,
    u = d.toString,
    p = u.call(Object),
    h = {},
    f = function (e) {
      return "function" == typeof e && "number" != typeof e.nodeType;
    },
    g = function (e) {
      return null != e && e === e.window;
    },
    m = e.document,
    v = { type: !0, src: !0, nonce: !0, noModule: !0 };
  function y(e, t, i) {
    var n,
      o,
      s = (i = i || m).createElement("script");
    if (((s.text = e), t))
      for (n in v)
        (o = t[n] || (t.getAttribute && t.getAttribute(n))) &&
          s.setAttribute(n, o);
    i.head.appendChild(s).parentNode.removeChild(s);
  }
  function b(e) {
    return null == e
      ? e + ""
      : "object" == typeof e || "function" == typeof e
      ? l[c.call(e)] || "object"
      : typeof e;
  }
  var k = "3.5.1",
    x = function (e, t) {
      return new x.fn.init(e, t);
    };
  function C(e) {
    var t = !!e && "length" in e && e.length,
      i = b(e);
    return (
      !f(e) &&
      !g(e) &&
      ("array" === i ||
        0 === t ||
        ("number" == typeof t && 0 < t && t - 1 in e))
    );
  }
  (x.fn = x.prototype =
    {
      jquery: k,
      constructor: x,
      length: 0,
      toArray: function () {
        return o.call(this);
      },
      get: function (e) {
        return null == e
          ? o.call(this)
          : e < 0
          ? this[e + this.length]
          : this[e];
      },
      pushStack: function (e) {
        var t = x.merge(this.constructor(), e);
        return (t.prevObject = this), t;
      },
      each: function (e) {
        return x.each(this, e);
      },
      map: function (e) {
        return this.pushStack(
          x.map(this, function (t, i) {
            return e.call(t, i, t);
          })
        );
      },
      slice: function () {
        return this.pushStack(o.apply(this, arguments));
      },
      first: function () {
        return this.eq(0);
      },
      last: function () {
        return this.eq(-1);
      },
      even: function () {
        return this.pushStack(
          x.grep(this, function (e, t) {
            return (t + 1) % 2;
          })
        );
      },
      odd: function () {
        return this.pushStack(
          x.grep(this, function (e, t) {
            return t % 2;
          })
        );
      },
      eq: function (e) {
        var t = this.length,
          i = +e + (e < 0 ? t : 0);
        return this.pushStack(0 <= i && i < t ? [this[i]] : []);
      },
      end: function () {
        return this.prevObject || this.constructor();
      },
      push: r,
      sort: i.sort,
      splice: i.splice,
    }),
    (x.extend = x.fn.extend =
      function () {
        var e,
          t,
          i,
          n,
          o,
          s,
          r = arguments[0] || {},
          a = 1,
          l = arguments.length,
          c = !1;
        for (
          "boolean" == typeof r && ((c = r), (r = arguments[a] || {}), a++),
            "object" == typeof r || f(r) || (r = {}),
            a === l && ((r = this), a--);
          a < l;
          a++
        )
          if (null != (e = arguments[a]))
            for (t in e)
              (n = e[t]),
                "__proto__" !== t &&
                  r !== n &&
                  (c && n && (x.isPlainObject(n) || (o = Array.isArray(n)))
                    ? ((i = r[t]),
                      (s =
                        o && !Array.isArray(i)
                          ? []
                          : o || x.isPlainObject(i)
                          ? i
                          : {}),
                      (o = !1),
                      (r[t] = x.extend(c, s, n)))
                    : void 0 !== n && (r[t] = n));
        return r;
      }),
    x.extend({
      expando: "jQuery" + (k + Math.random()).replace(/\D/g, ""),
      isReady: !0,
      error: function (e) {
        throw Error(e);
      },
      noop: function () {},
      isPlainObject: function (e) {
        var t, i;
        return (
          !(!e || "[object Object]" !== c.call(e)) &&
          (!(t = n(e)) ||
            ("function" ==
              typeof (i = d.call(t, "constructor") && t.constructor) &&
              u.call(i) === p))
        );
      },
      isEmptyObject: function (e) {
        var t;
        for (t in e) return !1;
        return !0;
      },
      globalEval: function (e, t, i) {
        y(e, { nonce: t && t.nonce }, i);
      },
      each: function (e, t) {
        var i,
          n = 0;
        if (C(e))
          for (i = e.length; n < i && !1 !== t.call(e[n], n, e[n]); n++);
        else for (n in e) if (!1 === t.call(e[n], n, e[n])) break;
        return e;
      },
      makeArray: function (e, t) {
        var i = t || [];
        return (
          null != e &&
            (C(Object(e))
              ? x.merge(i, "string" == typeof e ? [e] : e)
              : r.call(i, e)),
          i
        );
      },
      inArray: function (e, t, i) {
        return null == t ? -1 : a.call(t, e, i);
      },
      merge: function (e, t) {
        for (var i = +t.length, n = 0, o = e.length; n < i; n++) e[o++] = t[n];
        return (e.length = o), e;
      },
      grep: function (e, t, i) {
        for (var n = [], o = 0, s = e.length, r = !i; o < s; o++)
          !t(e[o], o) !== r && n.push(e[o]);
        return n;
      },
      map: function (e, t, i) {
        var n,
          o,
          r = 0,
          a = [];
        if (C(e))
          for (n = e.length; r < n; r++)
            null != (o = t(e[r], r, i)) && a.push(o);
        else for (r in e) null != (o = t(e[r], r, i)) && a.push(o);
        return s(a);
      },
      guid: 1,
      support: h,
    }),
    "function" == typeof Symbol && (x.fn[Symbol.iterator] = i[Symbol.iterator]),
    x.each(
      "Boolean Number String Function Array Date RegExp Object Error Symbol".split(
        " "
      ),
      function (e, t) {
        l["[object " + t + "]"] = t.toLowerCase();
      }
    );
  var w = (function (e) {
    var t,
      i,
      n,
      o,
      s,
      r,
      a,
      l,
      c,
      d,
      u,
      p,
      h,
      f,
      g,
      m,
      v,
      y,
      b,
      k = "sizzle" + 1 * new Date(),
      x = e.document,
      C = 0,
      w = 0,
      S = ed(),
      T = ed(),
      _ = ed(),
      E = ed(),
      P = function (e, t) {
        return e === t && (u = !0), 0;
      },
      A = {}.hasOwnProperty,
      L = [],
      j = L.pop,
      I = L.push,
      D = L.push,
      z = L.slice,
      M = function (e, t) {
        for (var i = 0, n = e.length; i < n; i++) if (e[i] === t) return i;
        return -1;
      },
      q =
        "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
      O = "[\\x20\\t\\r\\n\\f]",
      F =
        "(?:\\\\[\\da-fA-F]{1,6}" +
        O +
        "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
      H =
        "\\[" +
        O +
        "*(" +
        F +
        ")(?:" +
        O +
        "*([*^$|!~]?=)" +
        O +
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
        F +
        "))|)" +
        O +
        "*\\]",
      W =
        ":(" +
        F +
        ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
        H +
        ")*)|.*)\\)|)",
      N = RegExp(O + "+", "g"),
      B = RegExp("^" + O + "+|((?:^|[^\\\\])(?:\\\\.)*)" + O + "+$", "g"),
      R = RegExp("^" + O + "*," + O + "*"),
      V = RegExp("^" + O + "*([>+~]|" + O + ")" + O + "*"),
      U = RegExp(O + "|>"),
      G = RegExp(W),
      X = RegExp("^" + F + "$"),
      Y = {
        ID: RegExp("^#(" + F + ")"),
        CLASS: RegExp("^\\.(" + F + ")"),
        TAG: RegExp("^(" + F + "|[*])"),
        ATTR: RegExp("^" + H),
        PSEUDO: RegExp("^" + W),
        CHILD: RegExp(
          "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
            O +
            "*(even|odd|(([+-]|)(\\d*)n|)" +
            O +
            "*(?:([+-]|)" +
            O +
            "*(\\d+)|))" +
            O +
            "*\\)|)",
          "i"
        ),
        bool: RegExp("^(?:" + q + ")$", "i"),
        needsContext: RegExp(
          "^" +
            O +
            "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
            O +
            "*((?:-\\d)?\\d*)" +
            O +
            "*\\)|)(?=[^-]|$)",
          "i"
        ),
      },
      Q = /HTML$/i,
      K = /^(?:input|select|textarea|button)$/i,
      Z = /^h\d$/i,
      J = /^[^{]+\{\s*\[native \w/,
      ee = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
      et = /[+~]/,
      ei = RegExp("\\\\[\\da-fA-F]{1,6}" + O + "?|\\\\([^\\r\\n\\f])", "g"),
      en = function (e, t) {
        var i = "0x" + e.slice(1) - 65536;
        return (
          t ||
          (i < 0
            ? String.fromCharCode(i + 65536)
            : String.fromCharCode((i >> 10) | 55296, (1023 & i) | 56320))
        );
      },
      eo = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
      es = function (e, t) {
        return t
          ? "\0" === e
            ? "�"
            : e.slice(0, -1) +
              "\\" +
              e.charCodeAt(e.length - 1).toString(16) +
              " "
          : "\\" + e;
      },
      er = function () {
        p();
      },
      ea = ex(
        function (e) {
          return !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase();
        },
        { dir: "parentNode", next: "legend" }
      );
    try {
      D.apply((L = z.call(x.childNodes)), x.childNodes),
        L[x.childNodes.length].nodeType;
    } catch (el) {
      D = {
        apply: L.length
          ? function (e, t) {
              I.apply(e, z.call(t));
            }
          : function (e, t) {
              for (var i = e.length, n = 0; (e[i++] = t[n++]); );
              e.length = i - 1;
            },
      };
    }
    function ec(e, t, n, o) {
      var s,
        a,
        c,
        d,
        u,
        f,
        v,
        y = t && t.ownerDocument,
        x = t ? t.nodeType : 9;
      if (
        ((n = n || []),
        "string" != typeof e || !e || (1 !== x && 9 !== x && 11 !== x))
      )
        return n;
      if (!o && (p(t), (t = t || h), g)) {
        if (11 !== x && (u = ee.exec(e))) {
          if ((s = u[1])) {
            if (9 === x) {
              if (!(c = t.getElementById(s))) return n;
              if (c.id === s) return n.push(c), n;
            } else if (y && (c = y.getElementById(s)) && b(t, c) && c.id === s)
              return n.push(c), n;
          } else {
            if (u[2]) return D.apply(n, t.getElementsByTagName(e)), n;
            if (
              (s = u[3]) &&
              i.getElementsByClassName &&
              t.getElementsByClassName
            )
              return D.apply(n, t.getElementsByClassName(s)), n;
          }
        }
        if (
          i.qsa &&
          !E[e + " "] &&
          (!m || !m.test(e)) &&
          (1 !== x || "object" !== t.nodeName.toLowerCase())
        ) {
          if (((v = e), (y = t), 1 === x && (U.test(e) || V.test(e)))) {
            for (
              ((y = (et.test(e) && eb(t.parentNode)) || t) === t && i.scope) ||
                ((d = t.getAttribute("id"))
                  ? (d = d.replace(eo, es))
                  : t.setAttribute("id", (d = k))),
                a = (f = r(e)).length;
              a--;

            )
              f[a] = (d ? "#" + d : ":scope") + " " + ek(f[a]);
            v = f.join(",");
          }
          try {
            return D.apply(n, y.querySelectorAll(v)), n;
          } catch (C) {
            E(e, !0);
          } finally {
            d === k && t.removeAttribute("id");
          }
        }
      }
      return l(e.replace(B, "$1"), t, n, o);
    }
    function ed() {
      var e = [];
      return function t(i, o) {
        return (
          e.push(i + " ") > n.cacheLength && delete t[e.shift()],
          (t[i + " "] = o)
        );
      };
    }
    function eu(e) {
      return (e[k] = !0), e;
    }
    function ep(e) {
      var t = h.createElement("fieldset");
      try {
        return !!e(t);
      } catch (i) {
        return !1;
      } finally {
        t.parentNode && t.parentNode.removeChild(t), (t = null);
      }
    }
    function eh(e, t) {
      for (var i = e.split("|"), o = i.length; o--; ) n.attrHandle[i[o]] = t;
    }
    function ef(e, t) {
      var i = t && e,
        n =
          i &&
          1 === e.nodeType &&
          1 === t.nodeType &&
          e.sourceIndex - t.sourceIndex;
      if (n) return n;
      if (i) {
        for (; (i = i.nextSibling); ) if (i === t) return -1;
      }
      return e ? 1 : -1;
    }
    function eg(e) {
      return function (t) {
        return "input" === t.nodeName.toLowerCase() && t.type === e;
      };
    }
    function em(e) {
      return function (t) {
        var i = t.nodeName.toLowerCase();
        return ("input" === i || "button" === i) && t.type === e;
      };
    }
    function ev(e) {
      return function (t) {
        return "form" in t
          ? t.parentNode && !1 === t.disabled
            ? "label" in t
              ? "label" in t.parentNode
                ? t.parentNode.disabled === e
                : t.disabled === e
              : t.isDisabled === e || (!e !== t.isDisabled && ea(t) === e)
            : t.disabled === e
          : "label" in t && t.disabled === e;
      };
    }
    function ey(e) {
      return eu(function (t) {
        return (
          (t = +t),
          eu(function (i, n) {
            for (var o, s = e([], i.length, t), r = s.length; r--; )
              i[(o = s[r])] && (i[o] = !(n[o] = i[o]));
          })
        );
      });
    }
    function eb(e) {
      return e && void 0 !== e.getElementsByTagName && e;
    }
    for (t in ((i = ec.support = {}),
    (s = ec.isXML =
      function (e) {
        var t = e.namespaceURI,
          i = (e.ownerDocument || e).documentElement;
        return !Q.test(t || (i && i.nodeName) || "HTML");
      }),
    (p = ec.setDocument =
      function (e) {
        var t,
          o,
          r = e ? e.ownerDocument || e : x;
        return (
          r != h &&
            9 === r.nodeType &&
            r.documentElement &&
            ((f = (h = r).documentElement),
            (g = !s(h)),
            x != h &&
              (o = h.defaultView) &&
              o.top !== o &&
              (o.addEventListener
                ? o.addEventListener("unload", er, !1)
                : o.attachEvent && o.attachEvent("onunload", er)),
            (i.scope = ep(function (e) {
              return (
                f.appendChild(e).appendChild(h.createElement("div")),
                void 0 !== e.querySelectorAll &&
                  !e.querySelectorAll(":scope fieldset div").length
              );
            })),
            (i.attributes = ep(function (e) {
              return (e.className = "i"), !e.getAttribute("className");
            })),
            (i.getElementsByTagName = ep(function (e) {
              return (
                e.appendChild(h.createComment("")),
                !e.getElementsByTagName("*").length
              );
            })),
            (i.getElementsByClassName = J.test(h.getElementsByClassName)),
            (i.getById = ep(function (e) {
              return (
                (f.appendChild(e).id = k),
                !h.getElementsByName || !h.getElementsByName(k).length
              );
            })),
            i.getById
              ? ((n.filter.ID = function (e) {
                  var t = e.replace(ei, en);
                  return function (e) {
                    return e.getAttribute("id") === t;
                  };
                }),
                (n.find.ID = function (e, t) {
                  if (void 0 !== t.getElementById && g) {
                    var i = t.getElementById(e);
                    return i ? [i] : [];
                  }
                }))
              : ((n.filter.ID = function (e) {
                  var t = e.replace(ei, en);
                  return function (e) {
                    var i =
                      void 0 !== e.getAttributeNode && e.getAttributeNode("id");
                    return i && i.value === t;
                  };
                }),
                (n.find.ID = function (e, t) {
                  if (void 0 !== t.getElementById && g) {
                    var i,
                      n,
                      o,
                      s = t.getElementById(e);
                    if (s) {
                      if ((i = s.getAttributeNode("id")) && i.value === e)
                        return [s];
                      for (o = t.getElementsByName(e), n = 0; (s = o[n++]); )
                        if ((i = s.getAttributeNode("id")) && i.value === e)
                          return [s];
                    }
                    return [];
                  }
                })),
            (n.find.TAG = i.getElementsByTagName
              ? function (e, t) {
                  return void 0 !== t.getElementsByTagName
                    ? t.getElementsByTagName(e)
                    : i.qsa
                    ? t.querySelectorAll(e)
                    : void 0;
                }
              : function (e, t) {
                  var i,
                    n = [],
                    o = 0,
                    s = t.getElementsByTagName(e);
                  if ("*" === e) {
                    for (; (i = s[o++]); ) 1 === i.nodeType && n.push(i);
                    return n;
                  }
                  return s;
                }),
            (n.find.CLASS =
              i.getElementsByClassName &&
              function (e, t) {
                if (void 0 !== t.getElementsByClassName && g)
                  return t.getElementsByClassName(e);
              }),
            (v = []),
            (m = []),
            (i.qsa = J.test(h.querySelectorAll)) &&
              (ep(function (e) {
                var t;
                (f.appendChild(e).innerHTML =
                  "<a id='" +
                  k +
                  "'></a><select id='" +
                  k +
                  "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                  e.querySelectorAll("[msallowcapture^='']").length &&
                    m.push("[*^$]=" + O + "*(?:''|\"\")"),
                  e.querySelectorAll("[selected]").length ||
                    m.push("\\[" + O + "*(?:value|" + q + ")"),
                  e.querySelectorAll("[id~=" + k + "-]").length || m.push("~="),
                  (t = h.createElement("input")).setAttribute("name", ""),
                  e.appendChild(t),
                  e.querySelectorAll("[name='']").length ||
                    m.push("\\[" + O + "*name" + O + "*=" + O + "*(?:''|\"\")"),
                  e.querySelectorAll(":checked").length || m.push(":checked"),
                  e.querySelectorAll("a#" + k + "+*").length ||
                    m.push(".#.+[+~]"),
                  e.querySelectorAll("\\\f"),
                  m.push("[\\r\\n\\f]");
              }),
              ep(function (e) {
                e.innerHTML =
                  "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                var t = h.createElement("input");
                t.setAttribute("type", "hidden"),
                  e.appendChild(t).setAttribute("name", "D"),
                  e.querySelectorAll("[name=d]").length &&
                    m.push("name" + O + "*[*^$|!~]?="),
                  2 !== e.querySelectorAll(":enabled").length &&
                    m.push(":enabled", ":disabled"),
                  (f.appendChild(e).disabled = !0),
                  2 !== e.querySelectorAll(":disabled").length &&
                    m.push(":enabled", ":disabled"),
                  e.querySelectorAll("*,:x"),
                  m.push(",.*:");
              })),
            (i.matchesSelector = J.test(
              (y =
                f.matches ||
                f.webkitMatchesSelector ||
                f.mozMatchesSelector ||
                f.oMatchesSelector ||
                f.msMatchesSelector)
            )) &&
              ep(function (e) {
                (i.disconnectedMatch = y.call(e, "*")),
                  y.call(e, "[s!='']:x"),
                  v.push("!=", W);
              }),
            (m = m.length && RegExp(m.join("|"))),
            (v = v.length && RegExp(v.join("|"))),
            (b =
              (t = J.test(f.compareDocumentPosition)) || J.test(f.contains)
                ? function (e, t) {
                    var i = 9 === e.nodeType ? e.documentElement : e,
                      n = t && t.parentNode;
                    return (
                      e === n ||
                      !(
                        !n ||
                        1 !== n.nodeType ||
                        !(i.contains
                          ? i.contains(n)
                          : e.compareDocumentPosition &&
                            16 & e.compareDocumentPosition(n))
                      )
                    );
                  }
                : function (e, t) {
                    if (t) {
                      for (; (t = t.parentNode); ) if (t === e) return !0;
                    }
                    return !1;
                  }),
            (P = t
              ? function (e, t) {
                  if (e === t) return (u = !0), 0;
                  var n =
                    !e.compareDocumentPosition - !t.compareDocumentPosition;
                  return (
                    n ||
                    (1 &
                      (n =
                        (e.ownerDocument || e) == (t.ownerDocument || t)
                          ? e.compareDocumentPosition(t)
                          : 1) ||
                    (!i.sortDetached && t.compareDocumentPosition(e) === n)
                      ? e == h || (e.ownerDocument == x && b(x, e))
                        ? -1
                        : t == h || (t.ownerDocument == x && b(x, t))
                        ? 1
                        : d
                        ? M(d, e) - M(d, t)
                        : 0
                      : 4 & n
                      ? -1
                      : 1)
                  );
                }
              : function (e, t) {
                  if (e === t) return (u = !0), 0;
                  var i,
                    n = 0,
                    o = e.parentNode,
                    s = t.parentNode,
                    r = [e],
                    a = [t];
                  if (!o || !s)
                    return e == h
                      ? -1
                      : t == h
                      ? 1
                      : o
                      ? -1
                      : s
                      ? 1
                      : d
                      ? M(d, e) - M(d, t)
                      : 0;
                  if (o === s) return ef(e, t);
                  for (i = e; (i = i.parentNode); ) r.unshift(i);
                  for (i = t; (i = i.parentNode); ) a.unshift(i);
                  for (; r[n] === a[n]; ) n++;
                  return n
                    ? ef(r[n], a[n])
                    : r[n] == x
                    ? -1
                    : a[n] == x
                    ? 1
                    : 0;
                })),
          h
        );
      }),
    (ec.matches = function (e, t) {
      return ec(e, null, null, t);
    }),
    (ec.matchesSelector = function (e, t) {
      if (
        (p(e),
        i.matchesSelector &&
          g &&
          !E[t + " "] &&
          (!v || !v.test(t)) &&
          (!m || !m.test(t)))
      )
        try {
          var n = y.call(e, t);
          if (
            n ||
            i.disconnectedMatch ||
            (e.document && 11 !== e.document.nodeType)
          )
            return n;
        } catch (o) {
          E(t, !0);
        }
      return 0 < ec(t, h, null, [e]).length;
    }),
    (ec.contains = function (e, t) {
      return (e.ownerDocument || e) != h && p(e), b(e, t);
    }),
    (ec.attr = function (e, t) {
      (e.ownerDocument || e) != h && p(e);
      var o = n.attrHandle[t.toLowerCase()],
        s = o && A.call(n.attrHandle, t.toLowerCase()) ? o(e, t, !g) : void 0;
      return void 0 !== s
        ? s
        : i.attributes || !g
        ? e.getAttribute(t)
        : (s = e.getAttributeNode(t)) && s.specified
        ? s.value
        : null;
    }),
    (ec.escape = function (e) {
      return (e + "").replace(eo, es);
    }),
    (ec.error = function (e) {
      throw Error("Syntax error, unrecognized expression: " + e);
    }),
    (ec.uniqueSort = function (e) {
      var t,
        n = [],
        o = 0,
        s = 0;
      if (
        ((u = !i.detectDuplicates),
        (d = !i.sortStable && e.slice(0)),
        e.sort(P),
        u)
      ) {
        for (; (t = e[s++]); ) t === e[s] && (o = n.push(s));
        for (; o--; ) e.splice(n[o], 1);
      }
      return (d = null), e;
    }),
    (o = ec.getText =
      function (e) {
        var t,
          i = "",
          n = 0,
          s = e.nodeType;
        if (s) {
          if (1 === s || 9 === s || 11 === s) {
            if ("string" == typeof e.textContent) return e.textContent;
            for (e = e.firstChild; e; e = e.nextSibling) i += o(e);
          } else if (3 === s || 4 === s) return e.nodeValue;
        } else for (; (t = e[n++]); ) i += o(t);
        return i;
      }),
    ((n = ec.selectors =
      {
        cacheLength: 50,
        createPseudo: eu,
        match: Y,
        attrHandle: {},
        find: {},
        relative: {
          ">": { dir: "parentNode", first: !0 },
          " ": { dir: "parentNode" },
          "+": { dir: "previousSibling", first: !0 },
          "~": { dir: "previousSibling" },
        },
        preFilter: {
          ATTR: function (e) {
            return (
              (e[1] = e[1].replace(ei, en)),
              (e[3] = (e[3] || e[4] || e[5] || "").replace(ei, en)),
              "~=" === e[2] && (e[3] = " " + e[3] + " "),
              e.slice(0, 4)
            );
          },
          CHILD: function (e) {
            return (
              (e[1] = e[1].toLowerCase()),
              "nth" === e[1].slice(0, 3)
                ? (e[3] || ec.error(e[0]),
                  (e[4] = +(e[4]
                    ? e[5] + (e[6] || 1)
                    : 2 * ("even" === e[3] || "odd" === e[3]))),
                  (e[5] = +(e[7] + e[8] || "odd" === e[3])))
                : e[3] && ec.error(e[0]),
              e
            );
          },
          PSEUDO: function (e) {
            var t,
              i = !e[6] && e[2];
            return Y.CHILD.test(e[0])
              ? null
              : (e[3]
                  ? (e[2] = e[4] || e[5] || "")
                  : i &&
                    G.test(i) &&
                    (t = r(i, !0)) &&
                    (t = i.indexOf(")", i.length - t) - i.length) &&
                    ((e[0] = e[0].slice(0, t)), (e[2] = i.slice(0, t))),
                e.slice(0, 3));
          },
        },
        filter: {
          TAG: function (e) {
            var t = e.replace(ei, en).toLowerCase();
            return "*" === e
              ? function () {
                  return !0;
                }
              : function (e) {
                  return e.nodeName && e.nodeName.toLowerCase() === t;
                };
          },
          CLASS: function (e) {
            var t = S[e + " "];
            return (
              t ||
              ((t = RegExp("(^|" + O + ")" + e + "(" + O + "|$)")),
              S(e, function (e) {
                return t.test(
                  ("string" == typeof e.className && e.className) ||
                    (void 0 !== e.getAttribute && e.getAttribute("class")) ||
                    ""
                );
              }))
            );
          },
          ATTR: function (e, t, i) {
            return function (n) {
              var o = ec.attr(n, e);
              return null == o
                ? "!=" === t
                : !t ||
                    ((o += ""),
                    "=" === t
                      ? o === i
                      : "!=" === t
                      ? o !== i
                      : "^=" === t
                      ? i && 0 === o.indexOf(i)
                      : "*=" === t
                      ? i && -1 < o.indexOf(i)
                      : "$=" === t
                      ? i && o.slice(-i.length) === i
                      : "~=" === t
                      ? -1 < (" " + o.replace(N, " ") + " ").indexOf(i)
                      : "|=" === t &&
                        (o === i || o.slice(0, i.length + 1) === i + "-"));
            };
          },
          CHILD: function (e, t, i, n, o) {
            var s = "nth" !== e.slice(0, 3),
              r = "last" !== e.slice(-4),
              a = "of-type" === t;
            return 1 === n && 0 === o
              ? function (e) {
                  return !!e.parentNode;
                }
              : function (t, i, l) {
                  var c,
                    d,
                    u,
                    p,
                    h,
                    f,
                    g = s !== r ? "nextSibling" : "previousSibling",
                    m = t.parentNode,
                    v = a && t.nodeName.toLowerCase(),
                    y = !l && !a,
                    b = !1;
                  if (m) {
                    if (s) {
                      for (; g; ) {
                        for (p = t; (p = p[g]); )
                          if (
                            a
                              ? p.nodeName.toLowerCase() === v
                              : 1 === p.nodeType
                          )
                            return !1;
                        f = g = "only" === e && !f && "nextSibling";
                      }
                      return !0;
                    }
                    if (((f = [r ? m.firstChild : m.lastChild]), r && y)) {
                      for (
                        b =
                          (h =
                            (c =
                              (d =
                                (u = (p = m)[k] || (p[k] = {}))[p.uniqueID] ||
                                (u[p.uniqueID] = {}))[e] || [])[0] === C &&
                            c[1]) && c[2],
                          p = h && m.childNodes[h];
                        (p = (++h && p && p[g]) || (b = h = 0) || f.pop());

                      )
                        if (1 === p.nodeType && ++b && p === t) {
                          d[e] = [C, h, b];
                          break;
                        }
                    } else if (
                      (y &&
                        (b = h =
                          (c =
                            (d =
                              (u = (p = t)[k] || (p[k] = {}))[p.uniqueID] ||
                              (u[p.uniqueID] = {}))[e] || [])[0] === C && c[1]),
                      !1 === b)
                    )
                      for (
                        ;
                        (p = (++h && p && p[g]) || (b = h = 0) || f.pop()) &&
                        (!(
                          (a
                            ? p.nodeName.toLowerCase() === v
                            : 1 === p.nodeType) && ++b
                        ) ||
                          (y &&
                            ((d =
                              (u = p[k] || (p[k] = {}))[p.uniqueID] ||
                              (u[p.uniqueID] = {}))[e] = [C, b]),
                          p !== t));

                      );
                    return (b -= o) === n || (b % n == 0 && 0 <= b / n);
                  }
                };
          },
          PSEUDO: function (e, t) {
            var i,
              o =
                n.pseudos[e] ||
                n.setFilters[e.toLowerCase()] ||
                ec.error("unsupported pseudo: " + e);
            return o[k]
              ? o(t)
              : 1 < o.length
              ? ((i = [e, e, "", t]),
                n.setFilters.hasOwnProperty(e.toLowerCase())
                  ? eu(function (e, i) {
                      for (var n, s = o(e, t), r = s.length; r--; )
                        e[(n = M(e, s[r]))] = !(i[n] = s[r]);
                    })
                  : function (e) {
                      return o(e, 0, i);
                    })
              : o;
          },
        },
        pseudos: {
          not: eu(function (e) {
            var t = [],
              i = [],
              n = a(e.replace(B, "$1"));
            return n[k]
              ? eu(function (e, t, i, o) {
                  for (var s, r = n(e, null, o, []), a = e.length; a--; )
                    (s = r[a]) && (e[a] = !(t[a] = s));
                })
              : function (e, o, s) {
                  return (t[0] = e), n(t, null, s, i), (t[0] = null), !i.pop();
                };
          }),
          has: eu(function (e) {
            return function (t) {
              return 0 < ec(e, t).length;
            };
          }),
          contains: eu(function (e) {
            return (
              (e = e.replace(ei, en)),
              function (t) {
                return -1 < (t.textContent || o(t)).indexOf(e);
              }
            );
          }),
          lang: eu(function (e) {
            return (
              X.test(e || "") || ec.error("unsupported lang: " + e),
              (e = e.replace(ei, en).toLowerCase()),
              function (t) {
                var i;
                do
                  if (
                    (i = g
                      ? t.lang
                      : t.getAttribute("xml:lang") || t.getAttribute("lang"))
                  )
                    return (
                      (i = i.toLowerCase()) === e || 0 === i.indexOf(e + "-")
                    );
                while ((t = t.parentNode) && 1 === t.nodeType);
                return !1;
              }
            );
          }),
          target: function (t) {
            var i = e.location && e.location.hash;
            return i && i.slice(1) === t.id;
          },
          root: function (e) {
            return e === f;
          },
          focus: function (e) {
            return (
              e === h.activeElement &&
              (!h.hasFocus || h.hasFocus()) &&
              !!(e.type || e.href || ~e.tabIndex)
            );
          },
          enabled: ev(!1),
          disabled: ev(!0),
          checked: function (e) {
            var t = e.nodeName.toLowerCase();
            return (
              ("input" === t && !!e.checked) || ("option" === t && !!e.selected)
            );
          },
          selected: function (e) {
            return (
              e.parentNode && e.parentNode.selectedIndex, !0 === e.selected
            );
          },
          empty: function (e) {
            for (e = e.firstChild; e; e = e.nextSibling)
              if (e.nodeType < 6) return !1;
            return !0;
          },
          parent: function (e) {
            return !n.pseudos.empty(e);
          },
          header: function (e) {
            return Z.test(e.nodeName);
          },
          input: function (e) {
            return K.test(e.nodeName);
          },
          button: function (e) {
            var t = e.nodeName.toLowerCase();
            return ("input" === t && "button" === e.type) || "button" === t;
          },
          text: function (e) {
            var t;
            return (
              "input" === e.nodeName.toLowerCase() &&
              "text" === e.type &&
              (null == (t = e.getAttribute("type")) ||
                "text" === t.toLowerCase())
            );
          },
          first: ey(function () {
            return [0];
          }),
          last: ey(function (e, t) {
            return [t - 1];
          }),
          eq: ey(function (e, t, i) {
            return [i < 0 ? i + t : i];
          }),
          even: ey(function (e, t) {
            for (var i = 0; i < t; i += 2) e.push(i);
            return e;
          }),
          odd: ey(function (e, t) {
            for (var i = 1; i < t; i += 2) e.push(i);
            return e;
          }),
          lt: ey(function (e, t, i) {
            for (var n = i < 0 ? i + t : t < i ? t : i; 0 <= --n; ) e.push(n);
            return e;
          }),
          gt: ey(function (e, t, i) {
            for (var n = i < 0 ? i + t : i; ++n < t; ) e.push(n);
            return e;
          }),
        },
      }).pseudos.nth = n.pseudos.eq),
    { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
      n.pseudos[t] = eg(t);
    for (t in { submit: !0, reset: !0 }) n.pseudos[t] = em(t);
    function e$() {}
    function ek(e) {
      for (var t = 0, i = e.length, n = ""; t < i; t++) n += e[t].value;
      return n;
    }
    function ex(e, t, i) {
      var n = t.dir,
        o = t.next,
        s = o || n,
        r = i && "parentNode" === s,
        a = w++;
      return t.first
        ? function (t, i, o) {
            for (; (t = t[n]); ) if (1 === t.nodeType || r) return e(t, i, o);
            return !1;
          }
        : function (t, i, l) {
            var c,
              d,
              u,
              p = [C, a];
            if (l) {
              for (; (t = t[n]); )
                if ((1 === t.nodeType || r) && e(t, i, l)) return !0;
            } else
              for (; (t = t[n]); )
                if (1 === t.nodeType || r) {
                  if (
                    ((d =
                      (u = t[k] || (t[k] = {}))[t.uniqueID] ||
                      (u[t.uniqueID] = {})),
                    o && o === t.nodeName.toLowerCase())
                  )
                    t = t[n] || t;
                  else {
                    if ((c = d[s]) && c[0] === C && c[1] === a)
                      return (p[2] = c[2]);
                    if (((d[s] = p)[2] = e(t, i, l))) return !0;
                  }
                }
            return !1;
          };
    }
    function eC(e) {
      return 1 < e.length
        ? function (t, i, n) {
            for (var o = e.length; o--; ) if (!e[o](t, i, n)) return !1;
            return !0;
          }
        : e[0];
    }
    function ew(e, t, i, n, o) {
      for (var s, r = [], a = 0, l = e.length, c = null != t; a < l; a++)
        (s = e[a]) && ((i && !i(s, n, o)) || (r.push(s), c && t.push(a)));
      return r;
    }
    function eS(e, t, i, n, o, s) {
      return (
        n && !n[k] && (n = eS(n)),
        o && !o[k] && (o = eS(o, s)),
        eu(function (s, r, a, l) {
          var c,
            d,
            u,
            p = [],
            h = [],
            f = r.length,
            g =
              s ||
              (function (e, t, i) {
                for (var n = 0, o = t.length; n < o; n++) ec(e, t[n], i);
                return i;
              })(t || "*", a.nodeType ? [a] : a, []),
            m = e && (s || !t) ? ew(g, p, e, a, l) : g,
            v = i ? (o || (s ? e : f || n) ? [] : r) : m;
          if ((i && i(m, v, a, l), n))
            for (c = ew(v, h), n(c, [], a, l), d = c.length; d--; )
              (u = c[d]) && (v[h[d]] = !(m[h[d]] = u));
          if (s) {
            if (o || e) {
              if (o) {
                for (c = [], d = v.length; d--; )
                  (u = v[d]) && c.push((m[d] = u));
                o(null, (v = []), c, l);
              }
              for (d = v.length; d--; )
                (u = v[d]) &&
                  -1 < (c = o ? M(s, u) : p[d]) &&
                  (s[c] = !(r[c] = u));
            }
          } else (v = ew(v === r ? v.splice(f, v.length) : v)), o ? o(null, r, v, l) : D.apply(r, v);
        })
      );
    }
    function eT(e) {
      for (
        var t,
          i,
          o,
          s = e.length,
          r = n.relative[e[0].type],
          a = r || n.relative[" "],
          l = r ? 1 : 0,
          d = ex(
            function (e) {
              return e === t;
            },
            a,
            !0
          ),
          u = ex(
            function (e) {
              return -1 < M(t, e);
            },
            a,
            !0
          ),
          p = [
            function (e, i, n) {
              var o =
                (!r && (n || i !== c)) ||
                ((t = i).nodeType ? d(e, i, n) : u(e, i, n));
              return (t = null), o;
            },
          ];
        l < s;
        l++
      )
        if ((i = n.relative[e[l].type])) p = [ex(eC(p), i)];
        else {
          if ((i = n.filter[e[l].type].apply(null, e[l].matches))[k]) {
            for (o = ++l; o < s && !n.relative[e[o].type]; o++);
            return eS(
              1 < l && eC(p),
              1 < l &&
                ek(
                  e
                    .slice(0, l - 1)
                    .concat({ value: " " === e[l - 2].type ? "*" : "" })
                ).replace(B, "$1"),
              i,
              l < o && eT(e.slice(l, o)),
              o < s && eT((e = e.slice(o))),
              o < s && ek(e)
            );
          }
          p.push(i);
        }
      return eC(p);
    }
    return (
      (e$.prototype = n.filters = n.pseudos),
      (n.setFilters = new e$()),
      (r = ec.tokenize =
        function (e, t) {
          var i,
            o,
            s,
            r,
            a,
            l,
            c,
            d = T[e + " "];
          if (d) return t ? 0 : d.slice(0);
          for (a = e, l = [], c = n.preFilter; a; ) {
            for (r in ((!i || (o = R.exec(a))) &&
              (o && (a = a.slice(o[0].length) || a), l.push((s = []))),
            (i = !1),
            (o = V.exec(a)) &&
              ((i = o.shift()),
              s.push({ value: i, type: o[0].replace(B, " ") }),
              (a = a.slice(i.length))),
            n.filter))
              (o = Y[r].exec(a)) &&
                (!c[r] || (o = c[r](o))) &&
                ((i = o.shift()),
                s.push({ value: i, type: r, matches: o }),
                (a = a.slice(i.length)));
            if (!i) break;
          }
          return t ? a.length : a ? ec.error(e) : T(e, l).slice(0);
        }),
      (a = ec.compile =
        function (e, t) {
          var i,
            o,
            s,
            a,
            l,
            d,
            u = [],
            f = [],
            m = _[e + " "];
          if (!m) {
            for (t || (t = r(e)), i = t.length; i--; )
              (m = eT(t[i]))[k] ? u.push(m) : f.push(m);
            (m = _(
              e,
              ((o = f),
              (a = 0 < (s = u).length),
              (l = 0 < o.length),
              (d = function (e, t, i, r, d) {
                var u,
                  f,
                  m,
                  v = 0,
                  y = "0",
                  b = e && [],
                  k = [],
                  x = c,
                  w = e || (l && n.find.TAG("*", d)),
                  S = (C += null == x ? 1 : Math.random() || 0.1),
                  T = w.length;
                for (
                  d && (c = t == h || t || d);
                  y !== T && null != (u = w[y]);
                  y++
                ) {
                  if (l && u) {
                    for (
                      f = 0, t || u.ownerDocument == h || (p(u), (i = !g));
                      (m = o[f++]);

                    )
                      if (m(u, t || h, i)) {
                        r.push(u);
                        break;
                      }
                    d && (C = S);
                  }
                  a && ((u = !m && u) && v--, e && b.push(u));
                }
                if (((v += y), a && y !== v)) {
                  for (f = 0; (m = s[f++]); ) m(b, k, t, i);
                  if (e) {
                    if (0 < v) for (; y--; ) b[y] || k[y] || (k[y] = j.call(r));
                    k = ew(k);
                  }
                  D.apply(r, k),
                    d &&
                      !e &&
                      0 < k.length &&
                      1 < v + s.length &&
                      ec.uniqueSort(r);
                }
                return d && ((C = S), (c = x)), b;
              }),
              a ? eu(d) : d)
            )).selector = e;
          }
          return m;
        }),
      (l = ec.select =
        function (e, t, i, o) {
          var s,
            l,
            c,
            d,
            u,
            p = "function" == typeof e && e,
            h = !o && r((e = p.selector || e));
          if (((i = i || []), 1 === h.length)) {
            if (
              2 < (l = h[0] = h[0].slice(0)).length &&
              "ID" === (c = l[0]).type &&
              9 === t.nodeType &&
              g &&
              n.relative[l[1].type]
            ) {
              if (!(t = (n.find.ID(c.matches[0].replace(ei, en), t) || [])[0]))
                return i;
              p && (t = t.parentNode), (e = e.slice(l.shift().value.length));
            }
            for (
              s = Y.needsContext.test(e) ? 0 : l.length;
              s-- && ((c = l[s]), !n.relative[(d = c.type)]);

            )
              if (
                (u = n.find[d]) &&
                (o = u(
                  c.matches[0].replace(ei, en),
                  (et.test(l[0].type) && eb(t.parentNode)) || t
                ))
              ) {
                if ((l.splice(s, 1), !(e = o.length && ek(l))))
                  return D.apply(i, o), i;
                break;
              }
          }
          return (
            (p || a(e, h))(
              o,
              t,
              !g,
              i,
              !t || (et.test(e) && eb(t.parentNode)) || t
            ),
            i
          );
        }),
      (i.sortStable = k.split("").sort(P).join("") === k),
      (i.detectDuplicates = !!u),
      p(),
      (i.sortDetached = ep(function (e) {
        return 1 & e.compareDocumentPosition(h.createElement("fieldset"));
      })),
      ep(function (e) {
        return (
          (e.innerHTML = "<a href='#'></a>"),
          "#" === e.firstChild.getAttribute("href")
        );
      }) ||
        eh("type|href|height|width", function (e, t, i) {
          if (!i) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
        }),
      (i.attributes &&
        ep(function (e) {
          return (
            (e.innerHTML = "<input/>"),
            e.firstChild.setAttribute("value", ""),
            "" === e.firstChild.getAttribute("value")
          );
        })) ||
        eh("value", function (e, t, i) {
          if (!i && "input" === e.nodeName.toLowerCase()) return e.defaultValue;
        }),
      ep(function (e) {
        return null == e.getAttribute("disabled");
      }) ||
        eh(q, function (e, t, i) {
          var n;
          if (!i)
            return !0 === e[t]
              ? t.toLowerCase()
              : (n = e.getAttributeNode(t)) && n.specified
              ? n.value
              : null;
        }),
      ec
    );
  })(e);
  (x.find = w),
    (x.expr = w.selectors),
    (x.expr[":"] = x.expr.pseudos),
    (x.uniqueSort = x.unique = w.uniqueSort),
    (x.text = w.getText),
    (x.isXMLDoc = w.isXML),
    (x.contains = w.contains),
    (x.escapeSelector = w.escape);
  var S = function (e, t, i) {
      for (var n = [], o = void 0 !== i; (e = e[t]) && 9 !== e.nodeType; )
        if (1 === e.nodeType) {
          if (o && x(e).is(i)) break;
          n.push(e);
        }
      return n;
    },
    T = function (e, t) {
      for (var i = []; e; e = e.nextSibling)
        1 === e.nodeType && e !== t && i.push(e);
      return i;
    },
    _ = x.expr.match.needsContext;
  function E(e, t) {
    return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
  }
  var P = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
  function A(e, t, i) {
    return f(t)
      ? x.grep(e, function (e, n) {
          return !!t.call(e, n, e) !== i;
        })
      : t.nodeType
      ? x.grep(e, function (e) {
          return (e === t) !== i;
        })
      : "string" != typeof t
      ? x.grep(e, function (e) {
          return -1 < a.call(t, e) !== i;
        })
      : x.filter(t, e, i);
  }
  (x.filter = function (e, t, i) {
    var n = t[0];
    return (
      i && (e = ":not(" + e + ")"),
      1 === t.length && 1 === n.nodeType
        ? x.find.matchesSelector(n, e)
          ? [n]
          : []
        : x.find.matches(
            e,
            x.grep(t, function (e) {
              return 1 === e.nodeType;
            })
          )
    );
  }),
    x.fn.extend({
      find: function (e) {
        var t,
          i,
          n = this.length,
          o = this;
        if ("string" != typeof e)
          return this.pushStack(
            x(e).filter(function () {
              for (t = 0; t < n; t++) if (x.contains(o[t], this)) return !0;
            })
          );
        for (i = this.pushStack([]), t = 0; t < n; t++) x.find(e, o[t], i);
        return 1 < n ? x.uniqueSort(i) : i;
      },
      filter: function (e) {
        return this.pushStack(A(this, e || [], !1));
      },
      not: function (e) {
        return this.pushStack(A(this, e || [], !0));
      },
      is: function (e) {
        return !!A(this, "string" == typeof e && _.test(e) ? x(e) : e || [], !1)
          .length;
      },
    });
  var L,
    j = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
  ((x.fn.init = function (e, t, i) {
    var n, o;
    if (!e) return this;
    if (((i = i || L), "string" == typeof e)) {
      if (
        !(n =
          "<" === e[0] && ">" === e[e.length - 1] && 3 <= e.length
            ? [null, e, null]
            : j.exec(e)) ||
        (!n[1] && t)
      )
        return !t || t.jquery ? (t || i).find(e) : this.constructor(t).find(e);
      if (n[1]) {
        if (
          ((t = t instanceof x ? t[0] : t),
          x.merge(
            this,
            x.parseHTML(n[1], t && t.nodeType ? t.ownerDocument || t : m, !0)
          ),
          P.test(n[1]) && x.isPlainObject(t))
        )
          for (n in t) f(this[n]) ? this[n](t[n]) : this.attr(n, t[n]);
        return this;
      }
      return (
        (o = m.getElementById(n[2])) && ((this[0] = o), (this.length = 1)), this
      );
    }
    return e.nodeType
      ? ((this[0] = e), (this.length = 1), this)
      : f(e)
      ? void 0 !== i.ready
        ? i.ready(e)
        : e(x)
      : x.makeArray(e, this);
  }).prototype = x.fn),
    (L = x(m));
  var I = /^(?:parents|prev(?:Until|All))/,
    D = { children: !0, contents: !0, next: !0, prev: !0 };
  function z(e, t) {
    for (; (e = e[t]) && 1 !== e.nodeType; );
    return e;
  }
  x.fn.extend({
    has: function (e) {
      var t = x(e, this),
        i = t.length;
      return this.filter(function () {
        for (var e = 0; e < i; e++) if (x.contains(this, t[e])) return !0;
      });
    },
    closest: function (e, t) {
      var i,
        n = 0,
        o = this.length,
        s = [],
        r = "string" != typeof e && x(e);
      if (!_.test(e)) {
        for (; n < o; n++)
          for (i = this[n]; i && i !== t; i = i.parentNode)
            if (
              i.nodeType < 11 &&
              (r
                ? -1 < r.index(i)
                : 1 === i.nodeType && x.find.matchesSelector(i, e))
            ) {
              s.push(i);
              break;
            }
      }
      return this.pushStack(1 < s.length ? x.uniqueSort(s) : s);
    },
    index: function (e) {
      return e
        ? "string" == typeof e
          ? a.call(x(e), this[0])
          : a.call(this, e.jquery ? e[0] : e)
        : this[0] && this[0].parentNode
        ? this.first().prevAll().length
        : -1;
    },
    add: function (e, t) {
      return this.pushStack(x.uniqueSort(x.merge(this.get(), x(e, t))));
    },
    addBack: function (e) {
      return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
    },
  }),
    x.each(
      {
        parent: function (e) {
          var t = e.parentNode;
          return t && 11 !== t.nodeType ? t : null;
        },
        parents: function (e) {
          return S(e, "parentNode");
        },
        parentsUntil: function (e, t, i) {
          return S(e, "parentNode", i);
        },
        next: function (e) {
          return z(e, "nextSibling");
        },
        prev: function (e) {
          return z(e, "previousSibling");
        },
        nextAll: function (e) {
          return S(e, "nextSibling");
        },
        prevAll: function (e) {
          return S(e, "previousSibling");
        },
        nextUntil: function (e, t, i) {
          return S(e, "nextSibling", i);
        },
        prevUntil: function (e, t, i) {
          return S(e, "previousSibling", i);
        },
        siblings: function (e) {
          return T((e.parentNode || {}).firstChild, e);
        },
        children: function (e) {
          return T(e.firstChild);
        },
        contents: function (e) {
          return null != e.contentDocument && n(e.contentDocument)
            ? e.contentDocument
            : (E(e, "template") && (e = e.content || e),
              x.merge([], e.childNodes));
        },
      },
      function (e, t) {
        x.fn[e] = function (i, n) {
          var o = x.map(this, t, i);
          return (
            "Until" !== e.slice(-5) && (n = i),
            n && "string" == typeof n && (o = x.filter(n, o)),
            1 < this.length &&
              (D[e] || x.uniqueSort(o), I.test(e) && o.reverse()),
            this.pushStack(o)
          );
        };
      }
    );
  var M = /[^\x20\t\r\n\f]+/g;
  function q(e) {
    return e;
  }
  function O(e) {
    throw e;
  }
  function F(e, t, i, n) {
    var o;
    try {
      e && f((o = e.promise))
        ? o.call(e).done(t).fail(i)
        : e && f((o = e.then))
        ? o.call(e, t, i)
        : t.apply(void 0, [e].slice(n));
    } catch (s) {
      i.apply(void 0, [s]);
    }
  }
  (x.Callbacks = function (e) {
    e =
      "string" == typeof e
        ? ((t = e),
          (i = {}),
          x.each(t.match(M) || [], function (e, t) {
            i[t] = !0;
          }),
          i)
        : x.extend({}, e);
    var t,
      i,
      n,
      o,
      s,
      r,
      a = [],
      l = [],
      c = -1,
      d = function () {
        for (r = r || e.once, s = n = !0; l.length; c = -1)
          for (o = l.shift(); ++c < a.length; )
            !1 === a[c].apply(o[0], o[1]) &&
              e.stopOnFalse &&
              ((c = a.length), (o = !1));
        e.memory || (o = !1), (n = !1), r && (a = o ? [] : "");
      },
      u = {
        add: function () {
          return (
            a &&
              (o && !n && ((c = a.length - 1), l.push(o)),
              (function t(i) {
                x.each(i, function (i, n) {
                  f(n)
                    ? (e.unique && u.has(n)) || a.push(n)
                    : n && n.length && "string" !== b(n) && t(n);
                });
              })(arguments),
              o && !n && d()),
            this
          );
        },
        remove: function () {
          return (
            x.each(arguments, function (e, t) {
              for (var i; -1 < (i = x.inArray(t, a, i)); )
                a.splice(i, 1), i <= c && c--;
            }),
            this
          );
        },
        has: function (e) {
          return e ? -1 < x.inArray(e, a) : 0 < a.length;
        },
        empty: function () {
          return a && (a = []), this;
        },
        disable: function () {
          return (r = l = []), (a = o = ""), this;
        },
        disabled: function () {
          return !a;
        },
        lock: function () {
          return (r = l = []), o || n || (a = o = ""), this;
        },
        locked: function () {
          return !!r;
        },
        fireWith: function (e, t) {
          return (
            r ||
              ((t = [e, (t = t || []).slice ? t.slice() : t]),
              l.push(t),
              n || d()),
            this
          );
        },
        fire: function () {
          return u.fireWith(this, arguments), this;
        },
        fired: function () {
          return !!s;
        },
      };
    return u;
  }),
    x.extend({
      Deferred: function (t) {
        var i = [
            [
              "notify",
              "progress",
              x.Callbacks("memory"),
              x.Callbacks("memory"),
              2,
            ],
            [
              "resolve",
              "done",
              x.Callbacks("once memory"),
              x.Callbacks("once memory"),
              0,
              "resolved",
            ],
            [
              "reject",
              "fail",
              x.Callbacks("once memory"),
              x.Callbacks("once memory"),
              1,
              "rejected",
            ],
          ],
          n = "pending",
          o = {
            state: function () {
              return n;
            },
            always: function () {
              return s.done(arguments).fail(arguments), this;
            },
            catch: function (e) {
              return o.then(null, e);
            },
            pipe: function () {
              var e = arguments;
              return x
                .Deferred(function (t) {
                  x.each(i, function (i, n) {
                    var o = f(e[n[4]]) && e[n[4]];
                    s[n[1]](function () {
                      var e = o && o.apply(this, arguments);
                      e && f(e.promise)
                        ? e
                            .promise()
                            .progress(t.notify)
                            .done(t.resolve)
                            .fail(t.reject)
                        : t[n[0] + "With"](this, o ? [e] : arguments);
                    });
                  }),
                    (e = null);
                })
                .promise();
            },
            then: function (t, n, o) {
              var s = 0;
              function r(t, i, n, o) {
                return function () {
                  var a = this,
                    l = arguments,
                    c = function () {
                      var e, c;
                      if (!(t < s)) {
                        if ((e = n.apply(a, l)) === i.promise())
                          throw TypeError("Thenable self-resolution");
                        f(
                          (c =
                            e &&
                            ("object" == typeof e || "function" == typeof e) &&
                            e.then)
                        )
                          ? o
                            ? c.call(e, r(s, i, q, o), r(s, i, O, o))
                            : (s++,
                              c.call(
                                e,
                                r(s, i, q, o),
                                r(s, i, O, o),
                                r(s, i, q, i.notifyWith)
                              ))
                          : (n !== q && ((a = void 0), (l = [e])),
                            (o || i.resolveWith)(a, l));
                      }
                    },
                    d = o
                      ? c
                      : function () {
                          try {
                            c();
                          } catch (e) {
                            x.Deferred.exceptionHook &&
                              x.Deferred.exceptionHook(e, d.stackTrace),
                              s <= t + 1 &&
                                (n !== O && ((a = void 0), (l = [e])),
                                i.rejectWith(a, l));
                          }
                        };
                  t
                    ? d()
                    : (x.Deferred.getStackHook &&
                        (d.stackTrace = x.Deferred.getStackHook()),
                      e.setTimeout(d));
                };
              }
              return x
                .Deferred(function (e) {
                  i[0][3].add(r(0, e, f(o) ? o : q, e.notifyWith)),
                    i[1][3].add(r(0, e, f(t) ? t : q)),
                    i[2][3].add(r(0, e, f(n) ? n : O));
                })
                .promise();
            },
            promise: function (e) {
              return null != e ? x.extend(e, o) : o;
            },
          },
          s = {};
        return (
          x.each(i, function (e, t) {
            var r = t[2],
              a = t[5];
            (o[t[1]] = r.add),
              a &&
                r.add(
                  function () {
                    n = a;
                  },
                  i[3 - e][2].disable,
                  i[3 - e][3].disable,
                  i[0][2].lock,
                  i[0][3].lock
                ),
              r.add(t[3].fire),
              (s[t[0]] = function () {
                return (
                  s[t[0] + "With"](this === s ? void 0 : this, arguments), this
                );
              }),
              (s[t[0] + "With"] = r.fireWith);
          }),
          o.promise(s),
          t && t.call(s, s),
          s
        );
      },
      when: function (e) {
        var t = arguments.length,
          i = t,
          n = Array(i),
          s = o.call(arguments),
          r = x.Deferred(),
          a = function (e) {
            return function (i) {
              (n[e] = this),
                (s[e] = 1 < arguments.length ? o.call(arguments) : i),
                --t || r.resolveWith(n, s);
            };
          };
        if (
          t <= 1 &&
          (F(e, r.done(a(i)).resolve, r.reject, !t),
          "pending" === r.state() || f(s[i] && s[i].then))
        )
          return r.then();
        for (; i--; ) F(s[i], a(i), r.reject);
        return r.promise();
      },
    });
  var H = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
  (x.Deferred.exceptionHook = function (t, i) {
    e.console &&
      e.console.warn &&
      t &&
      H.test(t.name) &&
      e.console.warn("jQuery.Deferred exception: " + t.message, t.stack, i);
  }),
    (x.readyException = function (t) {
      e.setTimeout(function () {
        throw t;
      });
    });
  var W = x.Deferred();
  function N() {
    m.removeEventListener("DOMContentLoaded", N),
      e.removeEventListener("load", N),
      x.ready();
  }
  (x.fn.ready = function (e) {
    return (
      W.then(e).catch(function (e) {
        x.readyException(e);
      }),
      this
    );
  }),
    x.extend({
      isReady: !1,
      readyWait: 1,
      ready: function (e) {
        (!0 === e ? --x.readyWait : x.isReady) ||
          ((x.isReady = !0) !== e && 0 < --x.readyWait) ||
          W.resolveWith(m, [x]);
      },
    }),
    (x.ready.then = W.then),
    "complete" !== m.readyState &&
    ("loading" === m.readyState || m.documentElement.doScroll)
      ? (m.addEventListener("DOMContentLoaded", N),
        e.addEventListener("load", N))
      : e.setTimeout(x.ready);
  var B = function (e, t, i, n, o, s, r) {
      var a = 0,
        l = e.length,
        c = null == i;
      if ("object" === b(i))
        for (a in ((o = !0), i)) B(e, t, a, i[a], !0, s, r);
      else if (
        void 0 !== n &&
        ((o = !0),
        f(n) || (r = !0),
        c &&
          (r
            ? (t.call(e, n), (t = null))
            : ((c = t),
              (t = function (e, t, i) {
                return c.call(x(e), i);
              }))),
        t)
      )
        for (; a < l; a++) t(e[a], i, r ? n : n.call(e[a], a, t(e[a], i)));
      return o ? e : c ? t.call(e) : l ? t(e[0], i) : s;
    },
    R = /^-ms-/,
    V = /-([a-z])/g;
  function U(e, t) {
    return t.toUpperCase();
  }
  function G(e) {
    return e.replace(R, "ms-").replace(V, U);
  }
  var X = function (e) {
    return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
  };
  function Y() {
    this.expando = x.expando + Y.uid++;
  }
  (Y.uid = 1),
    (Y.prototype = {
      cache: function (e) {
        var t = e[this.expando];
        return (
          t ||
            ((t = {}),
            X(e) &&
              (e.nodeType
                ? (e[this.expando] = t)
                : Object.defineProperty(e, this.expando, {
                    value: t,
                    configurable: !0,
                  }))),
          t
        );
      },
      set: function (e, t, i) {
        var n,
          o = this.cache(e);
        if ("string" == typeof t) o[G(t)] = i;
        else for (n in t) o[G(n)] = t[n];
        return o;
      },
      get: function (e, t) {
        return void 0 === t
          ? this.cache(e)
          : e[this.expando] && e[this.expando][G(t)];
      },
      access: function (e, t, i) {
        return void 0 === t || (t && "string" == typeof t && void 0 === i)
          ? this.get(e, t)
          : (this.set(e, t, i), void 0 !== i ? i : t);
      },
      remove: function (e, t) {
        var i,
          n = e[this.expando];
        if (void 0 !== n) {
          if (void 0 !== t)
            for (
              i = (t = Array.isArray(t)
                ? t.map(G)
                : ((t = G(t)) in n)
                ? [t]
                : t.match(M) || []).length;
              i--;

            )
              delete n[t[i]];
          (void 0 === t || x.isEmptyObject(n)) &&
            (e.nodeType ? (e[this.expando] = void 0) : delete e[this.expando]);
        }
      },
      hasData: function (e) {
        var t = e[this.expando];
        return void 0 !== t && !x.isEmptyObject(t);
      },
    });
  var Q = new Y(),
    K = new Y(),
    Z = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
    J = /[A-Z]/g;
  function ee(e, t, i) {
    var n, o;
    if (void 0 === i && 1 === e.nodeType) {
      if (
        ((n = "data-" + t.replace(J, "-$&").toLowerCase()),
        "string" == typeof (i = e.getAttribute(n)))
      ) {
        try {
          i =
            "true" === (o = i) ||
            ("false" !== o &&
              ("null" === o
                ? null
                : o === +o + ""
                ? +o
                : Z.test(o)
                ? JSON.parse(o)
                : o));
        } catch (s) {}
        K.set(e, t, i);
      } else i = void 0;
    }
    return i;
  }
  x.extend({
    hasData: function (e) {
      return K.hasData(e) || Q.hasData(e);
    },
    data: function (e, t, i) {
      return K.access(e, t, i);
    },
    removeData: function (e, t) {
      K.remove(e, t);
    },
    _data: function (e, t, i) {
      return Q.access(e, t, i);
    },
    _removeData: function (e, t) {
      Q.remove(e, t);
    },
  }),
    x.fn.extend({
      data: function (e, t) {
        var i,
          n,
          o,
          s = this[0],
          r = s && s.attributes;
        if (void 0 === e) {
          if (
            this.length &&
            ((o = K.get(s)), 1 === s.nodeType && !Q.get(s, "hasDataAttrs"))
          ) {
            for (i = r.length; i--; )
              r[i] &&
                0 === (n = r[i].name).indexOf("data-") &&
                ee(s, (n = G(n.slice(5))), o[n]);
            Q.set(s, "hasDataAttrs", !0);
          }
          return o;
        }
        return "object" == typeof e
          ? this.each(function () {
              K.set(this, e);
            })
          : B(
              this,
              function (t) {
                var i;
                if (s && void 0 === t)
                  return void 0 !== (i = K.get(s, e))
                    ? i
                    : void 0 !== (i = ee(s, e))
                    ? i
                    : void 0;
                this.each(function () {
                  K.set(this, e, t);
                });
              },
              null,
              t,
              1 < arguments.length,
              null,
              !0
            );
      },
      removeData: function (e) {
        return this.each(function () {
          K.remove(this, e);
        });
      },
    }),
    x.extend({
      queue: function (e, t, i) {
        var n;
        if (e)
          return (
            (t = (t || "fx") + "queue"),
            (n = Q.get(e, t)),
            i &&
              (!n || Array.isArray(i)
                ? (n = Q.access(e, t, x.makeArray(i)))
                : n.push(i)),
            n || []
          );
      },
      dequeue: function (e, t) {
        t = t || "fx";
        var i = x.queue(e, t),
          n = i.length,
          o = i.shift(),
          s = x._queueHooks(e, t);
        "inprogress" === o && ((o = i.shift()), n--),
          o &&
            ("fx" === t && i.unshift("inprogress"),
            delete s.stop,
            o.call(
              e,
              function () {
                x.dequeue(e, t);
              },
              s
            )),
          !n && s && s.empty.fire();
      },
      _queueHooks: function (e, t) {
        var i = t + "queueHooks";
        return (
          Q.get(e, i) ||
          Q.access(e, i, {
            empty: x.Callbacks("once memory").add(function () {
              Q.remove(e, [t + "queue", i]);
            }),
          })
        );
      },
    }),
    x.fn.extend({
      queue: function (e, t) {
        var i = 2;
        return (
          "string" != typeof e && ((t = e), (e = "fx"), i--),
          arguments.length < i
            ? x.queue(this[0], e)
            : void 0 === t
            ? this
            : this.each(function () {
                var i = x.queue(this, e, t);
                x._queueHooks(this, e),
                  "fx" === e && "inprogress" !== i[0] && x.dequeue(this, e);
              })
        );
      },
      dequeue: function (e) {
        return this.each(function () {
          x.dequeue(this, e);
        });
      },
      clearQueue: function (e) {
        return this.queue(e || "fx", []);
      },
      promise: function (e, t) {
        var i,
          n = 1,
          o = x.Deferred(),
          s = this,
          r = this.length,
          a = function () {
            --n || o.resolveWith(s, [s]);
          };
        for (
          "string" != typeof e && ((t = e), (e = void 0)), e = e || "fx";
          r--;

        )
          (i = Q.get(s[r], e + "queueHooks")) &&
            i.empty &&
            (n++, i.empty.add(a));
        return a(), o.promise(t);
      },
    });
  var et = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
    ei = RegExp("^(?:([+-])=|)(" + et + ")([a-z%]*)$", "i"),
    en = ["Top", "Right", "Bottom", "Left"],
    eo = m.documentElement,
    es = function (e) {
      return x.contains(e.ownerDocument, e);
    },
    er = { composed: !0 };
  eo.getRootNode &&
    (es = function (e) {
      return (
        x.contains(e.ownerDocument, e) || e.getRootNode(er) === e.ownerDocument
      );
    });
  var ea = function (e, t) {
    return (
      "none" === (e = t || e).style.display ||
      ("" === e.style.display && es(e) && "none" === x.css(e, "display"))
    );
  };
  function el(e, t, i, n) {
    var o,
      s,
      r = 20,
      a = n
        ? function () {
            return n.cur();
          }
        : function () {
            return x.css(e, t, "");
          },
      l = a(),
      c = (i && i[3]) || (x.cssNumber[t] ? "" : "px"),
      d =
        e.nodeType &&
        (x.cssNumber[t] || ("px" !== c && +l)) &&
        ei.exec(x.css(e, t));
    if (d && d[3] !== c) {
      for (l /= 2, c = c || d[3], d = +l || 1; r--; )
        x.style(e, t, d + c),
          (1 - s) * (1 - (s = a() / l || 0.5)) <= 0 && (r = 0),
          (d /= s);
      (d *= 2), x.style(e, t, d + c), (i = i || []);
    }
    return (
      i &&
        ((d = +d || +l || 0),
        (o = i[1] ? d + (i[1] + 1) * i[2] : +i[2]),
        n && ((n.unit = c), (n.start = d), (n.end = o))),
      o
    );
  }
  var ec = {};
  function ed(e, t) {
    for (var i, n, o, s, r, a, l, c = [], d = 0, u = e.length; d < u; d++)
      (n = e[d]).style &&
        ((i = n.style.display),
        t
          ? ("none" === i &&
              ((c[d] = Q.get(n, "display") || null),
              c[d] || (n.style.display = "")),
            "" === n.style.display &&
              ea(n) &&
              (c[d] =
                ((l = r = s = void 0),
                (r = (o = n).ownerDocument),
                (l = ec[(a = o.nodeName)]) ||
                  ((s = r.body.appendChild(r.createElement(a))),
                  (l = x.css(s, "display")),
                  s.parentNode.removeChild(s),
                  "none" === l && (l = "block"),
                  (ec[a] = l)))))
          : "none" !== i && ((c[d] = "none"), Q.set(n, "display", i)));
    for (d = 0; d < u; d++) null != c[d] && (e[d].style.display = c[d]);
    return e;
  }
  x.fn.extend({
    show: function () {
      return ed(this, !0);
    },
    hide: function () {
      return ed(this);
    },
    toggle: function (e) {
      return "boolean" == typeof e
        ? e
          ? this.show()
          : this.hide()
        : this.each(function () {
            ea(this) ? x(this).show() : x(this).hide();
          });
    },
  });
  var eu,
    ep,
    eh = /^(?:checkbox|radio)$/i,
    ef = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
    eg = /^$|^module$|\/(?:java|ecma)script/i;
  (eu = m.createDocumentFragment().appendChild(m.createElement("div"))),
    (ep = m.createElement("input")).setAttribute("type", "radio"),
    ep.setAttribute("checked", "checked"),
    ep.setAttribute("name", "t"),
    eu.appendChild(ep),
    (h.checkClone = eu.cloneNode(!0).cloneNode(!0).lastChild.checked),
    (eu.innerHTML = "<textarea>x</textarea>"),
    (h.noCloneChecked = !!eu.cloneNode(!0).lastChild.defaultValue),
    (eu.innerHTML = "<option></option>"),
    (h.option = !!eu.lastChild);
  var em = {
    thead: [1, "<table>", "</table>"],
    col: [2, "<table><colgroup>", "</colgroup></table>"],
    tr: [2, "<table><tbody>", "</tbody></table>"],
    td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
    _default: [0, "", ""],
  };
  function ev(e, t) {
    var i;
    return (
      (i =
        void 0 !== e.getElementsByTagName
          ? e.getElementsByTagName(t || "*")
          : void 0 !== e.querySelectorAll
          ? e.querySelectorAll(t || "*")
          : []),
      void 0 === t || (t && E(e, t)) ? x.merge([e], i) : i
    );
  }
  function ey(e, t) {
    for (var i = 0, n = e.length; i < n; i++)
      Q.set(e[i], "globalEval", !t || Q.get(t[i], "globalEval"));
  }
  (em.tbody = em.tfoot = em.colgroup = em.caption = em.thead),
    (em.th = em.td),
    h.option ||
      (em.optgroup = em.option =
        [1, "<select multiple='multiple'>", "</select>"]);
  var eb = /<|&#?\w+;/;
  function e$(e, t, i, n, o) {
    for (
      var s,
        r,
        a,
        l,
        c,
        d,
        u = t.createDocumentFragment(),
        p = [],
        h = 0,
        f = e.length;
      h < f;
      h++
    )
      if ((s = e[h]) || 0 === s) {
        if ("object" === b(s)) x.merge(p, s.nodeType ? [s] : s);
        else if (eb.test(s)) {
          for (
            r = r || u.appendChild(t.createElement("div")),
              l =
                em[(a = (ef.exec(s) || ["", ""])[1].toLowerCase())] ||
                em._default,
              r.innerHTML = l[1] + x.htmlPrefilter(s) + l[2],
              d = l[0];
            d--;

          )
            r = r.lastChild;
          x.merge(p, r.childNodes), ((r = u.firstChild).textContent = "");
        } else p.push(t.createTextNode(s));
      }
    for (u.textContent = "", h = 0; (s = p[h++]); )
      if (n && -1 < x.inArray(s, n)) o && o.push(s);
      else if (
        ((c = es(s)), (r = ev(u.appendChild(s), "script")), c && ey(r), i)
      )
        for (d = 0; (s = r[d++]); ) eg.test(s.type || "") && i.push(s);
    return u;
  }
  var ek = /^key/,
    ex = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
    eC = /^([^.]*)(?:\.(.+)|)/;
  function ew() {
    return !0;
  }
  function eS() {
    return !1;
  }
  function eT(e, t) {
    return (
      (e ===
        (function () {
          try {
            return m.activeElement;
          } catch (e) {}
        })()) ==
      ("focus" === t)
    );
  }
  function e_(e, t, i, n, o, s) {
    var r, a;
    if ("object" == typeof t) {
      for (a in ("string" != typeof i && ((n = n || i), (i = void 0)), t))
        e_(e, a, i, n, t[a], s);
      return e;
    }
    if (
      (null == n && null == o
        ? ((o = i), (n = i = void 0))
        : null == o &&
          ("string" == typeof i
            ? ((o = n), (n = void 0))
            : ((o = n), (n = i), (i = void 0))),
      !1 === o)
    )
      o = eS;
    else if (!o) return e;
    return (
      1 === s &&
        ((r = o),
        ((o = function (e) {
          return x().off(e), r.apply(this, arguments);
        }).guid = r.guid || (r.guid = x.guid++))),
      e.each(function () {
        x.event.add(this, t, o, n, i);
      })
    );
  }
  function e8(e, t, i) {
    i
      ? (Q.set(e, t, !1),
        x.event.add(e, t, {
          namespace: !1,
          handler: function (e) {
            var n,
              s,
              r = Q.get(this, t);
            if (1 & e.isTrigger && this[t]) {
              if (r.length)
                (x.event.special[t] || {}).delegateType && e.stopPropagation();
              else if (
                ((r = o.call(arguments)),
                Q.set(this, t, r),
                (n = i(this, t)),
                this[t](),
                r !== (s = Q.get(this, t)) || n ? Q.set(this, t, !1) : (s = {}),
                r !== s)
              )
                return (
                  e.stopImmediatePropagation(), e.preventDefault(), s.value
                );
            } else
              r.length &&
                (Q.set(this, t, {
                  value: x.event.trigger(
                    x.extend(r[0], x.Event.prototype),
                    r.slice(1),
                    this
                  ),
                }),
                e.stopImmediatePropagation());
          },
        }))
      : void 0 === Q.get(e, t) && x.event.add(e, t, ew);
  }
  (x.event = {
    global: {},
    add: function (e, t, i, n, o) {
      var s,
        r,
        a,
        l,
        c,
        d,
        u,
        p,
        h,
        f,
        g,
        m = Q.get(e);
      if (X(e))
        for (
          i.handler && ((i = (s = i).handler), (o = s.selector)),
            o && x.find.matchesSelector(eo, o),
            i.guid || (i.guid = x.guid++),
            (l = m.events) || (l = m.events = Object.create(null)),
            (r = m.handle) ||
              (r = m.handle =
                function (t) {
                  return x.event.triggered !== t.type
                    ? x.event.dispatch.apply(e, arguments)
                    : void 0;
                }),
            c = (t = (t || "").match(M) || [""]).length;
          c--;

        )
          (h = g = (a = eC.exec(t[c]) || [])[1]),
            (f = (a[2] || "").split(".").sort()),
            h &&
              ((u = x.event.special[h] || {}),
              (h = (o ? u.delegateType : u.bindType) || h),
              (u = x.event.special[h] || {}),
              (d = x.extend(
                {
                  type: h,
                  origType: g,
                  data: n,
                  handler: i,
                  guid: i.guid,
                  selector: o,
                  needsContext: o && x.expr.match.needsContext.test(o),
                  namespace: f.join("."),
                },
                s
              )),
              (p = l[h]) ||
                (((p = l[h] = []).delegateCount = 0),
                (u.setup && !1 !== u.setup.call(e, n, f, r)) ||
                  (e.addEventListener && e.addEventListener(h, r))),
              u.add &&
                (u.add.call(e, d), d.handler.guid || (d.handler.guid = i.guid)),
              o ? p.splice(p.delegateCount++, 0, d) : p.push(d),
              (x.event.global[h] = !0));
    },
    remove: function (e, t, i, n, o) {
      var s,
        r,
        a,
        l,
        c,
        d,
        u,
        p,
        h,
        f,
        g,
        m = Q.hasData(e) && Q.get(e);
      if (m && (l = m.events)) {
        for (c = (t = (t || "").match(M) || [""]).length; c--; )
          if (
            ((h = g = (a = eC.exec(t[c]) || [])[1]),
            (f = (a[2] || "").split(".").sort()),
            h)
          ) {
            for (
              u = x.event.special[h] || {},
                p = l[(h = (n ? u.delegateType : u.bindType) || h)] || [],
                a =
                  a[2] &&
                  RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                r = s = p.length;
              s--;

            )
              (d = p[s]),
                (!o && g !== d.origType) ||
                  (i && i.guid !== d.guid) ||
                  (a && !a.test(d.namespace)) ||
                  (n && n !== d.selector && ("**" !== n || !d.selector)) ||
                  (p.splice(s, 1),
                  d.selector && p.delegateCount--,
                  u.remove && u.remove.call(e, d));
            r &&
              !p.length &&
              ((u.teardown && !1 !== u.teardown.call(e, f, m.handle)) ||
                x.removeEvent(e, h, m.handle),
              delete l[h]);
          } else for (h in l) x.event.remove(e, h + t[c], i, n, !0);
        x.isEmptyObject(l) && Q.remove(e, "handle events");
      }
    },
    dispatch: function (e) {
      var t,
        i,
        n,
        o,
        s,
        r,
        a = Array(arguments.length),
        l = x.event.fix(e),
        c = (Q.get(this, "events") || Object.create(null))[l.type] || [],
        d = x.event.special[l.type] || {};
      for (a[0] = l, t = 1; t < arguments.length; t++) a[t] = arguments[t];
      if (
        ((l.delegateTarget = this),
        !d.preDispatch || !1 !== d.preDispatch.call(this, l))
      ) {
        for (
          r = x.event.handlers.call(this, l, c), t = 0;
          (o = r[t++]) && !l.isPropagationStopped();

        )
          for (
            l.currentTarget = o.elem, i = 0;
            (s = o.handlers[i++]) && !l.isImmediatePropagationStopped();

          )
            (l.rnamespace &&
              !1 !== s.namespace &&
              !l.rnamespace.test(s.namespace)) ||
              ((l.handleObj = s),
              (l.data = s.data),
              void 0 !==
                (n = (
                  (x.event.special[s.origType] || {}).handle || s.handler
                ).apply(o.elem, a)) &&
                !1 === (l.result = n) &&
                (l.preventDefault(), l.stopPropagation()));
        return d.postDispatch && d.postDispatch.call(this, l), l.result;
      }
    },
    handlers: function (e, t) {
      var i,
        n,
        o,
        s,
        r,
        a = [],
        l = t.delegateCount,
        c = e.target;
      if (l && c.nodeType && !("click" === e.type && 1 <= e.button)) {
        for (; c !== this; c = c.parentNode || this)
          if (1 === c.nodeType && ("click" !== e.type || !0 !== c.disabled)) {
            for (s = [], r = {}, i = 0; i < l; i++)
              void 0 === r[(o = (n = t[i]).selector + " ")] &&
                (r[o] = n.needsContext
                  ? -1 < x(o, this).index(c)
                  : x.find(o, this, null, [c]).length),
                r[o] && s.push(n);
            s.length && a.push({ elem: c, handlers: s });
          }
      }
      return (
        (c = this), l < t.length && a.push({ elem: c, handlers: t.slice(l) }), a
      );
    },
    addProp: function (e, t) {
      Object.defineProperty(x.Event.prototype, e, {
        enumerable: !0,
        configurable: !0,
        get: f(t)
          ? function () {
              if (this.originalEvent) return t(this.originalEvent);
            }
          : function () {
              if (this.originalEvent) return this.originalEvent[e];
            },
        set: function (t) {
          Object.defineProperty(this, e, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: t,
          });
        },
      });
    },
    fix: function (e) {
      return e[x.expando] ? e : new x.Event(e);
    },
    special: {
      load: { noBubble: !0 },
      click: {
        setup: function (e) {
          var t = this || e;
          return (
            eh.test(t.type) && t.click && E(t, "input") && e8(t, "click", ew),
            !1
          );
        },
        trigger: function (e) {
          var t = this || e;
          return (
            eh.test(t.type) && t.click && E(t, "input") && e8(t, "click"), !0
          );
        },
        _default: function (e) {
          var t = e.target;
          return (
            (eh.test(t.type) &&
              t.click &&
              E(t, "input") &&
              Q.get(t, "click")) ||
            E(t, "a")
          );
        },
      },
      beforeunload: {
        postDispatch: function (e) {
          void 0 !== e.result &&
            e.originalEvent &&
            (e.originalEvent.returnValue = e.result);
        },
      },
    },
  }),
    (x.removeEvent = function (e, t, i) {
      e.removeEventListener && e.removeEventListener(t, i);
    }),
    (x.Event = function (e, t) {
      if (!(this instanceof x.Event)) return new x.Event(e, t);
      e && e.type
        ? ((this.originalEvent = e),
          (this.type = e.type),
          (this.isDefaultPrevented =
            e.defaultPrevented ||
            (void 0 === e.defaultPrevented && !1 === e.returnValue)
              ? ew
              : eS),
          (this.target =
            e.target && 3 === e.target.nodeType
              ? e.target.parentNode
              : e.target),
          (this.currentTarget = e.currentTarget),
          (this.relatedTarget = e.relatedTarget))
        : (this.type = e),
        t && x.extend(this, t),
        (this.timeStamp = (e && e.timeStamp) || Date.now()),
        (this[x.expando] = !0);
    }),
    (x.Event.prototype = {
      constructor: x.Event,
      isDefaultPrevented: eS,
      isPropagationStopped: eS,
      isImmediatePropagationStopped: eS,
      isSimulated: !1,
      preventDefault: function () {
        var e = this.originalEvent;
        (this.isDefaultPrevented = ew),
          e && !this.isSimulated && e.preventDefault();
      },
      stopPropagation: function () {
        var e = this.originalEvent;
        (this.isPropagationStopped = ew),
          e && !this.isSimulated && e.stopPropagation();
      },
      stopImmediatePropagation: function () {
        var e = this.originalEvent;
        (this.isImmediatePropagationStopped = ew),
          e && !this.isSimulated && e.stopImmediatePropagation(),
          this.stopPropagation();
      },
    }),
    x.each(
      {
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        char: !0,
        code: !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: function (e) {
          var t = e.button;
          return null == e.which && ek.test(e.type)
            ? null != e.charCode
              ? e.charCode
              : e.keyCode
            : !e.which && void 0 !== t && ex.test(e.type)
            ? 1 & t
              ? 1
              : 2 & t
              ? 3
              : 4 & t
              ? 2
              : 0
            : e.which;
        },
      },
      x.event.addProp
    ),
    x.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
      x.event.special[e] = {
        setup: function () {
          return e8(this, e, eT), !1;
        },
        trigger: function () {
          return e8(this, e), !0;
        },
        delegateType: t,
      };
    }),
    x.each(
      {
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout",
      },
      function (e, t) {
        x.event.special[e] = {
          delegateType: t,
          bindType: t,
          handle: function (e) {
            var i,
              n = e.relatedTarget,
              o = e.handleObj;
            return (
              (n && (n === this || x.contains(this, n))) ||
                ((e.type = o.origType),
                (i = o.handler.apply(this, arguments)),
                (e.type = t)),
              i
            );
          },
        };
      }
    ),
    x.fn.extend({
      on: function (e, t, i, n) {
        return e_(this, e, t, i, n);
      },
      one: function (e, t, i, n) {
        return e_(this, e, t, i, n, 1);
      },
      off: function (e, t, i) {
        var n, o;
        if (e && e.preventDefault && e.handleObj)
          return (
            (n = e.handleObj),
            x(e.delegateTarget).off(
              n.namespace ? n.origType + "." + n.namespace : n.origType,
              n.selector,
              n.handler
            ),
            this
          );
        if ("object" == typeof e) {
          for (o in e) this.off(o, t, e[o]);
          return this;
        }
        return (
          (!1 !== t && "function" != typeof t) || ((i = t), (t = void 0)),
          !1 === i && (i = eS),
          this.each(function () {
            x.event.remove(this, e, i, t);
          })
        );
      },
    });
  var eE = /<script|<style|<link/i,
    eP = /checked\s*(?:[^=]|=\s*.checked.)/i,
    eA = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
  function eL(e, t) {
    return (
      (E(e, "table") &&
        E(11 !== t.nodeType ? t : t.firstChild, "tr") &&
        x(e).children("tbody")[0]) ||
      e
    );
  }
  function ej(e) {
    return (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e;
  }
  function eI(e) {
    return (
      "true/" === (e.type || "").slice(0, 5)
        ? (e.type = e.type.slice(5))
        : e.removeAttribute("type"),
      e
    );
  }
  function eD(e, t) {
    var i, n, o, s, r, a;
    if (1 === t.nodeType) {
      if (Q.hasData(e) && (a = Q.get(e).events))
        for (o in (Q.remove(t, "handle events"), a))
          for (i = 0, n = a[o].length; i < n; i++) x.event.add(t, o, a[o][i]);
      K.hasData(e) && ((s = K.access(e)), (r = x.extend({}, s)), K.set(t, r));
    }
  }
  function e9(e, t, i, n) {
    t = s(t);
    var o,
      r,
      a,
      l,
      c,
      d,
      u = 0,
      p = e.length,
      g = p - 1,
      m = t[0],
      v = f(m);
    if (v || (1 < p && "string" == typeof m && !h.checkClone && eP.test(m)))
      return e.each(function (o) {
        var s = e.eq(o);
        v && (t[0] = m.call(this, o, s.html())), e9(s, t, i, n);
      });
    if (
      p &&
      ((r = (o = e$(t, e[0].ownerDocument, !1, e, n)).firstChild),
      1 === o.childNodes.length && (o = r),
      r || n)
    ) {
      for (l = (a = x.map(ev(o, "script"), ej)).length; u < p; u++)
        (c = o),
          u !== g &&
            ((c = x.clone(c, !0, !0)), l && x.merge(a, ev(c, "script"))),
          i.call(e[u], c, u);
      if (l)
        for (d = a[a.length - 1].ownerDocument, x.map(a, eI), u = 0; u < l; u++)
          (c = a[u]),
            eg.test(c.type || "") &&
              !Q.access(c, "globalEval") &&
              x.contains(d, c) &&
              (c.src && "module" !== (c.type || "").toLowerCase()
                ? x._evalUrl &&
                  !c.noModule &&
                  x._evalUrl(
                    c.src,
                    { nonce: c.nonce || c.getAttribute("nonce") },
                    d
                  )
                : y(c.textContent.replace(eA, ""), c, d));
    }
    return e;
  }
  function ez(e, t, i) {
    for (var n, o = t ? x.filter(t, e) : e, s = 0; null != (n = o[s]); s++)
      i || 1 !== n.nodeType || x.cleanData(ev(n)),
        n.parentNode &&
          (i && es(n) && ey(ev(n, "script")), n.parentNode.removeChild(n));
    return e;
  }
  x.extend({
    htmlPrefilter: function (e) {
      return e;
    },
    clone: function (e, t, i) {
      var n,
        o,
        s,
        r,
        a,
        l,
        c,
        d = e.cloneNode(!0),
        u = es(e);
      if (
        !(
          h.noCloneChecked ||
          (1 !== e.nodeType && 11 !== e.nodeType) ||
          x.isXMLDoc(e)
        )
      )
        for (r = ev(d), n = 0, o = (s = ev(e)).length; n < o; n++)
          (a = s[n]),
            "input" === (c = (l = r[n]).nodeName.toLowerCase()) &&
            eh.test(a.type)
              ? (l.checked = a.checked)
              : ("input" !== c && "textarea" !== c) ||
                (l.defaultValue = a.defaultValue);
      if (t) {
        if (i)
          for (s = s || ev(e), r = r || ev(d), n = 0, o = s.length; n < o; n++)
            eD(s[n], r[n]);
        else eD(e, d);
      }
      return (
        0 < (r = ev(d, "script")).length && ey(r, !u && ev(e, "script")), d
      );
    },
    cleanData: function (e) {
      for (var t, i, n, o = x.event.special, s = 0; void 0 !== (i = e[s]); s++)
        if (X(i)) {
          if ((t = i[Q.expando])) {
            if (t.events)
              for (n in t.events)
                o[n] ? x.event.remove(i, n) : x.removeEvent(i, n, t.handle);
            i[Q.expando] = void 0;
          }
          i[K.expando] && (i[K.expando] = void 0);
        }
    },
  }),
    x.fn.extend({
      detach: function (e) {
        return ez(this, e, !0);
      },
      remove: function (e) {
        return ez(this, e);
      },
      text: function (e) {
        return B(
          this,
          function (e) {
            return void 0 === e
              ? x.text(this)
              : this.empty().each(function () {
                  (1 !== this.nodeType &&
                    11 !== this.nodeType &&
                    9 !== this.nodeType) ||
                    (this.textContent = e);
                });
          },
          null,
          e,
          arguments.length
        );
      },
      append: function () {
        return e9(this, arguments, function (e) {
          (1 !== this.nodeType &&
            11 !== this.nodeType &&
            9 !== this.nodeType) ||
            eL(this, e).appendChild(e);
        });
      },
      prepend: function () {
        return e9(this, arguments, function (e) {
          if (
            1 === this.nodeType ||
            11 === this.nodeType ||
            9 === this.nodeType
          ) {
            var t = eL(this, e);
            t.insertBefore(e, t.firstChild);
          }
        });
      },
      before: function () {
        return e9(this, arguments, function (e) {
          this.parentNode && this.parentNode.insertBefore(e, this);
        });
      },
      after: function () {
        return e9(this, arguments, function (e) {
          this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
        });
      },
      empty: function () {
        for (var e, t = 0; null != (e = this[t]); t++)
          1 === e.nodeType && (x.cleanData(ev(e, !1)), (e.textContent = ""));
        return this;
      },
      clone: function (e, t) {
        return (
          (e = null != e && e),
          (t = null == t ? e : t),
          this.map(function () {
            return x.clone(this, e, t);
          })
        );
      },
      html: function (e) {
        return B(
          this,
          function (e) {
            var t = this[0] || {},
              i = 0,
              n = this.length;
            if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
            if (
              "string" == typeof e &&
              !eE.test(e) &&
              !em[(ef.exec(e) || ["", ""])[1].toLowerCase()]
            ) {
              e = x.htmlPrefilter(e);
              try {
                for (; i < n; i++)
                  1 === (t = this[i] || {}).nodeType &&
                    (x.cleanData(ev(t, !1)), (t.innerHTML = e));
                t = 0;
              } catch (o) {}
            }
            t && this.empty().append(e);
          },
          null,
          e,
          arguments.length
        );
      },
      replaceWith: function () {
        var e = [];
        return e9(
          this,
          arguments,
          function (t) {
            var i = this.parentNode;
            0 > x.inArray(this, e) &&
              (x.cleanData(ev(this)), i && i.replaceChild(t, this));
          },
          e
        );
      },
    }),
    x.each(
      {
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith",
      },
      function (e, t) {
        x.fn[e] = function (e) {
          for (var i, n = [], o = x(e), s = o.length - 1, a = 0; a <= s; a++)
            (i = a === s ? this : this.clone(!0)),
              x(o[a])[t](i),
              r.apply(n, i.get());
          return this.pushStack(n);
        };
      }
    );
  var eM = RegExp("^(" + et + ")(?!px)[a-z%]+$", "i"),
    eq = function (t) {
      var i = t.ownerDocument.defaultView;
      return (i && i.opener) || (i = e), i.getComputedStyle(t);
    },
    eO = function (e, t, i) {
      var n,
        o,
        s = {};
      for (o in t) (s[o] = e.style[o]), (e.style[o] = t[o]);
      for (o in ((n = i.call(e)), t)) e.style[o] = s[o];
      return n;
    },
    eF = RegExp(en.join("|"), "i");
  function eH(e, t, i) {
    var n,
      o,
      s,
      r,
      a = e.style;
    return (
      (i = i || eq(e)) &&
        ("" !== (r = i.getPropertyValue(t) || i[t]) ||
          es(e) ||
          (r = x.style(e, t)),
        !h.pixelBoxStyles() &&
          eM.test(r) &&
          eF.test(t) &&
          ((n = a.width),
          (o = a.minWidth),
          (s = a.maxWidth),
          (a.minWidth = a.maxWidth = a.width = r),
          (r = i.width),
          (a.width = n),
          (a.minWidth = o),
          (a.maxWidth = s))),
      void 0 !== r ? r + "" : r
    );
  }
  function eW(e, t) {
    return {
      get: function () {
        if (!e()) return (this.get = t).apply(this, arguments);
        delete this.get;
      },
    };
  }
  !(function () {
    function t() {
      if (d) {
        (c.style.cssText =
          "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
          (d.style.cssText =
            "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
          eo.appendChild(c).appendChild(d);
        var t = e.getComputedStyle(d);
        (n = "1%" !== t.top),
          (l = 12 === i(t.marginLeft)),
          (d.style.right = "60%"),
          (r = 36 === i(t.right)),
          (o = 36 === i(t.width)),
          (d.style.position = "absolute"),
          (s = 12 === i(d.offsetWidth / 3)),
          eo.removeChild(c),
          (d = null);
      }
    }
    function i(e) {
      return Math.round(parseFloat(e));
    }
    var n,
      o,
      s,
      r,
      a,
      l,
      c = m.createElement("div"),
      d = m.createElement("div");
    d.style &&
      ((d.style.backgroundClip = "content-box"),
      (d.cloneNode(!0).style.backgroundClip = ""),
      (h.clearCloneStyle = "content-box" === d.style.backgroundClip),
      x.extend(h, {
        boxSizingReliable: function () {
          return t(), o;
        },
        pixelBoxStyles: function () {
          return t(), r;
        },
        pixelPosition: function () {
          return t(), n;
        },
        reliableMarginLeft: function () {
          return t(), l;
        },
        scrollboxSize: function () {
          return t(), s;
        },
        reliableTrDimensions: function () {
          var t, i, n, o;
          return (
            null == a &&
              ((t = m.createElement("table")),
              (i = m.createElement("tr")),
              (n = m.createElement("div")),
              (t.style.cssText = "position:absolute;left:-11111px"),
              (i.style.height = "1px"),
              (n.style.height = "9px"),
              eo.appendChild(t).appendChild(i).appendChild(n),
              (a = 3 < parseInt((o = e.getComputedStyle(i)).height)),
              eo.removeChild(t)),
            a
          );
        },
      }));
  })();
  var eN = ["Webkit", "Moz", "ms"],
    eB = m.createElement("div").style,
    e0 = {};
  function eR(e) {
    return (
      x.cssProps[e] ||
      e0[e] ||
      (e in eB
        ? e
        : (e0[e] =
            (function (e) {
              for (
                var t = e[0].toUpperCase() + e.slice(1), i = eN.length;
                i--;

              )
                if ((e = eN[i] + t) in eB) return e;
            })(e) || e))
    );
  }
  var e1 = /^(none|table(?!-c[ea]).+)/,
    e3 = /^--/,
    eV = { position: "absolute", visibility: "hidden", display: "block" },
    eU = { letterSpacing: "0", fontWeight: "400" };
  function e4(e, t, i) {
    var n = ei.exec(t);
    return n ? Math.max(0, n[2] - (i || 0)) + (n[3] || "px") : t;
  }
  function e5(e, t, i, n, o, s) {
    var r = "width" === t ? 1 : 0,
      a = 0,
      l = 0;
    if (i === (n ? "border" : "content")) return 0;
    for (; r < 4; r += 2)
      "margin" === i && (l += x.css(e, i + en[r], !0, o)),
        n
          ? ("content" === i && (l -= x.css(e, "padding" + en[r], !0, o)),
            "margin" !== i &&
              (l -= x.css(e, "border" + en[r] + "Width", !0, o)))
          : ((l += x.css(e, "padding" + en[r], !0, o)),
            "padding" !== i
              ? (l += x.css(e, "border" + en[r] + "Width", !0, o))
              : (a += x.css(e, "border" + en[r] + "Width", !0, o)));
    return (
      !n &&
        0 <= s &&
        (l +=
          Math.max(
            0,
            Math.ceil(
              e["offset" + t[0].toUpperCase() + t.slice(1)] - s - l - a - 0.5
            )
          ) || 0),
      l
    );
  }
  function e7(e, t, i) {
    var n = eq(e),
      o =
        (!h.boxSizingReliable() || i) &&
        "border-box" === x.css(e, "boxSizing", !1, n),
      s = o,
      r = eH(e, t, n),
      a = "offset" + t[0].toUpperCase() + t.slice(1);
    if (eM.test(r)) {
      if (!i) return r;
      r = "auto";
    }
    return (
      ((!h.boxSizingReliable() && o) ||
        (!h.reliableTrDimensions() && E(e, "tr")) ||
        "auto" === r ||
        (!parseFloat(r) && "inline" === x.css(e, "display", !1, n))) &&
        e.getClientRects().length &&
        ((o = "border-box" === x.css(e, "boxSizing", !1, n)),
        (s = a in e) && (r = e[a])),
      (r = parseFloat(r) || 0) +
        e5(e, t, i || (o ? "border" : "content"), s, n, r) +
        "px"
    );
  }
  function e2(e, t, i, n, o) {
    return new e2.prototype.init(e, t, i, n, o);
  }
  x.extend({
    cssHooks: {
      opacity: {
        get: function (e, t) {
          if (t) {
            var i = eH(e, "opacity");
            return "" === i ? "1" : i;
          }
        },
      },
    },
    cssNumber: {
      animationIterationCount: !0,
      columnCount: !0,
      fillOpacity: !0,
      flexGrow: !0,
      flexShrink: !0,
      fontWeight: !0,
      gridArea: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnStart: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowStart: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
    },
    cssProps: {},
    style: function (e, t, i, n) {
      if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
        var o,
          s,
          r,
          a = G(t),
          l = e3.test(t),
          c = e.style;
        if (
          (l || (t = eR(a)), (r = x.cssHooks[t] || x.cssHooks[a]), void 0 === i)
        )
          return r && "get" in r && void 0 !== (o = r.get(e, !1, n)) ? o : c[t];
        "string" == (s = typeof i) &&
          (o = ei.exec(i)) &&
          o[1] &&
          ((i = el(e, t, o)), (s = "number")),
          null != i &&
            i == i &&
            ("number" !== s ||
              l ||
              (i += (o && o[3]) || (x.cssNumber[a] ? "" : "px")),
            h.clearCloneStyle ||
              "" !== i ||
              0 !== t.indexOf("background") ||
              (c[t] = "inherit"),
            (r && "set" in r && void 0 === (i = r.set(e, i, n))) ||
              (l ? c.setProperty(t, i) : (c[t] = i)));
      }
    },
    css: function (e, t, i, n) {
      var o,
        s,
        r,
        a = G(t);
      return (
        e3.test(t) || (t = eR(a)),
        (r = x.cssHooks[t] || x.cssHooks[a]) &&
          "get" in r &&
          (o = r.get(e, !0, i)),
        void 0 === o && (o = eH(e, t, n)),
        "normal" === o && t in eU && (o = eU[t]),
        "" === i || i
          ? ((s = parseFloat(o)), !0 === i || isFinite(s) ? s || 0 : o)
          : o
      );
    },
  }),
    x.each(["height", "width"], function (e, t) {
      x.cssHooks[t] = {
        get: function (e, i, n) {
          if (i)
            return !e1.test(x.css(e, "display")) ||
              (e.getClientRects().length && e.getBoundingClientRect().width)
              ? e7(e, t, n)
              : eO(e, eV, function () {
                  return e7(e, t, n);
                });
        },
        set: function (e, i, n) {
          var o,
            s = eq(e),
            r = !h.scrollboxSize() && "absolute" === s.position,
            a = (r || n) && "border-box" === x.css(e, "boxSizing", !1, s),
            l = n ? e5(e, t, n, a, s) : 0;
          return (
            a &&
              r &&
              (l -= Math.ceil(
                e["offset" + t[0].toUpperCase() + t.slice(1)] -
                  parseFloat(s[t]) -
                  e5(e, t, "border", !1, s) -
                  0.5
              )),
            l &&
              (o = ei.exec(i)) &&
              "px" !== (o[3] || "px") &&
              ((e.style[t] = i), (i = x.css(e, t))),
            e4(0, i, l)
          );
        },
      };
    }),
    (x.cssHooks.marginLeft = eW(h.reliableMarginLeft, function (e, t) {
      if (t)
        return (
          (parseFloat(eH(e, "marginLeft")) ||
            e.getBoundingClientRect().left -
              eO(e, { marginLeft: 0 }, function () {
                return e.getBoundingClientRect().left;
              })) + "px"
        );
    })),
    x.each({ margin: "", padding: "", border: "Width" }, function (e, t) {
      (x.cssHooks[e + t] = {
        expand: function (i) {
          for (
            var n = 0, o = {}, s = "string" == typeof i ? i.split(" ") : [i];
            n < 4;
            n++
          )
            o[e + en[n] + t] = s[n] || s[n - 2] || s[0];
          return o;
        },
      }),
        "margin" !== e && (x.cssHooks[e + t].set = e4);
    }),
    x.fn.extend({
      css: function (e, t) {
        return B(
          this,
          function (e, t, i) {
            var n,
              o,
              s = {},
              r = 0;
            if (Array.isArray(t)) {
              for (n = eq(e), o = t.length; r < o; r++)
                s[t[r]] = x.css(e, t[r], !1, n);
              return s;
            }
            return void 0 !== i ? x.style(e, t, i) : x.css(e, t);
          },
          e,
          t,
          1 < arguments.length
        );
      },
    }),
    (((x.Tween = e2).prototype = {
      constructor: e2,
      init: function (e, t, i, n, o, s) {
        (this.elem = e),
          (this.prop = i),
          (this.easing = o || x.easing._default),
          (this.options = t),
          (this.start = this.now = this.cur()),
          (this.end = n),
          (this.unit = s || (x.cssNumber[i] ? "" : "px"));
      },
      cur: function () {
        var e = e2.propHooks[this.prop];
        return e && e.get ? e.get(this) : e2.propHooks._default.get(this);
      },
      run: function (e) {
        var t,
          i = e2.propHooks[this.prop];
        return (
          this.options.duration
            ? (this.pos = t =
                x.easing[this.easing](
                  e,
                  this.options.duration * e,
                  0,
                  1,
                  this.options.duration
                ))
            : (this.pos = t = e),
          (this.now = (this.end - this.start) * t + this.start),
          this.options.step &&
            this.options.step.call(this.elem, this.now, this),
          i && i.set ? i.set(this) : e2.propHooks._default.set(this),
          this
        );
      },
    }).init.prototype = e2.prototype),
    ((e2.propHooks = {
      _default: {
        get: function (e) {
          var t;
          return 1 !== e.elem.nodeType ||
            (null != e.elem[e.prop] && null == e.elem.style[e.prop])
            ? e.elem[e.prop]
            : (t = x.css(e.elem, e.prop, "")) && "auto" !== t
            ? t
            : 0;
        },
        set: function (e) {
          x.fx.step[e.prop]
            ? x.fx.step[e.prop](e)
            : 1 === e.elem.nodeType &&
              (x.cssHooks[e.prop] || null != e.elem.style[eR(e.prop)])
            ? x.style(e.elem, e.prop, e.now + e.unit)
            : (e.elem[e.prop] = e.now);
        },
      },
    }).scrollTop = e2.propHooks.scrollLeft =
      {
        set: function (e) {
          e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
        },
      }),
    (x.easing = {
      linear: function (e) {
        return e;
      },
      swing: function (e) {
        return 0.5 - Math.cos(e * Math.PI) / 2;
      },
      _default: "swing",
    }),
    (x.fx = e2.prototype.init),
    (x.fx.step = {});
  var eG,
    e6,
    eX,
    eY,
    eQ = /^(?:toggle|show|hide)$/,
    eK = /queueHooks$/;
  function eZ() {
    return (
      e.setTimeout(function () {
        eG = void 0;
      }),
      (eG = Date.now())
    );
  }
  function eJ(e, t) {
    var i,
      n = 0,
      o = { height: e };
    for (t = t ? 1 : 0; n < 4; n += 2 - t)
      o["margin" + (i = en[n])] = o["padding" + i] = e;
    return t && (o.opacity = o.width = e), o;
  }
  function te(e, t, i) {
    for (
      var n,
        o = (tt.tweeners[t] || []).concat(tt.tweeners["*"]),
        s = 0,
        r = o.length;
      s < r;
      s++
    )
      if ((n = o[s].call(i, t, e))) return n;
  }
  function tt(e, t, i) {
    var n,
      o,
      s = 0,
      r = tt.prefilters.length,
      a = x.Deferred().always(function () {
        delete l.elem;
      }),
      l = function () {
        if (o) return !1;
        for (
          var t = eG || eZ(),
            i = Math.max(0, c.startTime + c.duration - t),
            n = 1 - (i / c.duration || 0),
            s = 0,
            r = c.tweens.length;
          s < r;
          s++
        )
          c.tweens[s].run(n);
        return (
          a.notifyWith(e, [c, n, i]),
          n < 1 && r
            ? i
            : (r || a.notifyWith(e, [c, 1, 0]), a.resolveWith(e, [c]), !1)
        );
      },
      c = a.promise({
        elem: e,
        props: x.extend({}, t),
        opts: x.extend(!0, { specialEasing: {}, easing: x.easing._default }, i),
        originalProperties: t,
        originalOptions: i,
        startTime: eG || eZ(),
        duration: i.duration,
        tweens: [],
        createTween: function (t, i) {
          var n = x.Tween(
            e,
            c.opts,
            t,
            i,
            c.opts.specialEasing[t] || c.opts.easing
          );
          return c.tweens.push(n), n;
        },
        stop: function (t) {
          var i = 0,
            n = t ? c.tweens.length : 0;
          if (o) return this;
          for (o = !0; i < n; i++) c.tweens[i].run(1);
          return (
            t
              ? (a.notifyWith(e, [c, 1, 0]), a.resolveWith(e, [c, t]))
              : a.rejectWith(e, [c, t]),
            this
          );
        },
      }),
      d = c.props;
    for (
      (function (e, t) {
        var i, n, o, s, r;
        for (i in e)
          if (
            ((o = t[(n = G(i))]),
            Array.isArray((s = e[i])) && ((o = s[1]), (s = e[i] = s[0])),
            i !== n && ((e[n] = s), delete e[i]),
            (r = x.cssHooks[n]) && ("expand" in r))
          )
            for (i in ((s = r.expand(s)), delete e[n], s))
              (i in e) || ((e[i] = s[i]), (t[i] = o));
          else t[n] = o;
      })(d, c.opts.specialEasing);
      s < r;
      s++
    )
      if ((n = tt.prefilters[s].call(c, e, d, c.opts)))
        return (
          f(n.stop) &&
            (x._queueHooks(c.elem, c.opts.queue).stop = n.stop.bind(n)),
          n
        );
    return (
      x.map(d, te, c),
      f(c.opts.start) && c.opts.start.call(e, c),
      c
        .progress(c.opts.progress)
        .done(c.opts.done, c.opts.complete)
        .fail(c.opts.fail)
        .always(c.opts.always),
      x.fx.timer(x.extend(l, { elem: e, anim: c, queue: c.opts.queue })),
      c
    );
  }
  (x.Animation = x.extend(tt, {
    tweeners: {
      "*": [
        function (e, t) {
          var i = this.createTween(e, t);
          return el(i.elem, e, ei.exec(t), i), i;
        },
      ],
    },
    tweener: function (e, t) {
      f(e) ? ((t = e), (e = ["*"])) : (e = e.match(M));
      for (var i, n = 0, o = e.length; n < o; n++)
        (i = e[n]),
          (tt.tweeners[i] = tt.tweeners[i] || []),
          tt.tweeners[i].unshift(t);
    },
    prefilters: [
      function (e, t, i) {
        var n,
          o,
          s,
          r,
          a,
          l,
          c,
          d,
          u = "width" in t || "height" in t,
          p = this,
          h = {},
          f = e.style,
          g = e.nodeType && ea(e),
          m = Q.get(e, "fxshow");
        for (n in (i.queue ||
          (null == (r = x._queueHooks(e, "fx")).unqueued &&
            ((r.unqueued = 0),
            (a = r.empty.fire),
            (r.empty.fire = function () {
              r.unqueued || a();
            })),
          r.unqueued++,
          p.always(function () {
            p.always(function () {
              r.unqueued--, x.queue(e, "fx").length || r.empty.fire();
            });
          })),
        t))
          if (((o = t[n]), eQ.test(o))) {
            if (
              (delete t[n],
              (s = s || "toggle" === o),
              o === (g ? "hide" : "show"))
            ) {
              if ("show" !== o || !m || void 0 === m[n]) continue;
              g = !0;
            }
            h[n] = (m && m[n]) || x.style(e, n);
          }
        if ((l = !x.isEmptyObject(t)) || !x.isEmptyObject(h))
          for (n in (u &&
            1 === e.nodeType &&
            ((i.overflow = [f.overflow, f.overflowX, f.overflowY]),
            null == (c = m && m.display) && (c = Q.get(e, "display")),
            "none" === (d = x.css(e, "display")) &&
              (c
                ? (d = c)
                : (ed([e], !0),
                  (c = e.style.display || c),
                  (d = x.css(e, "display")),
                  ed([e]))),
            ("inline" === d || ("inline-block" === d && null != c)) &&
              "none" === x.css(e, "float") &&
              (l ||
                (p.done(function () {
                  f.display = c;
                }),
                null == c && (c = "none" === (d = f.display) ? "" : d)),
              (f.display = "inline-block"))),
          i.overflow &&
            ((f.overflow = "hidden"),
            p.always(function () {
              (f.overflow = i.overflow[0]),
                (f.overflowX = i.overflow[1]),
                (f.overflowY = i.overflow[2]);
            })),
          (l = !1),
          h))
            l ||
              (m
                ? "hidden" in m && (g = m.hidden)
                : (m = Q.access(e, "fxshow", { display: c })),
              s && (m.hidden = !g),
              g && ed([e], !0),
              p.done(function () {
                for (n in (g || ed([e]), Q.remove(e, "fxshow"), h))
                  x.style(e, n, h[n]);
              })),
              (l = te(g ? m[n] : 0, n, p)),
              n in m ||
                ((m[n] = l.start), g && ((l.end = l.start), (l.start = 0)));
      },
    ],
    prefilter: function (e, t) {
      t ? tt.prefilters.unshift(e) : tt.prefilters.push(e);
    },
  })),
    (x.speed = function (e, t, i) {
      var n =
        e && "object" == typeof e
          ? x.extend({}, e)
          : {
              complete: i || (!i && t) || (f(e) && e),
              duration: e,
              easing: (i && t) || (t && !f(t) && t),
            };
      return (
        x.fx.off
          ? (n.duration = 0)
          : "number" != typeof n.duration &&
            (n.duration in x.fx.speeds
              ? (n.duration = x.fx.speeds[n.duration])
              : (n.duration = x.fx.speeds._default)),
        (null != n.queue && !0 !== n.queue) || (n.queue = "fx"),
        (n.old = n.complete),
        (n.complete = function () {
          f(n.old) && n.old.call(this), n.queue && x.dequeue(this, n.queue);
        }),
        n
      );
    }),
    x.fn.extend({
      fadeTo: function (e, t, i, n) {
        return this.filter(ea)
          .css("opacity", 0)
          .show()
          .end()
          .animate({ opacity: t }, e, i, n);
      },
      animate: function (e, t, i, n) {
        var o = x.isEmptyObject(e),
          s = x.speed(t, i, n),
          r = function () {
            var t = tt(this, x.extend({}, e), s);
            (o || Q.get(this, "finish")) && t.stop(!0);
          };
        return (
          (r.finish = r),
          o || !1 === s.queue ? this.each(r) : this.queue(s.queue, r)
        );
      },
      stop: function (e, t, i) {
        var n = function (e) {
          var t = e.stop;
          delete e.stop, t(i);
        };
        return (
          "string" != typeof e && ((i = t), (t = e), (e = void 0)),
          t && this.queue(e || "fx", []),
          this.each(function () {
            var t = !0,
              o = null != e && e + "queueHooks",
              s = x.timers,
              r = Q.get(this);
            if (o) r[o] && r[o].stop && n(r[o]);
            else for (o in r) r[o] && r[o].stop && eK.test(o) && n(r[o]);
            for (o = s.length; o--; )
              s[o].elem !== this ||
                (null != e && s[o].queue !== e) ||
                (s[o].anim.stop(i), (t = !1), s.splice(o, 1));
            (!t && i) || x.dequeue(this, e);
          })
        );
      },
      finish: function (e) {
        return (
          !1 !== e && (e = e || "fx"),
          this.each(function () {
            var t,
              i = Q.get(this),
              n = i[e + "queue"],
              o = i[e + "queueHooks"],
              s = x.timers,
              r = n ? n.length : 0;
            for (
              i.finish = !0,
                x.queue(this, e, []),
                o && o.stop && o.stop.call(this, !0),
                t = s.length;
              t--;

            )
              s[t].elem === this &&
                s[t].queue === e &&
                (s[t].anim.stop(!0), s.splice(t, 1));
            for (t = 0; t < r; t++)
              n[t] && n[t].finish && n[t].finish.call(this);
            delete i.finish;
          })
        );
      },
    }),
    x.each(["toggle", "show", "hide"], function (e, t) {
      var i = x.fn[t];
      x.fn[t] = function (e, n, o) {
        return null == e || "boolean" == typeof e
          ? i.apply(this, arguments)
          : this.animate(eJ(t, !0), e, n, o);
      };
    }),
    x.each(
      {
        slideDown: eJ("show"),
        slideUp: eJ("hide"),
        slideToggle: eJ("toggle"),
        fadeIn: { opacity: "show" },
        fadeOut: { opacity: "hide" },
        fadeToggle: { opacity: "toggle" },
      },
      function (e, t) {
        x.fn[e] = function (e, i, n) {
          return this.animate(t, e, i, n);
        };
      }
    ),
    (x.timers = []),
    (x.fx.tick = function () {
      var e,
        t = 0,
        i = x.timers;
      for (eG = Date.now(); t < i.length; t++)
        (e = i[t])() || i[t] !== e || i.splice(t--, 1);
      i.length || x.fx.stop(), (eG = void 0);
    }),
    (x.fx.timer = function (e) {
      x.timers.push(e), x.fx.start();
    }),
    (x.fx.interval = 13),
    (x.fx.start = function () {
      e6 ||
        ((e6 = !0),
        (function t() {
          e6 &&
            (!1 === m.hidden && e.requestAnimationFrame
              ? e.requestAnimationFrame(t)
              : e.setTimeout(t, x.fx.interval),
            x.fx.tick());
        })());
    }),
    (x.fx.stop = function () {
      e6 = null;
    }),
    (x.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
    (x.fn.delay = function (t, i) {
      return (
        (t = (x.fx && x.fx.speeds[t]) || t),
        (i = i || "fx"),
        this.queue(i, function (i, n) {
          var o = e.setTimeout(i, t);
          n.stop = function () {
            e.clearTimeout(o);
          };
        })
      );
    }),
    (eX = m.createElement("input")),
    (eY = m.createElement("select").appendChild(m.createElement("option"))),
    (eX.type = "checkbox"),
    (h.checkOn = "" !== eX.value),
    (h.optSelected = eY.selected),
    ((eX = m.createElement("input")).value = "t"),
    (eX.type = "radio"),
    (h.radioValue = "t" === eX.value);
  var ti,
    tn = x.expr.attrHandle;
  x.fn.extend({
    attr: function (e, t) {
      return B(this, x.attr, e, t, 1 < arguments.length);
    },
    removeAttr: function (e) {
      return this.each(function () {
        x.removeAttr(this, e);
      });
    },
  }),
    x.extend({
      attr: function (e, t, i) {
        var n,
          o,
          s = e.nodeType;
        if (3 !== s && 8 !== s && 2 !== s)
          return void 0 === e.getAttribute
            ? x.prop(e, t, i)
            : ((1 === s && x.isXMLDoc(e)) ||
                (o =
                  x.attrHooks[t.toLowerCase()] ||
                  (x.expr.match.bool.test(t) ? ti : void 0)),
              void 0 !== i
                ? null === i
                  ? void x.removeAttr(e, t)
                  : o && "set" in o && void 0 !== (n = o.set(e, i, t))
                  ? n
                  : (e.setAttribute(t, i + ""), i)
                : o && "get" in o && null !== (n = o.get(e, t))
                ? n
                : null == (n = x.find.attr(e, t))
                ? void 0
                : n);
      },
      attrHooks: {
        type: {
          set: function (e, t) {
            if (!h.radioValue && "radio" === t && E(e, "input")) {
              var i = e.value;
              return e.setAttribute("type", t), i && (e.value = i), t;
            }
          },
        },
      },
      removeAttr: function (e, t) {
        var i,
          n = 0,
          o = t && t.match(M);
        if (o && 1 === e.nodeType) for (; (i = o[n++]); ) e.removeAttribute(i);
      },
    }),
    (ti = {
      set: function (e, t, i) {
        return !1 === t ? x.removeAttr(e, i) : e.setAttribute(i, i), i;
      },
    }),
    x.each(x.expr.match.bool.source.match(/\w+/g), function (e, t) {
      var i = tn[t] || x.find.attr;
      tn[t] = function (e, t, n) {
        var o,
          s,
          r = t.toLowerCase();
        return (
          n ||
            ((s = tn[r]),
            (tn[r] = o),
            (o = null != i(e, t, n) ? r : null),
            (tn[r] = s)),
          o
        );
      };
    });
  var to = /^(?:input|select|textarea|button)$/i,
    ts = /^(?:a|area)$/i;
  function tr(e) {
    return (e.match(M) || []).join(" ");
  }
  function ta(e) {
    return (e.getAttribute && e.getAttribute("class")) || "";
  }
  function tl(e) {
    return Array.isArray(e) ? e : ("string" == typeof e && e.match(M)) || [];
  }
  x.fn.extend({
    prop: function (e, t) {
      return B(this, x.prop, e, t, 1 < arguments.length);
    },
    removeProp: function (e) {
      return this.each(function () {
        delete this[x.propFix[e] || e];
      });
    },
  }),
    x.extend({
      prop: function (e, t, i) {
        var n,
          o,
          s = e.nodeType;
        if (3 !== s && 8 !== s && 2 !== s)
          return (
            (1 === s && x.isXMLDoc(e)) ||
              ((t = x.propFix[t] || t), (o = x.propHooks[t])),
            void 0 !== i
              ? o && "set" in o && void 0 !== (n = o.set(e, i, t))
                ? n
                : (e[t] = i)
              : o && "get" in o && null !== (n = o.get(e, t))
              ? n
              : e[t]
          );
      },
      propHooks: {
        tabIndex: {
          get: function (e) {
            var t = x.find.attr(e, "tabindex");
            return t
              ? parseInt(t, 10)
              : to.test(e.nodeName) || (ts.test(e.nodeName) && e.href)
              ? 0
              : -1;
          },
        },
      },
      propFix: { for: "htmlFor", class: "className" },
    }),
    h.optSelected ||
      (x.propHooks.selected = {
        get: function (e) {
          var t = e.parentNode;
          return t && t.parentNode && t.parentNode.selectedIndex, null;
        },
        set: function (e) {
          var t = e.parentNode;
          t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
        },
      }),
    x.each(
      [
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable",
      ],
      function () {
        x.propFix[this.toLowerCase()] = this;
      }
    ),
    x.fn.extend({
      addClass: function (e) {
        var t,
          i,
          n,
          o,
          s,
          r,
          a,
          l = 0;
        if (f(e))
          return this.each(function (t) {
            x(this).addClass(e.call(this, t, ta(this)));
          });
        if ((t = tl(e)).length) {
          for (; (i = this[l++]); )
            if (((o = ta(i)), (n = 1 === i.nodeType && " " + tr(o) + " "))) {
              for (r = 0; (s = t[r++]); )
                0 > n.indexOf(" " + s + " ") && (n += s + " ");
              o !== (a = tr(n)) && i.setAttribute("class", a);
            }
        }
        return this;
      },
      removeClass: function (e) {
        var t,
          i,
          n,
          o,
          s,
          r,
          a,
          l = 0;
        if (f(e))
          return this.each(function (t) {
            x(this).removeClass(e.call(this, t, ta(this)));
          });
        if (!arguments.length) return this.attr("class", "");
        if ((t = tl(e)).length) {
          for (; (i = this[l++]); )
            if (((o = ta(i)), (n = 1 === i.nodeType && " " + tr(o) + " "))) {
              for (r = 0; (s = t[r++]); )
                for (; -1 < n.indexOf(" " + s + " "); )
                  n = n.replace(" " + s + " ", " ");
              o !== (a = tr(n)) && i.setAttribute("class", a);
            }
        }
        return this;
      },
      toggleClass: function (e, t) {
        var i = typeof e,
          n = "string" === i || Array.isArray(e);
        return "boolean" == typeof t && n
          ? t
            ? this.addClass(e)
            : this.removeClass(e)
          : f(e)
          ? this.each(function (i) {
              x(this).toggleClass(e.call(this, i, ta(this), t), t);
            })
          : this.each(function () {
              var t, o, s, r;
              if (n)
                for (o = 0, s = x(this), r = tl(e); (t = r[o++]); )
                  s.hasClass(t) ? s.removeClass(t) : s.addClass(t);
              else
                (void 0 !== e && "boolean" !== i) ||
                  ((t = ta(this)) && Q.set(this, "__className__", t),
                  this.setAttribute &&
                    this.setAttribute(
                      "class",
                      t || !1 === e ? "" : Q.get(this, "__className__") || ""
                    ));
            });
      },
      hasClass: function (e) {
        var t,
          i,
          n = 0;
        for (t = " " + e + " "; (i = this[n++]); )
          if (1 === i.nodeType && -1 < (" " + tr(ta(i)) + " ").indexOf(t))
            return !0;
        return !1;
      },
    });
  var tc = /\r/g;
  x.fn.extend({
    val: function (e) {
      var t,
        i,
        n,
        o = this[0];
      return arguments.length
        ? ((n = f(e)),
          this.each(function (i) {
            var o;
            1 === this.nodeType &&
              (null == (o = n ? e.call(this, i, x(this).val()) : e)
                ? (o = "")
                : "number" == typeof o
                ? (o += "")
                : Array.isArray(o) &&
                  (o = x.map(o, function (e) {
                    return null == e ? "" : e + "";
                  })),
              ((t =
                x.valHooks[this.type] ||
                x.valHooks[this.nodeName.toLowerCase()]) &&
                "set" in t &&
                void 0 !== t.set(this, o, "value")) ||
                (this.value = o));
          }))
        : o
        ? (t = x.valHooks[o.type] || x.valHooks[o.nodeName.toLowerCase()]) &&
          "get" in t &&
          void 0 !== (i = t.get(o, "value"))
          ? i
          : "string" == typeof (i = o.value)
          ? i.replace(tc, "")
          : null == i
          ? ""
          : i
        : void 0;
    },
  }),
    x.extend({
      valHooks: {
        option: {
          get: function (e) {
            var t = x.find.attr(e, "value");
            return null != t ? t : tr(x.text(e));
          },
        },
        select: {
          get: function (e) {
            var t,
              i,
              n,
              o = e.options,
              s = e.selectedIndex,
              r = "select-one" === e.type,
              a = r ? null : [],
              l = r ? s + 1 : o.length;
            for (n = s < 0 ? l : r ? s : 0; n < l; n++)
              if (
                ((i = o[n]).selected || n === s) &&
                !i.disabled &&
                (!i.parentNode.disabled || !E(i.parentNode, "optgroup"))
              ) {
                if (((t = x(i).val()), r)) return t;
                a.push(t);
              }
            return a;
          },
          set: function (e, t) {
            for (
              var i, n, o = e.options, s = x.makeArray(t), r = o.length;
              r--;

            )
              ((n = o[r]).selected =
                -1 < x.inArray(x.valHooks.option.get(n), s)) && (i = !0);
            return i || (e.selectedIndex = -1), s;
          },
        },
      },
    }),
    x.each(["radio", "checkbox"], function () {
      (x.valHooks[this] = {
        set: function (e, t) {
          if (Array.isArray(t))
            return (e.checked = -1 < x.inArray(x(e).val(), t));
        },
      }),
        h.checkOn ||
          (x.valHooks[this].get = function (e) {
            return null === e.getAttribute("value") ? "on" : e.value;
          });
    }),
    (h.focusin = "onfocusin" in e);
  var td = /^(?:focusinfocus|focusoutblur)$/,
    tu = function (e) {
      e.stopPropagation();
    };
  x.extend(x.event, {
    trigger: function (t, i, n, o) {
      var s,
        r,
        a,
        l,
        c,
        u,
        p,
        h,
        v = [n || m],
        y = d.call(t, "type") ? t.type : t,
        b = d.call(t, "namespace") ? t.namespace.split(".") : [];
      if (
        ((r = h = a = n = n || m),
        3 !== n.nodeType &&
          8 !== n.nodeType &&
          !td.test(y + x.event.triggered) &&
          (-1 < y.indexOf(".") && ((y = (b = y.split(".")).shift()), b.sort()),
          (c = 0 > y.indexOf(":") && "on" + y),
          ((t = t[x.expando]
            ? t
            : new x.Event(y, "object" == typeof t && t)).isTrigger = o ? 2 : 3),
          (t.namespace = b.join(".")),
          (t.rnamespace = t.namespace
            ? RegExp("(^|\\.)" + b.join("\\.(?:.*\\.|)") + "(\\.|$)")
            : null),
          (t.result = void 0),
          t.target || (t.target = n),
          (i = null == i ? [t] : x.makeArray(i, [t])),
          (p = x.event.special[y] || {}),
          o || !p.trigger || !1 !== p.trigger.apply(n, i)))
      ) {
        if (!o && !p.noBubble && !g(n)) {
          for (
            l = p.delegateType || y, td.test(l + y) || (r = r.parentNode);
            r;
            r = r.parentNode
          )
            v.push(r), (a = r);
          a === (n.ownerDocument || m) &&
            v.push(a.defaultView || a.parentWindow || e);
        }
        for (s = 0; (r = v[s++]) && !t.isPropagationStopped(); )
          (h = r),
            (t.type = 1 < s ? l : p.bindType || y),
            (u =
              (Q.get(r, "events") || Object.create(null))[t.type] &&
              Q.get(r, "handle")) && u.apply(r, i),
            (u = c && r[c]) &&
              u.apply &&
              X(r) &&
              ((t.result = u.apply(r, i)),
              !1 === t.result && t.preventDefault());
        return (
          (t.type = y),
          o ||
            t.isDefaultPrevented() ||
            (p._default && !1 !== p._default.apply(v.pop(), i)) ||
            !X(n) ||
            (c &&
              f(n[y]) &&
              !g(n) &&
              ((a = n[c]) && (n[c] = null),
              (x.event.triggered = y),
              t.isPropagationStopped() && h.addEventListener(y, tu),
              n[y](),
              t.isPropagationStopped() && h.removeEventListener(y, tu),
              (x.event.triggered = void 0),
              a && (n[c] = a))),
          t.result
        );
      }
    },
    simulate: function (e, t, i) {
      var n = x.extend(new x.Event(), i, { type: e, isSimulated: !0 });
      x.event.trigger(n, null, t);
    },
  }),
    x.fn.extend({
      trigger: function (e, t) {
        return this.each(function () {
          x.event.trigger(e, t, this);
        });
      },
      triggerHandler: function (e, t) {
        var i = this[0];
        if (i) return x.event.trigger(e, t, i, !0);
      },
    }),
    h.focusin ||
      x.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
        var i = function (e) {
          x.event.simulate(t, e.target, x.event.fix(e));
        };
        x.event.special[t] = {
          setup: function () {
            var n = this.ownerDocument || this.document || this,
              o = Q.access(n, t);
            o || n.addEventListener(e, i, !0), Q.access(n, t, (o || 0) + 1);
          },
          teardown: function () {
            var n = this.ownerDocument || this.document || this,
              o = Q.access(n, t) - 1;
            o
              ? Q.access(n, t, o)
              : (n.removeEventListener(e, i, !0), Q.remove(n, t));
          },
        };
      });
  var tp = e.location,
    th = { guid: Date.now() },
    tf = /\?/;
  x.parseXML = function (t) {
    var i;
    if (!t || "string" != typeof t) return null;
    try {
      i = new e.DOMParser().parseFromString(t, "text/xml");
    } catch (n) {
      i = void 0;
    }
    return (
      (i && !i.getElementsByTagName("parsererror").length) ||
        x.error("Invalid XML: " + t),
      i
    );
  };
  var tg = /\[\]$/,
    tm = /\r?\n/g,
    tv = /^(?:submit|button|image|reset|file)$/i,
    ty = /^(?:input|select|textarea|keygen)/i;
  function tb(e, t, i, n) {
    var o;
    if (Array.isArray(t))
      x.each(t, function (t, o) {
        i || tg.test(e)
          ? n(e, o)
          : tb(
              e + "[" + ("object" == typeof o && null != o ? t : "") + "]",
              o,
              i,
              n
            );
      });
    else if (i || "object" !== b(t)) n(e, t);
    else for (o in t) tb(e + "[" + o + "]", t[o], i, n);
  }
  (x.param = function (e, t) {
    var i,
      n = [],
      o = function (e, t) {
        var i = f(t) ? t() : t;
        n[n.length] =
          encodeURIComponent(e) + "=" + encodeURIComponent(null == i ? "" : i);
      };
    if (null == e) return "";
    if (Array.isArray(e) || (e.jquery && !x.isPlainObject(e)))
      x.each(e, function () {
        o(this.name, this.value);
      });
    else for (i in e) tb(i, e[i], t, o);
    return n.join("&");
  }),
    x.fn.extend({
      serialize: function () {
        return x.param(this.serializeArray());
      },
      serializeArray: function () {
        return this.map(function () {
          var e = x.prop(this, "elements");
          return e ? x.makeArray(e) : this;
        })
          .filter(function () {
            var e = this.type;
            return (
              this.name &&
              !x(this).is(":disabled") &&
              ty.test(this.nodeName) &&
              !tv.test(e) &&
              (this.checked || !eh.test(e))
            );
          })
          .map(function (e, t) {
            var i = x(this).val();
            return null == i
              ? null
              : Array.isArray(i)
              ? x.map(i, function (e) {
                  return { name: t.name, value: e.replace(tm, "\r\n") };
                })
              : { name: t.name, value: i.replace(tm, "\r\n") };
          })
          .get();
      },
    });
  var t$ = /%20/g,
    tk = /#.*$/,
    tx = /([?&])_=[^&]*/,
    tC = /^(.*?):[ \t]*([^\r\n]*)$/gm,
    tw = /^(?:GET|HEAD)$/,
    tS = /^\/\//,
    tT = {},
    t_ = {},
    t8 = "*/".concat("*"),
    tE = m.createElement("a");
  function tP(e) {
    return function (t, i) {
      "string" != typeof t && ((i = t), (t = "*"));
      var n,
        o = 0,
        s = t.toLowerCase().match(M) || [];
      if (f(i))
        for (; (n = s[o++]); )
          "+" === n[0]
            ? (e[(n = n.slice(1) || "*")] = e[n] || []).unshift(i)
            : (e[n] = e[n] || []).push(i);
    };
  }
  function tA(e, t, i, n) {
    var o = {},
      s = e === t_;
    function r(a) {
      var l;
      return (
        (o[a] = !0),
        x.each(e[a] || [], function (e, a) {
          var c = a(t, i, n);
          return "string" != typeof c || s || o[c]
            ? s
              ? !(l = c)
              : void 0
            : (t.dataTypes.unshift(c), r(c), !1);
        }),
        l
      );
    }
    return r(t.dataTypes[0]) || (!o["*"] && r("*"));
  }
  function tL(e, t) {
    var i,
      n,
      o = x.ajaxSettings.flatOptions || {};
    for (i in t) void 0 !== t[i] && ((o[i] ? e : n || (n = {}))[i] = t[i]);
    return n && x.extend(!0, e, n), e;
  }
  (tE.href = tp.href),
    x.extend({
      active: 0,
      lastModified: {},
      etag: {},
      ajaxSettings: {
        url: tp.href,
        type: "GET",
        isLocal:
          /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(
            tp.protocol
          ),
        global: !0,
        processData: !0,
        async: !0,
        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
        accepts: {
          "*": t8,
          text: "text/plain",
          html: "text/html",
          xml: "application/xml, text/xml",
          json: "application/json, text/javascript",
        },
        contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
        responseFields: {
          xml: "responseXML",
          text: "responseText",
          json: "responseJSON",
        },
        converters: {
          "* text": String,
          "text html": !0,
          "text json": JSON.parse,
          "text xml": x.parseXML,
        },
        flatOptions: { url: !0, context: !0 },
      },
      ajaxSetup: function (e, t) {
        return t ? tL(tL(e, x.ajaxSettings), t) : tL(x.ajaxSettings, e);
      },
      ajaxPrefilter: tP(tT),
      ajaxTransport: tP(t_),
      ajax: function (t, i) {
        "object" == typeof t && ((i = t), (t = void 0)), (i = i || {});
        var n,
          o,
          s,
          r,
          a,
          l,
          c,
          d,
          u,
          p,
          h = x.ajaxSetup({}, i),
          f = h.context || h,
          g = h.context && (f.nodeType || f.jquery) ? x(f) : x.event,
          v = x.Deferred(),
          y = x.Callbacks("once memory"),
          b = h.statusCode || {},
          k = {},
          C = {},
          w = "canceled",
          S = {
            readyState: 0,
            getResponseHeader: function (e) {
              var t;
              if (c) {
                if (!r)
                  for (r = {}; (t = tC.exec(s)); )
                    r[t[1].toLowerCase() + " "] = (
                      r[t[1].toLowerCase() + " "] || []
                    ).concat(t[2]);
                t = r[e.toLowerCase() + " "];
              }
              return null == t ? null : t.join(", ");
            },
            getAllResponseHeaders: function () {
              return c ? s : null;
            },
            setRequestHeader: function (e, t) {
              return (
                null == c &&
                  (k[(e = C[e.toLowerCase()] = C[e.toLowerCase()] || e)] = t),
                this
              );
            },
            overrideMimeType: function (e) {
              return null == c && (h.mimeType = e), this;
            },
            statusCode: function (e) {
              var t;
              if (e) {
                if (c) S.always(e[S.status]);
                else for (t in e) b[t] = [b[t], e[t]];
              }
              return this;
            },
            abort: function (e) {
              var t = e || w;
              return n && n.abort(t), E(0, t), this;
            },
          };
        if (
          (v.promise(S),
          (h.url = ((t || h.url || tp.href) + "").replace(
            tS,
            tp.protocol + "//"
          )),
          (h.type = i.method || i.type || h.method || h.type),
          (h.dataTypes = (h.dataType || "*").toLowerCase().match(M) || [""]),
          null == h.crossDomain)
        ) {
          l = m.createElement("a");
          try {
            (l.href = h.url),
              (l.href = l.href),
              (h.crossDomain =
                tE.protocol + "//" + tE.host != l.protocol + "//" + l.host);
          } catch (T) {
            h.crossDomain = !0;
          }
        }
        if (
          (h.data &&
            h.processData &&
            "string" != typeof h.data &&
            (h.data = x.param(h.data, h.traditional)),
          tA(tT, h, i, S),
          c)
        )
          return S;
        for (u in ((d = x.event && h.global) &&
          0 == x.active++ &&
          x.event.trigger("ajaxStart"),
        (h.type = h.type.toUpperCase()),
        (h.hasContent = !tw.test(h.type)),
        (o = h.url.replace(tk, "")),
        h.hasContent
          ? h.data &&
            h.processData &&
            0 ===
              (h.contentType || "").indexOf(
                "application/x-www-form-urlencoded"
              ) &&
            (h.data = h.data.replace(t$, "+"))
          : ((p = h.url.slice(o.length)),
            h.data &&
              (h.processData || "string" == typeof h.data) &&
              ((o += (tf.test(o) ? "&" : "?") + h.data), delete h.data),
            !1 === h.cache &&
              ((o = o.replace(tx, "$1")),
              (p = (tf.test(o) ? "&" : "?") + "_=" + th.guid++ + p)),
            (h.url = o + p)),
        h.ifModified &&
          (x.lastModified[o] &&
            S.setRequestHeader("If-Modified-Since", x.lastModified[o]),
          x.etag[o] && S.setRequestHeader("If-None-Match", x.etag[o])),
        ((h.data && h.hasContent && !1 !== h.contentType) || i.contentType) &&
          S.setRequestHeader("Content-Type", h.contentType),
        S.setRequestHeader(
          "Accept",
          h.dataTypes[0] && h.accepts[h.dataTypes[0]]
            ? h.accepts[h.dataTypes[0]] +
                ("*" !== h.dataTypes[0] ? ", " + t8 + "; q=0.01" : "")
            : h.accepts["*"]
        ),
        h.headers))
          S.setRequestHeader(u, h.headers[u]);
        if (h.beforeSend && (!1 === h.beforeSend.call(f, S, h) || c))
          return S.abort();
        if (
          ((w = "abort"),
          y.add(h.complete),
          S.done(h.success),
          S.fail(h.error),
          (n = tA(t_, h, i, S)))
        ) {
          if (((S.readyState = 1), d && g.trigger("ajaxSend", [S, h]), c))
            return S;
          h.async &&
            0 < h.timeout &&
            (a = e.setTimeout(function () {
              S.abort("timeout");
            }, h.timeout));
          try {
            (c = !1), n.send(k, E);
          } catch (_) {
            if (c) throw _;
            E(-1, _);
          }
        } else E(-1, "No Transport");
        function E(t, i, r, l) {
          var u,
            p,
            m,
            k,
            C,
            w = i;
          c ||
            ((c = !0),
            a && e.clearTimeout(a),
            (n = void 0),
            (s = l || ""),
            (S.readyState = 0 < t ? 4 : 0),
            (u = (200 <= t && t < 300) || 304 === t),
            r &&
              (k = (function (e, t, i) {
                for (
                  var n, o, s, r, a = e.contents, l = e.dataTypes;
                  "*" === l[0];

                )
                  l.shift(),
                    void 0 === n &&
                      (n = e.mimeType || t.getResponseHeader("Content-Type"));
                if (n) {
                  for (o in a)
                    if (a[o] && a[o].test(n)) {
                      l.unshift(o);
                      break;
                    }
                }
                if (l[0] in i) s = l[0];
                else {
                  for (o in i) {
                    if (!l[0] || e.converters[o + " " + l[0]]) {
                      s = o;
                      break;
                    }
                    r || (r = o);
                  }
                  s = s || r;
                }
                if (s) return s !== l[0] && l.unshift(s), i[s];
              })(h, S, r)),
            !u &&
              -1 < x.inArray("script", h.dataTypes) &&
              (h.converters["text script"] = function () {}),
            (k = (function (e, t, i, n) {
              var o,
                s,
                r,
                a,
                l,
                c = {},
                d = e.dataTypes.slice();
              if (d[1])
                for (r in e.converters) c[r.toLowerCase()] = e.converters[r];
              for (s = d.shift(); s; )
                if (
                  (e.responseFields[s] && (i[e.responseFields[s]] = t),
                  !l && n && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
                  (l = s),
                  (s = d.shift()))
                ) {
                  if ("*" === s) s = l;
                  else if ("*" !== l && l !== s) {
                    if (!(r = c[l + " " + s] || c["* " + s])) {
                      for (o in c)
                        if (
                          (a = o.split(" "))[1] === s &&
                          (r = c[l + " " + a[0]] || c["* " + a[0]])
                        ) {
                          !0 === r
                            ? (r = c[o])
                            : !0 !== c[o] && ((s = a[0]), d.unshift(a[1]));
                          break;
                        }
                    }
                    if (!0 !== r) {
                      if (r && e.throws) t = r(t);
                      else
                        try {
                          t = r(t);
                        } catch (u) {
                          return {
                            state: "parsererror",
                            error: r
                              ? u
                              : "No conversion from " + l + " to " + s,
                          };
                        }
                    }
                  }
                }
              return { state: "success", data: t };
            })(h, k, S, u)),
            u
              ? (h.ifModified &&
                  ((C = S.getResponseHeader("Last-Modified")) &&
                    (x.lastModified[o] = C),
                  (C = S.getResponseHeader("etag")) && (x.etag[o] = C)),
                204 === t || "HEAD" === h.type
                  ? (w = "nocontent")
                  : 304 === t
                  ? (w = "notmodified")
                  : ((w = k.state), (p = k.data), (u = !(m = k.error))))
              : ((m = w), (!t && w) || ((w = "error"), t < 0 && (t = 0))),
            (S.status = t),
            (S.statusText = (i || w) + ""),
            u ? v.resolveWith(f, [p, w, S]) : v.rejectWith(f, [S, w, m]),
            S.statusCode(b),
            (b = void 0),
            d && g.trigger(u ? "ajaxSuccess" : "ajaxError", [S, h, u ? p : m]),
            y.fireWith(f, [S, w]),
            d &&
              (g.trigger("ajaxComplete", [S, h]),
              --x.active || x.event.trigger("ajaxStop")));
        }
        return S;
      },
      getJSON: function (e, t, i) {
        return x.get(e, t, i, "json");
      },
      getScript: function (e, t) {
        return x.get(e, void 0, t, "script");
      },
    }),
    x.each(["get", "post"], function (e, t) {
      x[t] = function (e, i, n, o) {
        return (
          f(i) && ((o = o || n), (n = i), (i = void 0)),
          x.ajax(
            x.extend(
              { url: e, type: t, dataType: o, data: i, success: n },
              x.isPlainObject(e) && e
            )
          )
        );
      };
    }),
    x.ajaxPrefilter(function (e) {
      var t;
      for (t in e.headers)
        "content-type" === t.toLowerCase() &&
          (e.contentType = e.headers[t] || "");
    }),
    (x._evalUrl = function (e, t, i) {
      return x.ajax({
        url: e,
        type: "GET",
        dataType: "script",
        cache: !0,
        async: !1,
        global: !1,
        converters: { "text script": function () {} },
        dataFilter: function (e) {
          x.globalEval(e, t, i);
        },
      });
    }),
    x.fn.extend({
      wrapAll: function (e) {
        var t;
        return (
          this[0] &&
            (f(e) && (e = e.call(this[0])),
            (t = x(e, this[0].ownerDocument).eq(0).clone(!0)),
            this[0].parentNode && t.insertBefore(this[0]),
            t
              .map(function () {
                for (var e = this; e.firstElementChild; )
                  e = e.firstElementChild;
                return e;
              })
              .append(this)),
          this
        );
      },
      wrapInner: function (e) {
        return f(e)
          ? this.each(function (t) {
              x(this).wrapInner(e.call(this, t));
            })
          : this.each(function () {
              var t = x(this),
                i = t.contents();
              i.length ? i.wrapAll(e) : t.append(e);
            });
      },
      wrap: function (e) {
        var t = f(e);
        return this.each(function (i) {
          x(this).wrapAll(t ? e.call(this, i) : e);
        });
      },
      unwrap: function (e) {
        return (
          this.parent(e)
            .not("body")
            .each(function () {
              x(this).replaceWith(this.childNodes);
            }),
          this
        );
      },
    }),
    (x.expr.pseudos.hidden = function (e) {
      return !x.expr.pseudos.visible(e);
    }),
    (x.expr.pseudos.visible = function (e) {
      return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
    }),
    (x.ajaxSettings.xhr = function () {
      try {
        return new e.XMLHttpRequest();
      } catch (t) {}
    });
  var tj = { 0: 200, 1223: 204 },
    tI = x.ajaxSettings.xhr();
  (h.cors = !!tI && "withCredentials" in tI),
    (h.ajax = tI = !!tI),
    x.ajaxTransport(function (t) {
      var i, n;
      if (h.cors || (tI && !t.crossDomain))
        return {
          send: function (o, s) {
            var r,
              a = t.xhr();
            if (
              (a.open(t.type, t.url, t.async, t.username, t.password),
              t.xhrFields)
            )
              for (r in t.xhrFields) a[r] = t.xhrFields[r];
            for (r in (t.mimeType &&
              a.overrideMimeType &&
              a.overrideMimeType(t.mimeType),
            t.crossDomain ||
              o["X-Requested-With"] ||
              (o["X-Requested-With"] = "XMLHttpRequest"),
            o))
              a.setRequestHeader(r, o[r]);
            (i = function (e) {
              return function () {
                i &&
                  ((i =
                    n =
                    a.onload =
                    a.onerror =
                    a.onabort =
                    a.ontimeout =
                    a.onreadystatechange =
                      null),
                  "abort" === e
                    ? a.abort()
                    : "error" === e
                    ? "number" != typeof a.status
                      ? s(0, "error")
                      : s(a.status, a.statusText)
                    : s(
                        tj[a.status] || a.status,
                        a.statusText,
                        "text" !== (a.responseType || "text") ||
                          "string" != typeof a.responseText
                          ? { binary: a.response }
                          : { text: a.responseText },
                        a.getAllResponseHeaders()
                      ));
              };
            }),
              (a.onload = i()),
              (n = a.onerror = a.ontimeout = i("error")),
              void 0 !== a.onabort
                ? (a.onabort = n)
                : (a.onreadystatechange = function () {
                    4 === a.readyState &&
                      e.setTimeout(function () {
                        i && n();
                      });
                  }),
              (i = i("abort"));
            try {
              a.send((t.hasContent && t.data) || null);
            } catch (l) {
              if (i) throw l;
            }
          },
          abort: function () {
            i && i();
          },
        };
    }),
    x.ajaxPrefilter(function (e) {
      e.crossDomain && (e.contents.script = !1);
    }),
    x.ajaxSetup({
      accepts: {
        script:
          "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
      },
      contents: { script: /\b(?:java|ecma)script\b/ },
      converters: {
        "text script": function (e) {
          return x.globalEval(e), e;
        },
      },
    }),
    x.ajaxPrefilter("script", function (e) {
      void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
    }),
    x.ajaxTransport("script", function (e) {
      var t, i;
      if (e.crossDomain || e.scriptAttrs)
        return {
          send: function (n, o) {
            (t = x("<script>")
              .attr(e.scriptAttrs || {})
              .prop({ charset: e.scriptCharset, src: e.url })
              .on(
                "load error",
                (i = function (e) {
                  t.remove(),
                    (i = null),
                    e && o("error" === e.type ? 404 : 200, e.type);
                })
              )),
              m.head.appendChild(t[0]);
          },
          abort: function () {
            i && i();
          },
        };
    });
  var tD,
    t9 = [],
    tz = /(=)\?(?=&|$)|\?\?/;
  x.ajaxSetup({
    jsonp: "callback",
    jsonpCallback: function () {
      var e = t9.pop() || x.expando + "_" + th.guid++;
      return (this[e] = !0), e;
    },
  }),
    x.ajaxPrefilter("json jsonp", function (t, i, n) {
      var o,
        s,
        r,
        a =
          !1 !== t.jsonp &&
          (tz.test(t.url)
            ? "url"
            : "string" == typeof t.data &&
              0 ===
                (t.contentType || "").indexOf(
                  "application/x-www-form-urlencoded"
                ) &&
              tz.test(t.data) &&
              "data");
      if (a || "jsonp" === t.dataTypes[0])
        return (
          (o = t.jsonpCallback =
            f(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback),
          a
            ? (t[a] = t[a].replace(tz, "$1" + o))
            : !1 !== t.jsonp &&
              (t.url += (tf.test(t.url) ? "&" : "?") + t.jsonp + "=" + o),
          (t.converters["script json"] = function () {
            return r || x.error(o + " was not called"), r[0];
          }),
          (t.dataTypes[0] = "json"),
          (s = e[o]),
          (e[o] = function () {
            r = arguments;
          }),
          n.always(function () {
            void 0 === s ? x(e).removeProp(o) : (e[o] = s),
              t[o] && ((t.jsonpCallback = i.jsonpCallback), t9.push(o)),
              r && f(s) && s(r[0]),
              (r = s = void 0);
          }),
          "script"
        );
    }),
    (h.createHTMLDocument =
      (((tD = m.implementation.createHTMLDocument("").body).innerHTML =
        "<form></form><form></form>"),
      2 === tD.childNodes.length)),
    (x.parseHTML = function (e, t, i) {
      var n, o, s;
      return "string" != typeof e
        ? []
        : ("boolean" == typeof t && ((i = t), (t = !1)),
          t ||
            (h.createHTMLDocument
              ? (((n = (t =
                  m.implementation.createHTMLDocument("")).createElement(
                  "base"
                )).href = m.location.href),
                t.head.appendChild(n))
              : (t = m)),
          (s = !i && []),
          (o = P.exec(e))
            ? [t.createElement(o[1])]
            : ((o = e$([e], t, s)),
              s && s.length && x(s).remove(),
              x.merge([], o.childNodes)));
    }),
    (x.fn.load = function (e, t, i) {
      var n,
        o,
        s,
        r = this,
        a = e.indexOf(" ");
      return (
        -1 < a && ((n = tr(e.slice(a))), (e = e.slice(0, a))),
        f(t)
          ? ((i = t), (t = void 0))
          : t && "object" == typeof t && (o = "POST"),
        0 < r.length &&
          x
            .ajax({ url: e, type: o || "GET", dataType: "html", data: t })
            .done(function (e) {
              (s = arguments),
                r.html(n ? x("<div>").append(x.parseHTML(e)).find(n) : e);
            })
            .always(
              i &&
                function (e, t) {
                  r.each(function () {
                    i.apply(this, s || [e.responseText, t, e]);
                  });
                }
            ),
        this
      );
    }),
    (x.expr.pseudos.animated = function (e) {
      return x.grep(x.timers, function (t) {
        return e === t.elem;
      }).length;
    }),
    (x.offset = {
      setOffset: function (e, t, i) {
        var n,
          o,
          s,
          r,
          a,
          l,
          c = x.css(e, "position"),
          d = x(e),
          u = {};
        "static" === c && (e.style.position = "relative"),
          (a = d.offset()),
          (s = x.css(e, "top")),
          (l = x.css(e, "left")),
          ("absolute" === c || "fixed" === c) && -1 < (s + l).indexOf("auto")
            ? ((r = (n = d.position()).top), (o = n.left))
            : ((r = parseFloat(s) || 0), (o = parseFloat(l) || 0)),
          f(t) && (t = t.call(e, i, x.extend({}, a))),
          null != t.top && (u.top = t.top - a.top + r),
          null != t.left && (u.left = t.left - a.left + o),
          "using" in t
            ? t.using.call(e, u)
            : ("number" == typeof u.top && (u.top += "px"),
              "number" == typeof u.left && (u.left += "px"),
              d.css(u));
      },
    }),
    x.fn.extend({
      offset: function (e) {
        if (arguments.length)
          return void 0 === e
            ? this
            : this.each(function (t) {
                x.offset.setOffset(this, e, t);
              });
        var t,
          i,
          n = this[0];
        return n
          ? n.getClientRects().length
            ? ((t = n.getBoundingClientRect()),
              (i = n.ownerDocument.defaultView),
              { top: t.top + i.pageYOffset, left: t.left + i.pageXOffset })
            : { top: 0, left: 0 }
          : void 0;
      },
      position: function () {
        if (this[0]) {
          var e,
            t,
            i,
            n = this[0],
            o = { top: 0, left: 0 };
          if ("fixed" === x.css(n, "position")) t = n.getBoundingClientRect();
          else {
            for (
              t = this.offset(),
                i = n.ownerDocument,
                e = n.offsetParent || i.documentElement;
              e &&
              (e === i.body || e === i.documentElement) &&
              "static" === x.css(e, "position");

            )
              e = e.parentNode;
            e &&
              e !== n &&
              1 === e.nodeType &&
              (((o = x(e).offset()).top += x.css(e, "borderTopWidth", !0)),
              (o.left += x.css(e, "borderLeftWidth", !0)));
          }
          return {
            top: t.top - o.top - x.css(n, "marginTop", !0),
            left: t.left - o.left - x.css(n, "marginLeft", !0),
          };
        }
      },
      offsetParent: function () {
        return this.map(function () {
          for (
            var e = this.offsetParent;
            e && "static" === x.css(e, "position");

          )
            e = e.offsetParent;
          return e || eo;
        });
      },
    }),
    x.each(
      { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" },
      function (e, t) {
        var i = "pageYOffset" === t;
        x.fn[e] = function (n) {
          return B(
            this,
            function (e, n, o) {
              var s;
              if (
                (g(e) ? (s = e) : 9 === e.nodeType && (s = e.defaultView),
                void 0 === o)
              )
                return s ? s[t] : e[n];
              s
                ? s.scrollTo(i ? s.pageXOffset : o, i ? o : s.pageYOffset)
                : (e[n] = o);
            },
            e,
            n,
            arguments.length
          );
        };
      }
    ),
    x.each(["top", "left"], function (e, t) {
      x.cssHooks[t] = eW(h.pixelPosition, function (e, i) {
        if (i)
          return (i = eH(e, t)), eM.test(i) ? x(e).position()[t] + "px" : i;
      });
    }),
    x.each({ Height: "height", Width: "width" }, function (e, t) {
      x.each(
        { padding: "inner" + e, content: t, "": "outer" + e },
        function (i, n) {
          x.fn[n] = function (o, s) {
            var r = arguments.length && (i || "boolean" != typeof o),
              a = i || (!0 === o || !0 === s ? "margin" : "border");
            return B(
              this,
              function (t, i, o) {
                var s;
                return g(t)
                  ? 0 === n.indexOf("outer")
                    ? t["inner" + e]
                    : t.document.documentElement["client" + e]
                  : 9 === t.nodeType
                  ? ((s = t.documentElement),
                    Math.max(
                      t.body["scroll" + e],
                      s["scroll" + e],
                      t.body["offset" + e],
                      s["offset" + e],
                      s["client" + e]
                    ))
                  : void 0 === o
                  ? x.css(t, i, a)
                  : x.style(t, i, o, a);
              },
              t,
              r ? o : void 0,
              r
            );
          };
        }
      );
    }),
    x.each(
      [
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend",
      ],
      function (e, t) {
        x.fn[t] = function (e) {
          return this.on(t, e);
        };
      }
    ),
    x.fn.extend({
      bind: function (e, t, i) {
        return this.on(e, null, t, i);
      },
      unbind: function (e, t) {
        return this.off(e, null, t);
      },
      delegate: function (e, t, i, n) {
        return this.on(t, e, i, n);
      },
      undelegate: function (e, t, i) {
        return 1 === arguments.length
          ? this.off(e, "**")
          : this.off(t, e || "**", i);
      },
      hover: function (e, t) {
        return this.mouseenter(e).mouseleave(t || e);
      },
    }),
    x.each(
      "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(
        " "
      ),
      function (e, t) {
        x.fn[t] = function (e, i) {
          return 0 < arguments.length
            ? this.on(t, null, e, i)
            : this.trigger(t);
        };
      }
    );
  var tM = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
  (x.proxy = function (e, t) {
    var i, n, s;
    if (("string" == typeof t && ((i = e[t]), (t = e), (e = i)), f(e)))
      return (
        (n = o.call(arguments, 2)),
        ((s = function () {
          return e.apply(t || this, n.concat(o.call(arguments)));
        }).guid = e.guid =
          e.guid || x.guid++),
        s
      );
  }),
    (x.holdReady = function (e) {
      e ? x.readyWait++ : x.ready(!0);
    }),
    (x.isArray = Array.isArray),
    (x.parseJSON = JSON.parse),
    (x.nodeName = E),
    (x.isFunction = f),
    (x.isWindow = g),
    (x.camelCase = G),
    (x.type = b),
    (x.now = Date.now),
    (x.isNumeric = function (e) {
      var t = x.type(e);
      return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e));
    }),
    (x.trim = function (e) {
      return null == e ? "" : (e + "").replace(tM, "");
    }),
    "function" == typeof define &&
      define.amd &&
      define("jquery", [], function () {
        return x;
      });
  var tq = e.jQuery,
    tO = e.$;
  return (
    (x.noConflict = function (t) {
      return e.$ === x && (e.$ = tO), t && e.jQuery === x && (e.jQuery = tq), x;
    }),
    void 0 === t && (e.jQuery = e.$ = x),
    x
  );
}),
  $.ajaxSetup({ cache: !1 }),
  document.addEventListener("touchstart", wasTouched, { passive: !0 }),
  (function (e, t) {
    "object" == typeof exports && "undefined" != typeof module
      ? t(exports)
      : "function" == typeof define && define.amd
      ? define(["exports"], t)
      : t(
          ((e =
            "undefined" != typeof globalThis ? globalThis : e || self).Sqrl =
            {})
        );
  })(this, function (e) {
    "use strict";
    function t(e) {
      var i,
        n,
        o = Error(e);
      return (
        (i = o),
        (n = t.prototype),
        Object.setPrototypeOf ? Object.setPrototypeOf(i, n) : (i.__proto__ = n),
        o
      );
    }
    function i(e, i, n) {
      var o = i.slice(0, n).split(/\n/),
        s = o.length,
        r = o[s - 1].length + 1;
      throw t(
        (e +=
          " at line " +
          s +
          " col " +
          r +
          ":\n\n  " +
          i.split(/\n/)[s - 1] +
          "\n  " +
          Array(r).join(" ") +
          "^")
      );
    }
    t.prototype = Object.create(Error.prototype, {
      name: { value: "Squirrelly Error", enumerable: !1 },
    });
    var n = Function("return this")().Promise,
      o = !1;
    try {
      o = Function("return (async function(){}).constructor")();
    } catch (s) {
      if (!(s instanceof SyntaxError)) throw s;
    }
    function r(e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }
    function a(e, t, i) {
      for (var n in t)
        r(t, n) &&
          (null == t[n] ||
          "object" != typeof t[n] ||
          ("storage" !== n && "prefixes" !== n) ||
          i
            ? (e[n] = t[n])
            : (e[n] = a({}, t[n])));
      return e;
    }
    var l = /^async +/,
      c = /`(?:\\[\s\S]|\${(?:[^{}]|{(?:[^{}]|{[^}]*})*})*}|(?!\${)[^\\`])*`/g,
      d = /'(?:\\[\s\w"'\\`]|[^\n\r'\\])*?'/g,
      u = /"(?:\\[\s\w"'\\`]|[^\n\r"\\])*?"/g,
      p = /[.*+\-?^${}()|[\]\\]/g;
    function h(e) {
      return p.test(e) ? e.replace(p, "\\$&") : e;
    }
    function f(e, n) {
      n.rmWhitespace &&
        (e = e.replace(/[\r\n]+/g, "\n").replace(/^\s+|\s+$/gm, "")),
        (c.lastIndex = 0),
        (d.lastIndex = 0),
        (u.lastIndex = 0);
      var o = n.prefixes,
        s = [o.h, o.b, o.i, o.r, o.c, o.e].reduce(function (e, t) {
          return e && t ? e + "|" + h(t) : t ? h(t) : e;
        }, ""),
        r = RegExp(
          "([|()]|=>)|('|\"|`|\\/\\*)|\\s*((\\/)?(-|_)?" + h(n.tags[1]) + ")",
          "g"
        ),
        a = RegExp(
          "([^]*?)" + h(n.tags[0]) + "(-|_)?\\s*(" + s + ")?\\s*",
          "g"
        ),
        p = 0,
        f = !1;
      function g(t, o) {
        var s,
          h = { f: [] },
          g = 0,
          m = "c";
        function v(t) {
          var o = e.slice(p, t),
            s = o.trim();
          "f" === m
            ? "safe" === s
              ? (h.raw = !0)
              : n.async && l.test(s)
              ? ((s = s.replace(l, "")), h.f.push([s, "", !0]))
              : h.f.push([s, ""])
            : "fp" === m
            ? (h.f[h.f.length - 1][1] += s)
            : "err" === m
            ? s && i("invalid syntax", e, p + o.search(/\S/))
            : (h[m] = s),
            (p = t + 1);
        }
        for (
          "h" === o || "b" === o || "c" === o
            ? (m = "n")
            : "r" === o && ((h.raw = !0), (o = "i")),
            r.lastIndex = p;
          null !== (s = r.exec(e));

        ) {
          var y = s[1],
            b = s[2],
            k = s[3],
            x = s[4],
            C = s[5],
            w = s.index;
          if (y)
            "(" === y
              ? (0 === g &&
                  ("n" === m
                    ? (v(w), (m = "p"))
                    : "f" === m && (v(w), (m = "fp"))),
                g++)
              : ")" === y
              ? 0 == --g && "c" !== m && (v(w), (m = "err"))
              : 0 === g && "|" === y
              ? (v(w), (m = "f"))
              : "=>" === y && (v(w), (p += 1), (m = "res"));
          else if (b) {
            if ("/*" === b) {
              var S = e.indexOf("*/", r.lastIndex);
              -1 === S && i("unclosed comment", e, s.index),
                (r.lastIndex = S + 2);
            } else
              "'" === b
                ? ((d.lastIndex = s.index),
                  d.exec(e)
                    ? (r.lastIndex = d.lastIndex)
                    : i("unclosed string", e, s.index))
                : '"' === b
                ? ((u.lastIndex = s.index),
                  u.exec(e)
                    ? (r.lastIndex = u.lastIndex)
                    : i("unclosed string", e, s.index))
                : "`" === b &&
                  ((c.lastIndex = s.index),
                  c.exec(e)
                    ? (r.lastIndex = c.lastIndex)
                    : i("unclosed string", e, s.index));
          } else if (k)
            return (
              v(w),
              (p = w + s[0].length),
              (a.lastIndex = p),
              (f = C),
              x && "h" === o && (o = "s"),
              (h.t = o),
              h
            );
        }
        return i("unclosed tag", e, t), h;
      }
      var m = (function s(r, c) {
        (r.b = []), (r.d = []);
        var d,
          u = !1,
          h = [];
        function m(e, t) {
          var i, o, s, r, a, l;
          e &&
            (e =
              ((i = e),
              (o = n),
              (s = f),
              (r = t),
              "string" == typeof o.autoTrim
                ? (a = l = o.autoTrim)
                : Array.isArray(o.autoTrim) &&
                  ((a = o.autoTrim[1]), (l = o.autoTrim[0])),
              (s || !1 === s) && (a = s),
              (r || !1 === r) && (l = r),
              "slurp" === a && "slurp" === l
                ? i.trim()
                : ("_" === a || "slurp" === a
                    ? (i = String.prototype.trimLeft
                        ? i.trimLeft()
                        : i.replace(/^[\s\uFEFF\xA0]+/, ""))
                    : ("-" !== a && "nl" !== a) ||
                      (i = i.replace(/^(?:\n|\r|\r\n)/, "")),
                  "_" === l || "slurp" === l
                    ? (i = String.prototype.trimRight
                        ? i.trimRight()
                        : i.replace(/[\s\uFEFF\xA0]+$/, ""))
                    : ("-" !== l && "nl" !== l) ||
                      (i = i.replace(/(?:\n|\r|\r\n)$/, "")),
                  i))) &&
            ((e = e.replace(/\\|'/g, "\\$&").replace(/\r\n|\n|\r/g, "\\n")),
            h.push(e));
        }
        for (; null !== (d = a.exec(e)); ) {
          var v,
            y = d[1],
            b = d[2],
            k = d[3] || "";
          for (var x in o)
            if (o[x] === k) {
              v = x;
              break;
            }
          m(y, b),
            (p = d.index + d[0].length),
            v || i("unrecognized tag type: " + k, e, p);
          var C = g(d.index, v),
            w = C.t;
          if ("h" === w) {
            var S = C.n || "";
            n.async && l.test(S) && ((C.a = !0), (C.n = S.replace(l, ""))),
              (C = s(C)),
              h.push(C);
          } else if ("c" === w) {
            if (r.n === C.n) return u ? ((u.d = h), r.b.push(u)) : (r.d = h), r;
            i("Helper start and end don't match", e, d.index + d[0].length);
          } else if ("b" === w) {
            u ? ((u.d = h), r.b.push(u)) : (r.d = h);
            var T = C.n || "";
            n.async && l.test(T) && ((C.a = !0), (C.n = T.replace(l, ""))),
              (u = C),
              (h = []);
          } else if ("s" === w) {
            var _ = C.n || "";
            n.async && l.test(_) && ((C.a = !0), (C.n = _.replace(l, ""))),
              h.push(C);
          } else h.push(C);
        }
        if (!c) throw t('unclosed helper "' + r.n + '"');
        return m(e.slice(p, e.length), !1), (r.d = h), r;
      })({ f: [] }, !0);
      if (n.plugins)
        for (var v = 0; v < n.plugins.length; v++) {
          var y = n.plugins[v];
          y.processAST && (m.d = y.processAST(m.d, n));
        }
      return m.d;
    }
    function g(e, t) {
      var i = f(e, t),
        n =
          "var tR='';" +
          (t.useWith ? "with(" + t.varName + "||{}){" : "") +
          k(i, t) +
          "if(cb){cb(null,tR)} return tR" +
          (t.useWith ? "}" : "");
      if (t.plugins)
        for (var o = 0; o < t.plugins.length; o++) {
          var s = t.plugins[o];
          s.processFnString && (n = s.processFnString(n, t));
        }
      return n;
    }
    function m(e, t) {
      for (var i = 0; i < t.length; i++) {
        var n = t[i][0],
          o = t[i][1];
        (e = (t[i][2] ? "await " : "") + "c.l('F','" + n + "')(" + e),
          o && (e += "," + o),
          (e += ")");
      }
      return e;
    }
    function v(e, t, i, n, o, s) {
      var r =
        "{exec:" + (o ? "async " : "") + b(i, t, e) + ",params:[" + n + "]";
      return (
        s && (r += ",name:'" + s + "'"), o && (r += ",async:true"), (r += "}")
      );
    }
    function y(e, t) {
      for (var i = "[", n = 0; n < e.length; n++) {
        var o = e[n];
        (i += v(t, o.res || "", o.d, o.p || "", o.a, o.n)),
          n < e.length && (i += ",");
      }
      return i + "]";
    }
    function b(e, t, i) {
      return "function(" + t + "){var tR='';" + k(e, i) + "return tR}";
    }
    function k(e, t) {
      for (var i = 0, n = e.length, o = ""; i < n; i++) {
        var s = e[i];
        if ("string" == typeof s) o += "tR+='" + s + "';";
        else {
          var r = s.t,
            a = s.c || "",
            l = s.f,
            c = s.n || "",
            d = s.p || "",
            u = s.res || "",
            p = s.b,
            h = !!s.a;
          if ("i" === r) {
            t.defaultFilter &&
              (a = "c.l('F','" + t.defaultFilter + "')(" + a + ")");
            var f = m(a, l);
            !s.raw && t.autoEscape && (f = "c.l('F','e')(" + f + ")"),
              (o += "tR+=" + f + ";");
          } else if ("h" === r) {
            if (t.storage.nativeHelpers.get(c))
              o += t.storage.nativeHelpers.get(c)(s, t);
            else {
              var g =
                (h ? "await " : "") +
                "c.l('H','" +
                c +
                "')(" +
                v(t, u, s.d, d, h);
              (g += p ? "," + y(p, t) : ",[]"),
                (o += "tR+=" + m((g += ",c)"), l) + ";");
            }
          } else
            "s" === r
              ? (o +=
                  "tR+=" +
                  m(
                    (h ? "await " : "") +
                      "c.l('H','" +
                      c +
                      "')({params:[" +
                      d +
                      "]},[],c)",
                    l
                  ) +
                  ";")
              : "e" === r && (o += a + "\n");
        }
      }
      return o;
    }
    var x = (function () {
        function e(e) {
          this.cache = e;
        }
        return (
          (e.prototype.define = function (e, t) {
            this.cache[e] = t;
          }),
          (e.prototype.get = function (e) {
            return this.cache[e];
          }),
          (e.prototype.remove = function (e) {
            delete this.cache[e];
          }),
          (e.prototype.reset = function () {
            this.cache = {};
          }),
          (e.prototype.load = function (e) {
            a(this.cache, e, !0);
          }),
          e
        );
      })(),
      C = new x({});
    function w(e, i, n, o) {
      if (i && i.length > 0)
        throw t(
          (o ? "Native" : "") + "Helper '" + e + "' doesn't accept blocks"
        );
      if (n && n.length > 0)
        throw t(
          (o ? "Native" : "") + "Helper '" + e + "' doesn't accept filters"
        );
    }
    var S = new x({
        each: function (e, t) {
          var i = "",
            n = e.params[0];
          if ((w("each", t, !1), e.async))
            return new Promise(function (t) {
              !(function e(t, i, n, o, s) {
                n(t[i], i).then(function (r) {
                  (o += r), i === t.length - 1 ? s(o) : e(t, i + 1, n, o, s);
                });
              })(n, 0, e.exec, i, t);
            });
          for (var o = 0; o < n.length; o++) i += e.exec(n[o], o);
          return i;
        },
        foreach: function (e, t) {
          var i = e.params[0];
          if ((w("foreach", t, !1), e.async))
            return new Promise(function (t) {
              !(function e(t, i, n, o, s, r) {
                o(i[n], t[i[n]]).then(function (a) {
                  (s += a), n === i.length - 1 ? r(s) : e(t, i, n + 1, o, s, r);
                });
              })(i, Object.keys(i), 0, e.exec, "", t);
            });
          var n = "";
          for (var o in i) r(i, o) && (n += e.exec(o, i[o]));
          return n;
        },
        include: function (e, i, n) {
          w("include", i, !1);
          var o = n.storage.templates.get(e.params[0]);
          if (!o) throw t('Could not fetch template "' + e.params[0] + '"');
          return o(e.params[1], n);
        },
        extends: function (e, i, n) {
          var o = e.params[1] || {};
          o.content = e.exec();
          for (var s = 0; s < i.length; s++) {
            var r = i[s];
            o[r.name] = r.exec();
          }
          var a = n.storage.templates.get(e.params[0]);
          if (!a) throw t('Could not fetch template "' + e.params[0] + '"');
          return a(o, n);
        },
        useScope: function (e, t) {
          return w("useScope", t, !1), e.exec(e.params[0]);
        },
      }),
      T = new x({
        if: function (e, t) {
          w("if", !1, e.f, !0);
          var i = "if(" + e.p + "){" + k(e.d, t) + "}";
          if (e.b)
            for (var n = 0; n < e.b.length; n++) {
              var o = e.b[n];
              "else" === o.n
                ? (i += "else{" + k(o.d, t) + "}")
                : "elif" === o.n &&
                  (i += "else if(" + o.p + "){" + k(o.d, t) + "}");
            }
          return i;
        },
        try: function (e, i) {
          if (
            (w("try", !1, e.f, !0),
            !e.b || 1 !== e.b.length || "catch" !== e.b[0].n)
          )
            throw t("native helper 'try' only accepts 1 block, 'catch'");
          var n = "try{" + k(e.d, i) + "}",
            o = e.b[0];
          return (
            n +
            ("catch" + (o.res ? "(" + o.res + ")" : "") + "{" + k(o.d, i)) +
            "}"
          );
        },
        block: function (e, t) {
          return (
            w("block", e.b, e.f, !0),
            "if(!" +
              t.varName +
              "[" +
              e.p +
              "]){tR+=(" +
              b(e.d, "", t) +
              ")()}else{tR+=" +
              t.varName +
              "[" +
              e.p +
              "]}"
          );
        },
      }),
      _ = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
      };
    function E(e) {
      return _[e];
    }
    var P = new x({
        e: function (e) {
          var t = String(e);
          return /[&<>"']/.test(t) ? t.replace(/[&<>"']/g, E) : t;
        },
      }),
      A = {
        varName: "it",
        autoTrim: [!1, "nl"],
        autoEscape: !0,
        defaultFilter: !1,
        tags: ["{{", "}}"],
        l: function (e, i) {
          if ("H" === e) {
            var n = this.storage.helpers.get(i);
            if (n) return n;
            throw t("Can't find helper '" + i + "'");
          }
          if ("F" === e) {
            var o = this.storage.filters.get(i);
            if (o) return o;
            throw t("Can't find filter '" + i + "'");
          }
        },
        async: !1,
        storage: { helpers: S, nativeHelpers: T, filters: P, templates: C },
        prefixes: { h: "@", b: "#", i: "", r: "*", c: "/", e: "!" },
        cache: !1,
        plugins: [],
        useWith: !1,
      };
    function L(e, t) {
      var i = {};
      return a(i, A), t && a(i, t), e && a(i, e), i.l.bind(i), i;
    }
    function j(e, i) {
      var n = L(i || {}),
        s = Function;
      if (n.async) {
        if (!o) throw t("This environment doesn't support async/await");
        s = o;
      }
      try {
        return new s(n.varName, "c", "cb", g(e, n));
      } catch (r) {
        throw r instanceof SyntaxError
          ? t(
              "Bad template syntax\n\n" +
                r.message +
                "\n" +
                Array(r.message.length + 1).join("=") +
                "\n" +
                g(e, n)
            )
          : r;
      }
    }
    function I(e, t) {
      var i;
      return t.cache && t.name && t.storage.templates.get(t.name)
        ? t.storage.templates.get(t.name)
        : ((i = "function" == typeof e ? e : j(e, t)),
          t.cache && t.name && t.storage.templates.define(t.name, i),
          i);
    }
    A.l.bind(A),
      (e.compile = j),
      (e.compileScope = k),
      (e.compileScopeIntoFunction = b),
      (e.compileToString = g),
      (e.defaultConfig = A),
      (e.filters = P),
      (e.getConfig = L),
      (e.helpers = S),
      (e.nativeHelpers = T),
      (e.parse = f),
      (e.render = function (e, i, o, s) {
        var r = L(o || {});
        if (!r.async) return I(e, r)(i, r);
        if (!s) {
          if ("function" == typeof n)
            return new n(function (t, n) {
              try {
                t(I(e, r)(i, r));
              } catch (o) {
                n(o);
              }
            });
          throw t(
            "Please provide a callback function, this env doesn't support Promises"
          );
        }
        try {
          I(e, r)(i, r, s);
        } catch (a) {
          return s(a);
        }
      }),
      (e.templates = C),
      Object.defineProperty(e, "__esModule", { value: !0 });
  }),
  (function (e) {
    if ("object" == typeof exports && "undefined" != typeof module)
      module.exports = e();
    else if ("function" == typeof define && define.amd) define([], e);
    else {
      var t;
      (t =
        "undefined" != typeof window
          ? window
          : "undefined" != typeof global
          ? global
          : "undefined" != typeof self
          ? self
          : this).enquire = e();
    }
  })(function () {
    return (function e(t, i, n) {
      function o(r, a) {
        if (!i[r]) {
          if (!t[r]) {
            var l = "function" == typeof require && require;
            if (!a && l) return l(r, !0);
            if (s) return s(r, !0);
            var c = Error("Cannot find module '" + r + "'");
            throw ((c.code = "MODULE_NOT_FOUND"), c);
          }
          var d = (i[r] = { exports: {} });
          t[r][0].call(
            d.exports,
            function (e) {
              var i;
              return o(t[r][1][e] || e);
            },
            d,
            d.exports,
            e,
            t,
            i,
            n
          );
        }
        return i[r].exports;
      }
      for (
        var s = "function" == typeof require && require, r = 0;
        r < n.length;
        r++
      )
        o(n[r]);
      return o;
    })(
      {
        1: [
          function (e, t, i) {
            function n(e, t) {
              (this.query = e),
                (this.isUnconditional = t),
                (this.handlers = []),
                (this.mql = window.matchMedia(e));
              var i = this;
              (this.listener = function (e) {
                (i.mql = e.currentTarget || e), i.assess();
              }),
                this.mql.addListener(this.listener);
            }
            var o = e(3),
              s = e(4).each;
            (n.prototype = {
              constuctor: n,
              addHandler: function (e) {
                var t = new o(e);
                this.handlers.push(t), this.matches() && t.on();
              },
              removeHandler: function (e) {
                var t = this.handlers;
                s(t, function (i, n) {
                  if (i.equals(e)) return i.destroy(), !t.splice(n, 1);
                });
              },
              matches: function () {
                return this.mql.matches || this.isUnconditional;
              },
              clear: function () {
                s(this.handlers, function (e) {
                  e.destroy();
                }),
                  this.mql.removeListener(this.listener),
                  (this.handlers.length = 0);
              },
              assess: function () {
                var e = this.matches() ? "on" : "off";
                s(this.handlers, function (t) {
                  t[e]();
                });
              },
            }),
              (t.exports = n);
          },
          { 3: 3, 4: 4 },
        ],
        2: [
          function (e, t, i) {
            function n() {
              if (!window.matchMedia)
                throw Error(
                  "matchMedia not present, legacy browsers require a polyfill"
                );
              (this.queries = {}),
                (this.browserIsIncapable =
                  !window.matchMedia("only all").matches);
            }
            var o = e(1),
              s = e(4),
              r = s.each,
              a = s.isFunction,
              l = s.isArray;
            (n.prototype = {
              constructor: n,
              register: function (e, t, i) {
                var n = this.queries,
                  s = i && this.browserIsIncapable;
                return (
                  n[e] || (n[e] = new o(e, s)),
                  a(t) && (t = { match: t }),
                  l(t) || (t = [t]),
                  r(t, function (t) {
                    a(t) && (t = { match: t }), n[e].addHandler(t);
                  }),
                  this
                );
              },
              unregister: function (e, t) {
                var i = this.queries[e];
                return (
                  i &&
                    (t
                      ? i.removeHandler(t)
                      : (i.clear(), delete this.queries[e])),
                  this
                );
              },
            }),
              (t.exports = n);
          },
          { 1: 1, 4: 4 },
        ],
        3: [
          function (e, t, i) {
            function n(e) {
              (this.options = e), e.deferSetup || this.setup();
            }
            (n.prototype = {
              constructor: n,
              setup: function () {
                this.options.setup && this.options.setup(),
                  (this.initialised = !0);
              },
              on: function () {
                this.initialised || this.setup(),
                  this.options.match && this.options.match();
              },
              off: function () {
                this.options.unmatch && this.options.unmatch();
              },
              destroy: function () {
                this.options.destroy ? this.options.destroy() : this.off();
              },
              equals: function (e) {
                return this.options === e || this.options.match === e;
              },
            }),
              (t.exports = n);
          },
          {},
        ],
        4: [
          function (e, t, i) {
            t.exports = {
              isFunction: function e(t) {
                return "function" == typeof t;
              },
              isArray: function e(t) {
                return "[object Array]" === Object.prototype.toString.apply(t);
              },
              each: function e(t, i) {
                for (var n = 0, o = t.length; n < o && !1 !== i(t[n], n); n++);
              },
            };
          },
          {},
        ],
        5: [
          function (e, t, i) {
            var n = e(2);
            t.exports = new n();
          },
          { 2: 2 },
        ],
      },
      {},
      [5]
    )(5);
  }),
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define("jquery-bridget/jquery-bridget", ["jquery"], function (i) {
          return t(e, i);
        })
      : "object" == typeof module && module.exports
      ? (module.exports = t(e, require("jquery")))
      : (e.jQueryBridget = t(e, e.jQuery));
  })(window, function (e, t) {
    "use strict";
    var i = Array.prototype.slice,
      n = e.console,
      o =
        void 0 === n
          ? function () {}
          : function (e) {
              n.error(e);
            };
    function s(n, s, a) {
      (a = a || t || e.jQuery) &&
        (s.prototype.option ||
          (s.prototype.option = function (e) {
            a.isPlainObject(e) &&
              (this.options = a.extend(!0, this.options, e));
          }),
        (a.fn[n] = function (e) {
          if ("string" != typeof e)
            return (
              (u = e),
              this.each(function (e, t) {
                var i = a.data(t, n);
                i
                  ? (i.option(u), i._init())
                  : ((i = new s(t, u)), a.data(t, n, i));
              }),
              this
            );
          var t,
            r,
            l,
            c,
            d,
            u,
            p = i.call(arguments, 1);
          return (
            (l = p),
            (d = "$()." + n + '("' + (r = e) + '")'),
            (t = this).each(function (e, t) {
              var i = a.data(t, n);
              if (i) {
                var s = i[r];
                if (s && "_" != r.charAt(0)) {
                  var u = s.apply(i, l);
                  c = void 0 === c ? u : c;
                } else o(d + " is not a valid method");
              } else o(n + " not initialized. Cannot call methods, i.e. " + d);
            }),
            void 0 !== c ? c : t
          );
        }),
        r(a));
    }
    function r(e) {
      !e || (e && e.bridget) || (e.bridget = s);
    }
    return r(t || e.jQuery), s;
  }),
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define("ev-emitter/ev-emitter", t)
      : "object" == typeof module && module.exports
      ? (module.exports = t())
      : (e.EvEmitter = t());
  })("undefined" != typeof window ? window : this, function () {
    function e() {}
    var t = e.prototype;
    return (
      (t.on = function (e, t) {
        if (e && t) {
          var i = (this._events = this._events || {}),
            n = (i[e] = i[e] || []);
          return -1 == n.indexOf(t) && n.push(t), this;
        }
      }),
      (t.once = function (e, t) {
        if (e && t) {
          this.on(e, t);
          var i = (this._onceEvents = this._onceEvents || {});
          return ((i[e] = i[e] || {})[t] = !0), this;
        }
      }),
      (t.off = function (e, t) {
        var i = this._events && this._events[e];
        if (i && i.length) {
          var n = i.indexOf(t);
          return -1 != n && i.splice(n, 1), this;
        }
      }),
      (t.emitEvent = function (e, t) {
        var i = this._events && this._events[e];
        if (i && i.length) {
          (i = i.slice(0)), (t = t || []);
          for (
            var n = this._onceEvents && this._onceEvents[e], o = 0;
            o < i.length;
            o++
          ) {
            var s = i[o];
            n && n[s] && (this.off(e, s), delete n[s]), s.apply(this, t);
          }
          return this;
        }
      }),
      (t.allOff = function () {
        delete this._events, delete this._onceEvents;
      }),
      e
    );
  }),
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define("get-size/get-size", t)
      : "object" == typeof module && module.exports
      ? (module.exports = t())
      : (e.getSize = t());
  })(window, function () {
    "use strict";
    function e(e) {
      var t = parseFloat(e);
      return -1 == e.indexOf("%") && !isNaN(t) && t;
    }
    var t =
        "undefined" == typeof console
          ? function () {}
          : function (e) {
              console.error(e);
            },
      i = [
        "paddingLeft",
        "paddingRight",
        "paddingTop",
        "paddingBottom",
        "marginLeft",
        "marginRight",
        "marginTop",
        "marginBottom",
        "borderLeftWidth",
        "borderRightWidth",
        "borderTopWidth",
        "borderBottomWidth",
      ],
      n = i.length;
    function o(e) {
      var i = getComputedStyle(e);
      return (
        i ||
          t(
            "Style returned " +
              i +
              ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"
          ),
        i
      );
    }
    var s,
      r = !1;
    function a(t) {
      if (
        ((function () {
          if (!r) {
            r = !0;
            var t = document.createElement("div");
            (t.style.width = "200px"),
              (t.style.padding = "1px 2px 3px 4px"),
              (t.style.borderStyle = "solid"),
              (t.style.borderWidth = "1px 2px 3px 4px"),
              (t.style.boxSizing = "border-box");
            var i = document.body || document.documentElement;
            i.appendChild(t),
              (s = 200 == Math.round(e(o(t).width))),
              (a.isBoxSizeOuter = s),
              i.removeChild(t);
          }
        })(),
        "string" == typeof t && (t = document.querySelector(t)),
        t && "object" == typeof t && t.nodeType)
      ) {
        var l = o(t);
        if ("none" == l.display)
          return (function () {
            for (
              var e = {
                  width: 0,
                  height: 0,
                  innerWidth: 0,
                  innerHeight: 0,
                  outerWidth: 0,
                  outerHeight: 0,
                },
                t = 0;
              t < n;
              t++
            )
              e[i[t]] = 0;
            return e;
          })();
        var c = {};
        (c.width = t.offsetWidth), (c.height = t.offsetHeight);
        for (
          var d = (c.isBorderBox = "border-box" == l.boxSizing), u = 0;
          u < n;
          u++
        ) {
          var p = i[u],
            h = parseFloat(l[p]);
          c[p] = isNaN(h) ? 0 : h;
        }
        var f = c.paddingLeft + c.paddingRight,
          g = c.paddingTop + c.paddingBottom,
          m = c.marginLeft + c.marginRight,
          v = c.marginTop + c.marginBottom,
          y = c.borderLeftWidth + c.borderRightWidth,
          b = c.borderTopWidth + c.borderBottomWidth,
          k = d && s,
          x = e(l.width);
        !1 !== x && (c.width = x + (k ? 0 : f + y));
        var C = e(l.height);
        return (
          !1 !== C && (c.height = C + (k ? 0 : g + b)),
          (c.innerWidth = c.width - (f + y)),
          (c.innerHeight = c.height - (g + b)),
          (c.outerWidth = c.width + m),
          (c.outerHeight = c.height + v),
          c
        );
      }
    }
    return a;
  }),
  (function (e, t) {
    "use strict";
    "function" == typeof define && define.amd
      ? define("desandro-matches-selector/matches-selector", t)
      : "object" == typeof module && module.exports
      ? (module.exports = t())
      : (e.matchesSelector = t());
  })(window, function () {
    "use strict";
    var e = (function () {
      var e = window.Element.prototype;
      if (e.matches) return "matches";
      if (e.matchesSelector) return "matchesSelector";
      for (var t = ["webkit", "moz", "ms", "o"], i = 0; i < t.length; i++) {
        var n = t[i] + "MatchesSelector";
        if (e[n]) return n;
      }
    })();
    return function (t, i) {
      return t[e](i);
    };
  }),
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define(
          "fizzy-ui-utils/utils",
          ["desandro-matches-selector/matches-selector"],
          function (i) {
            return t(e, i);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = t(e, require("desandro-matches-selector")))
      : (e.fizzyUIUtils = t(e, e.matchesSelector));
  })(window, function (e, t) {
    var i = {
        extend: function (e, t) {
          for (var i in t) e[i] = t[i];
          return e;
        },
        modulo: function (e, t) {
          return ((e % t) + t) % t;
        },
      },
      n = Array.prototype.slice;
    (i.makeArray = function (e) {
      return Array.isArray(e)
        ? e
        : null == e
        ? []
        : "object" == typeof e && "number" == typeof e.length
        ? n.call(e)
        : [e];
    }),
      (i.removeFrom = function (e, t) {
        var i = e.indexOf(t);
        -1 != i && e.splice(i, 1);
      }),
      (i.getParent = function (e, i) {
        for (; e.parentNode && e != document.body; )
          if (t((e = e.parentNode), i)) return e;
      }),
      (i.getQueryElement = function (e) {
        return "string" == typeof e ? document.querySelector(e) : e;
      }),
      (i.handleEvent = function (e) {
        var t = "on" + e.type;
        this[t] && this[t](e);
      }),
      (i.filterFindElements = function (e, n) {
        e = i.makeArray(e);
        var o = [];
        return (
          e.forEach(function (e) {
            if (e instanceof HTMLElement) {
              if (n) {
                t(e, n) && o.push(e);
                for (var i = e.querySelectorAll(n), s = 0; s < i.length; s++)
                  o.push(i[s]);
              } else o.push(e);
            }
          }),
          o
        );
      }),
      (i.debounceMethod = function (e, t, i) {
        i = i || 100;
        var n = e.prototype[t],
          o = t + "Timeout";
        e.prototype[t] = function () {
          clearTimeout(this[o]);
          var e = arguments,
            t = this;
          this[o] = setTimeout(function () {
            n.apply(t, e), delete t[o];
          }, i);
        };
      }),
      (i.docReady = function (e) {
        var t = document.readyState;
        "complete" == t || "interactive" == t
          ? setTimeout(e)
          : document.addEventListener("DOMContentLoaded", e);
      }),
      (i.toDashed = function (e) {
        return e
          .replace(/(.)([A-Z])/g, function (e, t, i) {
            return t + "-" + i;
          })
          .toLowerCase();
      });
    var o = e.console;
    return (
      (i.htmlInit = function (t, n) {
        i.docReady(function () {
          var s = i.toDashed(n),
            r = "data-" + s,
            a = document.querySelectorAll("[" + r + "]"),
            l = document.querySelectorAll(".js-" + s),
            c = i.makeArray(a).concat(i.makeArray(l)),
            d = r + "-options",
            u = e.jQuery;
          c.forEach(function (e) {
            var i,
              s = e.getAttribute(r) || e.getAttribute(d);
            try {
              i = s && JSON.parse(s);
            } catch (a) {
              return void (
                o &&
                o.error("Error parsing " + r + " on " + e.className + ": " + a)
              );
            }
            var l = new t(e, i);
            u && u.data(e, n, l);
          });
        });
      }),
      i
    );
  }),
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define("flickity/js/cell", ["get-size/get-size"], function (i) {
          return t(e, i);
        })
      : "object" == typeof module && module.exports
      ? (module.exports = t(e, require("get-size")))
      : ((e.Flickity = e.Flickity || {}), (e.Flickity.Cell = t(e, e.getSize)));
  })(window, function (e, t) {
    function i(e, t) {
      (this.element = e), (this.parent = t), this.create();
    }
    var n = i.prototype;
    return (
      (n.create = function () {
        (this.element.style.position = "absolute"),
          this.element.setAttribute("aria-hidden", "true"),
          (this.x = 0),
          (this.shift = 0);
      }),
      (n.destroy = function () {
        this.unselect(), (this.element.style.position = "");
        var e = this.parent.originSide;
        this.element.style[e] = "";
      }),
      (n.getSize = function () {
        this.size = t(this.element);
      }),
      (n.setPosition = function (e) {
        (this.x = e), this.updateTarget(), this.renderPosition(e);
      }),
      (n.updateTarget = n.setDefaultTarget =
        function () {
          var e =
            "left" == this.parent.originSide ? "marginLeft" : "marginRight";
          this.target =
            this.x + this.size[e] + this.size.width * this.parent.cellAlign;
        }),
      (n.renderPosition = function (e) {
        var t = this.parent.originSide;
        this.element.style[t] = this.parent.getPositionValue(e);
      }),
      (n.select = function () {
        this.element.classList.add("is-selected"),
          this.element.removeAttribute("aria-hidden");
      }),
      (n.unselect = function () {
        this.element.classList.remove("is-selected"),
          this.element.setAttribute("aria-hidden", "true");
      }),
      (n.wrapShift = function (e) {
        (this.shift = e),
          this.renderPosition(this.x + this.parent.slideableWidth * e);
      }),
      (n.remove = function () {
        this.element.parentNode.removeChild(this.element);
      }),
      i
    );
  }),
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define("flickity/js/slide", t)
      : "object" == typeof module && module.exports
      ? (module.exports = t())
      : ((e.Flickity = e.Flickity || {}), (e.Flickity.Slide = t()));
  })(window, function () {
    "use strict";
    function e(e) {
      (this.parent = e),
        (this.isOriginLeft = "left" == e.originSide),
        (this.cells = []),
        (this.outerWidth = 0),
        (this.height = 0);
    }
    var t = e.prototype;
    return (
      (t.addCell = function (e) {
        if (
          (this.cells.push(e),
          (this.outerWidth += e.size.outerWidth),
          (this.height = Math.max(e.size.outerHeight, this.height)),
          1 == this.cells.length)
        ) {
          this.x = e.x;
          var t = this.isOriginLeft ? "marginLeft" : "marginRight";
          this.firstMargin = e.size[t];
        }
      }),
      (t.updateTarget = function () {
        var e = this.isOriginLeft ? "marginRight" : "marginLeft",
          t = this.getLastCell(),
          i = t ? t.size[e] : 0,
          n = this.outerWidth - (this.firstMargin + i);
        this.target = this.x + this.firstMargin + n * this.parent.cellAlign;
      }),
      (t.getLastCell = function () {
        return this.cells[this.cells.length - 1];
      }),
      (t.select = function () {
        this.cells.forEach(function (e) {
          e.select();
        });
      }),
      (t.unselect = function () {
        this.cells.forEach(function (e) {
          e.unselect();
        });
      }),
      (t.getCellElements = function () {
        return this.cells.map(function (e) {
          return e.element;
        });
      }),
      e
    );
  }),
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define("flickity/js/animate", ["fizzy-ui-utils/utils"], function (i) {
          return t(e, i);
        })
      : "object" == typeof module && module.exports
      ? (module.exports = t(e, require("fizzy-ui-utils")))
      : ((e.Flickity = e.Flickity || {}),
        (e.Flickity.animatePrototype = t(e, e.fizzyUIUtils)));
  })(window, function (e, t) {
    return {
      startAnimation: function () {
        this.isAnimating ||
          ((this.isAnimating = !0), (this.restingFrames = 0), this.animate());
      },
      animate: function () {
        this.applyDragForce(), this.applySelectedAttraction();
        var e = this.x;
        if (
          (this.integratePhysics(),
          this.positionSlider(),
          this.settle(e),
          this.isAnimating)
        ) {
          var t = this;
          requestAnimationFrame(function () {
            t.animate();
          });
        }
      },
      positionSlider: function () {
        var e = this.x;
        this.options.wrapAround &&
          1 < this.cells.length &&
          ((e = t.modulo(e, this.slideableWidth)),
          (e -= this.slideableWidth),
          this.shiftWrapCells(e)),
          this.setTranslateX(e, this.isAnimating),
          this.dispatchScrollEvent();
      },
      setTranslateX: function (e, t) {
        (e += this.cursorPosition), (e = this.options.rightToLeft ? -e : e);
        var i = this.getPositionValue(e);
        this.slider.style.transform = t
          ? "translate3d(" + i + ",0,0)"
          : "translateX(" + i + ")";
      },
      dispatchScrollEvent: function () {
        var e = this.slides[0];
        if (e) {
          var t = -this.x - e.target,
            i = t / this.slidesWidth;
          this.dispatchEvent("scroll", null, [i, t]);
        }
      },
      positionSliderAtSelected: function () {
        this.cells.length &&
          ((this.x = -this.selectedSlide.target),
          (this.velocity = 0),
          this.positionSlider());
      },
      getPositionValue: function (e) {
        return this.options.percentPosition
          ? 0.01 * Math.round((e / this.size.innerWidth) * 1e4) + "%"
          : Math.round(e) + "px";
      },
      settle: function (e) {
        this.isPointerDown ||
          Math.round(100 * this.x) != Math.round(100 * e) ||
          this.restingFrames++,
          2 < this.restingFrames &&
            ((this.isAnimating = !1),
            delete this.isFreeScrolling,
            this.positionSlider(),
            this.dispatchEvent("settle", null, [this.selectedIndex]));
      },
      shiftWrapCells: function (e) {
        var t = this.cursorPosition + e;
        this._shiftCells(this.beforeShiftCells, t, -1);
        var i =
          this.size.innerWidth -
          (e + this.slideableWidth + this.cursorPosition);
        this._shiftCells(this.afterShiftCells, i, 1);
      },
      _shiftCells: function (e, t, i) {
        for (var n = 0; n < e.length; n++) {
          var o = e[n],
            s = 0 < t ? i : 0;
          o.wrapShift(s), (t -= o.size.outerWidth);
        }
      },
      _unshiftCells: function (e) {
        if (e && e.length) for (var t = 0; t < e.length; t++) e[t].wrapShift(0);
      },
      integratePhysics: function () {
        (this.x += this.velocity), (this.velocity *= this.getFrictionFactor());
      },
      applyForce: function (e) {
        this.velocity += e;
      },
      getFrictionFactor: function () {
        return (
          1 -
          this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"]
        );
      },
      getRestingPosition: function () {
        return this.x + this.velocity / (1 - this.getFrictionFactor());
      },
      applyDragForce: function () {
        if (this.isDraggable && this.isPointerDown) {
          var e = this.dragX - this.x - this.velocity;
          this.applyForce(e);
        }
      },
      applySelectedAttraction: function () {
        if (
          !(this.isDraggable && this.isPointerDown) &&
          !this.isFreeScrolling &&
          this.slides.length
        ) {
          var e =
            (-1 * this.selectedSlide.target - this.x) *
            this.options.selectedAttraction;
          this.applyForce(e);
        }
      },
    };
  }),
  (function (e, t) {
    if ("function" == typeof define && define.amd)
      define("flickity/js/flickity", [
        "ev-emitter/ev-emitter",
        "get-size/get-size",
        "fizzy-ui-utils/utils",
        "./cell",
        "./slide",
        "./animate",
      ], function (i, n, o, s, r, a) {
        return t(e, i, n, o, s, r, a);
      });
    else if ("object" == typeof module && module.exports)
      module.exports = t(
        e,
        require("ev-emitter"),
        require("get-size"),
        require("fizzy-ui-utils"),
        require("./cell"),
        require("./slide"),
        require("./animate")
      );
    else {
      var i = e.Flickity;
      e.Flickity = t(
        e,
        e.EvEmitter,
        e.getSize,
        e.fizzyUIUtils,
        i.Cell,
        i.Slide,
        i.animatePrototype
      );
    }
  })(window, function (e, t, i, n, o, s, r) {
    var a = e.jQuery,
      l = e.getComputedStyle,
      c = e.console;
    function d(e, t) {
      for (e = n.makeArray(e); e.length; ) t.appendChild(e.shift());
    }
    var u = 0,
      p = {};
    function h(e, t) {
      var i = n.getQueryElement(e);
      if (i) {
        if (((this.element = i), this.element.flickityGUID)) {
          var o = p[this.element.flickityGUID];
          return o.option(t), o;
        }
        a && (this.$element = a(this.element)),
          (this.options = n.extend({}, this.constructor.defaults)),
          this.option(t),
          this._create();
      } else c && c.error("Bad element for Flickity: " + (i || e));
    }
    (h.defaults = {
      accessibility: !0,
      cellAlign: "center",
      freeScrollFriction: 0.075,
      friction: 0.28,
      namespaceJQueryEvents: !0,
      percentPosition: !0,
      resize: !0,
      selectedAttraction: 0.025,
      setGallerySize: !0,
    }),
      (h.createMethods = []);
    var f = h.prototype;
    n.extend(f, t.prototype),
      (f._create = function () {
        var t = (this.guid = ++u);
        for (var i in ((this.element.flickityGUID = t),
        ((p[t] = this).selectedIndex = 0),
        (this.restingFrames = 0),
        (this.x = 0),
        (this.velocity = 0),
        (this.originSide = this.options.rightToLeft ? "right" : "left"),
        (this.viewport = document.createElement("div")),
        (this.viewport.className = "flickity-viewport"),
        this._createSlider(),
        (this.options.resize || this.options.watchCSS) &&
          e.addEventListener("resize", this),
        this.options.on)) {
          var n = this.options.on[i];
          this.on(i, n);
        }
        h.createMethods.forEach(function (e) {
          this[e]();
        }, this),
          this.options.watchCSS ? this.watchCSS() : this.activate();
      }),
      (f.option = function (e) {
        n.extend(this.options, e);
      }),
      (f.activate = function () {
        this.isActive ||
          ((this.isActive = !0),
          this.element.classList.add("flickity-enabled"),
          this.options.rightToLeft &&
            this.element.classList.add("flickity-rtl"),
          this.getSize(),
          d(this._filterFindCellElements(this.element.children), this.slider),
          this.viewport.appendChild(this.slider),
          this.element.appendChild(this.viewport),
          this.reloadCells(),
          this.options.accessibility &&
            ((this.element.tabIndex = 0),
            this.element.addEventListener("keydown", this)),
          this.emitEvent("activate"),
          this.selectInitialIndex(),
          (this.isInitActivated = !0),
          this.dispatchEvent("ready"));
      }),
      (f._createSlider = function () {
        var e = document.createElement("div");
        (e.className = "flickity-slider"),
          (e.style[this.originSide] = 0),
          (this.slider = e);
      }),
      (f._filterFindCellElements = function (e) {
        return n.filterFindElements(e, this.options.cellSelector);
      }),
      (f.reloadCells = function () {
        (this.cells = this._makeCells(this.slider.children)),
          this.positionCells(),
          this._getWrapShiftCells(),
          this.setGallerySize();
      }),
      (f._makeCells = function (e) {
        return this._filterFindCellElements(e).map(function (e) {
          return new o(e, this);
        }, this);
      }),
      (f.getLastCell = function () {
        return this.cells[this.cells.length - 1];
      }),
      (f.getLastSlide = function () {
        return this.slides[this.slides.length - 1];
      }),
      (f.positionCells = function () {
        this._sizeCells(this.cells), this._positionCells(0);
      }),
      (f._positionCells = function (e) {
        (e = e || 0), (this.maxCellHeight = (e && this.maxCellHeight) || 0);
        var t = 0;
        if (0 < e) {
          var i = this.cells[e - 1];
          t = i.x + i.size.outerWidth;
        }
        for (var n = this.cells.length, o = e; o < n; o++) {
          var s = this.cells[o];
          s.setPosition(t),
            (t += s.size.outerWidth),
            (this.maxCellHeight = Math.max(
              s.size.outerHeight,
              this.maxCellHeight
            ));
        }
        (this.slideableWidth = t),
          this.updateSlides(),
          this._containSlides(),
          (this.slidesWidth = n
            ? this.getLastSlide().target - this.slides[0].target
            : 0);
      }),
      (f._sizeCells = function (e) {
        e.forEach(function (e) {
          e.getSize();
        });
      }),
      (f.updateSlides = function () {
        if (((this.slides = []), this.cells.length)) {
          var e = new s(this);
          this.slides.push(e);
          var t = "left" == this.originSide ? "marginRight" : "marginLeft",
            i = this._getCanCellFit();
          this.cells.forEach(function (n, o) {
            if (e.cells.length) {
              var r =
                e.outerWidth - e.firstMargin + (n.size.outerWidth - n.size[t]);
              i.call(this, o, r) ||
                (e.updateTarget(), (e = new s(this)), this.slides.push(e)),
                e.addCell(n);
            } else e.addCell(n);
          }, this),
            e.updateTarget(),
            this.updateSelectedSlide();
        }
      }),
      (f._getCanCellFit = function () {
        var e = this.options.groupCells;
        if (!e)
          return function () {
            return !1;
          };
        if ("number" == typeof e) {
          var t = parseInt(e, 10);
          return function (e) {
            return e % t != 0;
          };
        }
        var i = "string" == typeof e && e.match(/^(\d+)%$/),
          n = i ? parseInt(i[1], 10) / 100 : 1;
        return function (e, t) {
          return t <= (this.size.innerWidth + 1) * n;
        };
      }),
      (f._init = f.reposition =
        function () {
          this.positionCells(), this.positionSliderAtSelected();
        }),
      (f.getSize = function () {
        (this.size = i(this.element)),
          this.setCellAlign(),
          (this.cursorPosition = this.size.innerWidth * this.cellAlign);
      });
    var g = {
      center: { left: 0.5, right: 0.5 },
      left: { left: 0, right: 1 },
      right: { right: 0, left: 1 },
    };
    return (
      (f.setCellAlign = function () {
        var e = g[this.options.cellAlign];
        this.cellAlign = e ? e[this.originSide] : this.options.cellAlign;
      }),
      (f.setGallerySize = function () {
        if (this.options.setGallerySize) {
          var e =
            this.options.adaptiveHeight && this.selectedSlide
              ? this.selectedSlide.height
              : this.maxCellHeight;
          this.viewport.style.height = e + "px";
        }
      }),
      (f._getWrapShiftCells = function () {
        if (this.options.wrapAround) {
          this._unshiftCells(this.beforeShiftCells),
            this._unshiftCells(this.afterShiftCells);
          var e = this.cursorPosition,
            t = this.cells.length - 1;
          (this.beforeShiftCells = this._getGapCells(e, t, -1)),
            (e = this.size.innerWidth - this.cursorPosition),
            (this.afterShiftCells = this._getGapCells(e, 0, 1));
        }
      }),
      (f._getGapCells = function (e, t, i) {
        for (var n = []; 0 < e; ) {
          var o = this.cells[t];
          if (!o) break;
          n.push(o), (t += i), (e -= o.size.outerWidth);
        }
        return n;
      }),
      (f._containSlides = function () {
        if (
          this.options.contain &&
          !this.options.wrapAround &&
          this.cells.length
        ) {
          var e = this.options.rightToLeft,
            t =
              this.slideableWidth -
              this.getLastCell().size[e ? "marginLeft" : "marginRight"],
            i = t < this.size.innerWidth,
            n =
              this.cursorPosition +
              this.cells[0].size[e ? "marginRight" : "marginLeft"],
            o = t - this.size.innerWidth * (1 - this.cellAlign);
          this.slides.forEach(function (e) {
            i
              ? (e.target = t * this.cellAlign)
              : ((e.target = Math.max(e.target, n)),
                (e.target = Math.min(e.target, o)));
          }, this);
        }
      }),
      (f.dispatchEvent = function (e, t, i) {
        var n = t ? [t].concat(i) : i;
        if ((this.emitEvent(e, n), a && this.$element)) {
          var o = (e += this.options.namespaceJQueryEvents ? ".flickity" : "");
          if (t) {
            var s = a.Event(t);
            (s.type = e), (o = s);
          }
          this.$element.trigger(o, i);
        }
      }),
      (f.select = function (e, t, i) {
        if (
          this.isActive &&
          ((e = parseInt(e, 10)),
          this._wrapSelect(e),
          (this.options.wrapAround || t) &&
            (e = n.modulo(e, this.slides.length)),
          this.slides[e])
        ) {
          var o = this.selectedIndex;
          (this.selectedIndex = e),
            this.updateSelectedSlide(),
            i ? this.positionSliderAtSelected() : this.startAnimation(),
            this.options.adaptiveHeight && this.setGallerySize(),
            this.dispatchEvent("select", null, [e]),
            e != o && this.dispatchEvent("change", null, [e]),
            this.dispatchEvent("cellSelect");
        }
      }),
      (f._wrapSelect = function (e) {
        var t = this.slides.length;
        if (!(this.options.wrapAround && 1 < t)) return e;
        var i = n.modulo(e, t),
          o = Math.abs(i - this.selectedIndex),
          s = Math.abs(i + t - this.selectedIndex),
          r = Math.abs(i - t - this.selectedIndex);
        !this.isDragSelect && s < o
          ? (e += t)
          : !this.isDragSelect && r < o && (e -= t),
          e < 0
            ? (this.x -= this.slideableWidth)
            : t <= e && (this.x += this.slideableWidth);
      }),
      (f.previous = function (e, t) {
        this.select(this.selectedIndex - 1, e, t);
      }),
      (f.next = function (e, t) {
        this.select(this.selectedIndex + 1, e, t);
      }),
      (f.updateSelectedSlide = function () {
        var e = this.slides[this.selectedIndex];
        e &&
          (this.unselectSelectedSlide(),
          (this.selectedSlide = e).select(),
          (this.selectedCells = e.cells),
          (this.selectedElements = e.getCellElements()),
          (this.selectedCell = e.cells[0]),
          (this.selectedElement = this.selectedElements[0]));
      }),
      (f.unselectSelectedSlide = function () {
        this.selectedSlide && this.selectedSlide.unselect();
      }),
      (f.selectInitialIndex = function () {
        var e = this.options.initialIndex;
        if (this.isInitActivated) this.select(this.selectedIndex, !1, !0);
        else {
          if (e && "string" == typeof e && this.queryCell(e))
            return void this.selectCell(e, !1, !0);
          var t = 0;
          e && this.slides[e] && (t = e), this.select(t, !1, !0);
        }
      }),
      (f.selectCell = function (e, t, i) {
        var n = this.queryCell(e);
        if (n) {
          var o = this.getCellSlideIndex(n);
          this.select(o, t, i);
        }
      }),
      (f.getCellSlideIndex = function (e) {
        for (var t = 0; t < this.slides.length; t++)
          if (-1 != this.slides[t].cells.indexOf(e)) return t;
      }),
      (f.getCell = function (e) {
        for (var t = 0; t < this.cells.length; t++) {
          var i = this.cells[t];
          if (i.element == e) return i;
        }
      }),
      (f.getCells = function (e) {
        e = n.makeArray(e);
        var t = [];
        return (
          e.forEach(function (e) {
            var i = this.getCell(e);
            i && t.push(i);
          }, this),
          t
        );
      }),
      (f.getCellElements = function () {
        return this.cells.map(function (e) {
          return e.element;
        });
      }),
      (f.getParentCell = function (e) {
        return (
          this.getCell(e) ||
          ((e = n.getParent(e, ".flickity-slider > *")), this.getCell(e))
        );
      }),
      (f.getAdjacentCellElements = function (e, t) {
        if (!e) return this.selectedSlide.getCellElements();
        t = void 0 === t ? this.selectedIndex : t;
        var i = this.slides.length;
        if (i <= 1 + 2 * e) return this.getCellElements();
        for (var o = [], s = t - e; s <= t + e; s++) {
          var r = this.options.wrapAround ? n.modulo(s, i) : s,
            a = this.slides[r];
          a && (o = o.concat(a.getCellElements()));
        }
        return o;
      }),
      (f.queryCell = function (e) {
        if ("number" == typeof e) return this.cells[e];
        if ("string" == typeof e) {
          if (e.match(/^[#\.]?[\d\/]/)) return;
          e = this.element.querySelector(e);
        }
        return this.getCell(e);
      }),
      (f.uiChange = function () {
        this.emitEvent("uiChange");
      }),
      (f.childUIPointerDown = function (e) {
        "touchstart" != e.type && e.preventDefault(), this.focus();
      }),
      (f.onresize = function () {
        this.watchCSS(), this.resize();
      }),
      n.debounceMethod(h, "onresize", 150),
      (f.resize = function () {
        if (this.isActive) {
          this.getSize(),
            this.options.wrapAround &&
              (this.x = n.modulo(this.x, this.slideableWidth)),
            this.positionCells(),
            this._getWrapShiftCells(),
            this.setGallerySize(),
            this.emitEvent("resize");
          var e = this.selectedElements && this.selectedElements[0];
          this.selectCell(e, !1, !0);
        }
      }),
      (f.watchCSS = function () {
        this.options.watchCSS &&
          (-1 != l(this.element, ":after").content.indexOf("flickity")
            ? this.activate()
            : this.deactivate());
      }),
      (f.onkeydown = function (e) {
        var t =
          document.activeElement && document.activeElement != this.element;
        if (this.options.accessibility && !t) {
          var i = h.keyboardHandlers[e.keyCode];
          i && i.call(this);
        }
      }),
      (h.keyboardHandlers = {
        37: function () {
          var e = this.options.rightToLeft ? "next" : "previous";
          this.uiChange(), this[e]();
        },
        39: function () {
          var e = this.options.rightToLeft ? "previous" : "next";
          this.uiChange(), this[e]();
        },
      }),
      (f.focus = function () {
        var t = e.pageYOffset;
        this.element.focus({ preventScroll: !0 }),
          e.pageYOffset != t && e.scrollTo(e.pageXOffset, t);
      }),
      (f.deactivate = function () {
        this.isActive &&
          (this.element.classList.remove("flickity-enabled"),
          this.element.classList.remove("flickity-rtl"),
          this.unselectSelectedSlide(),
          this.cells.forEach(function (e) {
            e.destroy();
          }),
          this.element.removeChild(this.viewport),
          d(this.slider.children, this.element),
          this.options.accessibility &&
            (this.element.removeAttribute("tabIndex"),
            this.element.removeEventListener("keydown", this)),
          (this.isActive = !1),
          this.emitEvent("deactivate"));
      }),
      (f.destroy = function () {
        this.deactivate(),
          e.removeEventListener("resize", this),
          this.allOff(),
          this.emitEvent("destroy"),
          a && this.$element && a.removeData(this.element, "flickity"),
          delete this.element.flickityGUID,
          delete p[this.guid];
      }),
      n.extend(f, r),
      (h.data = function (e) {
        var t = (e = n.getQueryElement(e)) && e.flickityGUID;
        return t && p[t];
      }),
      n.htmlInit(h, "flickity"),
      a && a.bridget && a.bridget("flickity", h),
      (h.setJQuery = function (e) {
        a = e;
      }),
      (h.Cell = o),
      (h.Slide = s),
      h
    );
  }),
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define(
          "unipointer/unipointer",
          ["ev-emitter/ev-emitter"],
          function (i) {
            return t(e, i);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = t(e, require("ev-emitter")))
      : (e.Unipointer = t(e, e.EvEmitter));
  })(window, function (e, t) {
    function i() {}
    var n = (i.prototype = Object.create(t.prototype));
    (n.bindStartEvent = function (e) {
      this._bindStartEvent(e, !0);
    }),
      (n.unbindStartEvent = function (e) {
        this._bindStartEvent(e, !1);
      }),
      (n._bindStartEvent = function (t, i) {
        var n = (i = void 0 === i || i)
            ? "addEventListener"
            : "removeEventListener",
          o = "mousedown";
        e.PointerEvent
          ? (o = "pointerdown")
          : "ontouchstart" in e && (o = "touchstart"),
          t[n](o, this);
      }),
      (n.handleEvent = function (e) {
        var t = "on" + e.type;
        this[t] && this[t](e);
      }),
      (n.getTouch = function (e) {
        for (var t = 0; t < e.length; t++) {
          var i = e[t];
          if (i.identifier == this.pointerIdentifier) return i;
        }
      }),
      (n.onmousedown = function (e) {
        var t = e.button;
        (t && 0 !== t && 1 !== t) || this._pointerDown(e, e);
      }),
      (n.ontouchstart = function (e) {
        this._pointerDown(e, e.changedTouches[0]);
      }),
      (n.onpointerdown = function (e) {
        this._pointerDown(e, e);
      }),
      (n._pointerDown = function (e, t) {
        e.button ||
          this.isPointerDown ||
          ((this.isPointerDown = !0),
          (this.pointerIdentifier =
            void 0 !== t.pointerId ? t.pointerId : t.identifier),
          this.pointerDown(e, t));
      }),
      (n.pointerDown = function (e, t) {
        this._bindPostStartEvents(e), this.emitEvent("pointerDown", [e, t]);
      });
    var o = {
      mousedown: ["mousemove", "mouseup"],
      touchstart: ["touchmove", "touchend", "touchcancel"],
      pointerdown: ["pointermove", "pointerup", "pointercancel"],
    };
    return (
      (n._bindPostStartEvents = function (t) {
        if (t) {
          var i = o[t.type];
          i.forEach(function (t) {
            e.addEventListener(t, this);
          }, this),
            (this._boundPointerEvents = i);
        }
      }),
      (n._unbindPostStartEvents = function () {
        this._boundPointerEvents &&
          (this._boundPointerEvents.forEach(function (t) {
            e.removeEventListener(t, this);
          }, this),
          delete this._boundPointerEvents);
      }),
      (n.onmousemove = function (e) {
        this._pointerMove(e, e);
      }),
      (n.onpointermove = function (e) {
        e.pointerId == this.pointerIdentifier && this._pointerMove(e, e);
      }),
      (n.ontouchmove = function (e) {
        var t = this.getTouch(e.changedTouches);
        t && this._pointerMove(e, t);
      }),
      (n._pointerMove = function (e, t) {
        this.pointerMove(e, t);
      }),
      (n.pointerMove = function (e, t) {
        this.emitEvent("pointerMove", [e, t]);
      }),
      (n.onmouseup = function (e) {
        this._pointerUp(e, e);
      }),
      (n.onpointerup = function (e) {
        e.pointerId == this.pointerIdentifier && this._pointerUp(e, e);
      }),
      (n.ontouchend = function (e) {
        var t = this.getTouch(e.changedTouches);
        t && this._pointerUp(e, t);
      }),
      (n._pointerUp = function (e, t) {
        this._pointerDone(), this.pointerUp(e, t);
      }),
      (n.pointerUp = function (e, t) {
        this.emitEvent("pointerUp", [e, t]);
      }),
      (n._pointerDone = function () {
        this._pointerReset(), this._unbindPostStartEvents(), this.pointerDone();
      }),
      (n._pointerReset = function () {
        (this.isPointerDown = !1), delete this.pointerIdentifier;
      }),
      (n.pointerDone = function () {}),
      (n.onpointercancel = function (e) {
        e.pointerId == this.pointerIdentifier && this._pointerCancel(e, e);
      }),
      (n.ontouchcancel = function (e) {
        var t = this.getTouch(e.changedTouches);
        t && this._pointerCancel(e, t);
      }),
      (n._pointerCancel = function (e, t) {
        this._pointerDone(), this.pointerCancel(e, t);
      }),
      (n.pointerCancel = function (e, t) {
        this.emitEvent("pointerCancel", [e, t]);
      }),
      (i.getPointerPoint = function (e) {
        return { x: e.pageX, y: e.pageY };
      }),
      i
    );
  }),
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define(
          "unidragger/unidragger",
          ["unipointer/unipointer"],
          function (i) {
            return t(e, i);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = t(e, require("unipointer")))
      : (e.Unidragger = t(e, e.Unipointer));
  })(window, function (e, t) {
    function i() {}
    var n = (i.prototype = Object.create(t.prototype));
    (n.bindHandles = function () {
      this._bindHandles(!0);
    }),
      (n.unbindHandles = function () {
        this._bindHandles(!1);
      }),
      (n._bindHandles = function (t) {
        for (
          var i = (t = void 0 === t || t)
              ? "addEventListener"
              : "removeEventListener",
            n = t ? this._touchActionValue : "",
            o = 0;
          o < this.handles.length;
          o++
        ) {
          var s = this.handles[o];
          this._bindStartEvent(s, t),
            s[i]("click", this),
            e.PointerEvent && (s.style.touchAction = n);
        }
      }),
      (n._touchActionValue = "none"),
      (n.pointerDown = function (e, t) {
        this.okayPointerDown(e) &&
          ((this.pointerDownPointer = t),
          e.preventDefault(),
          this.pointerDownBlur(),
          this._bindPostStartEvents(e),
          this.emitEvent("pointerDown", [e, t]));
      });
    var o = { TEXTAREA: !0, INPUT: !0, SELECT: !0, OPTION: !0 },
      s = {
        radio: !0,
        checkbox: !0,
        button: !0,
        submit: !0,
        image: !0,
        file: !0,
      };
    return (
      (n.okayPointerDown = function (e) {
        var t = o[e.target.nodeName],
          i = s[e.target.type],
          n = !t || i;
        return n || this._pointerReset(), n;
      }),
      (n.pointerDownBlur = function () {
        var e = document.activeElement;
        e && e.blur && e != document.body && e.blur();
      }),
      (n.pointerMove = function (e, t) {
        var i = this._dragPointerMove(e, t);
        this.emitEvent("pointerMove", [e, t, i]), this._dragMove(e, t, i);
      }),
      (n._dragPointerMove = function (e, t) {
        var i = {
          x: t.pageX - this.pointerDownPointer.pageX,
          y: t.pageY - this.pointerDownPointer.pageY,
        };
        return (
          !this.isDragging && this.hasDragStarted(i) && this._dragStart(e, t), i
        );
      }),
      (n.hasDragStarted = function (e) {
        return 3 < Math.abs(e.x) || 3 < Math.abs(e.y);
      }),
      (n.pointerUp = function (e, t) {
        this.emitEvent("pointerUp", [e, t]), this._dragPointerUp(e, t);
      }),
      (n._dragPointerUp = function (e, t) {
        this.isDragging ? this._dragEnd(e, t) : this._staticClick(e, t);
      }),
      (n._dragStart = function (e, t) {
        (this.isDragging = !0),
          (this.isPreventingClicks = !0),
          this.dragStart(e, t);
      }),
      (n.dragStart = function (e, t) {
        this.emitEvent("dragStart", [e, t]);
      }),
      (n._dragMove = function (e, t, i) {
        this.isDragging && this.dragMove(e, t, i);
      }),
      (n.dragMove = function (e, t, i) {
        e.preventDefault(), this.emitEvent("dragMove", [e, t, i]);
      }),
      (n._dragEnd = function (e, t) {
        (this.isDragging = !1),
          setTimeout(
            function () {
              delete this.isPreventingClicks;
            }.bind(this)
          ),
          this.dragEnd(e, t);
      }),
      (n.dragEnd = function (e, t) {
        this.emitEvent("dragEnd", [e, t]);
      }),
      (n.onclick = function (e) {
        this.isPreventingClicks && e.preventDefault();
      }),
      (n._staticClick = function (e, t) {
        (this.isIgnoringMouseUp && "mouseup" == e.type) ||
          (this.staticClick(e, t),
          "mouseup" != e.type &&
            ((this.isIgnoringMouseUp = !0),
            setTimeout(
              function () {
                delete this.isIgnoringMouseUp;
              }.bind(this),
              400
            )));
      }),
      (n.staticClick = function (e, t) {
        this.emitEvent("staticClick", [e, t]);
      }),
      (i.getPointerPoint = t.getPointerPoint),
      i
    );
  }),
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define(
          "flickity/js/drag",
          ["./flickity", "unidragger/unidragger", "fizzy-ui-utils/utils"],
          function (i, n, o) {
            return t(e, i, n, o);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = t(
          e,
          require("./flickity"),
          require("unidragger"),
          require("fizzy-ui-utils")
        ))
      : (e.Flickity = t(e, e.Flickity, e.Unidragger, e.fizzyUIUtils));
  })(window, function (e, t, i, n) {
    n.extend(t.defaults, { draggable: ">1", dragThreshold: 3 }),
      t.createMethods.push("_createDrag");
    var o = t.prototype;
    n.extend(o, i.prototype), (o._touchActionValue = "pan-y");
    var s = "createTouch" in document,
      r = !1;
    (o._createDrag = function () {
      this.on("activate", this.onActivateDrag),
        this.on("uiChange", this._uiChangeDrag),
        this.on("deactivate", this.onDeactivateDrag),
        this.on("cellChange", this.updateDraggable),
        s && !r && (e.addEventListener("touchmove", function () {}), (r = !0));
    }),
      (o.onActivateDrag = function () {
        (this.handles = [this.viewport]),
          this.bindHandles(),
          this.updateDraggable();
      }),
      (o.onDeactivateDrag = function () {
        this.unbindHandles(), this.element.classList.remove("is-draggable");
      }),
      (o.updateDraggable = function () {
        ">1" == this.options.draggable
          ? (this.isDraggable = 1 < this.slides.length)
          : (this.isDraggable = this.options.draggable),
          this.isDraggable
            ? this.element.classList.add("is-draggable")
            : this.element.classList.remove("is-draggable");
      }),
      (o.bindDrag = function () {
        (this.options.draggable = !0), this.updateDraggable();
      }),
      (o.unbindDrag = function () {
        (this.options.draggable = !1), this.updateDraggable();
      }),
      (o._uiChangeDrag = function () {
        delete this.isFreeScrolling;
      }),
      (o.pointerDown = function (t, i) {
        this.isDraggable
          ? this.okayPointerDown(t) &&
            (this._pointerDownPreventDefault(t),
            this.pointerDownFocus(t),
            document.activeElement != this.element && this.pointerDownBlur(),
            (this.dragX = this.x),
            this.viewport.classList.add("is-pointer-down"),
            (this.pointerDownScroll = l()),
            e.addEventListener("scroll", this),
            this._pointerDownDefault(t, i))
          : this._pointerDownDefault(t, i);
      }),
      (o._pointerDownDefault = function (e, t) {
        (this.pointerDownPointer = { pageX: t.pageX, pageY: t.pageY }),
          this._bindPostStartEvents(e),
          this.dispatchEvent("pointerDown", e, [t]);
      });
    var a = { INPUT: !0, TEXTAREA: !0, SELECT: !0 };
    function l() {
      return { x: e.pageXOffset, y: e.pageYOffset };
    }
    return (
      (o.pointerDownFocus = function (e) {
        a[e.target.nodeName] || this.focus();
      }),
      (o._pointerDownPreventDefault = function (e) {
        var t = "touchstart" == e.type,
          i = "touch" == e.pointerType,
          n = a[e.target.nodeName];
        t || i || n || e.preventDefault();
      }),
      (o.hasDragStarted = function (e) {
        return Math.abs(e.x) > this.options.dragThreshold;
      }),
      (o.pointerUp = function (e, t) {
        delete this.isTouchScrolling,
          this.viewport.classList.remove("is-pointer-down"),
          this.dispatchEvent("pointerUp", e, [t]),
          this._dragPointerUp(e, t);
      }),
      (o.pointerDone = function () {
        e.removeEventListener("scroll", this), delete this.pointerDownScroll;
      }),
      (o.dragStart = function (t, i) {
        this.isDraggable &&
          ((this.dragStartPosition = this.x),
          this.startAnimation(),
          e.removeEventListener("scroll", this),
          this.dispatchEvent("dragStart", t, [i]));
      }),
      (o.pointerMove = function (e, t) {
        var i = this._dragPointerMove(e, t);
        this.dispatchEvent("pointerMove", e, [t, i]), this._dragMove(e, t, i);
      }),
      (o.dragMove = function (e, t, i) {
        if (this.isDraggable) {
          e.preventDefault();
          var n = this.options.rightToLeft ? -1 : 1;
          this.options.wrapAround && (i.x = i.x % this.slideableWidth);
          var o = this.dragStartPosition + i.x * n;
          if (!this.options.wrapAround && this.slides.length) {
            var s = Math.max(-this.slides[0].target, this.dragStartPosition);
            o = s < o ? 0.5 * (o + s) : o;
            var r = Math.min(
              -this.getLastSlide().target,
              this.dragStartPosition
            );
            o = o < r ? 0.5 * (o + r) : o;
          }
          this.dragX !== o && (this.previousDragX = this.dragX),
            (this.dragX = o),
            (this.dragMoveTime = new Date()),
            this.dispatchEvent("dragMove", e, [t, i]);
        }
      }),
      (o.dragEnd = function (e, t) {
        if (this.isDraggable) {
          this.options.freeScroll && (this.isFreeScrolling = !0);
          var i = this.dragEndRestingSelect();
          if (this.options.freeScroll && !this.options.wrapAround) {
            var n = this.getRestingPosition();
            this.isFreeScrolling =
              -n > this.slides[0].target && -n < this.getLastSlide().target;
          } else
            this.options.freeScroll ||
              i != this.selectedIndex ||
              (i += this.dragEndBoostSelect());
          delete this.previousDragX,
            (this.isDragSelect = this.options.wrapAround),
            this.select(i),
            delete this.isDragSelect,
            this.dispatchEvent("dragEnd", e, [t]);
        }
      }),
      (o.dragEndRestingSelect = function () {
        var e = this.getRestingPosition(),
          t = Math.abs(this.getSlideDistance(-e, this.selectedIndex)),
          i = this._getClosestResting(e, t, 1),
          n = this._getClosestResting(e, t, -1);
        return i.distance < n.distance ? i.index : n.index;
      }),
      (o._getClosestResting = function (e, t, i) {
        for (
          var n = this.selectedIndex,
            o = 1 / 0,
            s =
              this.options.contain && !this.options.wrapAround
                ? function (e, t) {
                    return e <= t;
                  }
                : function (e, t) {
                    return e < t;
                  };
          s(t, o) &&
          ((n += i), (o = t), null !== (t = this.getSlideDistance(-e, n)));

        )
          t = Math.abs(t);
        return { distance: o, index: n - i };
      }),
      (o.getSlideDistance = function (e, t) {
        var i = this.slides.length,
          o = this.options.wrapAround && 1 < i,
          s = o ? n.modulo(t, i) : t,
          r = this.slides[s];
        if (!r) return null;
        var a = o ? this.slideableWidth * Math.floor(t / i) : 0;
        return e - (r.target + a);
      }),
      (o.dragEndBoostSelect = function () {
        if (
          void 0 === this.previousDragX ||
          !this.dragMoveTime ||
          100 < new Date() - this.dragMoveTime
        )
          return 0;
        var e = this.getSlideDistance(-this.dragX, this.selectedIndex),
          t = this.previousDragX - this.dragX;
        return 0 < e && 0 < t ? 1 : e < 0 && t < 0 ? -1 : 0;
      }),
      (o.staticClick = function (e, t) {
        var i = this.getParentCell(e.target),
          n = i && i.element,
          o = i && this.cells.indexOf(i);
        this.dispatchEvent("staticClick", e, [t, n, o]);
      }),
      (o.onscroll = function () {
        var e = l(),
          t = this.pointerDownScroll.x - e.x,
          i = this.pointerDownScroll.y - e.y;
        (3 < Math.abs(t) || 3 < Math.abs(i)) && this._pointerDone();
      }),
      t
    );
  }),
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define(
          "flickity/js/prev-next-button",
          ["./flickity", "unipointer/unipointer", "fizzy-ui-utils/utils"],
          function (i, n, o) {
            return t(e, i, n, o);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = t(
          e,
          require("./flickity"),
          require("unipointer"),
          require("fizzy-ui-utils")
        ))
      : t(e, e.Flickity, e.Unipointer, e.fizzyUIUtils);
  })(window, function (e, t, i, n) {
    "use strict";
    var o = "http://www.w3.org/2000/svg";
    function s(e, t) {
      (this.direction = e), (this.parent = t), this._create();
    }
    ((s.prototype = Object.create(i.prototype))._create = function () {
      (this.isEnabled = !0), (this.isPrevious = -1 == this.direction);
      var e = this.parent.options.rightToLeft ? 1 : -1;
      this.isLeft = this.direction == e;
      var t = (this.element = document.createElement("button"));
      (t.className = "flickity-button flickity-prev-next-button"),
        (t.className += this.isPrevious ? " previous" : " next"),
        t.setAttribute("type", "button"),
        this.disable(),
        t.setAttribute("aria-label", this.isPrevious ? "Previous" : "Next");
      var i = this.createSVG();
      t.appendChild(i),
        this.parent.on("select", this.update.bind(this)),
        this.on(
          "pointerDown",
          this.parent.childUIPointerDown.bind(this.parent)
        );
    }),
      (s.prototype.activate = function () {
        this.bindStartEvent(this.element),
          this.element.addEventListener("click", this),
          this.parent.element.appendChild(this.element);
      }),
      (s.prototype.deactivate = function () {
        this.parent.element.removeChild(this.element),
          this.unbindStartEvent(this.element),
          this.element.removeEventListener("click", this);
      }),
      (s.prototype.createSVG = function () {
        var e = document.createElementNS(o, "svg");
        e.setAttribute("class", "flickity-button-icon"),
          e.setAttribute("viewBox", "0 0 100 100");
        var t,
          i = document.createElementNS(o, "path"),
          n =
            "string" != typeof (t = this.parent.options.arrowShape)
              ? "M " +
                t.x0 +
                ",50 L " +
                t.x1 +
                "," +
                (t.y1 + 50) +
                " L " +
                t.x2 +
                "," +
                (t.y2 + 50) +
                " L " +
                t.x3 +
                ",50  L " +
                t.x2 +
                "," +
                (50 - t.y2) +
                " L " +
                t.x1 +
                "," +
                (50 - t.y1) +
                " Z"
              : t;
        return (
          i.setAttribute("d", n),
          i.setAttribute("class", "arrow"),
          this.isLeft ||
            i.setAttribute("transform", "translate(100, 100) rotate(180) "),
          e.appendChild(i),
          e
        );
      }),
      (s.prototype.handleEvent = n.handleEvent),
      (s.prototype.onclick = function () {
        if (this.isEnabled) {
          this.parent.uiChange();
          var e = this.isPrevious ? "previous" : "next";
          this.parent[e]();
        }
      }),
      (s.prototype.enable = function () {
        this.isEnabled || ((this.element.disabled = !1), (this.isEnabled = !0));
      }),
      (s.prototype.disable = function () {
        this.isEnabled && ((this.element.disabled = !0), (this.isEnabled = !1));
      }),
      (s.prototype.update = function () {
        var e = this.parent.slides;
        if (this.parent.options.wrapAround && 1 < e.length) this.enable();
        else {
          var t = e.length ? e.length - 1 : 0,
            i = this.isPrevious ? 0 : t;
          this[this.parent.selectedIndex == i ? "disable" : "enable"]();
        }
      }),
      (s.prototype.destroy = function () {
        this.deactivate(), this.allOff();
      }),
      n.extend(t.defaults, {
        prevNextButtons: !0,
        arrowShape: { x0: 10, x1: 60, y1: 50, x2: 70, y2: 40, x3: 30 },
      }),
      t.createMethods.push("_createPrevNextButtons");
    var r = t.prototype;
    return (
      (r._createPrevNextButtons = function () {
        this.options.prevNextButtons &&
          ((this.prevButton = new s(-1, this)),
          (this.nextButton = new s(1, this)),
          this.on("activate", this.activatePrevNextButtons));
      }),
      (r.activatePrevNextButtons = function () {
        this.prevButton.activate(),
          this.nextButton.activate(),
          this.on("deactivate", this.deactivatePrevNextButtons);
      }),
      (r.deactivatePrevNextButtons = function () {
        this.prevButton.deactivate(),
          this.nextButton.deactivate(),
          this.off("deactivate", this.deactivatePrevNextButtons);
      }),
      (t.PrevNextButton = s),
      t
    );
  }),
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define(
          "flickity/js/page-dots",
          ["./flickity", "unipointer/unipointer", "fizzy-ui-utils/utils"],
          function (i, n, o) {
            return t(e, i, n, o);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = t(
          e,
          require("./flickity"),
          require("unipointer"),
          require("fizzy-ui-utils")
        ))
      : t(e, e.Flickity, e.Unipointer, e.fizzyUIUtils);
  })(window, function (e, t, i, n) {
    function o(e) {
      (this.parent = e), this._create();
    }
    ((o.prototype = Object.create(i.prototype))._create = function () {
      (this.holder = document.createElement("ol")),
        (this.holder.className = "flickity-page-dots"),
        (this.dots = []),
        (this.handleClick = this.onClick.bind(this)),
        this.on(
          "pointerDown",
          this.parent.childUIPointerDown.bind(this.parent)
        );
    }),
      (o.prototype.activate = function () {
        this.setDots(),
          this.holder.addEventListener("click", this.handleClick),
          this.bindStartEvent(this.holder),
          this.parent.element.appendChild(this.holder);
      }),
      (o.prototype.deactivate = function () {
        this.holder.removeEventListener("click", this.handleClick),
          this.unbindStartEvent(this.holder),
          this.parent.element.removeChild(this.holder);
      }),
      (o.prototype.setDots = function () {
        var e = this.parent.slides.length - this.dots.length;
        0 < e ? this.addDots(e) : e < 0 && this.removeDots(-e);
      }),
      (o.prototype.addDots = function (e) {
        for (
          var t = document.createDocumentFragment(),
            i = [],
            n = this.dots.length,
            o = n + e,
            s = n;
          s < o;
          s++
        ) {
          var r = document.createElement("li");
          (r.className = "dot"),
            r.setAttribute("aria-label", "Page dot " + (s + 1)),
            t.appendChild(r),
            i.push(r);
        }
        this.holder.appendChild(t), (this.dots = this.dots.concat(i));
      }),
      (o.prototype.removeDots = function (e) {
        this.dots.splice(this.dots.length - e, e).forEach(function (e) {
          this.holder.removeChild(e);
        }, this);
      }),
      (o.prototype.updateSelected = function () {
        this.selectedDot &&
          ((this.selectedDot.className = "dot"),
          this.selectedDot.removeAttribute("aria-current")),
          this.dots.length &&
            ((this.selectedDot = this.dots[this.parent.selectedIndex]),
            (this.selectedDot.className = "dot is-selected"),
            this.selectedDot.setAttribute("aria-current", "step"));
      }),
      (o.prototype.onTap = o.prototype.onClick =
        function (e) {
          var t = e.target;
          if ("LI" == t.nodeName) {
            this.parent.uiChange();
            var i = this.dots.indexOf(t);
            this.parent.select(i);
          }
        }),
      (o.prototype.destroy = function () {
        this.deactivate(), this.allOff();
      }),
      (t.PageDots = o),
      n.extend(t.defaults, { pageDots: !0 }),
      t.createMethods.push("_createPageDots");
    var s = t.prototype;
    return (
      (s._createPageDots = function () {
        this.options.pageDots &&
          ((this.pageDots = new o(this)),
          this.on("activate", this.activatePageDots),
          this.on("select", this.updateSelectedPageDots),
          this.on("cellChange", this.updatePageDots),
          this.on("resize", this.updatePageDots),
          this.on("deactivate", this.deactivatePageDots));
      }),
      (s.activatePageDots = function () {
        this.pageDots.activate();
      }),
      (s.updateSelectedPageDots = function () {
        this.pageDots.updateSelected();
      }),
      (s.updatePageDots = function () {
        this.pageDots.setDots();
      }),
      (s.deactivatePageDots = function () {
        this.pageDots.deactivate();
      }),
      (t.PageDots = o),
      t
    );
  }),
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define(
          "flickity/js/player",
          ["ev-emitter/ev-emitter", "fizzy-ui-utils/utils", "./flickity"],
          function (e, i, n) {
            return t(e, i, n);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = t(
          require("ev-emitter"),
          require("fizzy-ui-utils"),
          require("./flickity")
        ))
      : t(e.EvEmitter, e.fizzyUIUtils, e.Flickity);
  })(window, function (e, t, i) {
    function n(e) {
      (this.parent = e),
        (this.state = "stopped"),
        (this.onVisibilityChange = this.visibilityChange.bind(this)),
        (this.onVisibilityPlay = this.visibilityPlay.bind(this));
    }
    ((n.prototype = Object.create(e.prototype)).play = function () {
      "playing" != this.state &&
        (document.hidden
          ? document.addEventListener("visibilitychange", this.onVisibilityPlay)
          : ((this.state = "playing"),
            document.addEventListener(
              "visibilitychange",
              this.onVisibilityChange
            ),
            this.tick()));
    }),
      (n.prototype.tick = function () {
        if ("playing" == this.state) {
          var e = this.parent.options.autoPlay;
          e = "number" == typeof e ? e : 3e3;
          var t = this;
          this.clear(),
            (this.timeout = setTimeout(function () {
              t.parent.next(!0), t.tick();
            }, e));
        }
      }),
      (n.prototype.stop = function () {
        (this.state = "stopped"),
          this.clear(),
          document.removeEventListener(
            "visibilitychange",
            this.onVisibilityChange
          );
      }),
      (n.prototype.clear = function () {
        clearTimeout(this.timeout);
      }),
      (n.prototype.pause = function () {
        "playing" == this.state && ((this.state = "paused"), this.clear());
      }),
      (n.prototype.unpause = function () {
        "paused" == this.state && this.play();
      }),
      (n.prototype.visibilityChange = function () {
        this[document.hidden ? "pause" : "unpause"]();
      }),
      (n.prototype.visibilityPlay = function () {
        this.play(),
          document.removeEventListener(
            "visibilitychange",
            this.onVisibilityPlay
          );
      }),
      t.extend(i.defaults, { pauseAutoPlayOnHover: !0 }),
      i.createMethods.push("_createPlayer");
    var o = i.prototype;
    return (
      (o._createPlayer = function () {
        (this.player = new n(this)),
          this.on("activate", this.activatePlayer),
          this.on("uiChange", this.stopPlayer),
          this.on("pointerDown", this.stopPlayer),
          this.on("deactivate", this.deactivatePlayer);
      }),
      (o.activatePlayer = function () {
        this.options.autoPlay &&
          (this.player.play(),
          this.element.addEventListener("mouseenter", this));
      }),
      (o.playPlayer = function () {
        this.player.play();
      }),
      (o.stopPlayer = function () {
        this.player.stop();
      }),
      (o.pausePlayer = function () {
        this.player.pause();
      }),
      (o.unpausePlayer = function () {
        this.player.unpause();
      }),
      (o.deactivatePlayer = function () {
        this.player.stop(),
          this.element.removeEventListener("mouseenter", this);
      }),
      (o.onmouseenter = function () {
        this.options.pauseAutoPlayOnHover &&
          (this.player.pause(),
          this.element.addEventListener("mouseleave", this));
      }),
      (o.onmouseleave = function () {
        this.player.unpause(),
          this.element.removeEventListener("mouseleave", this);
      }),
      (i.Player = n),
      i
    );
  }),
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define(
          "flickity/js/add-remove-cell",
          ["./flickity", "fizzy-ui-utils/utils"],
          function (i, n) {
            return t(e, i, n);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = t(
          e,
          require("./flickity"),
          require("fizzy-ui-utils")
        ))
      : t(e, e.Flickity, e.fizzyUIUtils);
  })(window, function (e, t, i) {
    var n = t.prototype;
    return (
      (n.insert = function (e, t) {
        var i = this._makeCells(e);
        if (i && i.length) {
          var n = this.cells.length;
          t = void 0 === t ? n : t;
          var o,
            s,
            r =
              ((o = i),
              (s = document.createDocumentFragment()),
              o.forEach(function (e) {
                s.appendChild(e.element);
              }),
              s),
            a = t == n;
          if (a) this.slider.appendChild(r);
          else {
            var l = this.cells[t].element;
            this.slider.insertBefore(r, l);
          }
          if (0 === t) this.cells = i.concat(this.cells);
          else if (a) this.cells = this.cells.concat(i);
          else {
            var c = this.cells.splice(t, n - t);
            this.cells = this.cells.concat(i).concat(c);
          }
          this._sizeCells(i), this.cellChange(t, !0);
        }
      }),
      (n.append = function (e) {
        this.insert(e, this.cells.length);
      }),
      (n.prepend = function (e) {
        this.insert(e, 0);
      }),
      (n.remove = function (e) {
        var t = this.getCells(e);
        if (t && t.length) {
          var n = this.cells.length - 1;
          t.forEach(function (e) {
            e.remove(),
              (n = Math.min(this.cells.indexOf(e), n)),
              i.removeFrom(this.cells, e);
          }, this),
            this.cellChange(n, !0);
        }
      }),
      (n.cellSizeChange = function (e) {
        var t = this.getCell(e);
        if (t) {
          t.getSize();
          var i = this.cells.indexOf(t);
          this.cellChange(i);
        }
      }),
      (n.cellChange = function (e, t) {
        var i = this.selectedElement;
        this._positionCells(e),
          this._getWrapShiftCells(),
          this.setGallerySize();
        var n = this.getCell(i);
        n && (this.selectedIndex = this.getCellSlideIndex(n)),
          (this.selectedIndex = Math.min(
            this.slides.length - 1,
            this.selectedIndex
          )),
          this.emitEvent("cellChange", [e]),
          this.select(this.selectedIndex),
          t && this.positionSliderAtSelected();
      }),
      t
    );
  }),
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define(
          "flickity/js/lazyload",
          ["./flickity", "fizzy-ui-utils/utils"],
          function (i, n) {
            return t(e, i, n);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = t(
          e,
          require("./flickity"),
          require("fizzy-ui-utils")
        ))
      : t(e, e.Flickity, e.fizzyUIUtils);
  })(window, function (e, t, i) {
    "use strict";
    t.createMethods.push("_createLazyload");
    var n = t.prototype;
    function o(e, t) {
      (this.img = e), (this.flickity = t), this.load();
    }
    return (
      (n._createLazyload = function () {
        this.on("select", this.lazyLoad);
      }),
      (n.lazyLoad = function () {
        var e = this.options.lazyLoad;
        if (e) {
          var t = this.getAdjacentCellElements("number" == typeof e ? e : 0),
            n = [];
          t.forEach(function (e) {
            var t = (function (e) {
              if ("IMG" == e.nodeName) {
                var t = e.getAttribute("data-flickity-lazyload"),
                  n = e.getAttribute("data-flickity-lazyload-src"),
                  o = e.getAttribute("data-flickity-lazyload-srcset");
                if (t || n || o) return [e];
              }
              var s = e.querySelectorAll(
                "img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]"
              );
              return i.makeArray(s);
            })(e);
            n = n.concat(t);
          }),
            n.forEach(function (e) {
              new o(e, this);
            }, this);
        }
      }),
      (o.prototype.handleEvent = i.handleEvent),
      (o.prototype.load = function () {
        this.img.addEventListener("load", this),
          this.img.addEventListener("error", this);
        var e =
            this.img.getAttribute("data-flickity-lazyload") ||
            this.img.getAttribute("data-flickity-lazyload-src"),
          t = this.img.getAttribute("data-flickity-lazyload-srcset");
        (this.img.src = e),
          t && this.img.setAttribute("srcset", t),
          this.img.removeAttribute("data-flickity-lazyload"),
          this.img.removeAttribute("data-flickity-lazyload-src"),
          this.img.removeAttribute("data-flickity-lazyload-srcset");
      }),
      (o.prototype.onload = function (e) {
        this.complete(e, "flickity-lazyloaded");
      }),
      (o.prototype.onerror = function (e) {
        this.complete(e, "flickity-lazyerror");
      }),
      (o.prototype.complete = function (e, t) {
        this.img.removeEventListener("load", this),
          this.img.removeEventListener("error", this);
        var i = this.flickity.getParentCell(this.img),
          n = i && i.element;
        this.flickity.cellSizeChange(n),
          this.img.classList.add(t),
          this.flickity.dispatchEvent("lazyLoad", e, n);
      }),
      (t.LazyLoader = o),
      t
    );
  }),
  (function (e) {
    "function" == typeof define && define.amd
      ? define(
          "flickity/js/index",
          [
            "./flickity",
            "./drag",
            "./prev-next-button",
            "./page-dots",
            "./player",
            "./add-remove-cell",
            "./lazyload",
          ],
          e
        )
      : "object" == typeof module &&
        module.exports &&
        (module.exports = e(
          require("./flickity"),
          require("./drag"),
          require("./prev-next-button"),
          require("./page-dots"),
          require("./player"),
          require("./add-remove-cell"),
          require("./lazyload")
        ));
  })(
    (window,
    function (e) {
      return e;
    })
  ),
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define(
          "flickity-as-nav-for/as-nav-for",
          ["flickity/js/index", "fizzy-ui-utils/utils"],
          t
        )
      : "object" == typeof module && module.exports
      ? (module.exports = t(require("flickity"), require("fizzy-ui-utils")))
      : (e.Flickity = t(e.Flickity, e.fizzyUIUtils));
  })(window, function (e, t) {
    e.createMethods.push("_createAsNavFor");
    var i = e.prototype;
    return (
      (i._createAsNavFor = function () {
        this.on("activate", this.activateAsNavFor),
          this.on("deactivate", this.deactivateAsNavFor),
          this.on("destroy", this.destroyAsNavFor);
        var e = this.options.asNavFor;
        if (e) {
          var t = this;
          setTimeout(function () {
            t.setNavCompanion(e);
          });
        }
      }),
      (i.setNavCompanion = function (i) {
        i = t.getQueryElement(i);
        var n = e.data(i);
        if (n && n != this) {
          this.navCompanion = n;
          var o = this;
          (this.onNavCompanionSelect = function () {
            o.navCompanionSelect();
          }),
            n.on("select", this.onNavCompanionSelect),
            this.on("staticClick", this.onNavStaticClick),
            this.navCompanionSelect(!0);
        }
      }),
      (i.navCompanionSelect = function (e) {
        var t = this.navCompanion && this.navCompanion.selectedCells;
        if (t) {
          var i,
            n,
            o,
            s = t[0],
            r = this.navCompanion.cells.indexOf(s),
            a = r + t.length - 1,
            l = Math.floor(
              ((i = r), ((n = a) - i) * (o = this.navCompanion.cellAlign) + i)
            );
          if (
            (this.selectCell(l, !1, e),
            this.removeNavSelectedElements(),
            !(l >= this.cells.length))
          ) {
            var c = this.cells.slice(r, 1 + a);
            (this.navSelectedElements = c.map(function (e) {
              return e.element;
            })),
              this.changeNavSelectedClass("add");
          }
        }
      }),
      (i.changeNavSelectedClass = function (e) {
        this.navSelectedElements.forEach(function (t) {
          t.classList[e]("is-nav-selected");
        });
      }),
      (i.activateAsNavFor = function () {
        this.navCompanionSelect(!0);
      }),
      (i.removeNavSelectedElements = function () {
        this.navSelectedElements &&
          (this.changeNavSelectedClass("remove"),
          delete this.navSelectedElements);
      }),
      (i.onNavStaticClick = function (e, t, i, n) {
        "number" == typeof n && this.navCompanion.selectCell(n);
      }),
      (i.deactivateAsNavFor = function () {
        this.removeNavSelectedElements();
      }),
      (i.destroyAsNavFor = function () {
        this.navCompanion &&
          (this.navCompanion.off("select", this.onNavCompanionSelect),
          this.off("staticClick", this.onNavStaticClick),
          delete this.navCompanion);
      }),
      e
    );
  }),
  (function (e, t) {
    "use strict";
    "function" == typeof define && define.amd
      ? define(
          "imagesloaded/imagesloaded",
          ["ev-emitter/ev-emitter"],
          function (i) {
            return t(e, i);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = t(e, require("ev-emitter")))
      : (e.imagesLoaded = t(e, e.EvEmitter));
  })("undefined" != typeof window ? window : this, function (e, t) {
    var i = e.jQuery,
      n = e.console;
    function o(e, t) {
      for (var i in t) e[i] = t[i];
      return e;
    }
    var s = Array.prototype.slice;
    function r(e, t, a) {
      if (!(this instanceof r)) return new r(e, t, a);
      var l,
        c = e;
      ("string" == typeof e && (c = document.querySelectorAll(e)), c)
        ? ((this.elements = Array.isArray((l = c))
            ? l
            : "object" == typeof l && "number" == typeof l.length
            ? s.call(l)
            : [l]),
          (this.options = o({}, this.options)),
          "function" == typeof t ? (a = t) : o(this.options, t),
          a && this.on("always", a),
          this.getImages(),
          i && (this.jqDeferred = new i.Deferred()),
          setTimeout(this.check.bind(this)))
        : n.error("Bad element for imagesLoaded " + (c || e));
    }
    ((r.prototype = Object.create(t.prototype)).options = {}),
      (r.prototype.getImages = function () {
        (this.images = []), this.elements.forEach(this.addElementImages, this);
      }),
      (r.prototype.addElementImages = function (e) {
        "IMG" == e.nodeName && this.addImage(e),
          !0 === this.options.background && this.addElementBackgroundImages(e);
        var t = e.nodeType;
        if (t && a[t]) {
          for (var i = e.querySelectorAll("img"), n = 0; n < i.length; n++) {
            var o = i[n];
            this.addImage(o);
          }
          if ("string" == typeof this.options.background) {
            var s = e.querySelectorAll(this.options.background);
            for (n = 0; n < s.length; n++) {
              var r = s[n];
              this.addElementBackgroundImages(r);
            }
          }
        }
      });
    var a = { 1: !0, 9: !0, 11: !0 };
    function l(e) {
      this.img = e;
    }
    function c(e, t) {
      (this.url = e), (this.element = t), (this.img = new Image());
    }
    return (
      (r.prototype.addElementBackgroundImages = function (e) {
        var t = getComputedStyle(e);
        if (t)
          for (
            var i = /url\((['"])?(.*?)\1\)/gi, n = i.exec(t.backgroundImage);
            null !== n;

          ) {
            var o = n && n[2];
            o && this.addBackground(o, e), (n = i.exec(t.backgroundImage));
          }
      }),
      (r.prototype.addImage = function (e) {
        var t = new l(e);
        this.images.push(t);
      }),
      (r.prototype.addBackground = function (e, t) {
        var i = new c(e, t);
        this.images.push(i);
      }),
      (r.prototype.check = function () {
        var e = this;
        function t(t, i, n) {
          setTimeout(function () {
            e.progress(t, i, n);
          });
        }
        (this.progressedCount = 0),
          (this.hasAnyBroken = !1),
          this.images.length
            ? this.images.forEach(function (e) {
                e.once("progress", t), e.check();
              })
            : this.complete();
      }),
      (r.prototype.progress = function (e, t, i) {
        this.progressedCount++,
          (this.hasAnyBroken = this.hasAnyBroken || !e.isLoaded),
          this.emitEvent("progress", [this, e, t]),
          this.jqDeferred &&
            this.jqDeferred.notify &&
            this.jqDeferred.notify(this, e),
          this.progressedCount == this.images.length && this.complete(),
          this.options.debug && n && n.log("progress: " + i, e, t);
      }),
      (r.prototype.complete = function () {
        var e = this.hasAnyBroken ? "fail" : "done";
        if (
          ((this.isComplete = !0),
          this.emitEvent(e, [this]),
          this.emitEvent("always", [this]),
          this.jqDeferred)
        ) {
          var t = this.hasAnyBroken ? "reject" : "resolve";
          this.jqDeferred[t](this);
        }
      }),
      ((l.prototype = Object.create(t.prototype)).check = function () {
        this.getIsImageComplete()
          ? this.confirm(0 !== this.img.naturalWidth, "naturalWidth")
          : ((this.proxyImage = new Image()),
            this.proxyImage.addEventListener("load", this),
            this.proxyImage.addEventListener("error", this),
            this.img.addEventListener("load", this),
            this.img.addEventListener("error", this),
            (this.proxyImage.src = this.img.src));
      }),
      (l.prototype.getIsImageComplete = function () {
        return this.img.complete && this.img.naturalWidth;
      }),
      (l.prototype.confirm = function (e, t) {
        (this.isLoaded = e), this.emitEvent("progress", [this, this.img, t]);
      }),
      (l.prototype.handleEvent = function (e) {
        var t = "on" + e.type;
        this[t] && this[t](e);
      }),
      (l.prototype.onload = function () {
        this.confirm(!0, "onload"), this.unbindEvents();
      }),
      (l.prototype.onerror = function () {
        this.confirm(!1, "onerror"), this.unbindEvents();
      }),
      (l.prototype.unbindEvents = function () {
        this.proxyImage.removeEventListener("load", this),
          this.proxyImage.removeEventListener("error", this),
          this.img.removeEventListener("load", this),
          this.img.removeEventListener("error", this);
      }),
      ((c.prototype = Object.create(l.prototype)).check = function () {
        this.img.addEventListener("load", this),
          this.img.addEventListener("error", this),
          (this.img.src = this.url),
          this.getIsImageComplete() &&
            (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"),
            this.unbindEvents());
      }),
      (c.prototype.unbindEvents = function () {
        this.img.removeEventListener("load", this),
          this.img.removeEventListener("error", this);
      }),
      (c.prototype.confirm = function (e, t) {
        (this.isLoaded = e),
          this.emitEvent("progress", [this, this.element, t]);
      }),
      (r.makeJQueryPlugin = function (t) {
        (t = t || e.jQuery) &&
          ((i = t).fn.imagesLoaded = function (e, t) {
            return new r(this, e, t).jqDeferred.promise(i(this));
          });
      })(),
      r
    );
  }),
  (function (e, t) {
    "function" == typeof define && define.amd
      ? define(
          ["flickity/js/index", "imagesloaded/imagesloaded"],
          function (i, n) {
            return t(e, i, n);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = t(e, require("flickity"), require("imagesloaded")))
      : (e.Flickity = t(e, e.Flickity, e.imagesLoaded));
  })(window, function (e, t, i) {
    "use strict";
    t.createMethods.push("_createImagesLoaded");
    var n = t.prototype;
    return (
      (n._createImagesLoaded = function () {
        this.on("activate", this.imagesLoaded);
      }),
      (n.imagesLoaded = function () {
        if (this.options.imagesLoaded) {
          var e = this;
          i(this.slider).on("progress", function (t, i) {
            var n = e.getParentCell(i.img);
            e.cellSizeChange(n && n.element),
              e.options.freeScroll || e.positionSliderAtSelected();
          });
        }
      }),
      t
    );
  }),
  (function (e) {
    "use strict";
    "function" == typeof define && define.amd
      ? define(["jquery"], e)
      : "undefined" != typeof exports
      ? (module.exports = e(require("jquery")))
      : e(jQuery);
  })(function (e) {
    "use strict";
    var t,
      i = window.Slick || {};
    ((i =
      ((t = 0),
      function i(n, o) {
        var s,
          r = this;
        (r.defaults = {
          accessibility: !0,
          adaptiveHeight: !1,
          appendArrows: e(n),
          appendDots: e(n),
          arrows: !0,
          asNavFor: null,
          prevArrow:
            '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
          nextArrow:
            '<button class="slick-next" aria-label="Next" type="button">Next</button>',
          autoplay: !1,
          autoplaySpeed: 3e3,
          centerMode: !1,
          centerPadding: "50px",
          cssEase: "ease",
          customPaging: function (t, i) {
            return e('<button type="button" />').text(i + 1);
          },
          dots: !1,
          dotsClass: "slick-dots",
          draggable: !0,
          easing: "linear",
          edgeFriction: 0.35,
          fade: !1,
          focusOnSelect: !1,
          focusOnChange: !1,
          infinite: !0,
          initialSlide: 0,
          lazyLoad: "ondemand",
          mobileFirst: !1,
          pauseOnHover: !0,
          pauseOnFocus: !0,
          pauseOnDotsHover: !1,
          respondTo: "window",
          responsive: null,
          rows: 1,
          rtl: !1,
          slide: "",
          slidesPerRow: 1,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 500,
          swipe: !0,
          swipeToSlide: !1,
          touchMove: !0,
          touchThreshold: 5,
          useCSS: !0,
          useTransform: !0,
          variableWidth: !1,
          vertical: !1,
          verticalSwiping: !1,
          waitForAnimate: !0,
          zIndex: 1e3,
        }),
          (r.initials = {
            animating: !1,
            dragging: !1,
            autoPlayTimer: null,
            currentDirection: 0,
            currentLeft: null,
            currentSlide: 0,
            direction: 1,
            $dots: null,
            listWidth: null,
            listHeight: null,
            loadIndex: 0,
            $nextArrow: null,
            $prevArrow: null,
            scrolling: !1,
            slideCount: null,
            slideWidth: null,
            $slideTrack: null,
            $slides: null,
            sliding: !1,
            slideOffset: 0,
            swipeLeft: null,
            swiping: !1,
            $list: null,
            touchObject: {},
            transformsEnabled: !1,
            unslicked: !1,
          }),
          e.extend(r, r.initials),
          (r.activeBreakpoint = null),
          (r.animType = null),
          (r.animProp = null),
          (r.breakpoints = []),
          (r.breakpointSettings = []),
          (r.cssTransitions = !1),
          (r.focussed = !1),
          (r.interrupted = !1),
          (r.hidden = "hidden"),
          (r.paused = !0),
          (r.positionProp = null),
          (r.respondTo = null),
          (r.rowCount = 1),
          (r.shouldClick = !0),
          (r.$slider = e(n)),
          (r.$slidesCache = null),
          (r.transformType = null),
          (r.transitionType = null),
          (r.visibilityChange = "visibilitychange"),
          (r.windowWidth = 0),
          (r.windowTimer = null),
          (s = e(n).data("slick") || {}),
          (r.options = e.extend({}, r.defaults, o, s)),
          (r.currentSlide = r.options.initialSlide),
          (r.originalSettings = r.options),
          void 0 !== document.mozHidden
            ? ((r.hidden = "mozHidden"),
              (r.visibilityChange = "mozvisibilitychange"))
            : void 0 !== document.webkitHidden &&
              ((r.hidden = "webkitHidden"),
              (r.visibilityChange = "webkitvisibilitychange")),
          (r.autoPlay = e.proxy(r.autoPlay, r)),
          (r.autoPlayClear = e.proxy(r.autoPlayClear, r)),
          (r.autoPlayIterator = e.proxy(r.autoPlayIterator, r)),
          (r.changeSlide = e.proxy(r.changeSlide, r)),
          (r.clickHandler = e.proxy(r.clickHandler, r)),
          (r.selectHandler = e.proxy(r.selectHandler, r)),
          (r.setPosition = e.proxy(r.setPosition, r)),
          (r.swipeHandler = e.proxy(r.swipeHandler, r)),
          (r.dragHandler = e.proxy(r.dragHandler, r)),
          (r.keyHandler = e.proxy(r.keyHandler, r)),
          (r.instanceUid = t++),
          (r.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
          r.registerBreakpoints(),
          r.init(!0);
      })).prototype.activateADA = function () {
      this.$slideTrack
        .find(".slick-active")
        .attr({ "aria-hidden": "false" })
        .find("a, input, button, select")
        .attr({ tabindex: "0" });
    }),
      (i.prototype.addSlide = i.prototype.slickAdd =
        function (t, i, n) {
          var o = this;
          if ("boolean" == typeof i) (n = i), (i = null);
          else if (i < 0 || i >= o.slideCount) return !1;
          o.unload(),
            "number" == typeof i
              ? 0 === i && 0 === o.$slides.length
                ? e(t).appendTo(o.$slideTrack)
                : n
                ? e(t).insertBefore(o.$slides.eq(i))
                : e(t).insertAfter(o.$slides.eq(i))
              : !0 === n
              ? e(t).prependTo(o.$slideTrack)
              : e(t).appendTo(o.$slideTrack),
            (o.$slides = o.$slideTrack.children(this.options.slide)),
            o.$slideTrack.children(this.options.slide).detach(),
            o.$slideTrack.append(o.$slides),
            o.$slides.each(function (t, i) {
              e(i).attr("data-slick-index", t);
            }),
            (o.$slidesCache = o.$slides),
            o.reinit();
        }),
      (i.prototype.animateHeight = function () {
        if (
          1 === this.options.slidesToShow &&
          !0 === this.options.adaptiveHeight &&
          !1 === this.options.vertical
        ) {
          var e = this.$slides.eq(this.currentSlide).outerHeight(!0);
          this.$list.animate({ height: e }, this.options.speed);
        }
      }),
      (i.prototype.animateSlide = function (t, i) {
        var n = {},
          o = this;
        o.animateHeight(),
          !0 === o.options.rtl && !1 === o.options.vertical && (t = -t),
          !1 === o.transformsEnabled
            ? !1 === o.options.vertical
              ? o.$slideTrack.animate(
                  { left: t },
                  o.options.speed,
                  o.options.easing,
                  i
                )
              : o.$slideTrack.animate(
                  { top: t },
                  o.options.speed,
                  o.options.easing,
                  i
                )
            : !1 === o.cssTransitions
            ? (!0 === o.options.rtl && (o.currentLeft = -o.currentLeft),
              e({ animStart: o.currentLeft }).animate(
                { animStart: t },
                {
                  duration: o.options.speed,
                  easing: o.options.easing,
                  step: function (e) {
                    (e = Math.ceil(e)),
                      !1 === o.options.vertical
                        ? ((n[o.animType] = "translate(" + e + "px, 0px)"),
                          o.$slideTrack.css(n))
                        : ((n[o.animType] = "translate(0px," + e + "px)"),
                          o.$slideTrack.css(n));
                  },
                  complete: function () {
                    i && i.call();
                  },
                }
              ))
            : (o.applyTransition(),
              (t = Math.ceil(t)),
              !1 === o.options.vertical
                ? (n[o.animType] = "translate3d(" + t + "px, 0px, 0px)")
                : (n[o.animType] = "translate3d(0px," + t + "px, 0px)"),
              o.$slideTrack.css(n),
              i &&
                setTimeout(function () {
                  o.disableTransition(), i.call();
                }, o.options.speed));
      }),
      (i.prototype.getNavTarget = function () {
        var t = this.options.asNavFor;
        return t && null !== t && (t = e(t).not(this.$slider)), t;
      }),
      (i.prototype.asNavFor = function (t) {
        var i = this.getNavTarget();
        null !== i &&
          "object" == typeof i &&
          i.each(function () {
            var i = e(this).slick("getSlick");
            i.unslicked || i.slideHandler(t, !0);
          });
      }),
      (i.prototype.applyTransition = function (e) {
        var t = this,
          i = {};
        !1 === t.options.fade
          ? (i[t.transitionType] =
              t.transformType +
              " " +
              t.options.speed +
              "ms " +
              t.options.cssEase)
          : (i[t.transitionType] =
              "opacity " + t.options.speed + "ms " + t.options.cssEase),
          !1 === t.options.fade ? t.$slideTrack.css(i) : t.$slides.eq(e).css(i);
      }),
      (i.prototype.autoPlay = function () {
        var e = this;
        e.autoPlayClear(),
          e.slideCount > e.options.slidesToShow &&
            (e.autoPlayTimer = setInterval(
              e.autoPlayIterator,
              e.options.autoplaySpeed
            ));
      }),
      (i.prototype.autoPlayClear = function () {
        this.autoPlayTimer && clearInterval(this.autoPlayTimer);
      }),
      (i.prototype.autoPlayIterator = function () {
        var e = this,
          t = e.currentSlide + e.options.slidesToScroll;
        e.paused ||
          e.interrupted ||
          e.focussed ||
          (!1 === e.options.infinite &&
            (1 === e.direction && e.currentSlide + 1 === e.slideCount - 1
              ? (e.direction = 0)
              : 0 === e.direction &&
                ((t = e.currentSlide - e.options.slidesToScroll),
                e.currentSlide - 1 == 0 && (e.direction = 1))),
          e.slideHandler(t));
      }),
      (i.prototype.buildArrows = function () {
        var t = this;
        !0 === t.options.arrows &&
          ((t.$prevArrow = e(t.options.prevArrow).addClass("slick-arrow")),
          (t.$nextArrow = e(t.options.nextArrow).addClass("slick-arrow")),
          t.slideCount > t.options.slidesToShow
            ? (t.$prevArrow
                .removeClass("slick-hidden")
                .removeAttr("aria-hidden tabindex"),
              t.$nextArrow
                .removeClass("slick-hidden")
                .removeAttr("aria-hidden tabindex"),
              t.htmlExpr.test(t.options.prevArrow) &&
                t.$prevArrow.prependTo(t.options.appendArrows),
              t.htmlExpr.test(t.options.nextArrow) &&
                t.$nextArrow.appendTo(t.options.appendArrows),
              !0 !== t.options.infinite &&
                t.$prevArrow
                  .addClass("slick-disabled")
                  .attr("aria-disabled", "true"))
            : t.$prevArrow
                .add(t.$nextArrow)
                .addClass("slick-hidden")
                .attr({ "aria-disabled": "true", tabindex: "-1" }));
      }),
      (i.prototype.buildDots = function () {
        var t,
          i,
          n = this;
        if (!0 === n.options.dots && n.slideCount > n.options.slidesToShow) {
          for (
            n.$slider.addClass("slick-dotted"),
              i = e("<ul />").addClass(n.options.dotsClass),
              t = 0;
            t <= n.getDotCount();
            t += 1
          )
            i.append(
              e("<li />").append(n.options.customPaging.call(this, n, t))
            );
          (n.$dots = i.appendTo(n.options.appendDots)),
            n.$dots.find("li").first().addClass("slick-active");
        }
      }),
      (i.prototype.buildOut = function () {
        var t = this;
        (t.$slides = t.$slider
          .children(t.options.slide + ":not(.slick-cloned)")
          .addClass("slick-slide")),
          (t.slideCount = t.$slides.length),
          t.$slides.each(function (t, i) {
            e(i)
              .attr("data-slick-index", t)
              .data("originalStyling", e(i).attr("style") || "");
          }),
          t.$slider.addClass("slick-slider"),
          (t.$slideTrack =
            0 === t.slideCount
              ? e('<div class="slick-track"/>').appendTo(t.$slider)
              : t.$slides.wrapAll('<div class="slick-track"/>').parent()),
          (t.$list = t.$slideTrack.wrap('<div class="slick-list"/>').parent()),
          t.$slideTrack.css("opacity", 0),
          (!0 !== t.options.centerMode && !0 !== t.options.swipeToSlide) ||
            (t.options.slidesToScroll = 1),
          e("img[data-lazy]", t.$slider).not("[src]").addClass("slick-loading"),
          t.setupInfinite(),
          t.buildArrows(),
          t.buildDots(),
          t.updateDots(),
          t.setSlideClasses(
            "number" == typeof t.currentSlide ? t.currentSlide : 0
          ),
          !0 === t.options.draggable && t.$list.addClass("draggable");
      }),
      (i.prototype.buildRows = function () {
        var e, t, i, n, o, s, r;
        if (
          ((n = document.createDocumentFragment()),
          (s = this.$slider.children()),
          this.options.rows > 0)
        ) {
          for (
            r = this.options.slidesPerRow * this.options.rows,
              o = Math.ceil(s.length / r),
              e = 0;
            e < o;
            e++
          ) {
            var a = document.createElement("div");
            for (t = 0; t < this.options.rows; t++) {
              var l = document.createElement("div");
              for (i = 0; i < this.options.slidesPerRow; i++) {
                var c = e * r + (t * this.options.slidesPerRow + i);
                s.get(c) && l.appendChild(s.get(c));
              }
              a.appendChild(l);
            }
            n.appendChild(a);
          }
          this.$slider.empty().append(n),
            this.$slider
              .children()
              .children()
              .children()
              .css({
                width: 100 / this.options.slidesPerRow + "%",
                display: "inline-block",
              });
        }
      }),
      (i.prototype.checkResponsive = function (t, i) {
        var n,
          o,
          s,
          r = this,
          a = !1,
          l = r.$slider.width(),
          c = window.innerWidth || e(window).width();
        if (
          ("window" === r.respondTo
            ? (s = c)
            : "slider" === r.respondTo
            ? (s = l)
            : "min" === r.respondTo && (s = Math.min(c, l)),
          r.options.responsive &&
            r.options.responsive.length &&
            null !== r.options.responsive)
        ) {
          for (n in ((o = null), r.breakpoints))
            r.breakpoints.hasOwnProperty(n) &&
              (!1 === r.originalSettings.mobileFirst
                ? s < r.breakpoints[n] && (o = r.breakpoints[n])
                : s > r.breakpoints[n] && (o = r.breakpoints[n]));
          null !== o
            ? null !== r.activeBreakpoint
              ? (o !== r.activeBreakpoint || i) &&
                ((r.activeBreakpoint = o),
                "unslick" === r.breakpointSettings[o]
                  ? r.unslick(o)
                  : ((r.options = e.extend(
                      {},
                      r.originalSettings,
                      r.breakpointSettings[o]
                    )),
                    !0 === t && (r.currentSlide = r.options.initialSlide),
                    r.refresh(t)),
                (a = o))
              : ((r.activeBreakpoint = o),
                "unslick" === r.breakpointSettings[o]
                  ? r.unslick(o)
                  : ((r.options = e.extend(
                      {},
                      r.originalSettings,
                      r.breakpointSettings[o]
                    )),
                    !0 === t && (r.currentSlide = r.options.initialSlide),
                    r.refresh(t)),
                (a = o))
            : null !== r.activeBreakpoint &&
              ((r.activeBreakpoint = null),
              (r.options = r.originalSettings),
              !0 === t && (r.currentSlide = r.options.initialSlide),
              r.refresh(t),
              (a = o)),
            t || !1 === a || r.$slider.trigger("breakpoint", [r, a]);
        }
      }),
      (i.prototype.changeSlide = function (t, i) {
        var n,
          o,
          s,
          r = e(t.currentTarget);
        switch (
          (r.is("a") && t.preventDefault(),
          r.is("li") || (r = r.closest("li")),
          (n = (s = this.slideCount % this.options.slidesToScroll != 0)
            ? 0
            : (this.slideCount - this.currentSlide) %
              this.options.slidesToScroll),
          t.data.message)
        ) {
          case "previous":
            (o =
              0 === n
                ? this.options.slidesToScroll
                : this.options.slidesToShow - n),
              this.slideCount > this.options.slidesToShow &&
                this.slideHandler(this.currentSlide - o, !1, i);
            break;
          case "next":
            (o = 0 === n ? this.options.slidesToScroll : n),
              this.slideCount > this.options.slidesToShow &&
                this.slideHandler(this.currentSlide + o, !1, i);
            break;
          case "index":
            var a =
              0 === t.data.index
                ? 0
                : t.data.index || r.index() * this.options.slidesToScroll;
            this.slideHandler(this.checkNavigable(a), !1, i),
              r.children().trigger("focus");
            break;
          default:
            return;
        }
      }),
      (i.prototype.checkNavigable = function (e) {
        var t, i;
        if (((t = this.getNavigableIndexes()), (i = 0), e > t[t.length - 1]))
          e = t[t.length - 1];
        else
          for (var n in t) {
            if (e < t[n]) {
              e = i;
              break;
            }
            i = t[n];
          }
        return e;
      }),
      (i.prototype.cleanUpEvents = function () {
        this.options.dots &&
          null !== this.$dots &&
          (e("li", this.$dots)
            .off("click.slick", this.changeSlide)
            .off("mouseenter.slick", e.proxy(this.interrupt, this, !0))
            .off("mouseleave.slick", e.proxy(this.interrupt, this, !1)),
          !0 === this.options.accessibility &&
            this.$dots.off("keydown.slick", this.keyHandler)),
          this.$slider.off("focus.slick blur.slick"),
          !0 === this.options.arrows &&
            this.slideCount > this.options.slidesToShow &&
            (this.$prevArrow &&
              this.$prevArrow.off("click.slick", this.changeSlide),
            this.$nextArrow &&
              this.$nextArrow.off("click.slick", this.changeSlide),
            !0 === this.options.accessibility &&
              (this.$prevArrow &&
                this.$prevArrow.off("keydown.slick", this.keyHandler),
              this.$nextArrow &&
                this.$nextArrow.off("keydown.slick", this.keyHandler))),
          this.$list.off("touchstart.slick mousedown.slick", this.swipeHandler),
          this.$list.off("touchmove.slick mousemove.slick", this.swipeHandler),
          this.$list.off("touchend.slick mouseup.slick", this.swipeHandler),
          this.$list.off(
            "touchcancel.slick mouseleave.slick",
            this.swipeHandler
          ),
          this.$list.off("click.slick", this.clickHandler),
          e(document).off(this.visibilityChange, this.visibility),
          this.cleanUpSlideEvents(),
          !0 === this.options.accessibility &&
            this.$list.off("keydown.slick", this.keyHandler),
          !0 === this.options.focusOnSelect &&
            e(this.$slideTrack)
              .children()
              .off("click.slick", this.selectHandler),
          e(window).off(
            "orientationchange.slick.slick-" + this.instanceUid,
            this.orientationChange
          ),
          e(window).off("resize.slick.slick-" + this.instanceUid, this.resize),
          e("[draggable!=true]", this.$slideTrack).off(
            "dragstart",
            this.preventDefault
          ),
          e(window).off(
            "load.slick.slick-" + this.instanceUid,
            this.setPosition
          );
      }),
      (i.prototype.cleanUpSlideEvents = function () {
        this.$list.off("mouseenter.slick", e.proxy(this.interrupt, this, !0)),
          this.$list.off("mouseleave.slick", e.proxy(this.interrupt, this, !1));
      }),
      (i.prototype.cleanUpRows = function () {
        var e;
        this.options.rows > 0 &&
          ((e = this.$slides.children().children()).removeAttr("style"),
          this.$slider.empty().append(e));
      }),
      (i.prototype.clickHandler = function (e) {
        !1 === this.shouldClick &&
          (e.stopImmediatePropagation(),
          e.stopPropagation(),
          e.preventDefault());
      }),
      (i.prototype.destroy = function (t) {
        var i = this;
        i.autoPlayClear(),
          (i.touchObject = {}),
          i.cleanUpEvents(),
          e(".slick-cloned", i.$slider).detach(),
          i.$dots && i.$dots.remove(),
          i.$prevArrow &&
            i.$prevArrow.length &&
            (i.$prevArrow
              .removeClass("slick-disabled slick-arrow slick-hidden")
              .removeAttr("aria-hidden aria-disabled tabindex")
              .css("display", ""),
            i.htmlExpr.test(i.options.prevArrow) && i.$prevArrow.remove()),
          i.$nextArrow &&
            i.$nextArrow.length &&
            (i.$nextArrow
              .removeClass("slick-disabled slick-arrow slick-hidden")
              .removeAttr("aria-hidden aria-disabled tabindex")
              .css("display", ""),
            i.htmlExpr.test(i.options.nextArrow) && i.$nextArrow.remove()),
          i.$slides &&
            (i.$slides
              .removeClass(
                "slick-slide slick-active slick-center slick-visible slick-current"
              )
              .removeAttr("aria-hidden")
              .removeAttr("data-slick-index")
              .each(function () {
                e(this).attr("style", e(this).data("originalStyling"));
              }),
            i.$slideTrack.children(this.options.slide).detach(),
            i.$slideTrack.detach(),
            i.$list.detach(),
            i.$slider.append(i.$slides)),
          i.cleanUpRows(),
          i.$slider.removeClass("slick-slider"),
          i.$slider.removeClass("slick-initialized"),
          i.$slider.removeClass("slick-dotted"),
          (i.unslicked = !0),
          t || i.$slider.trigger("destroy", [i]);
      }),
      (i.prototype.disableTransition = function (e) {
        var t = this,
          i = {};
        (i[t.transitionType] = ""),
          !1 === t.options.fade ? t.$slideTrack.css(i) : t.$slides.eq(e).css(i);
      }),
      (i.prototype.fadeSlide = function (e, t) {
        var i = this;
        !1 === i.cssTransitions
          ? (i.$slides.eq(e).css({ zIndex: i.options.zIndex }),
            i.$slides
              .eq(e)
              .animate({ opacity: 1 }, i.options.speed, i.options.easing, t))
          : (i.applyTransition(e),
            i.$slides.eq(e).css({ opacity: 1, zIndex: i.options.zIndex }),
            t &&
              setTimeout(function () {
                i.disableTransition(e), t.call();
              }, i.options.speed));
      }),
      (i.prototype.fadeSlideOut = function (e) {
        !1 === this.cssTransitions
          ? this.$slides
              .eq(e)
              .animate(
                { opacity: 0, zIndex: this.options.zIndex - 2 },
                this.options.speed,
                this.options.easing
              )
          : (this.applyTransition(e),
            this.$slides
              .eq(e)
              .css({ opacity: 0, zIndex: this.options.zIndex - 2 }));
      }),
      (i.prototype.filterSlides = i.prototype.slickFilter =
        function (e) {
          var t = this;
          null !== e &&
            ((t.$slidesCache = t.$slides),
            t.unload(),
            t.$slideTrack.children(this.options.slide).detach(),
            t.$slidesCache.filter(e).appendTo(t.$slideTrack),
            t.reinit());
        }),
      (i.prototype.focusHandler = function () {
        var t = this;
        t.$slider
          .off("focus.slick blur.slick")
          .on("focus.slick", "*", function (i) {
            var n = e(this);
            setTimeout(function () {
              t.options.pauseOnFocus &&
                n.is(":focus") &&
                ((t.focussed = !0), t.autoPlay());
            }, 0);
          })
          .on("blur.slick", "*", function (i) {
            e(this),
              t.options.pauseOnFocus && ((t.focussed = !1), t.autoPlay());
          });
      }),
      (i.prototype.getCurrent = i.prototype.slickCurrentSlide =
        function () {
          return this.currentSlide;
        }),
      (i.prototype.getDotCount = function () {
        var e = 0,
          t = 0,
          i = 0;
        if (!0 === this.options.infinite) {
          if (this.slideCount <= this.options.slidesToShow) ++i;
          else
            for (; e < this.slideCount; )
              ++i,
                (e = t + this.options.slidesToScroll),
                (t +=
                  this.options.slidesToScroll <= this.options.slidesToShow
                    ? this.options.slidesToScroll
                    : this.options.slidesToShow);
        } else if (!0 === this.options.centerMode) i = this.slideCount;
        else if (this.options.asNavFor)
          for (; e < this.slideCount; )
            ++i,
              (e = t + this.options.slidesToScroll),
              (t +=
                this.options.slidesToScroll <= this.options.slidesToShow
                  ? this.options.slidesToScroll
                  : this.options.slidesToShow);
        else
          i =
            1 +
            Math.ceil(
              (this.slideCount - this.options.slidesToShow) /
                this.options.slidesToScroll
            );
        return i - 1;
      }),
      (i.prototype.getLeft = function (e) {
        var t,
          i,
          n,
          o,
          s = this,
          r = 0;
        return (
          (s.slideOffset = 0),
          (i = s.$slides.first().outerHeight(!0)),
          !0 === s.options.infinite
            ? (s.slideCount > s.options.slidesToShow &&
                ((s.slideOffset = -(s.slideWidth * s.options.slidesToShow * 1)),
                (o = -1),
                !0 === s.options.vertical &&
                  !0 === s.options.centerMode &&
                  (2 === s.options.slidesToShow
                    ? (o = -1.5)
                    : 1 === s.options.slidesToShow && (o = -2)),
                (r = i * s.options.slidesToShow * o)),
              s.slideCount % s.options.slidesToScroll != 0 &&
                e + s.options.slidesToScroll > s.slideCount &&
                s.slideCount > s.options.slidesToShow &&
                (e > s.slideCount
                  ? ((s.slideOffset = -(
                      (s.options.slidesToShow - (e - s.slideCount)) *
                      s.slideWidth *
                      1
                    )),
                    (r = -(
                      (s.options.slidesToShow - (e - s.slideCount)) *
                      i *
                      1
                    )))
                  : ((s.slideOffset = -(
                      (s.slideCount % s.options.slidesToScroll) *
                      s.slideWidth *
                      1
                    )),
                    (r = -(
                      (s.slideCount % s.options.slidesToScroll) *
                      i *
                      1
                    )))))
            : e + s.options.slidesToShow > s.slideCount &&
              ((s.slideOffset =
                (e + s.options.slidesToShow - s.slideCount) * s.slideWidth),
              (r = (e + s.options.slidesToShow - s.slideCount) * i)),
          s.slideCount <= s.options.slidesToShow &&
            ((s.slideOffset = 0), (r = 0)),
          !0 === s.options.centerMode && s.slideCount <= s.options.slidesToShow
            ? (s.slideOffset =
                (s.slideWidth * Math.floor(s.options.slidesToShow)) / 2 -
                (s.slideWidth * s.slideCount) / 2)
            : !0 === s.options.centerMode && !0 === s.options.infinite
            ? (s.slideOffset +=
                s.slideWidth * Math.floor(s.options.slidesToShow / 2) -
                s.slideWidth)
            : !0 === s.options.centerMode &&
              ((s.slideOffset = 0),
              (s.slideOffset +=
                s.slideWidth * Math.floor(s.options.slidesToShow / 2))),
          (t =
            !1 === s.options.vertical
              ? -(e * s.slideWidth * 1) + s.slideOffset
              : -(e * i * 1) + r),
          !0 === s.options.variableWidth &&
            ((n =
              s.slideCount <= s.options.slidesToShow ||
              !1 === s.options.infinite
                ? s.$slideTrack.children(".slick-slide").eq(e)
                : s.$slideTrack
                    .children(".slick-slide")
                    .eq(e + s.options.slidesToShow)),
            (t =
              !0 === s.options.rtl
                ? n[0]
                  ? -((s.$slideTrack.width() - n[0].offsetLeft - n.width()) * 1)
                  : 0
                : n[0]
                ? -1 * n[0].offsetLeft
                : 0),
            !0 === s.options.centerMode &&
              ((n =
                s.slideCount <= s.options.slidesToShow ||
                !1 === s.options.infinite
                  ? s.$slideTrack.children(".slick-slide").eq(e)
                  : s.$slideTrack
                      .children(".slick-slide")
                      .eq(e + s.options.slidesToShow + 1)),
              (t =
                !0 === s.options.rtl
                  ? n[0]
                    ? -(
                        (s.$slideTrack.width() - n[0].offsetLeft - n.width()) *
                        1
                      )
                    : 0
                  : n[0]
                  ? -1 * n[0].offsetLeft
                  : 0),
              (t += (s.$list.width() - n.outerWidth()) / 2))),
          t
        );
      }),
      (i.prototype.getOption = i.prototype.slickGetOption =
        function (e) {
          return this.options[e];
        }),
      (i.prototype.getNavigableIndexes = function () {
        var e,
          t = 0,
          i = 0,
          n = [];
        for (
          !1 === this.options.infinite
            ? (e = this.slideCount)
            : ((t = -1 * this.options.slidesToScroll),
              (i = -1 * this.options.slidesToScroll),
              (e = 2 * this.slideCount));
          t < e;

        )
          n.push(t),
            (t = i + this.options.slidesToScroll),
            (i +=
              this.options.slidesToScroll <= this.options.slidesToShow
                ? this.options.slidesToScroll
                : this.options.slidesToShow);
        return n;
      }),
      (i.prototype.getSlick = function () {
        return this;
      }),
      (i.prototype.getSlideCount = function () {
        var t,
          i,
          n,
          o,
          s = this;
        return (
          (o =
            !0 === s.options.centerMode ? Math.floor(s.$list.width() / 2) : 0),
          (n = -1 * s.swipeLeft + o),
          !0 === s.options.swipeToSlide
            ? (s.$slideTrack.find(".slick-slide").each(function (t, o) {
                var r, a, l;
                if (
                  ((r = e(o).outerWidth()),
                  (a = o.offsetLeft),
                  !0 !== s.options.centerMode && (a += r / 2),
                  n < (l = a + r))
                )
                  return (i = o), !1;
              }),
              (t =
                Math.abs(e(i).attr("data-slick-index") - s.currentSlide) || 1))
            : s.options.slidesToScroll
        );
      }),
      (i.prototype.goTo = i.prototype.slickGoTo =
        function (e, t) {
          this.changeSlide(
            { data: { message: "index", index: parseInt(e) } },
            t
          );
        }),
      (i.prototype.init = function (t) {
        var i = this;
        e(i.$slider).hasClass("slick-initialized") ||
          (e(i.$slider).addClass("slick-initialized"),
          i.buildRows(),
          i.buildOut(),
          i.setProps(),
          i.startLoad(),
          i.loadSlider(),
          i.initializeEvents(),
          i.updateArrows(),
          i.updateDots(),
          i.checkResponsive(!0),
          i.focusHandler()),
          t && i.$slider.trigger("init", [i]),
          !0 === i.options.accessibility && i.initADA(),
          i.options.autoplay && ((i.paused = !1), i.autoPlay());
      }),
      (i.prototype.initADA = function () {
        var t = this,
          i = Math.ceil(t.slideCount / t.options.slidesToShow),
          n = t.getNavigableIndexes().filter(function (e) {
            return e >= 0 && e < t.slideCount;
          });
        t.$slides
          .add(t.$slideTrack.find(".slick-cloned"))
          .attr({ "aria-hidden": "true", tabindex: "-1" })
          .find("a, input, button, select")
          .attr({ tabindex: "-1" }),
          null !== t.$dots &&
            (t.$slides
              .not(t.$slideTrack.find(".slick-cloned"))
              .each(function (i) {
                var o = n.indexOf(i);
                if (
                  (e(this).attr({
                    role: "tabpanel",
                    id: "slick-slide" + t.instanceUid + i,
                    tabindex: -1,
                  }),
                  -1 !== o)
                ) {
                  var s = "slick-slide-control" + t.instanceUid + o;
                  e("#" + s).length && e(this).attr({ "aria-describedby": s });
                }
              }),
            t.$dots
              .attr("role", "tablist")
              .find("li")
              .each(function (o) {
                var s = n[o];
                e(this).attr({ role: "presentation" }),
                  e(this)
                    .find("button")
                    .first()
                    .attr({
                      role: "tab",
                      id: "slick-slide-control" + t.instanceUid + o,
                      "aria-controls": "slick-slide" + t.instanceUid + s,
                      "aria-label": o + 1 + " of " + i,
                      "aria-selected": null,
                      tabindex: "-1",
                    });
              })
              .eq(t.currentSlide)
              .find("button")
              .attr({ "aria-selected": "true", tabindex: "0" })
              .end());
        for (var o = t.currentSlide, s = o + t.options.slidesToShow; o < s; o++)
          t.options.focusOnChange
            ? t.$slides.eq(o).attr({ tabindex: "0" })
            : t.$slides.eq(o).removeAttr("tabindex");
        t.activateADA();
      }),
      (i.prototype.initArrowEvents = function () {
        !0 === this.options.arrows &&
          this.slideCount > this.options.slidesToShow &&
          (this.$prevArrow
            .off("click.slick")
            .on("click.slick", { message: "previous" }, this.changeSlide),
          this.$nextArrow
            .off("click.slick")
            .on("click.slick", { message: "next" }, this.changeSlide),
          !0 === this.options.accessibility &&
            (this.$prevArrow.on("keydown.slick", this.keyHandler),
            this.$nextArrow.on("keydown.slick", this.keyHandler)));
      }),
      (i.prototype.initDotEvents = function () {
        !0 === this.options.dots &&
          this.slideCount > this.options.slidesToShow &&
          (e("li", this.$dots).on(
            "click.slick",
            { message: "index" },
            this.changeSlide
          ),
          !0 === this.options.accessibility &&
            this.$dots.on("keydown.slick", this.keyHandler)),
          !0 === this.options.dots &&
            !0 === this.options.pauseOnDotsHover &&
            this.slideCount > this.options.slidesToShow &&
            e("li", this.$dots)
              .on("mouseenter.slick", e.proxy(this.interrupt, this, !0))
              .on("mouseleave.slick", e.proxy(this.interrupt, this, !1));
      }),
      (i.prototype.initSlideEvents = function () {
        this.options.pauseOnHover &&
          (this.$list.on("mouseenter.slick", e.proxy(this.interrupt, this, !0)),
          this.$list.on("mouseleave.slick", e.proxy(this.interrupt, this, !1)));
      }),
      (i.prototype.initializeEvents = function () {
        this.initArrowEvents(),
          this.initDotEvents(),
          this.initSlideEvents(),
          this.$list.on(
            "touchstart.slick mousedown.slick",
            { action: "start" },
            this.swipeHandler
          ),
          this.$list.on(
            "touchmove.slick mousemove.slick",
            { action: "move" },
            this.swipeHandler
          ),
          this.$list.on(
            "touchend.slick mouseup.slick",
            { action: "end" },
            this.swipeHandler
          ),
          this.$list.on(
            "touchcancel.slick mouseleave.slick",
            { action: "end" },
            this.swipeHandler
          ),
          this.$list.on("click.slick", this.clickHandler),
          e(document).on(this.visibilityChange, e.proxy(this.visibility, this)),
          !0 === this.options.accessibility &&
            this.$list.on("keydown.slick", this.keyHandler),
          !0 === this.options.focusOnSelect &&
            e(this.$slideTrack)
              .children()
              .on("click.slick", this.selectHandler),
          e(window).on(
            "orientationchange.slick.slick-" + this.instanceUid,
            e.proxy(this.orientationChange, this)
          ),
          e(window).on(
            "resize.slick.slick-" + this.instanceUid,
            e.proxy(this.resize, this)
          ),
          e("[draggable!=true]", this.$slideTrack).on(
            "dragstart",
            this.preventDefault
          ),
          e(window).on(
            "load.slick.slick-" + this.instanceUid,
            this.setPosition
          ),
          e(this.setPosition);
      }),
      (i.prototype.initUI = function () {
        !0 === this.options.arrows &&
          this.slideCount > this.options.slidesToShow &&
          (this.$prevArrow.show(), this.$nextArrow.show()),
          !0 === this.options.dots &&
            this.slideCount > this.options.slidesToShow &&
            this.$dots.show();
      }),
      (i.prototype.keyHandler = function (e) {
        e.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
          (37 === e.keyCode && !0 === this.options.accessibility
            ? this.changeSlide({
                data: {
                  message: !0 === this.options.rtl ? "next" : "previous",
                },
              })
            : 39 === e.keyCode &&
              !0 === this.options.accessibility &&
              this.changeSlide({
                data: {
                  message: !0 === this.options.rtl ? "previous" : "next",
                },
              }));
      }),
      (i.prototype.lazyLoad = function () {
        function t(t) {
          e("img[data-lazy]", t).each(function () {
            var t = e(this),
              i = e(this).attr("data-lazy"),
              n = e(this).attr("data-srcset"),
              o = e(this).attr("data-sizes") || r.$slider.attr("data-sizes"),
              s = document.createElement("img");
            (s.onload = function () {
              t.animate({ opacity: 0 }, 100, function () {
                n && (t.attr("srcset", n), o && t.attr("sizes", o)),
                  t.attr("src", i).animate({ opacity: 1 }, 200, function () {
                    t.removeAttr(
                      "data-lazy data-srcset data-sizes"
                    ).removeClass("slick-loading");
                  }),
                  r.$slider.trigger("lazyLoaded", [r, t, i]);
              });
            }),
              (s.onerror = function () {
                t
                  .removeAttr("data-lazy")
                  .removeClass("slick-loading")
                  .addClass("slick-lazyload-error"),
                  r.$slider.trigger("lazyLoadError", [r, t, i]);
              }),
              (s.src = i);
          });
        }
        var i,
          n,
          o,
          s,
          r = this;
        if (
          (!0 === r.options.centerMode
            ? !0 === r.options.infinite
              ? (s =
                  (o = r.currentSlide + (r.options.slidesToShow / 2 + 1)) +
                  r.options.slidesToShow +
                  2)
              : ((o = Math.max(
                  0,
                  r.currentSlide - (r.options.slidesToShow / 2 + 1)
                )),
                (s = 2 + (r.options.slidesToShow / 2 + 1) + r.currentSlide))
            : ((s = Math.ceil(
                (o = r.options.infinite
                  ? r.options.slidesToShow + r.currentSlide
                  : r.currentSlide) + r.options.slidesToShow
              )),
              !0 === r.options.fade &&
                (o > 0 && o--, s <= r.slideCount && s++)),
          (i = r.$slider.find(".slick-slide").slice(o, s)),
          "anticipated" === r.options.lazyLoad)
        )
          for (
            var a = o - 1, l = s, c = r.$slider.find(".slick-slide"), d = 0;
            d < r.options.slidesToScroll;
            d++
          )
            a < 0 && (a = r.slideCount - 1),
              (i = (i = i.add(c.eq(a))).add(c.eq(l))),
              a--,
              l++;
        t(i),
          r.slideCount <= r.options.slidesToShow
            ? t((n = r.$slider.find(".slick-slide")))
            : r.currentSlide >= r.slideCount - r.options.slidesToShow
            ? t(
                (n = r.$slider
                  .find(".slick-cloned")
                  .slice(0, r.options.slidesToShow))
              )
            : 0 === r.currentSlide &&
              t(
                (n = r.$slider
                  .find(".slick-cloned")
                  .slice(-1 * r.options.slidesToShow))
              );
      }),
      (i.prototype.loadSlider = function () {
        this.setPosition(),
          this.$slideTrack.css({ opacity: 1 }),
          this.$slider.removeClass("slick-loading"),
          this.initUI(),
          "progressive" === this.options.lazyLoad && this.progressiveLazyLoad();
      }),
      (i.prototype.next = i.prototype.slickNext =
        function () {
          this.changeSlide({ data: { message: "next" } });
        }),
      (i.prototype.orientationChange = function () {
        this.checkResponsive(), this.setPosition();
      }),
      (i.prototype.pause = i.prototype.slickPause =
        function () {
          var e = this;
          e.autoPlayClear(), (e.paused = !0);
        }),
      (i.prototype.play = i.prototype.slickPlay =
        function () {
          var e = this;
          e.autoPlay(),
            (e.options.autoplay = !0),
            (e.paused = !1),
            (e.focussed = !1),
            (e.interrupted = !1);
        }),
      (i.prototype.postSlide = function (t) {
        var i = this;
        !i.unslicked &&
          (i.$slider.trigger("afterChange", [i, t]),
          (i.animating = !1),
          i.slideCount > i.options.slidesToShow && i.setPosition(),
          (i.swipeLeft = null),
          i.options.autoplay && i.autoPlay(),
          !0 === i.options.accessibility &&
            (i.initADA(), i.options.focusOnChange)) &&
          e(i.$slides.get(i.currentSlide)).attr("tabindex", 0).focus();
      }),
      (i.prototype.prev = i.prototype.slickPrev =
        function () {
          this.changeSlide({ data: { message: "previous" } });
        }),
      (i.prototype.preventDefault = function (e) {
        e.preventDefault();
      }),
      (i.prototype.progressiveLazyLoad = function (t) {
        t = t || 1;
        var i,
          n,
          o,
          s,
          r,
          a = this,
          l = e("img[data-lazy]", a.$slider);
        l.length
          ? ((n = (i = l.first()).attr("data-lazy")),
            (o = i.attr("data-srcset")),
            (s = i.attr("data-sizes") || a.$slider.attr("data-sizes")),
            ((r = document.createElement("img")).onload = function () {
              o && (i.attr("srcset", o), s && i.attr("sizes", s)),
                i
                  .attr("src", n)
                  .removeAttr("data-lazy data-srcset data-sizes")
                  .removeClass("slick-loading"),
                !0 === a.options.adaptiveHeight && a.setPosition(),
                a.$slider.trigger("lazyLoaded", [a, i, n]),
                a.progressiveLazyLoad();
            }),
            (r.onerror = function () {
              t < 3
                ? setTimeout(function () {
                    a.progressiveLazyLoad(t + 1);
                  }, 500)
                : (i
                    .removeAttr("data-lazy")
                    .removeClass("slick-loading")
                    .addClass("slick-lazyload-error"),
                  a.$slider.trigger("lazyLoadError", [a, i, n]),
                  a.progressiveLazyLoad());
            }),
            (r.src = n))
          : a.$slider.trigger("allImagesLoaded", [a]);
      }),
      (i.prototype.refresh = function (t) {
        var i,
          n,
          o = this;
        (n = o.slideCount - o.options.slidesToShow),
          !o.options.infinite && o.currentSlide > n && (o.currentSlide = n),
          o.slideCount <= o.options.slidesToShow && (o.currentSlide = 0),
          (i = o.currentSlide),
          o.destroy(!0),
          e.extend(o, o.initials, { currentSlide: i }),
          o.init(),
          t || o.changeSlide({ data: { message: "index", index: i } }, !1);
      }),
      (i.prototype.registerBreakpoints = function () {
        var t,
          i,
          n,
          o = this,
          s = o.options.responsive || null;
        if ("array" === e.type(s) && s.length) {
          for (t in ((o.respondTo = o.options.respondTo || "window"), s))
            if (((n = o.breakpoints.length - 1), s.hasOwnProperty(t))) {
              for (i = s[t].breakpoint; n >= 0; )
                o.breakpoints[n] &&
                  o.breakpoints[n] === i &&
                  o.breakpoints.splice(n, 1),
                  n--;
              o.breakpoints.push(i), (o.breakpointSettings[i] = s[t].settings);
            }
          o.breakpoints.sort(function (e, t) {
            return o.options.mobileFirst ? e - t : t - e;
          });
        }
      }),
      (i.prototype.reinit = function () {
        var t = this;
        (t.$slides = t.$slideTrack
          .children(t.options.slide)
          .addClass("slick-slide")),
          (t.slideCount = t.$slides.length),
          t.currentSlide >= t.slideCount &&
            0 !== t.currentSlide &&
            (t.currentSlide = t.currentSlide - t.options.slidesToScroll),
          t.slideCount <= t.options.slidesToShow && (t.currentSlide = 0),
          t.registerBreakpoints(),
          t.setProps(),
          t.setupInfinite(),
          t.buildArrows(),
          t.updateArrows(),
          t.initArrowEvents(),
          t.buildDots(),
          t.updateDots(),
          t.initDotEvents(),
          t.cleanUpSlideEvents(),
          t.initSlideEvents(),
          t.checkResponsive(!1, !0),
          !0 === t.options.focusOnSelect &&
            e(t.$slideTrack).children().on("click.slick", t.selectHandler),
          t.setSlideClasses(
            "number" == typeof t.currentSlide ? t.currentSlide : 0
          ),
          t.setPosition(),
          t.focusHandler(),
          (t.paused = !t.options.autoplay),
          t.autoPlay(),
          t.$slider.trigger("reInit", [t]);
      }),
      (i.prototype.resize = function () {
        var t = this;
        e(window).width() !== t.windowWidth &&
          (clearTimeout(t.windowDelay),
          (t.windowDelay = window.setTimeout(function () {
            (t.windowWidth = e(window).width()),
              t.checkResponsive(),
              t.unslicked || t.setPosition();
          }, 50)));
      }),
      (i.prototype.removeSlide = i.prototype.slickRemove =
        function (e, t, i) {
          var n = this;
          return (
            (e =
              "boolean" == typeof e
                ? !0 === (t = e)
                  ? 0
                  : n.slideCount - 1
                : !0 === t
                ? --e
                : e),
            !(n.slideCount < 1 || e < 0 || e > n.slideCount - 1) &&
              (n.unload(),
              !0 === i
                ? n.$slideTrack.children().remove()
                : n.$slideTrack.children(this.options.slide).eq(e).remove(),
              (n.$slides = n.$slideTrack.children(this.options.slide)),
              n.$slideTrack.children(this.options.slide).detach(),
              n.$slideTrack.append(n.$slides),
              (n.$slidesCache = n.$slides),
              void n.reinit())
          );
        }),
      (i.prototype.setCSS = function (e) {
        var t,
          i,
          n = this,
          o = {};
        !0 === n.options.rtl && (e = -e),
          (t = "left" == n.positionProp ? Math.ceil(e) + "px" : "0px"),
          (i = "top" == n.positionProp ? Math.ceil(e) + "px" : "0px"),
          (o[n.positionProp] = e),
          !1 === n.transformsEnabled
            ? n.$slideTrack.css(o)
            : ((o = {}),
              !1 === n.cssTransitions
                ? ((o[n.animType] = "translate(" + t + ", " + i + ")"),
                  n.$slideTrack.css(o))
                : ((o[n.animType] = "translate3d(" + t + ", " + i + ", 0px)"),
                  n.$slideTrack.css(o)));
      }),
      (i.prototype.setDimensions = function () {
        var e = this;
        !1 === e.options.vertical
          ? !0 === e.options.centerMode &&
            e.$list.css({ padding: "0px " + e.options.centerPadding })
          : (e.$list.height(
              e.$slides.first().outerHeight(!0) * e.options.slidesToShow
            ),
            !0 === e.options.centerMode &&
              e.$list.css({ padding: e.options.centerPadding + " 0px" })),
          (e.listWidth = e.$list.width()),
          (e.listHeight = e.$list.height()),
          !1 === e.options.vertical && !1 === e.options.variableWidth
            ? ((e.slideWidth = Math.ceil(e.listWidth / e.options.slidesToShow)),
              e.$slideTrack.width(
                Math.ceil(
                  e.slideWidth * e.$slideTrack.children(".slick-slide").length
                )
              ))
            : !0 === e.options.variableWidth
            ? e.$slideTrack.width(5e3 * e.slideCount)
            : ((e.slideWidth = Math.ceil(e.listWidth)),
              e.$slideTrack.height(
                Math.ceil(
                  e.$slides.first().outerHeight(!0) *
                    e.$slideTrack.children(".slick-slide").length
                )
              ));
        var t = e.$slides.first().outerWidth(!0) - e.$slides.first().width();
        !1 === e.options.variableWidth &&
          e.$slideTrack.children(".slick-slide").width(e.slideWidth - t);
      }),
      (i.prototype.setFade = function () {
        var t,
          i = this;
        i.$slides.each(function (n, o) {
          (t = -(i.slideWidth * n * 1)),
            !0 === i.options.rtl
              ? e(o).css({
                  position: "relative",
                  right: t,
                  top: 0,
                  zIndex: i.options.zIndex - 2,
                  opacity: 0,
                })
              : e(o).css({
                  position: "relative",
                  left: t,
                  top: 0,
                  zIndex: i.options.zIndex - 2,
                  opacity: 0,
                });
        }),
          i.$slides
            .eq(i.currentSlide)
            .css({ zIndex: i.options.zIndex - 1, opacity: 1 });
      }),
      (i.prototype.setHeight = function () {
        if (
          1 === this.options.slidesToShow &&
          !0 === this.options.adaptiveHeight &&
          !1 === this.options.vertical
        ) {
          var e = this.$slides.eq(this.currentSlide).outerHeight(!0);
          this.$list.css("height", e);
        }
      }),
      (i.prototype.setOption = i.prototype.slickSetOption =
        function () {
          var t,
            i,
            n,
            o,
            s,
            r = this,
            a = !1;
          if (
            ("object" === e.type(arguments[0])
              ? ((n = arguments[0]), (a = arguments[1]), (s = "multiple"))
              : "string" === e.type(arguments[0]) &&
                ((n = arguments[0]),
                (o = arguments[1]),
                (a = arguments[2]),
                "responsive" === arguments[0] &&
                "array" === e.type(arguments[1])
                  ? (s = "responsive")
                  : void 0 !== arguments[1] && (s = "single")),
            "single" === s)
          )
            r.options[n] = o;
          else if ("multiple" === s)
            e.each(n, function (e, t) {
              r.options[e] = t;
            });
          else if ("responsive" === s)
            for (i in o)
              if ("array" !== e.type(r.options.responsive))
                r.options.responsive = [o[i]];
              else {
                for (t = r.options.responsive.length - 1; t >= 0; )
                  r.options.responsive[t].breakpoint === o[i].breakpoint &&
                    r.options.responsive.splice(t, 1),
                    t--;
                r.options.responsive.push(o[i]);
              }
          a && (r.unload(), r.reinit());
        }),
      (i.prototype.setPosition = function () {
        this.setDimensions(),
          this.setHeight(),
          !1 === this.options.fade
            ? this.setCSS(this.getLeft(this.currentSlide))
            : this.setFade(),
          this.$slider.trigger("setPosition", [this]);
      }),
      (i.prototype.setProps = function () {
        var e = this,
          t = document.body.style;
        (e.positionProp = !0 === e.options.vertical ? "top" : "left"),
          "top" === e.positionProp
            ? e.$slider.addClass("slick-vertical")
            : e.$slider.removeClass("slick-vertical"),
          (void 0 === t.WebkitTransition &&
            void 0 === t.MozTransition &&
            void 0 === t.msTransition) ||
            (!0 === e.options.useCSS && (e.cssTransitions = !0)),
          e.options.fade &&
            ("number" == typeof e.options.zIndex
              ? e.options.zIndex < 3 && (e.options.zIndex = 3)
              : (e.options.zIndex = e.defaults.zIndex)),
          void 0 !== t.OTransform &&
            ((e.animType = "OTransform"),
            (e.transformType = "-o-transform"),
            (e.transitionType = "OTransition"),
            void 0 === t.perspectiveProperty &&
              void 0 === t.webkitPerspective &&
              (e.animType = !1)),
          void 0 !== t.MozTransform &&
            ((e.animType = "MozTransform"),
            (e.transformType = "-moz-transform"),
            (e.transitionType = "MozTransition"),
            void 0 === t.perspectiveProperty &&
              void 0 === t.MozPerspective &&
              (e.animType = !1)),
          void 0 !== t.webkitTransform &&
            ((e.animType = "webkitTransform"),
            (e.transformType = "-webkit-transform"),
            (e.transitionType = "webkitTransition"),
            void 0 === t.perspectiveProperty &&
              void 0 === t.webkitPerspective &&
              (e.animType = !1)),
          void 0 !== t.msTransform &&
            ((e.animType = "msTransform"),
            (e.transformType = "-ms-transform"),
            (e.transitionType = "msTransition"),
            void 0 === t.msTransform && (e.animType = !1)),
          void 0 !== t.transform &&
            !1 !== e.animType &&
            ((e.animType = "transform"),
            (e.transformType = "transform"),
            (e.transitionType = "transition")),
          (e.transformsEnabled =
            e.options.useTransform && null !== e.animType && !1 !== e.animType);
      }),
      (i.prototype.setSlideClasses = function (e) {
        var t, i, n, o;
        if (
          ((i = this.$slider
            .find(".slick-slide")
            .removeClass("slick-active slick-center slick-current")
            .attr("aria-hidden", "true")),
          this.$slides.eq(e).addClass("slick-current"),
          !0 === this.options.centerMode)
        ) {
          var s = this.options.slidesToShow % 2 == 0 ? 1 : 0;
          (t = Math.floor(this.options.slidesToShow / 2)),
            !0 === this.options.infinite &&
              (e >= t && e <= this.slideCount - 1 - t
                ? this.$slides
                    .slice(e - t + s, e + t + 1)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false")
                : ((n = this.options.slidesToShow + e),
                  i
                    .slice(n - t + 1 + s, n + t + 2)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false")),
              0 === e
                ? i
                    .eq(i.length - 1 - this.options.slidesToShow)
                    .addClass("slick-center")
                : e === this.slideCount - 1 &&
                  i.eq(this.options.slidesToShow).addClass("slick-center")),
            this.$slides.eq(e).addClass("slick-center");
        } else
          e >= 0 && e <= this.slideCount - this.options.slidesToShow
            ? this.$slides
                .slice(e, e + this.options.slidesToShow)
                .addClass("slick-active")
                .attr("aria-hidden", "false")
            : i.length <= this.options.slidesToShow
            ? i.addClass("slick-active").attr("aria-hidden", "false")
            : ((o = this.slideCount % this.options.slidesToShow),
              (n =
                !0 === this.options.infinite
                  ? this.options.slidesToShow + e
                  : e),
              this.options.slidesToShow == this.options.slidesToScroll &&
              this.slideCount - e < this.options.slidesToShow
                ? i
                    .slice(n - (this.options.slidesToShow - o), n + o)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false")
                : i
                    .slice(n, n + this.options.slidesToShow)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false"));
        ("ondemand" !== this.options.lazyLoad &&
          "anticipated" !== this.options.lazyLoad) ||
          this.lazyLoad();
      }),
      (i.prototype.setupInfinite = function () {
        var t,
          i,
          n,
          o = this;
        if (
          (!0 === o.options.fade && (o.options.centerMode = !1),
          !0 === o.options.infinite &&
            !1 === o.options.fade &&
            ((i = null), o.slideCount > o.options.slidesToShow))
        ) {
          for (
            n =
              !0 === o.options.centerMode
                ? o.options.slidesToShow + 1
                : o.options.slidesToShow,
              t = o.slideCount;
            t > o.slideCount - n;
            t -= 1
          )
            (i = t - 1),
              e(o.$slides[i])
                .clone(!0)
                .attr("id", "")
                .attr("data-slick-index", i - o.slideCount)
                .prependTo(o.$slideTrack)
                .addClass("slick-cloned");
          for (t = 0; t < n + o.slideCount; t += 1)
            (i = t),
              e(o.$slides[i])
                .clone(!0)
                .attr("id", "")
                .attr("data-slick-index", i + o.slideCount)
                .appendTo(o.$slideTrack)
                .addClass("slick-cloned");
          o.$slideTrack
            .find(".slick-cloned")
            .find("[id]")
            .each(function () {
              e(this).attr("id", "");
            });
        }
      }),
      (i.prototype.interrupt = function (e) {
        var t = this;
        e || t.autoPlay(), (t.interrupted = e);
      }),
      (i.prototype.selectHandler = function (t) {
        var i = e(t.target).is(".slick-slide")
            ? e(t.target)
            : e(t.target).parents(".slick-slide"),
          n = parseInt(i.attr("data-slick-index"));
        return (
          n || (n = 0),
          this.slideCount <= this.options.slidesToShow
            ? void this.slideHandler(n, !1, !0)
            : void this.slideHandler(n)
        );
      }),
      (i.prototype.slideHandler = function (e, t, i) {
        var n,
          o,
          s,
          r,
          a,
          l = null,
          c = this;
        if (
          ((t = t || !1),
          !(
            (!0 === c.animating && !0 === c.options.waitForAnimate) ||
            (!0 === c.options.fade && c.currentSlide === e)
          ))
        )
          return (
            !1 === t && c.asNavFor(e),
            (n = e),
            (l = c.getLeft(n)),
            (r = c.getLeft(c.currentSlide)),
            (c.currentLeft = null === c.swipeLeft ? r : c.swipeLeft),
            !1 === c.options.infinite &&
            !1 === c.options.centerMode &&
            (e < 0 || e > c.getDotCount() * c.options.slidesToScroll)
              ? void (
                  !1 === c.options.fade &&
                  ((n = c.currentSlide),
                  !0 !== i && c.slideCount > c.options.slidesToShow
                    ? c.animateSlide(r, function () {
                        c.postSlide(n);
                      })
                    : c.postSlide(n))
                )
              : !1 === c.options.infinite &&
                !0 === c.options.centerMode &&
                (e < 0 || e > c.slideCount - c.options.slidesToScroll)
              ? void (
                  !1 === c.options.fade &&
                  ((n = c.currentSlide),
                  !0 !== i && c.slideCount > c.options.slidesToShow
                    ? c.animateSlide(r, function () {
                        c.postSlide(n);
                      })
                    : c.postSlide(n))
                )
              : (c.options.autoplay && clearInterval(c.autoPlayTimer),
                (o =
                  n < 0
                    ? c.slideCount % c.options.slidesToScroll != 0
                      ? c.slideCount - (c.slideCount % c.options.slidesToScroll)
                      : c.slideCount + n
                    : n >= c.slideCount
                    ? c.slideCount % c.options.slidesToScroll != 0
                      ? 0
                      : n - c.slideCount
                    : n),
                (c.animating = !0),
                c.$slider.trigger("beforeChange", [c, c.currentSlide, o]),
                (s = c.currentSlide),
                (c.currentSlide = o),
                c.setSlideClasses(c.currentSlide),
                c.options.asNavFor &&
                  (a = (a = c.getNavTarget()).slick("getSlick")).slideCount <=
                    a.options.slidesToShow &&
                  a.setSlideClasses(c.currentSlide),
                c.updateDots(),
                c.updateArrows(),
                !0 === c.options.fade
                  ? (!0 !== i
                      ? (c.fadeSlideOut(s),
                        c.fadeSlide(o, function () {
                          c.postSlide(o);
                        }))
                      : c.postSlide(o),
                    void c.animateHeight())
                  : void (!0 !== i && c.slideCount > c.options.slidesToShow
                      ? c.animateSlide(l, function () {
                          c.postSlide(o);
                        })
                      : c.postSlide(o)))
          );
      }),
      (i.prototype.startLoad = function () {
        !0 === this.options.arrows &&
          this.slideCount > this.options.slidesToShow &&
          (this.$prevArrow.hide(), this.$nextArrow.hide()),
          !0 === this.options.dots &&
            this.slideCount > this.options.slidesToShow &&
            this.$dots.hide(),
          this.$slider.addClass("slick-loading");
      }),
      (i.prototype.swipeDirection = function () {
        var e, t, i, n;
        return (
          (e = this.touchObject.startX - this.touchObject.curX),
          (n = Math.round(
            (180 *
              (i = Math.atan2(
                (t = this.touchObject.startY - this.touchObject.curY),
                e
              ))) /
              Math.PI
          )) < 0 && (n = 360 - Math.abs(n)),
          n <= 45 && n >= 0
            ? !1 === this.options.rtl
              ? "left"
              : "right"
            : n <= 360 && n >= 315
            ? !1 === this.options.rtl
              ? "left"
              : "right"
            : n >= 135 && n <= 225
            ? !1 === this.options.rtl
              ? "right"
              : "left"
            : !0 === this.options.verticalSwiping
            ? n >= 35 && n <= 135
              ? "down"
              : "up"
            : "vertical"
        );
      }),
      (i.prototype.swipeEnd = function (e) {
        var t,
          i,
          n = this;
        if (((n.dragging = !1), (n.swiping = !1), n.scrolling))
          return (n.scrolling = !1), !1;
        if (
          ((n.interrupted = !1),
          (n.shouldClick = !(n.touchObject.swipeLength > 10)),
          void 0 === n.touchObject.curX)
        )
          return !1;
        if (
          (!0 === n.touchObject.edgeHit &&
            n.$slider.trigger("edge", [n, n.swipeDirection()]),
          n.touchObject.swipeLength >= n.touchObject.minSwipe)
        ) {
          switch ((i = n.swipeDirection())) {
            case "left":
            case "down":
              (t = n.options.swipeToSlide
                ? n.checkNavigable(n.currentSlide + n.getSlideCount())
                : n.currentSlide + n.getSlideCount()),
                (n.currentDirection = 0);
              break;
            case "right":
            case "up":
              (t = n.options.swipeToSlide
                ? n.checkNavigable(n.currentSlide - n.getSlideCount())
                : n.currentSlide - n.getSlideCount()),
                (n.currentDirection = 1);
          }
          "vertical" != i &&
            (n.slideHandler(t),
            (n.touchObject = {}),
            n.$slider.trigger("swipe", [n, i]));
        } else
          n.touchObject.startX !== n.touchObject.curX &&
            (n.slideHandler(n.currentSlide), (n.touchObject = {}));
      }),
      (i.prototype.swipeHandler = function (e) {
        var t = this;
        if (
          !(
            !1 === t.options.swipe ||
            ("ontouchend" in document && !1 === t.options.swipe) ||
            (!1 === t.options.draggable && -1 !== e.type.indexOf("mouse"))
          )
        )
          switch (
            ((t.touchObject.fingerCount =
              e.originalEvent && void 0 !== e.originalEvent.touches
                ? e.originalEvent.touches.length
                : 1),
            (t.touchObject.minSwipe = t.listWidth / t.options.touchThreshold),
            !0 === t.options.verticalSwiping &&
              (t.touchObject.minSwipe =
                t.listHeight / t.options.touchThreshold),
            e.data.action)
          ) {
            case "start":
              t.swipeStart(e);
              break;
            case "move":
              t.swipeMove(e);
              break;
            case "end":
              t.swipeEnd(e);
          }
      }),
      (i.prototype.swipeMove = function (e) {
        var t,
          i,
          n,
          o,
          s,
          r,
          a = this;
        return (
          (s = void 0 !== e.originalEvent ? e.originalEvent.touches : null),
          !(!a.dragging || a.scrolling || (s && 1 !== s.length)) &&
            ((t = a.getLeft(a.currentSlide)),
            (a.touchObject.curX = void 0 !== s ? s[0].pageX : e.clientX),
            (a.touchObject.curY = void 0 !== s ? s[0].pageY : e.clientY),
            (a.touchObject.swipeLength = Math.round(
              Math.sqrt(Math.pow(a.touchObject.curX - a.touchObject.startX, 2))
            )),
            (r = Math.round(
              Math.sqrt(Math.pow(a.touchObject.curY - a.touchObject.startY, 2))
            )),
            a.options.verticalSwiping || a.swiping || !(r > 4)
              ? (!0 === a.options.verticalSwiping &&
                  (a.touchObject.swipeLength = r),
                (i = a.swipeDirection()),
                void 0 !== e.originalEvent &&
                  a.touchObject.swipeLength > 4 &&
                  ((a.swiping = !0), e.preventDefault()),
                (o =
                  (!1 === a.options.rtl ? 1 : -1) *
                  (a.touchObject.curX > a.touchObject.startX ? 1 : -1)),
                !0 === a.options.verticalSwiping &&
                  (o = a.touchObject.curY > a.touchObject.startY ? 1 : -1),
                (n = a.touchObject.swipeLength),
                (a.touchObject.edgeHit = !1),
                !1 === a.options.infinite &&
                  ((0 === a.currentSlide && "right" === i) ||
                    (a.currentSlide >= a.getDotCount() && "left" === i)) &&
                  ((n = a.touchObject.swipeLength * a.options.edgeFriction),
                  (a.touchObject.edgeHit = !0)),
                !1 === a.options.vertical
                  ? (a.swipeLeft = t + n * o)
                  : (a.swipeLeft =
                      t + n * (a.$list.height() / a.listWidth) * o),
                !0 === a.options.verticalSwiping && (a.swipeLeft = t + n * o),
                !0 !== a.options.fade &&
                  !1 !== a.options.touchMove &&
                  (!0 === a.animating
                    ? ((a.swipeLeft = null), !1)
                    : void a.setCSS(a.swipeLeft)))
              : ((a.scrolling = !0), !1))
        );
      }),
      (i.prototype.swipeStart = function (e) {
        var t,
          i = this;
        return (
          (i.interrupted = !0),
          1 !== i.touchObject.fingerCount ||
          i.slideCount <= i.options.slidesToShow
            ? ((i.touchObject = {}), !1)
            : (void 0 !== e.originalEvent &&
                void 0 !== e.originalEvent.touches &&
                (t = e.originalEvent.touches[0]),
              (i.touchObject.startX = i.touchObject.curX =
                void 0 !== t ? t.pageX : e.clientX),
              (i.touchObject.startY = i.touchObject.curY =
                void 0 !== t ? t.pageY : e.clientY),
              void (i.dragging = !0))
        );
      }),
      (i.prototype.unfilterSlides = i.prototype.slickUnfilter =
        function () {
          null !== this.$slidesCache &&
            (this.unload(),
            this.$slideTrack.children(this.options.slide).detach(),
            this.$slidesCache.appendTo(this.$slideTrack),
            this.reinit());
        }),
      (i.prototype.unload = function () {
        e(".slick-cloned", this.$slider).remove(),
          this.$dots && this.$dots.remove(),
          this.$prevArrow &&
            this.htmlExpr.test(this.options.prevArrow) &&
            this.$prevArrow.remove(),
          this.$nextArrow &&
            this.htmlExpr.test(this.options.nextArrow) &&
            this.$nextArrow.remove(),
          this.$slides
            .removeClass("slick-slide slick-active slick-visible slick-current")
            .attr("aria-hidden", "true")
            .css("width", "");
      }),
      (i.prototype.unslick = function (e) {
        this.$slider.trigger("unslick", [this, e]), this.destroy();
      }),
      (i.prototype.updateArrows = function () {
        var e;
        (e = Math.floor(this.options.slidesToShow / 2)),
          !0 === this.options.arrows &&
            this.slideCount > this.options.slidesToShow &&
            !this.options.infinite &&
            (this.$prevArrow
              .removeClass("slick-disabled")
              .attr("aria-disabled", "false"),
            this.$nextArrow
              .removeClass("slick-disabled")
              .attr("aria-disabled", "false"),
            0 === this.currentSlide
              ? (this.$prevArrow
                  .addClass("slick-disabled")
                  .attr("aria-disabled", "true"),
                this.$nextArrow
                  .removeClass("slick-disabled")
                  .attr("aria-disabled", "false"))
              : this.currentSlide >=
                  this.slideCount - this.options.slidesToShow &&
                !1 === this.options.centerMode
              ? (this.$nextArrow
                  .addClass("slick-disabled")
                  .attr("aria-disabled", "true"),
                this.$prevArrow
                  .removeClass("slick-disabled")
                  .attr("aria-disabled", "false"))
              : this.currentSlide >= this.slideCount - 1 &&
                !0 === this.options.centerMode &&
                (this.$nextArrow
                  .addClass("slick-disabled")
                  .attr("aria-disabled", "true"),
                this.$prevArrow
                  .removeClass("slick-disabled")
                  .attr("aria-disabled", "false")));
      }),
      (i.prototype.updateDots = function () {
        null !== this.$dots &&
          (this.$dots.find("li").removeClass("slick-active").end(),
          this.$dots
            .find("li")
            .eq(Math.floor(this.currentSlide / this.options.slidesToScroll))
            .addClass("slick-active"));
      }),
      (i.prototype.visibility = function () {
        var e = this;
        e.options.autoplay &&
          (document[e.hidden] ? (e.interrupted = !0) : (e.interrupted = !1));
      }),
      (e.fn.slick = function () {
        var e,
          t,
          n = this,
          o = arguments[0],
          s = Array.prototype.slice.call(arguments, 1),
          r = n.length;
        for (e = 0; e < r; e++)
          if (
            ("object" == typeof o || void 0 === o
              ? (n[e].slick = new i(n[e], o))
              : (t = n[e].slick[o].apply(n[e].slick, s)),
            void 0 !== t)
          )
            return t;
        return n;
      });
  }),
  (function (e) {
    var t = e(window);
    e.fn.visible = function (e, i, n) {
      if (!(this.length < 1)) {
        var o = this.length > 1 ? this.eq(0) : this,
          s = o.get(0),
          r = t.width(),
          a = t.height(),
          n = n || "both",
          l = !0 !== i || s.offsetWidth * s.offsetHeight;
        if ("function" == typeof s.getBoundingClientRect) {
          var c = s.getBoundingClientRect(),
            d = c.top >= 0 && c.top < a,
            u = c.bottom > 0 && c.bottom <= a,
            p = c.left >= 0 && c.left < r,
            h = c.right > 0 && c.right <= r,
            f = e ? d || u : d && u,
            g = e ? p || h : p && h;
          if ("both" === n) return l && f && g;
          if ("vertical" === n) return l && f;
          if ("horizontal" === n) return l && g;
        } else {
          var m = t.scrollTop(),
            v = m + a,
            y = t.scrollLeft(),
            b = y + r,
            k = o.offset(),
            x = k.top,
            C = x + o.height(),
            w = k.left,
            S = w + o.width(),
            T = !0 === e ? C : x,
            _ = !0 === e ? x : C,
            E = !0 === e ? S : w,
            P = !0 === e ? w : S;
          if ("both" === n) return !!l && v >= _ && T >= m && b >= P && E >= y;
          if ("vertical" === n) return !!l && v >= _ && T >= m;
          if ("horizontal" === n) return !!l && b >= P && E >= y;
        }
      }
    };
  })(jQuery),
  (ajaxify = function (e) {
    var t,
      i,
      n,
      o,
      s,
      r,
      a = (e = e || {}).linkParent || ".pagination",
      l = e.parentContainer || "#MainContent",
      c = e.endlessScrollContainer || ".EndlessScroll",
      d = e.endlessClickContainer || ".EndlessClick",
      u = e.endlessOffset || 0,
      p = e.ajaxinateContainer || ".Ajaxinate",
      h = e.ajaxinateLink || ".page a",
      f =
        $(c).closest("[data-section-id]").data("section-id") ||
        $(d).closest("[data-section-id]").data("section-id") ||
        $(p).closest("[data-section-id]").data("section-id") ||
        "",
      g = e.fade || "fast",
      m = e.textChange || "Loading";
    let v = e.callback || !1;
    ($.loadMore = function () {
      r.length
        ? $.ajax({
            type: "GET",
            dataType: "html",
            url: r,
            success: function (e) {
              "ajax" == o
                ? ($(p)
                    .not('[data-page="' + n + '"]')
                    .hide(),
                  history.pushState({}, n, r))
                : $(t).fadeOut(g);
              var s = $(e).find(i).html();
              $(i).find(".gridSpacer, .pagination").remove().end().append(s),
                "endlessScroll" == o
                  ? $.endlessScroll()
                  : "ajax" == o
                  ? $.ajaxinationClick()
                  : "endlessClick" == o && $.endlessClick(),
                $(document).trigger("ajaxify:updated", [e]),
                v && "function" == typeof v && v(e);
            },
          })
        : $(document).trigger("ajaxify:updated");
    }),
      ($.endlessScroll = function () {
        (s = "scroll.endlessScroll--" + f + " load resize.endlessScroll--" + f),
          $(window).on(s, function () {
            if (
              ((i = c),
              (r = $(i + ":last-of-type " + t).attr("href")),
              (o = "endlessScroll"),
              $(t).text(m),
              $(i + ":last-of-type " + t).length)
            ) {
              var e = $(l).outerHeight();
              $(document).scrollTop() + $(window).height() + u > e &&
                ($(window).off(s), $.loadMore());
            }
          });
      }),
      ($.endlessClick = function () {
        $(t).on("click", function (e) {
          e.preventDefault(),
            (s = "click"),
            (i = d),
            (r = $(this).attr("href")),
            (o = "endlessClick"),
            $(t).text(m),
            $(t).off(s),
            $(t).on("click", function (e) {
              e.preventDefault();
            }),
            $.loadMore();
        });
      }),
      ($.ajaxinationClick = function () {
        $(t).on("click", function (e) {
          e.preventDefault(),
            (s = "click"),
            (i = p),
            (r = $(this).attr("href")),
            (n = $(this).attr("data-number")),
            (o = "ajax"),
            $(i + '[data-page="' + n + '"]').length
              ? ($(i)
                  .not('[data-page="' + n + '"]')
                  .hide(),
                $(i + '[data-page="' + n + '"]').fadeIn(g),
                history.pushState({}, n, r))
              : ($(t).off(s), $.loadMore()),
            $("html, body").animate({ scrollTop: $(l).offset().top }, 300);
        });
      }),
      $(d).length && ((t = a + " a"), $.endlessClick()),
      $(p).length && ((t = h), $.ajaxinationClick()),
      $(c).length && ((t = a + " a"), $.endlessScroll());
  }),
  (function (e, t) {
    "object" == typeof exports && "object" == typeof module
      ? (module.exports = t())
      : "function" == typeof define && define.amd
      ? define([], t)
      : "object" == typeof exports
      ? (exports.scrollLock = t())
      : (e.scrollLock = t());
  })(this, function () {
    return (function (e) {
      var t = {};
      function i(n) {
        if (t[n]) return t[n].exports;
        var o = (t[n] = { i: n, l: !1, exports: {} });
        return e[n].call(o.exports, o, o.exports, i), (o.l = !0), o.exports;
      }
      return (
        (i.m = e),
        (i.c = t),
        (i.d = function (e, t, n) {
          i.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: n });
        }),
        (i.r = function (e) {
          "undefined" != typeof Symbol &&
            Symbol.toStringTag &&
            Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
            Object.defineProperty(e, "__esModule", { value: !0 });
        }),
        (i.t = function (e, t) {
          if (
            (1 & t && (e = i(e)),
            8 & t || (4 & t && "object" == typeof e && e && e.__esModule))
          )
            return e;
          var n = Object.create(null);
          if (
            (i.r(n),
            Object.defineProperty(n, "default", { enumerable: !0, value: e }),
            2 & t && "string" != typeof e)
          )
            for (var o in e)
              i.d(
                n,
                o,
                function (t) {
                  return e[t];
                }.bind(null, o)
              );
          return n;
        }),
        (i.n = function (e) {
          var t =
            e && e.__esModule
              ? function () {
                  return e.default;
                }
              : function () {
                  return e;
                };
          return i.d(t, "a", t), t;
        }),
        (i.o = function (e, t) {
          return Object.prototype.hasOwnProperty.call(e, t);
        }),
        (i.p = ""),
        i((i.s = 0))
      );
    })([
      function (e, t, i) {
        "use strict";
        i.r(t);
        var n = function (e) {
            return Array.isArray(e) ? e : [e];
          },
          o = function (e) {
            return e instanceof Node;
          },
          s = function (e, t) {
            if (e && t) {
              e = e instanceof NodeList ? e : [e];
              for (var i = 0; i < e.length && !0 !== t(e[i], i, e.length); i++);
            }
          },
          r = function (e) {
            return console.error("[scroll-lock] ".concat(e));
          },
          a = function (e) {
            if (Array.isArray(e)) return e.join(", ");
          },
          l = function (e) {
            var t = [];
            return (
              s(e, function (e) {
                return t.push(e);
              }),
              t
            );
          },
          c = function (e, t) {
            var i =
                !(2 < arguments.length && void 0 !== arguments[2]) ||
                arguments[2],
              n =
                3 < arguments.length && void 0 !== arguments[3]
                  ? arguments[3]
                  : document;
            if (i && -1 !== l(n.querySelectorAll(t)).indexOf(e)) return e;
            for (
              ;
              (e = e.parentElement) &&
              -1 === l(n.querySelectorAll(t)).indexOf(e);

            );
            return e;
          },
          d = function (e, t) {
            var i =
              2 < arguments.length && void 0 !== arguments[2]
                ? arguments[2]
                : document;
            return -1 !== l(i.querySelectorAll(t)).indexOf(e);
          },
          u = function (e) {
            if (e) return "hidden" === getComputedStyle(e).overflow;
          },
          p = function (e) {
            if (e) return !!u(e) || e.scrollTop <= 0;
          },
          h = function (e) {
            if (e) {
              if (u(e)) return !0;
              var t = e.scrollTop;
              return e.scrollHeight <= t + e.offsetHeight;
            }
          },
          f = function (e) {
            if (e) return !!u(e) || e.scrollLeft <= 0;
          },
          g = function (e) {
            if (e) {
              if (u(e)) return !0;
              var t = e.scrollLeft;
              return e.scrollWidth <= t + e.offsetWidth;
            }
          };
        i.d(t, "disablePageScroll", function () {
          return y;
        }),
          i.d(t, "enablePageScroll", function () {
            return b;
          }),
          i.d(t, "getScrollState", function () {
            return k;
          }),
          i.d(t, "clearQueueScrollLocks", function () {
            return x;
          }),
          i.d(t, "getTargetScrollBarWidth", function () {
            return C;
          }),
          i.d(t, "getCurrentTargetScrollBarWidth", function () {
            return w;
          }),
          i.d(t, "getPageScrollBarWidth", function () {
            return S;
          }),
          i.d(t, "getCurrentPageScrollBarWidth", function () {
            return T;
          }),
          i.d(t, "addScrollableTarget", function () {
            return _;
          }),
          i.d(t, "removeScrollableTarget", function () {
            return E;
          }),
          i.d(t, "addScrollableSelector", function () {
            return P;
          }),
          i.d(t, "removeScrollableSelector", function () {
            return A;
          }),
          i.d(t, "addLockableTarget", function () {
            return L;
          }),
          i.d(t, "addLockableSelector", function () {
            return j;
          }),
          i.d(t, "setFillGapMethod", function () {
            return I;
          }),
          i.d(t, "addFillGapTarget", function () {
            return D;
          }),
          i.d(t, "removeFillGapTarget", function () {
            return z;
          }),
          i.d(t, "addFillGapSelector", function () {
            return M;
          }),
          i.d(t, "removeFillGapSelector", function () {
            return q;
          }),
          i.d(t, "refillGaps", function () {
            return O;
          });
        var m = ["padding", "margin", "width", "max-width", "none"],
          v = {
            scroll: !0,
            queue: 0,
            scrollableSelectors: ["[data-scroll-lock-scrollable]"],
            lockableSelectors: ["body", "[data-scroll-lock-lockable]"],
            fillGapSelectors: [
              "body",
              "[data-scroll-lock-fill-gap]",
              "[data-scroll-lock-lockable]",
            ],
            fillGapMethod: m[0],
            startTouchY: 0,
            startTouchX: 0,
          },
          y = function (e) {
            v.queue <= 0 && ((v.scroll = !1), F(), V()), _(e), v.queue++;
          },
          b = function (e) {
            0 < v.queue && v.queue--,
              v.queue <= 0 && ((v.scroll = !0), H(), U()),
              E(e);
          },
          k = function () {
            return v.scroll;
          },
          x = function () {
            v.queue = 0;
          },
          C = function (e) {
            var t =
              1 < arguments.length && void 0 !== arguments[1] && arguments[1];
            if (o(e)) {
              var i = e.style.overflowY;
              t
                ? k() ||
                  (e.style.overflowY = e.getAttribute(
                    "data-scroll-lock-saved-overflow-y-property"
                  ))
                : (e.style.overflowY = "scroll");
              var n = w(e);
              return (e.style.overflowY = i), n;
            }
            return 0;
          },
          w = function (e) {
            if (o(e)) {
              if (e === document.body) {
                var t = document.documentElement.clientWidth;
                return window.innerWidth - t;
              }
              var i = e.style.borderLeftWidth,
                n = e.style.borderRightWidth;
              (e.style.borderLeftWidth = "0px"),
                (e.style.borderRightWidth = "0px");
              var s = e.offsetWidth - e.clientWidth;
              return (
                (e.style.borderLeftWidth = i), (e.style.borderRightWidth = n), s
              );
            }
            return 0;
          },
          S = function () {
            var e =
              0 < arguments.length && void 0 !== arguments[0] && arguments[0];
            return C(document.body, e);
          },
          T = function () {
            return w(document.body);
          },
          _ = function (e) {
            e &&
              n(e).map(function (e) {
                s(e, function (e) {
                  o(e)
                    ? e.setAttribute("data-scroll-lock-scrollable", "")
                    : r('"'.concat(e, '" is not a Element.'));
                });
              });
          },
          E = function (e) {
            e &&
              n(e).map(function (e) {
                s(e, function (e) {
                  o(e)
                    ? e.removeAttribute("data-scroll-lock-scrollable")
                    : r('"'.concat(e, '" is not a Element.'));
                });
              });
          },
          P = function (e) {
            e &&
              n(e).map(function (e) {
                v.scrollableSelectors.push(e);
              });
          },
          A = function (e) {
            e &&
              n(e).map(function (e) {
                v.scrollableSelectors = v.scrollableSelectors.filter(function (
                  t
                ) {
                  return t !== e;
                });
              });
          },
          L = function (e) {
            e &&
              (n(e).map(function (e) {
                s(e, function (e) {
                  o(e)
                    ? e.setAttribute("data-scroll-lock-lockable", "")
                    : r('"'.concat(e, '" is not a Element.'));
                });
              }),
              k() || F());
          },
          j = function (e) {
            e &&
              (n(e).map(function (e) {
                v.lockableSelectors.push(e);
              }),
              k() || F(),
              M(e));
          },
          I = function (e) {
            if (e) {
              if (-1 !== m.indexOf(e)) (v.fillGapMethod = e), O();
              else {
                var t = m.join(", ");
                r(
                  '"'
                    .concat(
                      e,
                      '" method is not available!\nAvailable fill gap methods: '
                    )
                    .concat(t, ".")
                );
              }
            }
          },
          D = function (e) {
            e &&
              n(e).map(function (e) {
                s(e, function (e) {
                  o(e)
                    ? (e.setAttribute("data-scroll-lock-fill-gap", ""),
                      v.scroll || X(e))
                    : r('"'.concat(e, '" is not a Element.'));
                });
              });
          },
          z = function (e) {
            e &&
              n(e).map(function (e) {
                s(e, function (e) {
                  o(e)
                    ? (e.removeAttribute("data-scroll-lock-fill-gap"),
                      v.scroll || Q(e))
                    : r('"'.concat(e, '" is not a Element.'));
                });
              });
          },
          M = function (e) {
            e &&
              n(e).map(function (e) {
                -1 === v.fillGapSelectors.indexOf(e) &&
                  (v.fillGapSelectors.push(e), v.scroll || G(e));
              });
          },
          q = function (e) {
            e &&
              n(e).map(function (e) {
                (v.fillGapSelectors = v.fillGapSelectors.filter(function (t) {
                  return t !== e;
                })),
                  v.scroll || Y(e);
              });
          },
          O = function () {
            v.scroll || V();
          },
          F = function () {
            var e = a(v.lockableSelectors);
            W(e);
          },
          H = function () {
            var e = a(v.lockableSelectors);
            N(e);
          },
          W = function (e) {
            s(document.querySelectorAll(e), function (e) {
              B(e);
            });
          },
          N = function (e) {
            s(document.querySelectorAll(e), function (e) {
              R(e);
            });
          },
          B = function (e) {
            if (o(e) && "true" !== e.getAttribute("data-scroll-lock-locked")) {
              var t = window.getComputedStyle(e);
              e.setAttribute(
                "data-scroll-lock-saved-overflow-y-property",
                t.overflowY
              ),
                e.setAttribute(
                  "data-scroll-lock-saved-inline-overflow-property",
                  e.style.overflow
                ),
                e.setAttribute(
                  "data-scroll-lock-saved-inline-overflow-y-property",
                  e.style.overflowY
                ),
                (e.style.overflow = "hidden"),
                e.setAttribute("data-scroll-lock-locked", "true");
            }
          },
          R = function (e) {
            o(e) &&
              "true" === e.getAttribute("data-scroll-lock-locked") &&
              ((e.style.overflow = e.getAttribute(
                "data-scroll-lock-saved-inline-overflow-property"
              )),
              (e.style.overflowY = e.getAttribute(
                "data-scroll-lock-saved-inline-overflow-y-property"
              )),
              e.removeAttribute("data-scroll-lock-saved-overflow-property"),
              e.removeAttribute(
                "data-scroll-lock-saved-inline-overflow-property"
              ),
              e.removeAttribute(
                "data-scroll-lock-saved-inline-overflow-y-property"
              ),
              e.removeAttribute("data-scroll-lock-locked"));
          },
          V = function () {
            v.fillGapSelectors.map(function (e) {
              G(e);
            });
          },
          U = function () {
            v.fillGapSelectors.map(function (e) {
              Y(e);
            });
          },
          G = function (e) {
            var t = document.querySelectorAll(e),
              i = -1 !== v.lockableSelectors.indexOf(e);
            s(t, function (e) {
              X(e, i);
            });
          },
          X = function (e) {
            var t =
              1 < arguments.length && void 0 !== arguments[1] && arguments[1];
            if (o(e)) {
              if ("" === e.getAttribute("data-scroll-lock-lockable") || t)
                i = C(e, !0);
              else {
                var i,
                  n = c(e, a(v.lockableSelectors));
                i = C(n, !0);
              }
              "true" === e.getAttribute("data-scroll-lock-filled-gap") && Q(e);
              var s = window.getComputedStyle(e);
              if (
                (e.setAttribute("data-scroll-lock-filled-gap", "true"),
                e.setAttribute(
                  "data-scroll-lock-current-fill-gap-method",
                  v.fillGapMethod
                ),
                "margin" === v.fillGapMethod)
              ) {
                var r = parseFloat(s.marginRight);
                e.style.marginRight = "".concat(r + i, "px");
              } else if ("width" === v.fillGapMethod)
                e.style.width = "calc(100% - ".concat(i, "px)");
              else if ("max-width" === v.fillGapMethod)
                e.style.maxWidth = "calc(100% - ".concat(i, "px)");
              else if ("padding" === v.fillGapMethod) {
                var l = parseFloat(s.paddingRight);
                e.style.paddingRight = "".concat(l + i, "px");
              }
            }
          },
          Y = function (e) {
            s(document.querySelectorAll(e), function (e) {
              Q(e);
            });
          },
          Q = function (e) {
            if (
              o(e) &&
              "true" === e.getAttribute("data-scroll-lock-filled-gap")
            ) {
              var t = e.getAttribute(
                "data-scroll-lock-current-fill-gap-method"
              );
              e.removeAttribute("data-scroll-lock-filled-gap"),
                e.removeAttribute("data-scroll-lock-current-fill-gap-method"),
                "margin" === t
                  ? (e.style.marginRight = "")
                  : "width" === t
                  ? (e.style.width = "")
                  : "max-width" === t
                  ? (e.style.maxWidth = "")
                  : "padding" === t && (e.style.paddingRight = "");
            }
          };
        "undefined" != typeof window &&
          window.addEventListener("resize", function (e) {
            O();
          }),
          "undefined" != typeof document &&
            (document.addEventListener("touchstart", function (e) {
              v.scroll ||
                ((v.startTouchY = e.touches[0].clientY),
                (v.startTouchX = e.touches[0].clientX));
            }),
            document.addEventListener(
              "touchmove",
              function (e) {
                if (!v.scroll) {
                  var t = v.startTouchY,
                    i = v.startTouchX,
                    n = e.touches[0].clientY,
                    o = e.touches[0].clientX;
                  if (e.touches.length < 2) {
                    var s = a(v.scrollableSelectors),
                      r = t < n,
                      l = n < t,
                      u = i < o,
                      m = o < i,
                      y = t + 3 < n,
                      b = n < t - 3,
                      k = i + 3 < o,
                      x = o < i - 3;
                    !(function t(i) {
                      var n =
                        1 < arguments.length &&
                        void 0 !== arguments[1] &&
                        arguments[1];
                      if (i) {
                        var o = c(i, s, !1);
                        if (d(i, 'input[type="range"]')) return !1;
                        if (
                          n ||
                          (d(i, 'textarea, [contenteditable="true"]') &&
                            c(i, s)) ||
                          d(i, s)
                        ) {
                          var a = !1;
                          f(i) && g(i)
                            ? ((r && p(i)) || (l && h(i))) && (a = !0)
                            : p(i) && h(i)
                            ? ((u && f(i)) || (m && g(i))) && (a = !0)
                            : ((y && p(i)) ||
                                (b && h(i)) ||
                                (k && f(i)) ||
                                (x && g(i))) &&
                              (a = !0),
                            a &&
                              (o
                                ? t(o, !0)
                                : e.cancelable && e.preventDefault());
                        } else t(o);
                      } else e.cancelable && e.preventDefault();
                    })(e.target);
                  }
                }
              },
              { passive: !1 }
            ),
            document.addEventListener("touchend", function (e) {
              v.scroll || ((v.startTouchY = 0), (v.startTouchX = 0));
            }));
        var K = (function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var i = null != arguments[t] ? arguments[t] : {},
              n = Object.keys(i);
            "function" == typeof Object.getOwnPropertySymbols &&
              (n = n.concat(
                Object.getOwnPropertySymbols(i).filter(function (e) {
                  return Object.getOwnPropertyDescriptor(i, e).enumerable;
                })
              )),
              n.forEach(function (t) {
                var n, o, s;
                (n = e),
                  (s = i[(o = t)]),
                  o in n
                    ? Object.defineProperty(n, o, {
                        value: s,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0,
                      })
                    : (n[o] = s);
              });
          }
          return e;
        })(
          {
            disablePageScroll: y,
            enablePageScroll: b,
            getScrollState: k,
            clearQueueScrollLocks: x,
            getTargetScrollBarWidth: C,
            getCurrentTargetScrollBarWidth: w,
            getPageScrollBarWidth: S,
            getCurrentPageScrollBarWidth: T,
            addScrollableSelector: P,
            removeScrollableSelector: A,
            addScrollableTarget: _,
            removeScrollableTarget: E,
            addLockableSelector: j,
            addLockableTarget: L,
            addFillGapSelector: M,
            removeFillGapSelector: q,
            addFillGapTarget: D,
            removeFillGapTarget: z,
            setFillGapMethod: I,
            refillGaps: O,
            _state: v,
          },
          {
            hide: function (e) {
              r(
                '"hide" is deprecated! Use "disablePageScroll" instead. \n https://github.com/FL3NKEY/scroll-lock#disablepagescrollscrollabletarget'
              ),
                y(e);
            },
            show: function (e) {
              r(
                '"show" is deprecated! Use "enablePageScroll" instead. \n https://github.com/FL3NKEY/scroll-lock#enablepagescrollscrollabletarget'
              ),
                b(e);
            },
            toggle: function (e) {
              r('"toggle" is deprecated! Do not use it.'), k() ? y() : b(e);
            },
            getState: function () {
              return (
                r(
                  '"getState" is deprecated! Use "getScrollState" instead. \n https://github.com/FL3NKEY/scroll-lock#getscrollstate'
                ),
                k()
              );
            },
            getWidth: function () {
              return (
                r(
                  '"getWidth" is deprecated! Use "getPageScrollBarWidth" instead. \n https://github.com/FL3NKEY/scroll-lock#getpagescrollbarwidth'
                ),
                S()
              );
            },
            getCurrentWidth: function () {
              return (
                r(
                  '"getCurrentWidth" is deprecated! Use "getCurrentPageScrollBarWidth" instead. \n https://github.com/FL3NKEY/scroll-lock#getcurrentpagescrollbarwidth'
                ),
                T()
              );
            },
            setScrollableTargets: function (e) {
              r(
                '"setScrollableTargets" is deprecated! Use "addScrollableTarget" instead. \n https://github.com/FL3NKEY/scroll-lock#addscrollabletargetscrollabletarget'
              ),
                _(e);
            },
            setFillGapSelectors: function (e) {
              r(
                '"setFillGapSelectors" is deprecated! Use "addFillGapSelector" instead. \n https://github.com/FL3NKEY/scroll-lock#addfillgapselectorfillgapselector'
              ),
                M(e);
            },
            setFillGapTargets: function (e) {
              r(
                '"setFillGapTargets" is deprecated! Use "addFillGapTarget" instead. \n https://github.com/FL3NKEY/scroll-lock#addfillgaptargetfillgaptarget'
              ),
                D(e);
            },
            clearQueue: function () {
              r(
                '"clearQueue" is deprecated! Use "clearQueueScrollLocks" instead. \n https://github.com/FL3NKEY/scroll-lock#clearqueuescrolllocks'
              ),
                x();
            },
          }
        );
        t.default = K;
      },
    ]).default;
  });
var LibraryLoader = (function () {
  var e = { link: "link", script: "script" },
    t = { requested: "requested", loaded: "loaded" },
    i = "https://cdn.shopify.com/shopifycloud/",
    n = {
      youtubeSdk: {
        tagId: "youtube-sdk",
        src: "https://www.youtube.com/iframe_api",
        type: e.script,
      },
      plyrShopifyStyles: {
        tagId: "plyr-shopify-styles",
        src: i + "shopify-plyr/v1.0/shopify-plyr.css",
        type: e.link,
      },
      modelViewerUiStyles: {
        tagId: "shopify-model-viewer-ui-styles",
        src: i + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
        type: e.link,
      },
    };
  return {
    load: function i(o, s) {
      var r,
        a = n[o];
      if (a && a.status !== t.requested) {
        if (((s = s || function () {}), a.status === t.loaded)) {
          s();
          return;
        }
        switch (((a.status = t.requested), a.type)) {
          case e.script:
            r =
              ((l = a),
              (c = s),
              (d = document.createElement("script")),
              (d.src = l.src),
              d.addEventListener("load", function () {
                (l.status = t.loaded), c();
              }),
              d);
            break;
          case e.link:
            r =
              ((u = a),
              (p = s),
              (h = document.createElement("link")),
              (h.href = u.src),
              (h.rel = "stylesheet"),
              (h.type = "text/css"),
              h.addEventListener("load", function () {
                (u.status = t.loaded), p();
              }),
              h);
        }
        (r.id = a.tagId), (a.element = r);
        var l,
          c,
          d,
          u,
          p,
          h,
          f = document.getElementsByTagName(a.type)[0];
        f.parentNode.insertBefore(r, f);
      }
    },
  };
})();
jQuery(function (e) {
  (window.Site = {
    settings: { b: e("body"), w: e(window), d: e(document) },
    init: function () {
      (t = this.settings),
        this.general(),
        this.header.init(),
        this.footer(),
        this.nav.init(),
        this.sliders.init(),
        this.addresses.init(),
        this.keyboardAccessible(),
        this.video(),
        this.faq(),
        this.checkReviewsApp(),
        "true" == this.getQueryParameter("customer_posted") &&
          (e("body").addClass("signUp-posted"),
          t.d.scrollTop(t.d.height() - t.w.height()));
    },
    general: function () {
      e("body").removeClass("is-page-loading"),
        t.b.on("click", ".share-link", function (t) {
          t.preventDefault();
          var i = e(this),
            n = i.attr("data-network"),
            o = i.attr("href"),
            s = 400;
          "twitter" === n && (s = 300),
            window.open(o, n, "width=700, height=" + s);
        }),
        t.b.on("click", "[data-anchor-link]", function (t) {
          var i = e(this).attr("href");
          if (e(i).length) {
            var n = e(i).offset().top - 60;
            e("html, body").stop().animate({ scrollTop: n }),
              t.preventDefault();
          }
        });
    },
    getQueryParameter: function (e) {
      var t = RegExp(
        "[\\?&]" +
          (e = e.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]")) +
          "=([^&#]*)"
      ).exec(location.search);
      return null === t ? "" : decodeURIComponent(t[1].replace(/\+/g, " "));
    },
    keyboardAccessible: function () {
      t.w.mousedown(function (e) {
        t.b.addClass("no-outline");
      }),
        t.w.keyup(function (e) {
          9 === e.keyCode && t.b.removeClass("no-outline");
        });
    },
    preventBannerContentOverflow: function () {
      var t = {
        bannerContainer: "[data-banner-container]",
        bannerContent: "[data-banner-content]",
      };
      e(t.bannerContainer).each(function () {
        var i = e(t.bannerContent, this),
          n = parseInt(i.outerHeight(!0));
        e(this).css("min-height", n);
      });
    },
    header: {
      init: function () {
        var t = e(".site-header"),
          i = e("#shopify-section-header"),
          n = e(".bodyWrap"),
          o = Site.isHeaderTransparent(),
          s = window.innerWidth || document.documentElement.clientWidth,
          r = ".header";
        function a() {
          var e;
          window.scrollY > n.offset().top
            ? (i.addClass("shopify-section-header--fixed"),
              t
                .addClass("header--has-scrolled")
                .removeClass("header--transparent"))
            : (i.removeClass("shopify-section-header--fixed"),
              t.removeClass("header--has-scrolled"),
              o && t.addClass("header--transparent"));
        }
        function l() {
          var i,
            n,
            o,
            s,
            r,
            a,
            l,
            d,
            u,
            p,
            h,
            f =
              (t
                .addClass("header--is-standard")
                .removeClass("header--is-hamburger"),
              (r = e(".site-header .container > .row").width()),
              (a =
                ((i = 0),
                e(".nav-standard .menu > .menu-item").each(function () {
                  i += e(this).outerWidth(!0);
                }),
                i)),
              (l = !1),
              (d =
                t.hasClass("header--logo_center_links_center") ||
                t.hasClass("header--logo_left_links_center")),
              (u =
                t.hasClass("header--logo_center_links_left") ||
                t.hasClass("header--logo_left_links_left")),
              (p = e(".header__icons").outerWidth()),
              (h =
                ((n = 0),
                (o = e(".logo__image-link")),
                (s = e(".logo__text")),
                o.length && (n = o.data("width")),
                s.length && (n += s.outerWidth()),
                n)),
              d && ((h = h < p ? p : h), (h *= 2), (p = 0)),
              (l = parseInt(r) < parseInt(a + h + p + 40)),
              u && (l = parseInt((r - h) / 2) < parseInt(a)),
              l),
            g = e(window).width() >= 1024;
          f || !g
            ? t
                .removeClass("header--is-standard header--search-visible")
                .addClass("header--is-hamburger")
            : (t
                .removeClass("header--is-hamburger")
                .addClass("header--is-standard"),
              Site.nav.hide()),
            c(),
            e(document).one("shopify:section:unload", function () {
              setTimeout(c, 100);
            });
        }
        function c() {
          var e = Site.isHeaderTransparent();
          t.toggleClass("header--transparent", e),
            e
              ? n.removeAttr("data-spacer")
              : (n.attr("data-spacer", "default"),
                t.hasClass("header--is-hamburger")
                  ? n.attr("data-spacer", "small")
                  : t.hasClass("header--logo_center_links_center") &&
                    n.attr("data-spacer", "large"));
        }
        l(),
          a(),
          e(window)
            .off(r)
            .on("load", l)
            .on("scroll" + r, Reqs.throttle(a, 50))
            .on("resize" + r, Reqs.throttle(Site.setCartClosePosition, 50))
            .on(
              "resize" + r,
              Reqs.debounce(function () {
                var e =
                  window.innerWidth || document.documentElement.clientWidth;
                s != e && l(), (s = e);
              }, 250)
            );
      },
      resetHeader: function () {
        var t = e("body"),
          i = e(".bodyWrap"),
          n = e("#hamburger-menu"),
          o = e(".site-header, .site-alert, .bodyWrap, .shop-bar"),
          s = document.querySelector(".nav-hamburger .nav-inner");
        t.removeClass("nav--is-visible"),
          i.removeAttr("style"),
          o.css("transform", "none"),
          n.removeClass("open"),
          scrollLock.enablePageScroll(s),
          t.hasClass("cart--is-visible") &&
            e(".js-cartToggle").eq(0).trigger("click");
      },
    },
    isHeaderTransparent: function () {
      var t = e(".site-header"),
        i =
          e(".main-content")
            .children()
            .first(".shopify-section")
            .hasClass("header--full") ||
          e(".main-content")
            .children()
            .first(".shopify-section")
            .find('[data-header-style="index"]').length;
      return Boolean(t.data("transparent") && i);
    },
    setCartClosePosition: function () {
      if (e("#cartTotal").length) {
        var t = e(".cart-drawer .js-cartToggle"),
          i = window.scrollY,
          n = e("#cartTotal").offset().top - i;
        t.css("top", n - 40);
      }
    },
    footer: function () {
      var t = e(".js-product-template"),
        i = e(".site-footer"),
        n = document.querySelector("[data-powered-link] a");
      n && n.relList.add("noopener");
      var o = {
          disclosureLocale: "[data-disclosure-locale]",
          disclosureCurrency: "[data-disclosure-currency]",
        },
        s = e(o.disclosureLocale, i),
        r = {},
        a = e(o.disclosureCurrency, i),
        l = {};
      s.length && (r = new Disclosure(s)),
        a.length && (l = new Disclosure(a)),
        e(window).on(
          "scroll",
          Reqs.throttle(function () {
            var n = window.scrollY,
              o = e("#shop-bar");
            if (t.length && o.length) {
              var s = t.offset().top;
              n > s
                ? (o.addClass("shop-bar--is-visible"),
                  i.addClass("site-footer--push"))
                : n < s - 60 &&
                  (o.removeClass("shop-bar--is-visible"),
                  i.removeClass("site-footer--push"));
            }
          }, 100)
        );
    },
    video: function () {
      Reqs.lightbox(),
        e(".js-video").each(function () {
          e(this).magnificPopup({
            closeMarkup:
              '<button title="%title%" type="button" class="mfp-close">' +
              theme.icons.close +
              "</button>",
            type: "iframe",
            mainClass: "mfp-fade",
            removalDelay: 160,
            preloader: !1,
            autoFocusLast: !1,
            fixedContentPos: !1,
            iframe: {
              markup:
                '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" frameborder="0" allowfullscreen allow="autoplay, fullscreen"></iframe></div>',
              patterns: {
                youtube: {
                  index: "youtube.com/",
                  id: function (e) {
                    var t = e.match(
                      /^.*(?:youtu.be\/|v\/|e\/|u\/\w+\/|embed\/|v=)([^#\&\?]*).*/
                    );
                    return t && t[1] ? t[1] : null;
                  },
                  src: "//www.youtube.com/embed/%id%?autoplay=1&rel=0modestbranding=0",
                },
                youtube_short: {
                  index: "youtu.be/",
                  id: "youtu.be/",
                  src: "//www.youtube.com/embed/%id%?autoplay=1&autohide=0&branding=0&cc_load_policy=0&controls=0&fs=0&iv_load_policy=3&modestbranding=1&playsinline=1&quality=hd720&rel=0&showinfo=0&wmode=opaque",
                },
              },
              srcAction: "iframe_src",
            },
          });
        });
    },
    faq: function () {
      e(".faq-list__item-question").on("click", function (t) {
        t.preventDefault(), e(this).parent().toggleClass("is-expanded");
      });
    },
    sliders: {
      init: function () {
        this.hero(),
          this.collection(),
          this.gallery(),
          this.mosaic(),
          this.logoList();
      },
      hero: function () {
        var t = e(".js-hero-slider"),
          i = e(".js-scroll-down"),
          n = !1;
        t.each(function () {
          var i = e(this),
            o = e(this).closest("[data-section-id]").data("section-id"),
            s = i.data("autoplay"),
            r = JSON.parse(i.data("slick").replace(/'/g, '"'));
          (r = e.extend({}, r, {
            autoplay: !1,
            prevArrow:
              '<button class="slick-prev slick-arrow" aria-label="' +
              theme.translations.previous +
              '" type="button">' +
              theme.icons.arrowSlider +
              "</button>",
            nextArrow:
              '<button class="slick-next slick-arrow" aria-label="' +
              theme.translations.next +
              '" type="button">' +
              theme.icons.arrowSlider +
              "</button>",
          })),
            i.on("init", function () {
              var t = e(this)
                .find('.js-slide[data-slick-index="1"]')
                .data("style");
              e(this)
                .attr("data-current-style", t)
                .removeClass("hero--is-loading");
            }),
            i.on("beforeChange", function (t, i, n, o) {
              var s = parseInt(o + 1),
                r = e(this)
                  .find('.js-slide[data-slick-index="' + s + '"]')
                  .data("style");
              e(this).attr("data-current-style", r);
            }),
            i.slick(r),
            e(window).on(
              "scroll." + o + " resize." + o,
              Reqs.throttle(function () {
                var e = i.visible(!0);
                i.hasClass("slick-initialized") &&
                  (n && e && s ? i.slick("slickPlay") : i.slick("slickPause"));
              }, 100)
            ),
            e(window).on("load", function () {
              (n = !0), s && t.slick("slickPlay");
            });
        }),
          e(".slick-list").attr("tabindex", "-1"),
          i.on("click", function (i) {
            i.preventDefault();
            var n = parseInt(t.offset().top + t.outerHeight() - 59);
            e("html, body").stop(!0, !1).animate({ scrollTop: n });
          });
      },
      collection: function () {
        var t = e(".js-collection-grid"),
          i = e(".js-collection-slider");
        function n() {
          var e = i.find(".slick-slide--quickView");
          if (
            (e.length ||
              (e = i.find(".quickView--is-visible").closest(".slick-slide")),
            i.length && e.length)
          ) {
            var t = e.find(".quickView-wrap"),
              n =
                i.find(".slick-slide.slick-current").position().left -
                e.position().left;
            t.css("left", n);
          }
        }
        e(".quickView-button", i).on("click", function () {
          e(this).closest(".slick-slide").addClass("slick-slide--quickView");
        }),
          e("html, body").on("quickView:show", function () {
            n(),
              i
                .find(".slick-slide--quickView")
                .removeClass("slick-slide--quickView");
          }),
          e("html, body").on("quickView:ajax", n),
          t.each(function () {
            Site.sliders.setCarouselState(e(this));
          }),
          i.each(function () {
            Site.removeAnimationClass(e(this));
          }),
          e(window).on(
            "resize",
            Reqs.debounce(function () {
              n(),
                t.each(function () {
                  Site.sliders.setCarouselState(e(this));
                });
            }, 250)
          );
      },
      setCarouselState: function (t) {
        if (void 0 !== t) {
          var i = t.find(".js-collection-slider");
          if (i.length) {
            Site.removeAnimationClass(t);
            var n = i.hasClass("slick-initialized"),
              o = parseInt(t.data("slides-per-row")),
              s =
                window.innerWidth ||
                document.documentElement.clientWidth ||
                document.body.clientWidth,
              r = {
                slidesPerRow: o,
                infinite: !1,
                dots: !1,
                prevArrow:
                  '<button class="slick-prev slick-arrow" aria-label="' +
                  theme.translations.previous +
                  '" type="button">' +
                  theme.icons.arrowLong +
                  "</button>",
                nextArrow:
                  '<button class="slick-next slick-arrow" aria-label="' +
                  theme.translations.next +
                  '" type="button">' +
                  theme.icons.arrowLong +
                  "</button>",
                responsive: [
                  { breakpoint: 1024, settings: { slidesPerRow: 2 } },
                ],
              };
            s >= 768
              ? n ||
                (i.on("init", a),
                i.slick(r).on("beforeChange", function () {
                  e(".quickView--is-visible").length && QuickView.hide();
                }))
              : n && i.slick("unslick"),
              a();
          }
        }
        function a() {
          var e = i.find(".slick-arrow"),
            t = i.find(".product-block__image").outerHeight() / 2;
          e.css("top", t);
        }
      },
      gallery: function () {
        e(".js-slider").each(function () {
          var t = e(this),
            i = t.data("autoplay"),
            n = JSON.parse(t.data("slick").replace(/'/g, '"'));
          (n = e.extend({}, n, {
            autoplay: !1,
            prevArrow:
              '<button class="slick-prev slick-arrow" aria-label="' +
              theme.translations.previous +
              '" type="button">' +
              theme.icons.arrowSlider +
              "</button>",
            nextArrow:
              '<button class="slick-next slick-arrow" aria-label="' +
              theme.translations.next +
              '" type="button">' +
              theme.icons.arrowSlider +
              "</button>",
          })),
            t.on("init", function () {
              e(this).removeClass("gallery-slider--is-loading");
            }),
            t.slick(n),
            e(window)
              .on(
                "scroll.gallery",
                Reqs.debounce(function () {
                  (function e(t) {
                    let i = t.getBoundingClientRect(),
                      n =
                        window.innerHeight ||
                        document.documentElement.clientHeight,
                      o =
                        window.innerWidth ||
                        document.documentElement.clientWidth,
                      s = i.top <= n && i.top + i.height >= 0,
                      r = i.left <= o && i.left + i.width >= 0;
                    return s && r;
                  })(t.get(0)) && i
                    ? t.slick("slickPlay")
                    : t.slick("slickPause");
                }, 150)
              )
              .on("load", function () {
                i && t.slick("slickPlay");
              });
        });
      },
      mosaic: function () {
        var t = this;
        e(".js-mosaic__blocks").each(function () {
          var i = e(this),
            n = e(this).closest("[data-section-id]").data("section-id"),
            o = window.innerWidth || document.documentElement.clientWidth;
          t.initMobileSlider(i),
            e(window).on(
              "resize." + n,
              Reqs.debounce(function () {
                var e =
                  window.innerWidth || document.documentElement.clientWidth;
                o != e && t.initMobileSlider(i), (o = e);
              }, 250)
            );
        });
      },
      initMobileSlider: function (t) {
        var i = 768 > e(window).width(),
          n = t.hasClass("slick-initialized"),
          o = {
            infinite: !0,
            autoplay: !1,
            speed: 300,
            slidesToShow: 1,
            arrows: !0,
            prevArrow:
              '<button class="slick-prev slick-arrow" aria-label="' +
              theme.translations.previous +
              '" type="button">' +
              theme.icons.arrowSlider +
              "</button>",
            nextArrow:
              '<button class="slick-next slick-arrow" aria-label="' +
              theme.translations.next +
              '" type="button">' +
              theme.icons.arrowSlider +
              "</button>",
            dots: !1,
          };
        i && !n ? t.slick(o) : !i && n && t.slick("unslick");
      },
      logoList: function () {
        e("[data-logo-list-slider]").each(function () {
          var t = e(this),
            i = t.closest("[data-section-id]").attr("data-section-id");
          Site.sliders.logoListSlider(t),
            e(window).on(
              "resize." + i,
              Reqs.debounce(Site.sliders.logoListSlider.bind(this, t), 250)
            );
        });
      },
      logoListSlider: function (e) {
        var t =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
        220 * e.find("[data-block]").length > t &&
          !e.data("flickity") &&
          e.flickity({
            prevNextButtons: !1,
            pageDots: !1,
            draggable: !0,
            adaptiveHeight: !1,
            autoPlay: 4e3,
            contain: !0,
            wrapAround: !0,
          });
      },
      initSlickSlider: function (e, t) {
        e.hasClass("slick-initialized") || e.slick(t);
      },
      destroySlickSlider: function (e) {
        e.hasClass("slick-initialized") && e.slick("unslick");
      },
      checkThumbnailsOverflow: function (e) {
        var t,
          i = parseInt(
            e.find(".js-slide").outerWidth() * e.find(".js-slide").length
          );
        return e.width() < i;
      },
    },
    nav: {
      getWidth: function () {
        var t = e(window).outerWidth();
        return t >= 1280 ? t / 3 : t >= 768 ? (2 * t) / 3 : t;
      },
      init: function () {
        Site.nav.bindings(), Site.nav.activeLinks();
      },
      bindings: function () {
        var t = e("body"),
          i = e(".site-header"),
          n = ".header";
        t.off(n),
          e(document).off(n),
          e(".js-menuToggle").off(n),
          e('[data-dropdown-parent], .nav-main a[href^="#"]').off(n),
          e(".nav-standard .menu-item--dropdown").off(n),
          e(".nav-standard .menu-item--meganav").off(n),
          e(".nav-standard .toggle-submenu").off(n),
          e("[data-dropdown-trigger]").off(n),
          e(".js-searchToggle").off(n),
          e(".js-menuToggle").on("click" + n, function (t) {
            t.preventDefault(),
              e("body").hasClass("nav--is-visible")
                ? Site.nav.hide()
                : Site.nav.show();
          }),
          e("[data-dropdown-parent]").on("mouseenter" + n, function (t) {
            window.isTouch ||
              e(this)
                .addClass("is-expanded")
                .find("[aria-expanded]")
                .attr("aria-expanded", !0)
                .end()
                .siblings()
                .removeClass("is-expanded")
                .find("[aria-expanded]")
                .attr("aria-expanded", !1);
          }),
          e(".nav-standard .menu-item--dropdown").on(
            "mouseleave" + n,
            function () {
              e(this)
                .removeClass("is-expanded")
                .find("[aria-expanded]")
                .attr("aria-expanded", !1);
            }
          ),
          e(".nav-standard .menu-item--meganav")
            .on("mouseenter" + n, function () {
              e(".site-header").addClass("header--megamenu-visible"),
                e(this).find(".visible-nav-link").removeAttr("tabindex");
            })
            .on("mouseleave" + n, function () {
              e(this)
                .removeClass("is-expanded")
                .find("[aria-expanded]")
                .attr("aria-expanded", !1),
                e(".site-header").removeClass("header--megamenu-visible"),
                e(".visible-nav-link").attr("tabindex", "-1");
            }),
          e('[data-dropdown-trigger], .nav-main a[href^="#"]').on(
            "click" + n,
            function (t) {
              t.preventDefault();
              var i = e(this).parent();
              i.hasClass("is-expanded")
                ? (Site.nav.submenu.close(i), Site.nav.submenuStandard.close(i))
                : (Site.nav.submenu.open(i), Site.nav.submenuStandard.open(i));
            }
          ),
          t.on("keyup" + n, function (t) {
            if (
              t.keyCode === slate.utils.keyboardKeys.TAB ||
              t.keyCode === slate.utils.keyboardKeys.ESCAPE
            ) {
              var i = e(t.target),
                n = i.parents(".submenu").length,
                o = i.parents(".nav-hamburger").length,
                s =
                  i.parents(".nav-search").length ||
                  !i.is(".js-searchToggle--open");
              t.keyCode === slate.utils.keyboardKeys.TAB
                ? (n || Site.nav.submenuStandard.close(),
                  o || Site.nav.hide(),
                  s || (Site.nav.search.close(), Search.close()))
                : t.keyCode === slate.utils.keyboardKeys.ESCAPE &&
                  (Site.nav.submenuStandard.close(),
                  Site.nav.search.close(),
                  Search.close(),
                  Site.nav.hide());
            }
          }),
          e(".js-searchToggle").on("click" + n, function (t) {
            if ((t.preventDefault(), i.hasClass("header--search-visible")))
              Site.nav.search.close(), Search.close();
            else {
              var n = e(this).data("search-nav");
              Site.nav.search.open(n);
            }
          }),
          e(document).on("click" + n, function (t) {
            !e(t.target).is(
              ".nav-search-overlay, .nav-search-overlay *, .js-searchToggle, .js-searchToggle *"
            ) &&
              i.hasClass("header--search-visible") &&
              (Site.nav.search.close(), Search.close());
          }),
          t.on("click" + n, function (t) {
            e(t.target).is(".js-menuToggle, .js-menuToggle *, .nav-main *") ||
              Site.nav.hide();
          });
      },
      show: function () {
        var t = e(".nav-hamburger").width() + "px",
          i = e("body"),
          n = e("#hamburger-menu"),
          o = e(".site-header, .site-alert, .bodyWrap, .shop-bar"),
          s = document.querySelector(".nav-hamburger .nav-inner");
        scrollLock.disablePageScroll(s),
          n.addClass("open"),
          i.addClass("nav--is-visible"),
          e(".header__icons a:not(.js-menuToggle)").attr("tabindex", "-1"),
          e(".nav-hamburger").find("button, a").removeAttr("tabindex"),
          o.css({ transform: "translateX(" + t + ")" }),
          e(window).on(
            "resize.siteNav",
            Reqs.debounce(function () {
              e(".site-header").hasClass("header--is-hamburger") &&
                ((t = e(".nav-hamburger").width() + "px"),
                o.css({ transform: "translateX(" + t + ")" }));
            }, 100)
          );
      },
      hide: function () {
        var t = e("body"),
          i = e("#hamburger-menu"),
          n = e(".site-header, .site-alert, .bodyWrap, .shop-bar"),
          o = document.querySelector(".nav-hamburger .nav-inner");
        t.hasClass("nav--is-visible") &&
          (i.removeClass("open"),
          t.addClass("nav--is-hiding").removeClass("nav--is-visible"),
          n.css({ transform: "none" }),
          this.scrollLockTimeout && clearTimeout(this.scrollLockTimeout),
          (this.scrollLockTimeout = setTimeout(function () {
            scrollLock.enablePageScroll(o), t.removeClass("nav--is-hiding");
          }, 500)),
          e(window).off("resize.siteNav"),
          e(".header__icons a").removeAttr("tabindex"),
          e(".nav-hamburger").find("button, a").attr("tabindex", "-1"));
      },
      activeLinks: function () {
        var t = e(".menu-item"),
          i = e(".submenu-item");
        t.each(function () {
          e(this).find("> a").attr("href") === window.location.pathname
            ? e(this).addClass("is-active")
            : i.each(function () {
                e(this).find("> a").attr("href") === window.location.pathname &&
                  (e(this).addClass("is-active"),
                  e(this)
                    .closest(".menu-item.has-submenu")
                    .addClass("is-active"));
              });
        });
      },
      submenuStandard: {
        open: function (t) {
          t
            .parent()
            .siblings(".menu-item--meganav")
            .removeClass("is-expanded")
            .find("[aria-expanded]")
            .attr("aria-expanded", !1),
            t
              .parent()
              .siblings(".menu-item--meganav")
              .find(".visible-nav-link")
              .attr("tabindex", "-1"),
            t.addClass("is-expanded").children().attr("aria-expanded", !0),
            t.parent().find(".visible-nav-link").removeAttr("tabindex"),
            t.hasClass("menu-item--meganav") &&
              (e(".site-header").addClass("header--megamenu-visible"),
              t.find(".visible-nav-link").removeAttr("tabindex"));
        },
        close: function () {
          e(".visible-nav-link").attr("tabindex", "-1"),
            e(".nav-standard li")
              .removeClass("is-expanded")
              .find("[aria-expanded]")
              .attr("aria-expanded", !1),
            e(".site-header").removeClass("header--megamenu-visible");
        },
      },
      submenu: {
        open: function (t) {
          var i = e(t);
          i
            .addClass("is-expanded")
            .find("> .submenu")
            .stop(!0)
            .slideDown("fast"),
            i.find(".visible-nav-link").removeAttr("tabindex");
        },
        close: function (t) {
          var i = e(t);
          i
            .removeClass("is-expanded")
            .find("> .submenu")
            .stop(!0)
            .slideUp("fast"),
            i.find(".visible-nav-link").attr("tabindex", "-1");
        },
      },
      search: {
        open: function (t) {
          var i = e(".site-header"),
            n = e(".js-searchToggle"),
            o = e(t).find(".nav-search-input"),
            s = e(t).find(
              ".nav-search-input, .nav-search-submit, .js-searchToggle--close"
            );
          i.addClass("header--search-visible"),
            n.attr("aria-expanded", !0),
            s.removeAttr("tabindex"),
            o.focus().select();
        },
        close: function () {
          var t = e(".site-header"),
            i = e(".js-searchToggle"),
            n = e(".js-searchToggle--open"),
            o = e(
              ".nav-search-input, .nav-search-submit, .js-searchToggle--close"
            ),
            s = t.hasClass("header--search-visible");
          o.attr("tabindex", "-1"),
            i.attr("aria-expanded", !1),
            s &&
              (t
                .addClass("header--search-hiding")
                .removeClass("header--search-visible"),
              n.focus(),
              setTimeout(function () {
                t.removeClass("header--search-hiding");
              }, 300));
        },
      },
    },
    addresses: {
      addAddressForm: e(".js-addAddress > form"),
      editAddressForm: e(".js-editAddress > form"),
      init: function () {
        ($addAddressForm = this.addAddressForm),
          ($editAddressForm = this.editAddressForm),
          Site.addresses.validating();
      },
      validating: function () {
        $addAddressForm.add($editAddressForm).submit(function (t) {
          var i = !0;
          if (
            (e(this)
              .find("input")
              .not(".optional")
              .each(function () {
                e(this).val()
                  ? e(this).next().removeClass("validation--showup")
                  : e(this).next().addClass("validation--showup");
              }),
            e(this)
              .find("input")
              .not(".optional")
              .each(function () {
                e(this).val() || (i = !1);
              }),
            !i)
          )
            return !1;
        });
      },
    },
    checkReviewsApp: function () {
      var t = theme.settings.showReviews,
        i = theme.settings.enableYotpo,
        n = theme.settings.yotpoId;
      if (t && i && n) {
        var o = setInterval(function () {
          ("function" == typeof window.SPR && t) ||
          ("object" == typeof yotpo && i && n)
            ? (e("body").removeAttr("data-app-reviews"), clearInterval(o))
            : e("body").attr("data-app-reviews", "not-installed");
        }, 1e3);
        setTimeout(function () {
          clearInterval(o);
        }, 2e4);
      }
    },
    animations: {
      init: function () {
        this.animateAll(), e(document).on("ajaxify:updated", this.animateAll);
      },
      animateAll: function () {
        if (
          (!theme.settings.enableTextAnimations &&
            !theme.settings.enableGridItemsAnimations) ||
          (window.MSInputMethodContext && document.documentMode)
        )
          return;
        var e = document.querySelectorAll(".will-animate");
        if ("undefined" == typeof IntersectionObserver) {
          e.forEach((e) => {
            e.classList.remove("will-animate");
          });
          return;
        }
        let t = new IntersectionObserver(
          (e) => {
            e.forEach((e) => {
              if (!0 === e.isIntersecting) {
                var i = ["animated", e.target.getAttribute("data-animation")],
                  n = "moFadeInUp" == e.target.getAttribute("data-animation");
                if (
                  (e.target.classList.add(...i),
                  e.target.classList.remove("will-animate"),
                  n)
                ) {
                  var o =
                    parseInt(e.target.getAttribute("data-animation-delay")) ||
                    0;
                  t.unobserve(e.target),
                    setTimeout(() => {
                      e.target.classList.remove(...i);
                    }, 1e3 + o);
                }
              }
            });
          },
          { threshold: [0.1] }
        );
        e.forEach((e) => {
          t.observe(e);
        });
      },
    },
    initReviews: function () {
      var e = theme.settings.showReviews,
        t = theme.settings.enableYotpo,
        i = theme.settings.yotpoId;
      t && "" != i && "undefined" != typeof yotpo
        ? yotpo.initialized && yotpo.refreshWidgets()
        : e &&
          "function" == typeof window.SPR &&
          (window.SPR.initDomEls(),
          window.SPR.loadBadges(),
          window.SPR.loadProducts());
    },
    removeAnimationClass: function (t) {
      e(".will-animate", t).removeClass("will-animate");
    },
  }),
    Site.init(),
    Cart.init(),
    Collection.init(),
    Blog.init(),
    Site.animations.init(),
    e(document).ready(function () {
      Gmap.init();
    }),
    {
      init: function () {
        e(document)
          .on("shopify:section:load", this._onSectionLoad)
          .on("shopify:section:unload", this._onSectionUnload)
          .on("shopify:section:select", this._onSectionSelect)
          .on("shopify:section:deselect", this._onSectionDeselect)
          .on("shopify:block:select", this._onBlockSelect)
          .on("shopify:block:deselect", this._onBlockDeselect);
      },
      _onSectionLoad: function (t) {
        var i,
          n,
          o,
          s,
          r,
          a,
          l,
          c,
          d,
          u,
          p,
          h,
          f,
          g,
          m,
          v,
          y,
          b,
          k,
          x,
          C,
          w,
          S,
          T,
          _,
          E,
          P,
          A,
          L,
          j,
          I =
            e(t.target).children("[data-section-type]").data("section-type") ||
            !1;
        switch ((Site.animations.animateAll(), I)) {
          case "header":
            (i = t.target),
              Site.header.resetHeader(),
              Site.nav.hide(),
              Site.nav.init(),
              Site.header.init(),
              Search.init(),
              e(".template-cart").length || Cart.init(),
              setTimeout(function () {
                e(window).scroll();
              }, 100);
            break;
          case "footer":
            (n = t.target), Site.footer();
            break;
          case "product":
            (o = t.target),
              (s = e(o).find("[data-section-id]").data("section-id")),
              Product.init(!0, s),
              Site.video(),
              Site.initReviews(),
              Site.preventBannerContentOverflow();
            break;
          case "gallery":
            (r = t.target),
              (a = e(r).find(".js-slider")),
              (l = a.data("autoplay")),
              (c = JSON.parse(a.data("slick").replace(/'/g, '"'))),
              (c = e.extend({}, c, {
                autoplay: l,
                prevArrow:
                  '<button class="slick-prev slick-arrow" aria-label="' +
                  theme.translations.previous +
                  '" type="button">' +
                  theme.icons.arrowSlider +
                  "</button>",
                nextArrow:
                  '<button class="slick-next slick-arrow" aria-label="' +
                  theme.translations.next +
                  '" type="button">' +
                  theme.icons.arrowSlider +
                  "</button>",
              })),
              a.on("init", function () {
                e(this).removeClass("gallery-slider--is-loading");
              }),
              a.slick(c);
            break;
          case "mosaic":
            (d = t.target),
              e(d),
              (u = e(d).find(".js-mosaic__blocks")),
              (p = e(d).children().first().data("section-id")),
              (h = window.innerWidth || document.documentElement.clientWidth),
              Site.sliders.initMobileSlider(u),
              Site.video(),
              e(window).on(
                "resize." + p,
                Reqs.debounce(function () {
                  var e =
                    window.innerWidth || document.documentElement.clientWidth;
                  h != e && Site.sliders.initMobileSlider(u), (h = e);
                }, 250)
              );
          case "map":
            (f = t.target), Gmap.init();
            break;
          case "slideshow":
            (g = t.target),
              (m = e(g).find(".js-hero-slider")),
              (v = e(g).find("[data-section-id]").data("section-id")),
              (y = m.data("autoplay")),
              (b = JSON.parse(m.data("slick").replace(/'/g, '"'))),
              (k = e(g).find(".js-scroll-down")),
              (b = e.extend({}, b, {
                autoplay: y,
                prevArrow:
                  '<button class="slick-prev slick-arrow" aria-label="' +
                  theme.translations.previous +
                  '" type="button">' +
                  theme.icons.arrowSlider +
                  "</button>",
                nextArrow:
                  '<button class="slick-next slick-arrow" aria-label="' +
                  theme.translations.next +
                  '" type="button">' +
                  theme.icons.arrowSlider +
                  "</button>",
              })),
              m.on("init", function () {
                var t = e(this)
                  .find('.js-slide[data-slick-index="1"]')
                  .data("style");
                e(this).attr("data-current-style", t),
                  e(this).removeClass("hero--is-loading");
              }),
              m.on("beforeChange", function (t, i, n, o) {
                var s = parseInt(o + 1),
                  r = e(this)
                    .find('.js-slide[data-slick-index="' + s + '"]')
                    .data("style");
                e(this).attr("data-current-style", r);
              }),
              m.slick(b),
              e(window).on(
                "scroll." + v + " resize." + v,
                Reqs.throttle(function () {
                  var t = e(window).height(),
                    i = window.scrollY,
                    n = m.height(),
                    o = m.offset().top;
                  o + n >= i && o - t <= i && y
                    ? m.slick("slickPlay")
                    : m.slick("slickPause");
                }, 100)
              ),
              k.on("click", function (t) {
                t.preventDefault();
                var i = parseInt(m.offset().top + m.outerHeight() - 59);
                e("html, body").stop(!0, !1).animate({ scrollTop: i });
              }),
              Site.header.resetHeader(),
              Site.header.init();
            break;
          case "collection-template":
            (x = t.target),
              Collection.init(),
              Site.sliders.collection(),
              Site.initReviews(),
              Site.preventBannerContentOverflow();
            break;
          case "featured-collection":
            (C = t.target),
              (w = e(C).find(".js-collection-grid")),
              (S = w.data("section-id")),
              Collection.init(),
              Site.initReviews(),
              Site.sliders.collection(),
              Site.sliders.setCarouselState(w),
              e(window).on(
                "resize." + S,
                Reqs.debounce(function () {
                  Site.sliders.setCarouselState(w);
                }, 250)
              );
            break;
          case "related-products":
            (T = t.target), RelatedProducts.init();
            break;
          case "blog-template":
            (_ = t.target), ajaxify(), Blog.init();
            break;
          case "featured-blog":
            (E = t.target), Blog.init();
            break;
          case "featured-video":
            (P = t.target), Site.video();
            break;
          case "logo-list":
            (A = t.target),
              (L = e(A).find("[data-logo-list-slider]")),
              Site.sliders.logoListSlider(L);
            break;
          case "contact-section":
            t.target, Site.preventBannerContentOverflow();
            break;
          case "about-template":
            (j = t.target),
              Site.header.init(),
              Site.preventBannerContentOverflow();
            break;
          case "faq-template":
          case "faq-section":
            D(t.target);
        }
        function D(t) {
          e(t)
            .find(".faq-list")
            .on("click", ".faq-list__item-question", function (t) {
              t.preventDefault(), e(this).parent().toggleClass("is-expanded");
            });
        }
      },
      _onSectionUnload: function (t) {
        var i,
          n,
          o,
          s,
          r,
          a,
          l,
          c,
          d,
          u,
          p,
          h,
          f,
          g,
          m,
          v,
          y,
          b = t.target.children[0].getAttribute("data-section-type") || !1;
        switch (b) {
          case "header":
            (i = t.target), e(window).off("scroll.header resize.header");
            break;
          case "gallery":
            (n = t.target),
              e(n).find(".js-slider").slick("unslick"),
              e(window).off("scroll.gallery");
            break;
          case "slideshow":
            (o = t.target),
              (s = e(o).find(".js-hero-slider")),
              (r = e(o).find("[data-section-id]").data("section-id")),
              s.slick("unslick"),
              e(window)
                .off("scroll." + r)
                .off("resize." + r);
            break;
          case "logo-list":
            (a = t.target),
              (l = e(a).find("[data-section-id]").data("section-id")),
              e(window).off("resize." + l);
            break;
          case "mosaic":
            (c = t.target),
              (d = e(c).find(".js-mosaic__blocks")),
              (u = d.hasClass("slick-initialized")),
              (p = p = e(c).children().first().data("section-id")),
              u && d.slick("unslick"),
              e(window).off("resize." + p);
            break;
          case "popup":
            (h = t.target), Popup.hide();
            break;
          case "product":
            (f = t.target),
              (g = e(f).children().first()),
              (m = g.data("section-id")),
              e("#shop-bar").remove(),
              ProductVideo.removeSectionVideos(m),
              ProductModel.removeSectionModels(m),
              e(window).off("resize.product"),
              e(window).off("scroll.product"),
              g.off(".product" + m);
            break;
          case "collection-template":
          case "featured-collection":
          case "related-products":
            (function t(i) {
              var n = e(i).children().first().data("section-id");
              e(window).off(
                "resize." +
                  n +
                  " scroll.endlessScroll--" +
                  n +
                  " load resize.endlessScroll--" +
                  n
              );
            })(t.target);
            break;
          case "blog-template":
            (v = t.target),
              (y = e(v).children().first().data("section-id")),
              e(window).off(
                "scroll.endlessScroll--" +
                  y +
                  " load resize.endlessScroll--" +
                  y
              );
        }
      },
      _onSectionSelect: function (e) {
        var t,
          i,
          n,
          o =
            e.target.children[0].getAttribute("data-section-type") ||
            e.target.children[1].getAttribute("data-section-type") ||
            e.target.children[2].getAttribute("data-section-type") ||
            !1;
        switch (o) {
          case "header":
            (t = e.target),
              Site.header.resetHeader(),
              Site.nav.hide(),
              Site.header.init();
            break;
          case "blog-template":
            (i = e.target), Blog.init();
            break;
          case "popup":
            (n = e.target), Popup.init();
        }
      },
      _onSectionDeselect: function (e) {
        if (
          "header" ===
          (e.target.children[0].getAttribute("data-section-type") || !1)
        ) {
          var t;
          (t = e.target), Site.nav.hide();
        }
      },
      _onBlockSelect: function (t) {
        var i,
          n,
          o,
          s,
          r,
          a,
          l,
          c,
          d,
          u = t.target.getAttribute("data-block") || !1;
        switch (u) {
          case "slide":
            (i = t.target),
              (n = e(i).parents(".slick-slider")),
              (o = e(i)
                .parents(".slick-slide:not(.slick-cloned)")
                .attr("data-slick-index")),
              n.slick("slickGoTo", o),
              n.slick("slickPause");
            break;
          case "mosaic":
            (s = t.target),
              (a = e(s).parents(".js-mosaic__blocks")),
              a.hasClass("slick-initialized") &&
                ((r = e(s)
                  .parents(".slick-slide:not(.slick-cloned)")
                  .attr("data-slick-index")),
                a.slick("slickGoTo", r),
                a.slick("slickPause")),
              Site.video();
            break;
          case "testimonial":
            _selectBlockTestimonial(t.target);
            break;
          case "logo-list-slide":
            (l = t.target),
              (c = e(l).parents("[data-logo-list-slider]")),
              (d = e(l).attr("data-slide-index")),
              c.data("flickity") &&
                (c.flickity("select", d), c.flickity("pausePlayer"));
        }
      },
      _onBlockDeselect: function (t) {
        var i,
          n,
          o = t.target.getAttribute("data-block") || !1;
        switch (o) {
          case "slide":
            (i = t.target),
              (n = e(i).parents(".slick-slider")),
              n.data("autoplay") && n.slick("slickPlay");
            break;
          case "logo-list-slide":
            (function t(i) {
              e(i).parents("[data-logo-list-slider]").flickity("unpausePlayer");
            })(t.target);
        }
      },
    }.init(),
    Popup.init(),
    Search.init(),
    e(".template-product").length && (Product.init(), RelatedProducts.init()),
    e(".featured-product").length && Product.init(),
    e(".template-password").length && Password.init(),
    e(".template-customers-login").length && Login.init(),
    e(".template-customers-addresses").length && Addresses.init(),
    e(".template-search").length && SearchTemplate.init(),
    theme.settings.showQuickView && QuickView.init();
  var t,
    i = window.location.hash,
    n = i.substr(1, i.length);
  null !== document.getElementById(n) &&
    slate.a11y.pageLinkFocus(e(window.location.hash)),
    e(".in-page-link").on("click", function (t) {
      slate.a11y.pageLinkFocus(e(t.currentTarget.hash));
    }),
    tablesWrap(),
    e(document).on("shopify:section:reorder", Site.header.init),
    e(document).on("shopify:section:unload", Site.header.init),
    e(document).on("shopify:section:load", Site.header.init);
}),
  (Cart = {
    popoverTimer: 0,
    classes: { buttonSubmitSuccess: "productForm-submit--success" },
    init: function () {
      var e = $("#Cart"),
        t = $("body"),
        i = $("#CartPopoverCont"),
        n = theme.settings.enableAjaxCart,
        o = 0;
      if (
        (this.counter(),
        this.initTermsAcceptance(),
        $(window).on("resize", Reqs.throttle(Site.setCartClosePosition, 10)),
        e.on("click", ".js-continueShopping", function (e) {
          e.preventDefault();
          var t = document.referrer,
            i = window.location.origin + "/";
          768 > $(window).width() || window.location.href.indexOf("/cart") > -1
            ? t === i
              ? (window.location.href = theme.routes.root_url)
              : history.back(1)
            : $(".js-cartToggle-close").eq(0).trigger("click");
        }),
        !n)
      )
        return !1;
      $(document).off("click", ".js-cartToggle"),
        $(document).on("click", ".js-cartToggle", function (n) {
          var s = $(this),
            r = $("body").hasClass("template-cart"),
            a =
              window.innerWidth ||
              document.documentElement.clientWidth ||
              document.body.clientWidth,
            l = document.querySelector(".cart-drawer .scroll");
          if (r) return !1;
          a > 768
            ? (n.preventDefault(),
              Site.setCartClosePosition(),
              t.toggleClass("cart--is-visible"),
              t.hasClass("cart--is-visible")
                ? (e.removeClass("close"),
                  e.addClass("open"),
                  $("#cartTotal").attr("aria-expanded", !0),
                  scrollLock.disablePageScroll(l))
                : (e.removeClass("open"),
                  e.addClass("close"),
                  $("#cartTotal").attr("aria-expanded", !1),
                  Cart.popover.hide(i),
                  o && clearTimeout(o),
                  (o = setTimeout(function () {
                    scrollLock.enablePageScroll(l);
                  }, 500))),
              $(".js-continueShopping").attr("tabindex", "0"))
            : (s.hasClass("js-cartToggle-close") &&
                (n.preventDefault(),
                scrollLock.enablePageScroll(l),
                t.removeClass("cart--is-visible"),
                e.removeClass("open"),
                e.addClass("close"),
                $("#cartTotal").attr("aria-expanded", !1),
                Cart.popover.hide(i)),
              $(".js-continueShopping").attr("tabindex", "-1"));
        }),
        $("body").on("click", "[data-add-to-cart]", function (e) {
          var t = $(this).closest("form.productForm");
          if (n) {
            if ((e.preventDefault(), t.find('[type="file"]').length)) return;
            Cart.submit($(this));
          }
        }),
        $(window).on("keyup", function (n) {
          "Escape" === n.key &&
            (t.removeClass("cart--is-visible"),
            e.removeClass("open"),
            e.addClass("close"),
            $("#cartTotal").attr("aria-expanded", !1),
            Cart.popover.hide(i));
        });
    },
    submit: function (e) {
      var t = this,
        i = e.closest("form.productForm"),
        n = e.attr("data-handle"),
        o = i.find('[name="id"]').val(),
        s = i.serializeArray(),
        r = e,
        a = e.find("[data-add-to-cart-text]"),
        l = {};
      $.map(s, function (e, t) {
        l[e.name] = e.value;
      }),
        $.ajax({
          method: "POST",
          url: "/cart/add.js",
          dataType: "json",
          data: l,
          success: function (e) {
            r.attr("disabled", !0).addClass(t.classes.buttonSubmitSuccess),
              setTimeout(function () {
                r.attr("disabled", !1).removeClass(
                  t.classes.buttonSubmitSuccess
                );
              }, 2e3),
              Cart.getCart(Cart.buildCart),
              $(window).width() >= 550 && Cart.popover.show(e, l.quantity);
          },
          error: function (e) {
            $.ajax({
              method: "GET",
              url: "/products/" + n + ".js",
              dataType: "json",
              success: function (e) {
                var i = e.variants,
                  n =
                    ($.each(i, function (e, t) {
                      if (t.id == o) return t.inventory_quantity;
                    }),
                    $("#CartPopoverCont")),
                  s = theme.translations.form_submit_error_details,
                  r = s;
                !0 == /[[i]]/.test(s) &&
                  (r = s.replace("[[i]]", variant_quantity)),
                  a.html(theme.translations.form_submit_error),
                  setTimeout(function () {
                    a.html(theme.translations.form_submit);
                  }, 1e3),
                  clearTimeout(t.popoverTimer),
                  n
                    .empty()
                    .append('<div class="popover-error">' + r + "</div>")
                    .addClass("is-visible")
                    .css({ "pointer-events": "none" }),
                  (t.popoverTimer = setTimeout(function () {
                    n.removeClass("is-visible").css({
                      "pointer-events": "auto",
                    });
                  }, 5e3));
              },
              error: function () {
                console.log(
                  "Error: product is out of stock. If you're seeing this, Cart.submit.error() must have failed."
                );
              },
            });
          },
        });
    },
    popover: {
      show: async function (e, t) {
        var i = this,
          n = $("#CartPopoverCont"),
          o = {},
          s = $("#CartPopover").text(),
          r = slate.Currency.formatMoney(e.final_price, window.moneyFormat),
          a = "",
          finalSale = false,
          l = e.selling_plan_allocation
            ? e.selling_plan_allocation.selling_plan.name
            : null;

        if (
          (e.unit_price_measurement &&
            ((a =
              slate.Currency.formatMoney(e.unit_price, window.moneyFormat) +
              " "),
            1 != e.unit_price_measurement.reference_value &&
              (a += e.unit_price_measurement.reference_value),
            (a += e.unit_price_measurement.reference_unit)),
          null != e.image)
        )
          var c = bgset(
            e.image.replace(/(\.[^.]*)$/, "_1x1$1").replace("http:", ""),
            e.featured_image.aspect_ratio
          );
        else
          var c =
            "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";

        // Await the fetch operation before proceeding
        try {
          const res = await fetch("/products/" + e.handle + ".json");
          const data = await res.json();
          if (data.product.tags.includes("Sale")) {
            finalSale = true;
          }
        } catch (err) {
          console.log(err, "Fetching product error");
        }
        // Now create the object with the correct finalSale value
        o = {
          item_count: t,
          img: c,
          product_title: e.product_title,
          variation: !e.product_has_only_default_variant && e.variant_title,
          selling_plan_name: l,
          price: e.price,
          price_formatted: r,
          unit_price: a,
          finalSale: finalSale,
        };

        var d = Sqrl.render(s, o);
        n.empty().append(d),
          n.addClass("is-visible"),
          clearTimeout(i.popoverTimer),
          (i.popoverTimer = setTimeout(function () {
            Cart.popover.hide(n);
          }, 5e3));
      },
      hide: function (e) {
        e.removeClass("is-visible"),
          setTimeout(function () {
            e.empty();
          }, 300);
      },
    },
    getCart: function (e) {
      $.getJSON("/cart.js", function (t, i) {
        "function" == typeof e ? e(t) : ShopifyAPI.onCartUpdate(t);
      });
    },
    buildCart: async function (e) {
      var t = $("#Cart"),
        i = $("body"),
        n = !!t.attr("data-acceptance-checked");
      if (
        (t.empty(),
        i.hasClass("template-cart") ||
          t.append(
            '<div class="js-cartToggle js-cartToggle-close cart-close">' +
              theme.icons.close +
              "</div>"
          ),
        0 === e.item_count)
      ) {
        t.append(
          '<div class="cart-title cart-title--empty">							<h2>' +
            theme.translations.cart_title +
            "</h2>							<p>" +
            theme.translations.cart_empty +
            '</p>							<a tabindex="-1" class="js-continueShopping js-continueShopping--empty js-go-back button">' +
            theme.translations.continue_shopping +
            "</a>						</div>"
        ),
          this.updateCartTotal(),
          Site.setCartClosePosition();
        return;
      }

      var o = [],
        s = {},
        r = {},
        a = $("#CartTemplate").html();

      // Create an array of promises for all the fetch operations
      const fetchPromises = e.items.map(async (t) => {
        var i = t.quantity,
          n = t.variant_id,
          r = t.discounts,
          p = false,
          a = "",
          l = "",
          c = "",
          d = "",
          u =
            !!t.selling_plan_allocation &&
            t.selling_plan_allocation.selling_plan.name;

        if (
          (t.original_price > t.final_price &&
            (l +=
              "<s>" +
              slate.Currency.formatMoney(t.original_price, window.moneyFormat) +
              "</s> "),
          (l +=
            "<span>" +
            slate.Currency.formatMoney(t.final_price, window.moneyFormat) +
            "</span>"),
          t.original_line_price > t.final_line_price &&
            (c +=
              "<s>" +
              slate.Currency.formatMoney(
                t.original_line_price,
                window.moneyFormat
              ) +
              "</s> "),
          (c += slate.Currency.formatMoney(
            t.final_line_price,
            window.moneyFormat
          )),
          r.length)
        ) {
          a += '<div class="cart-product__discounts">';
          for (var discountIndex = 0; discountIndex < r.length; discountIndex++)
            a +=
              "<p>" +
              r[discountIndex].title +
              " (-" +
              slate.Currency.formatMoney(
                r[discountIndex].amount,
                window.moneyFormat
              ) +
              ")</p>";
          a += "</div>";
        }

        if (
          (t.unit_price_measurement &&
            ((d =
              slate.Currency.formatMoney(t.unit_price, window.moneyFormat) +
              " "),
            (d +=
              '<span aria-hidden="true">/</span><span class="visually-hidden">' +
              theme.translations.unit_price_separator +
              "</span>&nbsp;"),
            1 != t.unit_price_measurement.reference_value &&
              (d += t.unit_price_measurement.reference_value),
            (d += t.unit_price_measurement.reference_unit)),
          null != t.image)
        )
          var h = t.image.replace(/(\.[^.]*)$/, "_300x$1").replace("http:", "");
        else
          var h =
            "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";

        // Await the fetch operation
        try {
          const res = await fetch("/products/" + t.handle + ".json");
          const data = await res.json();
          if (data.product.tags.includes("Sale")) {
            p = true;
          }
        } catch (err) {
          console.log(err, "Fetching product error");
        }

        var f = t.product_title,
          g = t.variant_title;
        "Default Title" == g && (g = !1);

        return {
          id: t.variant_id,
          url: t.url,
          img: h,
          name: f,
          variation: g,
          sellingPlanName: u,
          itemQty: i,
          itemVariantId: n,
          properties: t.properties,
          price: t.price,
          priceFormatted: l,
          unitPrice: d,
          linePriceFormatted: c,
          discounts: a,
          vendor: t.vendor,
          iconPlus: theme.icons.plus,
          iconMinus: theme.icons.minus,
          saleTag: p,
        };
      });

      // Wait for all fetch operations to complete
      o = await Promise.all(fetchPromises);

      var l = "",
        c = e.cart_level_discount_applications;
      if (c.length) {
        l += '<p class="cart-discounts">';
        for (var d = 0; d < c.length; d++)
          (l +=
            '<span class="cart-discounts__title">' + c[d].title + ":</span>"),
            (l +=
              '<span class="cart-discounts__price">-' +
              slate.Currency.formatMoney(
                c[d].total_allocated_amount,
                window.moneyFormat
              ) +
              "</span>");
        l += "</p>";
      }

      r = {
        item_count: e.item_count,
        items: o,
        note: e.note,
        totalDiscounts: l,
        totalPrice: slate.Currency.formatMoney(
          e.total_price,
          window.moneyFormat
        ),
        acceptanceChecked: n,
      };

      var u = Sqrl.render(a, r);
      t.append(u),
        Cart.updateCartTotal(),
        Cart.initTermsAcceptance(),
        Site.setCartClosePosition(),
        window.Shopify &&
          Shopify.StorefrontExpressButtons &&
          Shopify.StorefrontExpressButtons.initialize();
    },
    counter: function () {
      var e = this,
        t = $("#Cart"),
        i = ".cart";
      t.off(i)
        .on("change" + i, ".inputCounter", function () {
          var t = $(this),
            i = $(this).val();
          e.inputCounter(t, i);
        })
        .on("click" + i, ".inputCounter__btn--down", function (t) {
          var i = $(this),
            n = parseInt(i.siblings(".inputCounter").val()) - 1;
          e.inputCounter(i, n);
        })
        .on("click" + i, ".inputCounter__btn--up", function (t) {
          var i = $(this),
            n = parseInt(i.siblings(".inputCounter").val()) + 1;
          e.inputCounter(i, n);
        })
        .on("click" + i, ".cart-product__remove", function (t) {
          var i = $(this);
          theme.settings.enableAjaxCart &&
            (e.inputCounter(i, 0), t.preventDefault());
        });
    },
    inputCounter: function (e, t) {
      var i = this,
        n = e.closest(".line-item").find(".inputCounter");
      if (theme.settings.enableAjaxCart) {
        0 == t
          ? n.closest(".line-item").fadeOut(function () {
              $(this).remove();
            })
          : t < 0 && (t = 0);
        var o = t,
          s = parseInt(n.closest(".line-item").index() + 1);
        $.ajax({
          type: "post",
          url: "/cart/change.js",
          dataType: "json",
          data: { quantity: o, line: s },
          success: function (e) {
            Cart.buildCart(e);
          },
        }),
          0 == o &&
            $(this)
              .closest(".line-item")
              .fadeOut(function () {
                $(this).remove(), i.updateCartTotal();
              });
      } else n.val(t);
    },
    updateCartTotal: function () {
      $.getJSON("/cart.js", function (e) {
        var t = e.item_count > 10 ? "9+" : e.item_count;
        $("#CartToggleItemCount").html(t),
          e.item_count
            ? $(".js-cartToggle").removeClass("cartToggle--empty")
            : $(".js-cartToggle").addClass("cartToggle--empty");
      });
    },
    initTermsAcceptance: function () {
      var e = ".cart",
        t = {
          cartAcceptanceCheckbox: "[data-cart-acceptance-checkbox]",
          cartAcceptanceLabel: "[data-cart-acceptance-label]",
          cartButtons: "[data-cart-buttons]",
          cartButtonsFieldset: "[data-cart-buttons-fieldset]",
          cartContainer: ".cart-container",
          cartFormError: "[data-cart-error]",
        };
      if ($(t.cartAcceptanceCheckbox).length) {
        var i =
            '<div class="errors" data-cart-error>' +
            theme.translations.cart_acceptance_error +
            "</div>",
          n = $(t.cartAcceptanceCheckbox).is(":checked"),
          o = function (e) {
            var n = $(t.cartAcceptanceCheckbox).is(":checked");
            if (!$(e.originalEvent.submitter).is('[name="update"]')) {
              if (n)
                $(t.cartFormError)
                  .stop()
                  .slideUp("fast", function () {
                    $(this).remove();
                  }),
                  $(t.cartButtonsFieldset).removeAttr("disabled"),
                  $(t.cartContainer).attr("data-acceptance-checked", "checked");
              else {
                if ((e.preventDefault(), $(t.cartFormError).length)) return;
                $(t.cartButtonsFieldset).attr("disabled", !0),
                  $(t.cartAcceptanceLabel).after(i),
                  $(t.cartFormError).slideDown(),
                  $(t.cartContainer).removeAttr("data-acceptance-checked");
              }
            }
          };
        n || $(t.cartButtonsFieldset).attr("disabled", !0),
          $(t.cartContainer)
            .on("click" + e, t.cartButtons, o)
            .on("submit" + e, t.cartForm, o)
            .on("submit" + e, t.cartFormDynamicCheckout, o)
            .on("change" + e, t.cartAcceptance, o);
      }
    },
  });
var Collection = {
    selectors: {
      body: "body",
      collectionWrapper: "[data-collection-wrapper]",
      collectionProductsWrapper: "[data-collection-products-wrapper]",
      collectionProducts: "[data-collection-products]",
      collectionFilters: "[data-collection-filters]",
      collectionFiltersResetButton: "[data-collection-filters-reset-button]",
      collectionFilter: "[data-collection-filter]",
      collectionFilterTag: "[data-collection-filter-tag]",
      collectionFilterTagButton: "[data-collection-filter-tag-button]",
      collectionFilterTitle: "[data-collection-filter-title]",
      collectionFilterCount: "[data-collection-filter-count]",
      collectionPagination: "[data-pagination]",
      collectionSort: "[data-collection-sort]",
      collectionBlockImage: ".product-block__image",
      collectionFeaturedImage: ".featured-block",
      productsFoundLabel: "[data-products-found-label]",
      loadMoreButton: "[data-load-more]",
      loadMoreIcon: "[data-icon-load-more]",
      gridSpacer: ".gridSpacer",
    },
    classes: {
      loading: "loading",
      isActive: "is-active",
      isVisible: "is-visible",
      isExpanded: "is-expanded",
      isLoading: "is-loading",
      ajaxSorting: "ajax-sorting",
      hasTagsExpanded: "has-tags-expanded",
      collectionFiltersTop: "collection__filters--top",
      collectionFiltersHasTagsSelected:
        "collection__filters--has-tags-selected",
      collectionFiltersResetButtonFullwidth:
        "collection__filters-reset--fullwidth",
      collectionFilterAccordionExpanded:
        "collection__filter--accordion-expanded",
    },
    init: function () {
      var e = this;
      (this.filterProductsRequest = null),
        $(this.selectors.collectionSort).length &&
          $(this.selectors.collectionSort).on("change", function () {
            document.location.href =
              "?sort_by=" + this.options[this.selectedIndex].value;
          }),
        $(this.selectors.collectionProducts).each(function () {
          var t = $(this),
            i = $(this).data("section-id");
          if ("contain" == theme.settings.imageBackgroundSize) {
            var n = $(e.selectors.collectionBlockImage, t);
            Collection.setBadgePosition(n),
              $(window).on(
                "resize." + i,
                Reqs.debounce(e.setBadgePosition.bind(e, n), 50)
              );
          }
          e.initFilters(t);
        }),
        Site.preventBannerContentOverflow(),
        $(window).on(
          "resize.collection-template",
          Reqs.debounce(Site.preventBannerContentOverflow, 50)
        ),
        ajaxify(),
        Product.qtyAdjust(),
        $(document).on("ajaxify:updated", function () {
          Site.initReviews();
        });
    },
    ajaxSort: function (e) {
      var t = this,
        i = $(this.selectors.loadMoreIcon);
      i.show(),
        $(this.selectors.collectionProducts).hide().next(".row").hide(),
        $.ajax({
          type: "GET",
          dataType: "html",
          url: e,
          success: function (e) {
            var n = $(e).find(t.selectors.collectionProducts)[0].outerHTML,
              o = $(e).find(t.selectors.collectionProducts).next(".row")[0]
                ? $(e).find(t.selectors.collectionProducts).next(".row")[0]
                    .outerHTML
                : "";
            $(t.selectors.collectionProducts).replaceWith(n),
              $(t.selectors.collectionProducts).next(".row").replaceWith(o),
              i.hide(),
              $(t.selectors.collectionSort).removeClass(t.classes.loading),
              $(t.selectors.body).removeClass(t.classes.ajaxSorting);
          },
        });
    },
    initLoadMore: function () {
      var e = this;
      $(this.selectors.body).on(
        "click",
        e.selectors.loadMoreButton,
        function (t) {
          if (!$(this).hasClass(e.classes.isLoading)) {
            QuickView.hide();
            var i = $(t.target),
              n = i.attr("href");
            t.preventDefault(),
              i.addClass(e.classes.loading),
              e.ajaxLoadMore(n);
          }
        }
      );
    },
    ajaxLoadMore: function (e) {
      var t = this;
      $.ajax({
        type: "GET",
        dataType: "html",
        url: e,
        success: function (e) {
          var i = $(e).find(t.selectors.collectionProducts).html(),
            n = $(e).find(t.selectors.loadMoreButton).attr("href");
          $(t.selectors.collectionProducts)
            .find(t.selectors.gridSpacer)
            .remove(),
            $(i).appendTo(t.selectors.collectionProducts),
            void 0 !== n
              ? $(t.selectors.loadMoreButton)
                  .attr("href", n)
                  .removeClass(t.classes.loading)
              : $(t.selectors.loadMoreButton).remove(),
            (collectionBlocks = $(".js-collection-block"));
        },
      });
    },
    setBadgePosition: function (e) {
      $(e).each(function () {
        var e = $(this),
          t = e.find(".product-status-flag");
        if (t.length) {
          var i = e.data("aspectratio"),
            n = e.outerWidth(),
            o = e.outerHeight(),
            s = 0,
            r = 0;
          i < n / o ? (r = (n - o * i) / 2) : (s = (o - n / i) / 2),
            t.css({ top: s, left: r });
        }
      });
    },
    initFilters: function (e) {
      var t = this,
        i = $(e),
        n = $(this.selectors.collectionFilters);
      if (n.length) {
        var o = $(e).data("section-id"),
          s = i.data("collection"),
          r = i.data("sort");
        (this.tags = i.data("tags")),
          this.checkFiltersPosition(),
          $(window).on(
            "resize." + o,
            Reqs.debounce(function () {
              t.checkFiltersPosition(t);
            }, 50)
          ),
          n.on("click", this.selectors.collectionFilterTitle, function () {
            var e =
                1280 >
                  (window.innerWidth ||
                    document.documentElement.clientWidth ||
                    document.body.clientWidth) ||
                $(".collection__filters--top").length,
              i = !(
                $(this).parent().hasClass(t.classes.isExpanded) ||
                $(this)
                  .parent()
                  .hasClass(t.classes.collectionFilterAccordionExpanded)
              );
            e
              ? ($(this)
                  .parent()
                  .toggleClass(t.classes.isExpanded)
                  .attr("aria-expanded", i)
                  .siblings()
                  .removeClass(t.classes.isExpanded)
                  .attr("aria-expanded", !1),
                n.find(".collection__filter.is-expanded").length
                  ? n.addClass(t.classes.hasTagsExpanded)
                  : n.removeClass(t.classes.hasTagsExpanded))
              : $(this)
                  .parent()
                  .toggleClass(t.classes.collectionFilterAccordionExpanded)
                  .attr("aria-expanded", i)
                  .siblings()
                  .removeClass(t.classes.isExpanded)
                  .attr("aria-expanded", !1);
          }),
          $(document).on("click", function (e) {
            $(e.target).is(".collection__filters *") ||
              n
                .find(t.selectors.collectionFilter)
                .removeClass(t.classes.isExpanded)
                .attr("aria-expanded", !1)
                .end()
                .removeClass(t.classes.hasTagsExpanded);
          }),
          n.on("click", this.selectors.collectionFilterTagButton, function (o) {
            var a = $(this).parent(),
              l = $(this).data("tag");
            if (a.hasClass(t.classes.isActive)) {
              var c = t.tags.indexOf(l);
              a.removeClass(t.classes.isActive), c > -1 && t.tags.splice(c, 1);
            } else a.addClass(t.classes.isActive), t.tags.push(l);
            var d = $(this)
              .closest(t.selectors.collectionFilter)
              .find(t.selectors.collectionFilterTag)
              .filter("." + t.classes.isActive).length;
            i.attr("data-tags", t.tags),
              $(this)
                .closest(t.selectors.collectionFilter)
                .removeClass(t.classes.isExpanded)
                .attr("aria-expanded", !1)
                .find(t.selectors.collectionFilterCount)
                .attr("data-count", d),
              n.removeClass(t.classes.hasTagsExpanded);
            var u = s + "/" + t.tags.join("+") + "?sort_by=" + r;
            t.requestFilteredProducts(t, e, u), o.preventDefault();
          }),
          this.bindResetButton(e);
      }
    },
    requestFilteredProducts: function (e, t, i) {
      var n = e,
        o = $(t),
        s = $(t).data("section-id"),
        r = parseInt(
          Math.ceil($(n.selectors.collectionWrapper).offset().top) - 60
        );
      $(window).off(
        "scroll.endlessScroll--" + s + " resize.endlessScroll--" + s
      ),
        null != n.filterProductsRequest && n.filterProductsRequest.abort(),
        n.tags.length ||
          ($(n.selectors.collectionFiltersResetButton)
            .removeClass(n.classes.isVisible)
            .slideUp(300),
          $(n.selectors.collectionFilters).removeClass(
            n.classes.collectionFiltersHasTagsSelected
          )),
        $(n.selectors.collectionWrapper).addClass(n.classes.isLoading),
        $("html, body").stop(!0).animate({ scrollTop: r }, 300),
        history.replaceState && window.history.pushState({ path: i }, "", i),
        (n.filterProductsRequest = $.ajax({
          method: "GET",
          url: i,
          dataType: "html",
        })
          .done(function (e) {
            var i = $(e).find(n.selectors.collectionProducts).html(),
              s = $(e).find(n.selectors.productsFoundLabel).html(),
              r = $(e).find(n.selectors.collectionPagination);
            if (
              (o.html(i),
              $(n.selectors.productsFoundLabel).html(s),
              r.length
                ? $(n.selectors.collectionPagination, t).html(r.html())
                : $(n.selectors.collectionPagination, t).empty(),
              n.bindResetButton(t),
              Site.animations.animateAll(),
              Site.initReviews(),
              ajaxify(),
              "contain" == theme.settings.imageBackgroundSize)
            ) {
              var a = $(n.selectors.collectionBlockImage, t);
              n.setBadgePosition(a),
                $(window)
                  .off("resize.products")
                  .on(
                    "resize.products",
                    Reqs.debounce(Collection.setBadgePosition.bind(this, a), 50)
                  );
            }
            n.tags.length &&
              ($(n.selectors.collectionFiltersResetButton)
                .addClass(n.classes.isVisible)
                .slideDown(300),
              $(n.selectors.collectionFilters).addClass(
                n.classes.collectionFiltersHasTagsSelected
              )),
              setTimeout(function () {
                $(n.selectors.collectionWrapper).removeClass(
                  n.classes.isLoading
                );
              }, 450);
          })
          .fail(function (e, t, i) {
            $(n.selectors.collectionWrapper).removeClass(n.classes.isLoading);
          })
          .always(function () {
            setVars();
          }));
    },
    checkFiltersPosition: function () {
      var e = $(this.selectors.collectionFilters).hasClass(
          this.classes.collectionFiltersTop
        ),
        t = window.innerWidth || document.documentElement.clientWidth,
        i = $(this.selectors.collectionFilters).children().first().width(),
        n = $(this.selectors.collectionFiltersResetButton),
        o = $(this.selectors.collectionFilter),
        s = n.outerWidth(!0),
        r = 0,
        a = !1;
      (e || t < 1280) &&
        (o.each(function () {
          r += $(this).outerWidth(!0);
        }),
        (a = i - r - 60 < s)
          ? n
              .parent()
              .addClass(this.classes.collectionFiltersResetButtonFullwidth)
          : n
              .parent()
              .removeClass(this.classes.collectionFiltersResetButtonFullwidth));
    },
    bindResetButton: function (e) {
      var t = this,
        i = $(t.selectors.collectionFilters),
        n = $(e).data("collection"),
        o = $(e).data("sort"),
        s = n + "/?sort_by=" + o;
      $(this.selectors.collectionFiltersResetButton).on("click", function (n) {
        $(t.selectors.collectionFilter).removeClass(t.classes.isExpanded),
          $(t.selectors.collectionFilterTag).removeClass(t.classes.isActive),
          $(t.selectors.collectionFilterCount).attr("data-count", "0"),
          i.removeClass(t.classes.hasTagsExpanded),
          (t.tags = []),
          $(e).attr("data-tags", !1),
          t.requestFilteredProducts(t, e, s),
          n.preventDefault();
      });
    },
  },
  QuickView = {
    selectors: {
      addToCart: "[data-add-to-cart]",
      addToCartText: "[data-add-to-cart-text]",
      section: "[data-section-id]",
      quickViewButton: ".js-quickView-button",
      closeButton: ".js-quickView-close",
      collectionGrid: ".js-collection-grid",
      productMedia: "[data-product-single-media-group]",
      productMediaSlider: "[data-product-single-media-slider]",
      productMediaWrapper: "[data-product-single-media-wrapper]",
      productMediaThumbs: "[data-product-single-media-thumbs]",
      productMediaTypeVideo: "[data-product-media-type-video]",
      productMediaTypeModel: "[data-product-media-type-model]",
      productTitle: "[data-product-title]",
      productPrice: "[data-product-price]",
      comparePrice: "[data-compare-price]",
      unitPrice: "[data-unit-price]",
      unitBase: "[data-unit-base]",
      unitWrapper: "[data-unit-wrapper]",
      originalSelectorId: "[data-product-select]",
      singleOptionSelector: "[data-single-option-selector]",
      priceWrapper: "[data-price-wrapper]",
      productFormContainer: "[data-product-form-container]",
      productFormWrapper: "[data-product-form-wrapper]",
      productFormBlock: ".productForm-block",
      productFormSelectWrapper: ".selector-wrapper",
      productDescription: "[data-product-description]",
      productBlock: "[data-product-block]",
    },
    init: function () {
      var e = this,
        t = (this.isQuickViewLoading = !1);
      $(document).on("click", this.selectors.quickViewButton, function (i) {
        var n = $(this),
          o = $(this).closest(e.selectors.productBlock),
          s = $(this).attr("href"),
          r = n.closest(e.selectors.section).data("section-id");
        t ||
          ((e.isQuickViewLoading = !0),
          o.addClass("quickView--is-loading"),
          o.hasClass("is-loaded") && o.hasClass("quickView--is-visible")
            ? e.hide(e)
            : !o.hasClass("is-loaded") ||
              o.hasClass("quickView--is-visible") ||
              $(".quickView--is-visible").length
            ? o.hasClass("is-loaded") &&
              !o.hasClass("quickView--is-visible") &&
              $(".quickView--is-visible").length
              ? (e.hide(e),
                setTimeout(function () {
                  e.show(o);
                }, 200))
              : $(".quickView--is-visible").length
              ? (e.hide(e),
                setTimeout(function () {
                  e.ajaxSearch(o, s, r);
                }, 200))
              : e.ajaxSearch(o, s, r)
            : e.show(o)),
          i.preventDefault();
      });
    },
    show: function (e) {
      var t = this,
        i = ($(window).height() - 680) / 2,
        n = e.children(".quickView").offset().top,
        o = !$("body").hasClass("no-outline"),
        s = getHeight("[data-collection-featured-block]");
      document.documentElement.style.setProperty(
        "--collection-featured-block-height",
        `${s}px`
      ),
        e.addClass("quickView--is-active"),
        e.removeClass("quickView--is-loading"),
        $("html, body")
          .stop(!0, !0)
          .animate({ scrollTop: n - i - 60 }, 300, function () {
            Site.initReviews(),
              e.hasClass("is-loaded")
                ? e.addClass("quickView--is-visible")
                : e.addClass("quickView--is-visible is-loaded"),
              (t.isQuickViewLoading = !1);
          }),
        $("html, body").trigger("quickView:show"),
        o && e.find(this.selectors.closeButton).focus();
    },
    hide: function () {
      var e = $(this.selectors.productBlock);
      e.hasClass("quickView--is-visible") &&
        e.removeClass(
          "quickView--is-visible quickView--is-active quickView--is-loading"
        ),
        e
          .find(".product-image.is-selected")
          .trigger("mediaHidden")
          .addClass("media--hidden"),
        setTimeout(function () {
          Site.animations.animateAll(),
            document.documentElement.style.setProperty(
              "--collection-featured-block-height",
              "none"
            );
        }, 300),
        $("html, body").trigger("quickView:hide");
    },
    ajaxSearch: function (e, t, i) {
      var n = this,
        o = theme.settings.showProductDescription;
      e.addClass("quickView--is-loading"),
        $.ajax({ url: t, cache: !1, dataType: "html" }).done(function (s) {
          var r = "product-template",
            a = $(s)
              .find("#ProductJson--" + r)
              .text(),
            l = $(s)
              .find("#ModelJson-" + r)
              .html(),
            c = JSON.parse(a),
            d = n.modifyProductMediaSettings(
              $(s).find(n.selectors.productMediaSlider),
              n.settings
            ),
            u = $(s).find(n.selectors.productMediaThumbs).html(),
            p = n.addProductTitleLink($(s).find(n.selectors.productTitle), t),
            h = n.modifyProductFormIds(
              $(s).find(n.selectors.productFormContainer),
              c.id
            ),
            f =
              !!o &&
              !!$(s).find(n.selectors.productDescription).length &&
              $(s).find(n.selectors.productDescription).html(),
            g = 1 == $(s).find(".js-productImgContainer > .js-slide").length,
            m = {},
            v = $("#ProductQuickViewTemplate--" + i).html();
          m = {
            productMediaSlider: d,
            productMediaThumbs: u,
            productTitle: p,
            productFormContainer: h,
            productDescription: f,
            productMediaJson: l,
            isProductMediaSingle: g,
          };
          var y = Sqrl.render(v, m);
          e.append(y),
            e.attr("data-section-id", r),
            e.on("click", n.selectors.closeButton, function (e) {
              e.preventDefault(), n.hide(n);
            }),
            n.initProductMediaSlider(e),
            n.initProductVideo(e),
            n.initMediaSwitch(e),
            n.initModelViewerLibraries(e),
            n.initShopifyXrLaunch(e),
            n.initVariants(e, c),
            n.initPaymentButton(e),
            n.show(e),
            $("html, body").trigger("quickView:ajax");
        });
    },
    initProductMediaSlider: function (e) {
      var t = this,
        i = $(e),
        n = i.find(".js-productImgSlider"),
        o = i.find(".js-productImgSlider-nav"),
        s = n.data("arrows"),
        r = n.data("dots"),
        a = !(
          n.find(".product-single__media--video").length ||
          n.find(".product-single__media--model").length
        ),
        l = n.find(".is-selected-product").index(),
        c = window.innerWidth || document.documentElement.clientWidth;
      if (((l = -1 == l ? 0 : l), n.find(".js-slide").length > 1)) {
        function d() {
          var e = o.data("flickity"),
            t = Site.sliders.checkThumbnailsOverflow(o);
          void 0 != e && o.flickity("destroy"),
            o.flickity({
              cellSelector: ".js-slide",
              asNavFor: n[0],
              initialIndex: l,
              pageDots: !1,
              prevNextButtons: t,
              arrowShape: theme.icons.arrowNavSlider,
              contain: !0,
              groupCells: !0,
            });
        }
        n
          .on("ready.flickity", function () {
            n.attr("tabindex", "-1"),
              n.find(".js-slide").attr("tabindex", "-1");
          })
          .on("change.flickity", function (e, t) {
            var i = n
              .find(".js-slide")
              .eq(t)
              .find(".product-single__media--image");
            i.hasClass("lazyloaded") || i.addClass("lazyload");
          })
          .on("settle.flickity", function (i, o) {
            var s = n.find(".js-slide").eq(o).data("media-id");
            t.switchMedia(e, s);
          }),
          n.flickity({
            cellSelector: ".js-slide",
            prevNextButtons: s,
            arrowShape: theme.icons.arrowNavSlider,
            pageDots: r,
            initialIndex: l,
            draggable: a,
            adaptiveHeight: !0,
            contain: !0,
            wrapAround: !0,
          }),
          o.on("ready.flickity", function () {
            o.attr("tabindex", "-1");
          }),
          d(),
          $(window).on(
            "resize.product",
            Reqs.debounce(function () {
              var e = window.innerWidth || document.documentElement.clientWidth;
              c != e && d(), (c = e);
            }, 250)
          );
      }
    },
    handleMediaFocus: function (e) {
      if (13 === e.keyCode || 9 === e.keyCode) {
        var t = $(e.currentTarget).closest(this.selectors.productBlock),
          i = $(e.currentTarget).data("thumbnail-id"),
          n = $(
            this.selectors.productMediaWrapper + '[data-media-id="' + i + '"]',
            t
          ).index(),
          o = $(this.selectors.productMediaSlider, t).data("flickity"),
          s = $(this.selectors.productMediaThumbs, t).data("flickity");
        o && o.isActive && n > -1 && 13 === e.keyCode && o.select(n),
          s && s.isActive && n > -1 && s.select(n);
      }
    },
    switchMedia: function (e, t) {
      var i = $(e),
        n = $(this.selectors.productMediaWrapper + ":not(.media--hidden)", i),
        o = $(
          this.selectors.productMediaWrapper + '[data-media-id="' + t + '"]',
          i
        ),
        s = $(
          this.selectors.productMediaWrapper +
            ':not([data-media-id="' +
            t +
            '"])',
          i
        );
      $("body").hasClass("no-outline") || o.focus(),
        n.trigger("mediaHidden"),
        o.removeClass("media--hidden").trigger("mediaVisible"),
        s.addClass("media--hidden");
    },
    initMediaSwitch: function (e) {
      var t = $(e),
        i = $("[data-thumbnail-id]", t);
      i.length &&
        i
          .on("click", function (e) {
            e.preventDefault();
          })
          .on("keyup", this.handleMediaFocus.bind(this));
    },
    initProductVideo: function (e) {
      var t = $(e).data("section-id");
      $(this.selectors.productMediaTypeVideo, e).each(function () {
        var e = $(this);
        ProductVideo.init(e, t);
      });
    },
    initModelViewerLibraries: function (e) {
      var t = $(e).data("section-id"),
        i = $(this.selectors.productMediaTypeModel, e);
      i.length < 1 || ProductModel.init(i, t);
    },
    initShopifyXrLaunch: function (e) {
      var t = this;
      $(document).on("shopify_xr_launch", function () {
        $(t.selectors.productMediaWrapper + ":not(.media--hidden)", e).trigger(
          "xrLaunch"
        );
      });
    },
    initVariants: function (e, t) {
      var i = $(e),
        n = ".product" + $(e).data("section-id"),
        o = {
          $container: i,
          enableHistoryState: !1,
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          product: t,
        };
      (this.$container = $(e)),
        (this.shopBarVariants = new slate.Variants(o)),
        i.on("variantChange" + n, this.updateAddToCartState.bind(this)),
        i.on("variantChange" + n, this.updateColorName.bind(this)),
        i.on("variantPriceChange" + n, this.updateProductPrices.bind(this)),
        i.on("variantUnitChange" + n, this.updateProductUnits.bind(this)),
        i.on("variantImageChange" + n, this.updateProductImage.bind(this));
    },
    updateAddToCartState: function (e) {
      var t = e.variant;
      t
        ? t.available
          ? ($(this.selectors.addToCart, this.$container).prop("disabled", !1),
            $(this.selectors.addToCartText, this.$container).html(
              theme.translations.add_to_cart
            ),
            $(this.selectors.notificationForm, this.$container).addClass(
              "visually-hidden"
            ))
          : ($(this.selectors.addToCart, this.$container).prop("disabled", !0),
            $(this.selectors.addToCartText, this.$container).html(
              theme.translations.sold_out
            ),
            $(this.selectors.notificationForm, this.$container).removeClass(
              "visually-hidden"
            ))
        : ($(this.selectors.addToCart, this.$container).prop("disabled", !0),
          $(this.selectors.addToCartText, this.$container).html(
            theme.translations.unavailable
          ),
          $(this.selectors.notificationForm, this.$container).removeClass(
            "visually-hidden"
          ));
    },
    updateColorName: function (e) {
      var t = $(this.selectors.colorSwatch, this.$container)
        .filter(":checked")
        .val();
      $(this.selectors.colorLabel).text(t);
    },
    updateProductPrices: function (e) {
      var t = e.variant,
        i = $(this.selectors.comparePrice, this.$container);
      $(this.selectors.productPrice, this.$container).html(
        slate.Currency.formatMoney(t.price, window.moneyFormat)
      ),
        t.compare_at_price > t.price
          ? i
              .html(
                slate.Currency.formatMoney(
                  t.compare_at_price,
                  window.moneyFormat
                )
              )
              .removeClass("visually-hidden")
          : i.html("").addClass("visually-hidden");
    },
    updateProductUnits: function (e) {
      var t = e.variant;
      if (void 0 !== t.unit_price) {
        var i = slate.Currency.formatMoney(t.unit_price, window.moneyFormat),
          n = this.getBaseUnit(t);
        $(this.selectors.unitPrice, this.$container).html(i),
          $(this.selectors.unitBase, this.$container).html(n),
          $(this.selectors.unitWrapper, this.$container).show();
      } else $(this.selectors.unitWrapper, this.$container).hide();
    },
    getBaseUnit: function (e) {
      return 1 === e.unit_price_measurement.reference_value
        ? e.unit_price_measurement.reference_unit
        : e.unit_price_measurement.reference_value +
            e.unit_price_measurement.reference_unit;
    },
    updateProductImage: function (e) {
      var t = e.variant,
        i = t.featured_media ? t.featured_media.id : "",
        n = $(this.selectors.productMediaSlider, this.$container),
        o = n.data("flickity");
      if (o && o.isActive) {
        var s = n.find('[data-id="' + i + '"]');
        -1 != s.index() && o.select(s.index());
      }
    },
    initPaymentButton: function (e) {
      var t = theme.settings.enablePaymentButton,
        i = theme.settings.enableAcceptTerms,
        n = $(this.selectors.addToCart, e);
      t && !i
        ? (n.addClass("button--alt"),
          Shopify.PaymentButton && Shopify.PaymentButton.init())
        : n.removeClass("button--alt");
    },
    modifyProductMediaSettings: function (e) {
      return (
        e.find(".product-image").each(function () {
          $(this)
            .attr(
              "data-enable-video-looping",
              theme.settings.enableVideoLooping
            )
            .attr("data-show_quantity", theme.settings.showQuantity)
            .attr("tabindex", "-1");
        }),
        e.html()
      );
    },
    modifyProductFormIds: function (e, t) {
      return (
        e.find("[id]").each(function () {
          var e = $(this).attr("id");
          $(this).attr("id", e + "--" + t + "-quickView");
        }),
        e.find("[for]").each(function () {
          var e = $(this).attr("for");
          $(this).attr("for", e + "--" + t + "-quickView");
        }),
        e.html()
      );
    },
    addProductTitleLink: function (e, t) {
      var i = e.find(".product-title").text();
      return (
        e.find(".product-title").html('<a href="' + t + '">' + i + "</a>"),
        e.html()
      );
    },
  },
  Product = {
    selectors: {
      body: "body",
      addToCart: "[data-add-to-cart]",
      addToCartText: "[data-add-to-cart-text]",
      productPrice: "[data-product-price]",
      comparePrice: "[data-compare-price]",
      unitPrice: "[data-unit-price]",
      unitBase: "[data-unit-base]",
      unitWrapper: "[data-unit-wrapper]",
      priceWrapper: "[data-price-wrapper]",
      notificationForm: "[data-notification-form]",
      originalSelectorId: "[data-product-select]",
      singleOptionSelector: "[data-single-option-selector]",
      productSection: '[data-section-type="product"]',
      productSectionContainer: ".js-product-template",
      productSliderContainer: ".js-productImgContainer",
      productSlider: "[data-product-single-media-slider]",
      productSliderNav: ".js-productImgSlider-nav",
      productSlide: ".js-slide",
      productScroller: ".js-productImgScroller",
      productScrollerNav: ".js-productImgScroller-nav",
      productSelected: ".is-selected-product",
      productMediaSlider: "[data-product-single-media-slider]",
      productMediaWrapper: "[data-product-single-media-wrapper]",
      productMediaTypeVideo: "[data-product-media-type-video]",
      productMediaTypeModel: "[data-product-media-type-model]",
      productMediaVideo: ".product-single__media--video",
      productMediaModel: ".product-single__media--model",
      productMediaImage: ".product-single__media--image",
      productMediaThumb: ".product-single__media-thumb",
      productThumbnail: ".js-product-single__thumbnail",
      productImageLightboxLink: "[data-lightbox-link]",
      productLayoutScrollable: ".product-layout--scrollable",
      productTabs: ".js-product-tabs",
      productTabsNav: ".product-tabs-nav",
      productTabsContents: ".product-tabs-contents",
      productTabTitle: ".product-tab-title",
      productTabContent: ".product-tab-content",
      productForm: "[data-product-form]",
      productFormBlock: ".productForm-block",
      productFormSelectWrapper: ".selector-wrapper",
      storeAvailabilityContainer: "[data-store-availability-container]",
      cartStatus: "[data-cart-status]",
      colorSwatch: "[data-color-swatch]",
      colorLabel: "[data-color-label]",
      shopBar: ".shop-bar",
      zoomContainer: ".zoom-container",
    },
    classes: { visibilityHidden: "visibility-hidden" },
    switchMediaTimeout: 0,
    init: function (e, t) {
      var i = this,
        e = void 0 !== e && e;
      if (e) {
        var n = document.querySelector('[data-section-id="' + t + '"]');
        this.initSingleProduct(n, e);
      } else
        document
          .querySelectorAll(this.selectors.productSection)
          .forEach((t) => {
            i.initSingleProduct(t, e);
          });
    },
    initSingleProduct: function (e, t) {
      var i = this,
        n = $(this.selectors.shopBar, e).length,
        o = $(this.selectors.productLayoutScrollable, e).length,
        s = $(e).hasClass("onboarding-product"),
        r = !$(e).hasClass("featured-product"),
        a = $(e).attr("data-store-availability");
      s
        ? (this.qtyAdjust(),
          $(this.selectors.colorSwatch, e).on("change", function () {
            var t = $(i.selectors.colorSwatch, e).filter(":checked").val();
            $(i.selectors.colorLabel, e).text(t);
          }))
        : (r
            ? ((this.mfpOpen = !0),
              a &&
                ((this.storeAvailabilityContainer = e.querySelector(
                  this.selectors.storeAvailabilityContainer
                )),
                this.storeAvailabilityContainer &&
                  (this.storeAvailability = new theme.StoreAvailability(
                    this.storeAvailabilityContainer
                  ))),
              this.initProductTabs(e),
              this.initImageGallery(e),
              this.qtyAdjust(),
              o ? this.initScroller(e, t) : this.initProductMediaSlider(e),
              n && this.initShopBar(e))
            : this.initProductMediaSlider(e),
          this.initProductVideo(e),
          this.initMediaSwitch(e),
          this.initModelViewerLibraries(e),
          this.initShopifyXrLaunch(e),
          this.initVariants(e),
          Site.initReviews());
    },
    initVariants: function (e) {
      var t = $(e),
        i = $(e).data("section-id"),
        n = ".product" + i,
        o = JSON.parse(document.getElementById("ProductJson--" + i).innerHTML),
        s = $(e).hasClass("featured-product"),
        r = {
          $container: t,
          enableHistoryState: !s,
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          product: o,
        };
      (this.shopBarVariants = new slate.Variants(r)),
        (this.productSingleObject = o),
        this.storeAvailability &&
          this.storeAvailability.updateContent(
            this.shopBarVariants.currentVariant.id,
            r.product.title
          ),
        t.on("variantChange" + n, this.updateAddToCartState.bind(this)),
        t.on("variantChange" + n, this.updateColorName.bind(this)),
        t.on("variantChange" + n, this.updateAvailability.bind(this)),
        t.on("variantPriceChange" + n, this.updateProductPrices.bind(this)),
        t.on("variantUnitChange" + n, this.updateProductUnits.bind(this)),
        t.on("variantImageChange" + n, this.updateProductImage.bind(this));
    },
    updateAddToCartState: function (e) {
      var t = e.target,
        i = e.variant,
        n = $(this.selectors.shopBar);
      i
        ? i.available
          ? ($(this.selectors.addToCart, t).prop("disabled", !1),
            $(this.selectors.addToCartText, t).html(
              theme.translations.add_to_cart
            ),
            $(this.selectors.notificationForm, t).addClass("visually-hidden"))
          : ($(this.selectors.addToCart, t).prop("disabled", !0),
            $(this.selectors.addToCartText, t).html(
              theme.translations.sold_out
            ),
            $(this.selectors.notificationForm, t).removeClass(
              "visually-hidden"
            ))
        : ($(this.selectors.addToCart, t).prop("disabled", !0),
          $(this.selectors.addToCartText, t).html(
            theme.translations.unavailable
          ),
          $(this.selectors.notificationForm, t).removeClass("visually-hidden")),
        n.length &&
          (i
            ? i.available
              ? ($(this.selectors.addToCart, n).prop("disabled", !1),
                $(this.selectors.addToCartText, n).html(
                  theme.translations.add_to_cart
                ))
              : ($(this.selectors.addToCart, n).prop("disabled", !0),
                $(this.selectors.addToCartText, n).html(
                  theme.translations.sold_out
                ))
            : ($(this.selectors.addToCart, n).prop("disabled", !0),
              $(this.selectors.addToCartText, n).html(
                theme.translations.unavailable
              )));
    },
    updateColorName: function (e) {
      var t = e.target,
        i = $(this.selectors.colorSwatch, t).filter(":checked").val();
      $(this.selectors.colorLabel, t).text(i);
    },
    updateProductPrices: function (e) {
      var t = e.target,
        i = e.variant,
        n = $(this.selectors.comparePrice, t).add(
          $(this.selectors.comparePrice, this.selectors.shopBar)
        );
      $(this.selectors.productPrice, t)
        .add($(this.selectors.productPrice, this.selectors.shopBar))
        .html(slate.Currency.formatMoney(i.price, window.moneyFormat)),
        i.compare_at_price > i.price
          ? n
              .html(
                slate.Currency.formatMoney(
                  i.compare_at_price,
                  window.moneyFormat
                )
              )
              .removeClass("visually-hidden")
          : n.html("").addClass("visually-hidden");
    },
    updateProductUnits: function (e) {
      var t = e.target,
        i = e.variant;
      if (void 0 !== i.unit_price) {
        var n = slate.Currency.formatMoney(i.unit_price, window.moneyFormat),
          o = this.getBaseUnit(i);
        $(this.selectors.unitPrice, t).html(n),
          $(this.selectors.unitBase, t).html(o),
          $(this.selectors.unitWrapper, t).show();
      } else $(this.selectors.unitWrapper, t).hide();
    },
    getBaseUnit: function (e) {
      return 1 === e.unit_price_measurement.reference_value
        ? e.unit_price_measurement.reference_unit
        : e.unit_price_measurement.reference_value +
            e.unit_price_measurement.reference_unit;
    },
    updateAvailability: function (e) {
      this.updateStoreAvailabilityContent(e);
    },
    updateStoreAvailabilityContent: function (e) {
      if (this.storeAvailability) {
        var t = e.variant;
        t
          ? this.storeAvailability.updateContent(
              t.id,
              this.productSingleObject.title
            )
          : this.storeAvailability.clearContent();
      }
    },
    updateProductImage: function (e) {
      var t = e.target,
        i = e.variant,
        n = i.featured_media ? i.featured_media.id : "",
        o = $(this.selectors.productLayoutScrollable, t).length,
        s = $(this.selectors.productSlider, t),
        r = s.data("flickity");
      if (r && r.isActive) {
        var a = s.find('[data-id="' + n + '"]');
        -1 != a.index() && r.select(a.index());
      }
      if (
        o &&
        (window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth) >= 768
      ) {
        var l = $(this.selectors.productMediaWrapper + '[data-id="' + n + '"]');
        if (l.length) {
          var c = l.data("media-id");
          $("html, body")
            .stop(!0, !0)
            .animate({ scrollTop: l.offset().top - 59 - 40 }),
            this.switchMediaTimeout && clearTimeout(this.switchMediaTimeout),
            (this.switchMediaTimeout = setTimeout(function () {
              Product.switchMedia(t, c);
            }, 500));
        }
      }
    },
    initProductMediaSlider: function (e) {
      var t = this,
        i = $(this.selectors.productSlider, e),
        n = $(this.selectors.productSliderNav, e),
        o = i.data("arrows"),
        s = i.data("dots"),
        r = !(
          $(this.selectors.productMediaVideo, i).length ||
          $(this.selectors.productMediaModel, i).length
        ),
        a = $(this.selectors.productSelected, i).index(),
        l = $(this.selectors.productSlide, i).length > 1,
        c = window.innerWidth || document.documentElement.clientWidth;
      if (((a = -1 == a ? 0 : a), l)) {
        function d() {
          var e = n.data("flickity"),
            t = Site.sliders.checkThumbnailsOverflow(n);
          void 0 != e && n.flickity("destroy"),
            n.flickity({
              cellSelector: ".js-slide",
              asNavFor: i[0],
              initialIndex: a,
              pageDots: !1,
              prevNextButtons: t,
              arrowShape: theme.icons.arrowNavSlider,
              groupCells: !0,
              contain: !0,
            });
        }
        i
          .on("ready.flickity", function () {
            i.attr("tabindex", "-1"),
              $(t.selectors.productSlide, i).attr("tabindex", "-1");
          })
          .on("change.flickity", function (e, n) {
            var o = $(t.selectors.productSlide, i).eq(n),
              s = $(t.selectors.productMediaImage, o);
            s.hasClass("lazyloaded") || s.addClass("lazyload"),
              setTimeout(function () {
                t.mfpOpen = !0;
              }, 10);
          })
          .on("dragStart.flickity", function (e, i) {
            t.mfpOpen = !1;
          })
          .on("settle.flickity", function (n, o) {
            var s = $(t.selectors.productSlide, i).eq(o).data("media-id");
            t.switchMedia(e, s);
          }),
          i.flickity({
            cellSelector: t.selectors.productSlide,
            prevNextButtons: o,
            arrowShape: theme.icons.arrowNavSlider,
            pageDots: s,
            initialIndex: a,
            draggable: r,
            adaptiveHeight: !0,
            contain: !0,
            wrapAround: !0,
          }),
          n.on("ready.flickity", function () {
            n.attr("tabindex", "-1");
          }),
          d(),
          $(window).on(
            "resize.product",
            Reqs.debounce(function () {
              var e = window.innerWidth || document.documentElement.clientWidth;
              c != e && d(), (c = e);
            }, 250)
          );
      }
    },
    initImageGallery: function (e) {
      var t = this,
        i = $(t.selectors.productSliderContainer, e);
      i.data("lightbox") &&
        (Reqs.lightbox(),
        Reqs.zoom(),
        $(t.selectors.productImageLightboxLink, i).magnificPopup({
          mainClass: "mfp-fade-in-up",
          type: "image",
          removalDelay: 300,
          fixedContentPos: !0,
          closeOnContentClick: !1,
          closeOnBgClick: !1,
          closeBtnInside: !0,
          gallery: {
            enabled: !0,
            preload: 0,
            tCounter: '<div class="mfp-counter-text">%curr% / %total%</div>',
            arrowMarkup:
              '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%">' +
              theme.icons.arrowSlider +
              "</button>",
          },
          tLoading: '<span class="icon-loader"></span>',
          closeMarkup:
            '<button title="%title%" type="button" class="mfp-close">' +
            theme.icons.close +
            "</button>",
          disableOn: function () {
            return t.mfpOpen;
          },
          callbacks: {
            open: function () {
              var e = $(this.currItem.el).attr("href"),
                i = $(this.contentContainer);
              t.initZoom(e, i);
            },
            change: function () {
              var e = $(this.currItem.el).attr("href"),
                i = $(this.contentContainer);
              t.initZoom(e, i);
            },
          },
        }));
    },
    initZoom: function (e, t) {
      $(this.selectors.zoomContainer, t).length ||
        t.append('<span class="zoom-container"></span>'),
        t
          .find(this.selectors.zoomContainer)
          .removeClass("zoom-container--loaded is-zoomed")
          .trigger("zoom.destroy")
          .empty()
          .zoom({
            on: "click",
            url: e,
            magnify: 1.5,
            duration: 500,
            callback: function () {
              $(this)
                .parent()
                .removeClass("is-zoomed")
                .addClass("zoom-container--loaded");
            },
            onZoomIn: function () {
              $(this).parent().addClass("is-zoomed");
            },
            onZoomOut: function () {
              $(this).parent().removeClass("is-zoomed");
            },
          });
    },
    initProductTabs: function (e) {
      var t = this,
        i = $(this.selectors.productTabs, e);
      enquire.register("screen and (min-width: 768px)", function () {
        var e = $(t.selectors.productTabsNav, i),
          n = $(t.selectors.productTabsContents, i);
        $(t.selectors.productTabTitle, i).remove().appendTo(e),
          $(t.selectors.productTabContent, i).remove().appendTo(n);
      }),
        enquire.register("screen and (max-width: 767px)", function () {
          for (
            var e = $(t.selectors.productTabTitle, i),
              n = $(t.selectors.productTabContent, i),
              o = 0;
            o < e.length;
            o++
          )
            e.eq(o).remove().appendTo(i), n.eq(o).remove().appendTo(i);
        }),
        i.on("click", t.selectors.productTabTitle, function () {
          var e = $(this).index(),
            n = $(this).hasClass("is-active"),
            o = $(this).siblings(t.selectors.productTabTitle).length + 1,
            s =
              window.innerWidth ||
              document.documentElement.clientWidth ||
              document.body.clientWidth;
          (1 != o || !(s >= 768)) &&
            (i.find(t.selectors.productTabTitle).removeClass("is-active"),
            i.find(t.selectors.productTabContent).removeClass("is-active"),
            n
              ? (e++,
                i.find(t.selectors.productTabTitle).eq(e).length || (e = 0),
                s >= 768
                  ? (i
                      .find(t.selectors.productTabTitle)
                      .eq(e)
                      .addClass("is-active")
                      .siblings()
                      .removeClass("is-active"),
                    i
                      .find(t.selectors.productTabContent)
                      .eq(e)
                      .addClass("is-active")
                      .siblings()
                      .removeClass("is-active"))
                  : $(this).next().next(t.selectors.productTabTitle).length
                  ? $(this)
                      .next()
                      .next(t.selectors.productTabTitle)
                      .addClass("is-active")
                      .next(t.selectors.productTabContent)
                      .addClass("is-active")
                  : 1 == o
                  ? $(this)
                      .removeClass("is-active")
                      .next(t.selectors.productTabContent)
                      .removeClass("is-active")
                  : $(this)
                      .parent()
                      .find(t.selectors.productTabTitle)
                      .eq(0)
                      .addClass("is-active")
                      .next(t.selectors.productTabContent)
                      .addClass("is-active"))
              : s >= 768
              ? (i
                  .find(t.selectors.productTabTitle)
                  .eq(e)
                  .addClass("is-active")
                  .siblings()
                  .removeClass("is-active"),
                i
                  .find(t.selectors.productTabContent)
                  .eq(e)
                  .addClass("is-active")
                  .siblings()
                  .removeClass("is-active"))
              : $(this)
                  .addClass("is-active")
                  .next(t.selectors.productTabContent)
                  .addClass("is-active"),
            s < 768 &&
              i.find(t.selectors.productTabTitle + ".is-active").length &&
              setTimeout(function () {
                var e =
                  i.find(t.selectors.productTabTitle + ".is-active").offset()
                    .top - 61;
                $("html, body").stop(!0, !0).animate({ scrollTop: e });
              }, 300));
        });
    },
    initScroller: function (e, t) {
      var i = this;
      if ($(this.selectors.productMediaWrapper, e).length > 1) {
        var n = !1,
          o = $(this.selectors.productLayoutScrollable, e),
          s = $(this.selectors.productMediaWrapper, e),
          r = $(this.selectors.productScrollerNav, e);
        function a() {
          var t,
            n,
            s,
            r,
            a,
            l,
            c,
            d,
            u,
            p,
            h,
            f,
            g,
            m,
            v =
              window.innerWidth ||
              document.documentElement.clientWidth ||
              document.body.clientWidth,
            y = $(i.selectors.productSlide, o).length > 1;
          v < 768 && y
            ? ((t = $(i.selectors.productScroller, e)),
              (n = $(i.selectors.productScrollerNav, e)),
              (s = $(i.selectors.productSlide, e).length > 1),
              (r = t.data("arrows")),
              (a = t.data("dots")),
              (l = Site.sliders.checkThumbnailsOverflow(n)),
              (c = !(
                $(i.selectors.productMediaVideo, t).length ||
                $(i.selectors.productMediaModel, t).length
              )),
              (d = $(i.selectors.productSelected, t).index()),
              (d = -1 == d ? 0 : d),
              (u = t.data("flickity")),
              (p = n.data("flickity")),
              s &&
                (void 0 == u &&
                  (t
                    .on("change.flickity", function (e, n) {
                      var o = $(i.selectors.productSlide, t).eq(n);
                      o.hasClass("lazyloaded") || o.addClass("lazyload"),
                        setTimeout(function () {
                          i.mfpOpen = !0;
                        }, 10);
                    })
                    .on("dragStart.flickity", function (e, t) {
                      i.mfpOpen = !1;
                    }),
                  t.flickity({
                    cellSelector: ".js-slide",
                    prevNextButtons: r,
                    arrowShape: theme.icons.arrowNavSlider,
                    pageDots: a,
                    initialIndex: d,
                    draggable: c,
                    selectedAttraction: 0.08,
                    friction: 0.8,
                    adaptiveHeight: !0,
                    contain: !0,
                    wrapAround: !0,
                  })),
                void 0 == p &&
                  n.flickity({
                    cellSelector: ".js-slide",
                    asNavFor: t[0],
                    initialIndex: d,
                    pageDots: !1,
                    prevNextButtons: l,
                    arrowShape: theme.icons.arrowNavSlider,
                    groupCells: !0,
                    contain: !0,
                  })))
            : ((h = $(i.selectors.productScroller, e)),
              (f = $(i.selectors.productScrollerNav, e)),
              (g = h.data("flickity")),
              (m = f.data("flickity")),
              g && g.isActive && h.flickity("destroy"),
              m && m.isActive && f.flickity("destroy"));
        }
        function l() {
          if (
            (window.innerWidth ||
              document.documentElement.clientWidth ||
              document.body.clientWidth) >= 768
          )
            for (
              var e = window.scrollY,
                t = o.offset().top - 100,
                n = s.length - 1;
              n >= 0;
              n--
            ) {
              var a = $(i.selectors.productMediaWrapper).eq(n),
                l = a.data("id"),
                t = parseInt(a.offset().top - 100);
              if (e >= t) {
                r.find(i.selectors.productMediaThumb + '[data-id="' + l + '"]')
                  .addClass("active")
                  .siblings()
                  .removeClass("active");
                break;
              }
            }
        }
        t && l(),
          $(window)
            .on("scroll.product", Reqs.throttle(l, 10))
            .on("load", function () {
              n = !0;
            }),
          r.on("click", this.selectors.productThumbnail, function (o) {
            if (
              (o.preventDefault(),
              (window.innerWidth ||
                document.documentElement.clientWidth ||
                document.body.clientWidth) >= 768)
            ) {
              var s = $(this).parent().data("id"),
                r = $(
                  i.selectors.productMediaWrapper + '[data-id="' + s + '"]'
                );
              if (r.length) {
                var a = r.data("media-id");
                (n || t) &&
                  $("html, body")
                    .stop(!0, !0)
                    .animate(
                      { scrollTop: r.offset().top - 59 - 40 },
                      300,
                      function () {
                        Product.switchMedia(e, a);
                      }
                    );
              }
            }
          }),
          $(window).on("resize.product", Reqs.throttle(a, 250)),
          a();
      }
    },
    handleMediaFocus: function (e, t) {
      if (13 === e.keyCode || 9 === e.keyCode) {
        var i = $(e.currentTarget).data("thumbnail-id"),
          n = $(
            this.selectors.productSlide + '[data-media-id="' + i + '"]',
            t
          ).index(),
          o = $(this.selectors.productSliderContainer, t).data("flickity"),
          s = $(this.selectors.productSliderNav, t).data("flickity");
        o && o.isActive && n > -1 && 13 === e.keyCode && o.select(n),
          s && s.isActive && n > -1 && s.select(n);
      }
    },
    switchMedia: function (e, t) {
      var i = $(this.selectors.productMediaWrapper + ":not(.media--hidden)", e),
        n = $(
          this.selectors.productMediaWrapper + '[data-media-id="' + t + '"]',
          e
        ),
        o = $(
          this.selectors.productMediaWrapper +
            ':not([data-media-id="' +
            t +
            '"])',
          e
        );
      $(this.selectors.body).hasClass("no-outline") || n.focus(),
        i.trigger("mediaHidden"),
        n.removeClass("media--hidden").trigger("mediaVisible"),
        o.addClass("media--hidden");
    },
    pauseOtherMedia: function (e, t) {
      var i = $(
          this.selectors.productMediaWrapper + '[data-media-id="' + e + '"]'
        ),
        n = $(
          this.selectors.productMediaWrapper +
            ':not([data-media-id="' +
            e +
            '"])'
        );
      i.removeClass("media--hidden"),
        n.trigger("mediaHidden").addClass("media--hidden");
    },
    initMediaSwitch: function (e) {
      var t = $(this.selectors.productThumbnail, e);
      t.length &&
        t
          .on("click", function (e) {
            e.preventDefault();
          })
          .on("keyup", this.handleMediaFocus.bind(this));
    },
    initProductVideo: function (e) {
      var t = $(e).data("section-id");
      $(this.selectors.productMediaTypeVideo, e).each(function () {
        var e = $(this);
        ProductVideo.init(e, t);
      });
    },
    initModelViewerLibraries: function (e) {
      var t = $(e).data("section-id"),
        i = $(this.selectors.productMediaTypeModel, e);
      i.length < 1 || ProductModel.init(i, t);
    },
    initShopifyXrLaunch: function (e) {
      var t = this;
      $(document).on("shopify_xr_launch", function () {
        $(t.selectors.productMediaWrapper + ":not(.media--hidden)", e).trigger(
          "xrLaunch"
        );
      });
    },
    initShopBar: function (e) {
      var t = $(e).data("section-id"),
        i = ".product" + t,
        n = JSON.parse(document.getElementById("ProductJson--" + t).innerHTML),
        o = $(this.selectors.body),
        s = $(this.selectors.footer),
        r = $(this.selectors.shopBar);
      r.find(this.selectors.originalSelectorId);
      var a = $(this.selectors.productSectionContainer, e),
        l = $(this.selectors.productForm, e);
      l.find(this.selectors.originalSelectorId);
      var c = l.find(this.selectors.singleOptionSelector),
        d = {
          $container: (r = r.remove().appendTo(o)),
          enableHistoryState: !1,
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          product: n,
        };
      (this.shopBarVariants = new slate.Variants(d)),
        r.on("variantChange" + i, this.updateAddToCartState.bind(this)),
        r.on("variantChange" + i, this.updateColorName.bind(this)),
        r.on("variantPriceChange" + i, this.updateProductPrices.bind(this)),
        r.on("variantUnitChange" + i, this.updateProductUnits.bind(this)),
        r.on("variantImageChange" + i, this.updateProductImage.bind(this)),
        r.on("change", this.selectors.singleOptionSelector, function (e) {
          var t = $(this).val(),
            i = $(this).data("index"),
            n = c.filter('[data-index="' + i + '"]');
          n.is("select")
            ? n.val(t).triggerHandler("change")
            : n
                .filter('[value="' + t + '"]')
                .prop("checked", !0)
                .triggerHandler("change");
        }),
        c.on("change", function (e) {
          var t = $(this).data("index"),
            i = $(this).val();
          r.find('[data-index="' + t + '"]')
            .val(i)
            .triggerHandler("change");
        }),
        $(window)
          .on(
            "scroll.product",
            Reqs.throttle(function () {
              var e = window.scrollY;
              if (a.length && r.length) {
                var t = a.offset().top;
                e > t
                  ? (r.addClass("shop-bar--is-visible"),
                    s.addClass("site-footer--push"))
                  : e < t - 60 &&
                    (r.removeClass("shop-bar--is-visible"),
                    s.removeClass("site-footer--push"));
              }
            }, 100)
          )
          .trigger("scroll.product");
    },
    showVariantImage: function (e, t) {
      var i = e.featured_media ? e.featured_media.id : "",
        n = t.find(".product-image"),
        o = t.find(".js-productImgContainer"),
        s = t.find(".productImgScroller-nav"),
        r = o.data("flickity");
      if (r && r.isActive) {
        var a = o.find('[data-id="' + i + '"]');
        -1 != a.index() && r.select(a.index()),
          n.removeClass("is-selected-product"),
          a.addClass("is-selected-product");
      } else {
        var l = s.find('[data-id="' + i + '"] .js-product-single__thumbnail');
        l.length && l.trigger("click");
      }
    },
    qtyAdjust: function () {
      var e = $("body");
      e.off("click", ".js-qty__adjust-btn"),
        e.on("click", ".js-qty__adjust-btn", function (e) {
          e.preventDefault();
          var t,
            i = $(this),
            n = $(this).siblings(".qty__adjust-input");
          (qty =
            ((t = parseInt(n.val().replace(/\D/g, ""))),
            (parseFloat(t) != parseInt(t) || isNaN(t)) && (t = 1),
            t)),
            i.hasClass("increase") ? (qty += 1) : (qty -= 1) < 1 && (qty = 1),
            n.val(qty);
        }),
        e.off("focusout", ".qty__adjust > input"),
        e.on("focusout", ".qty__adjust > input", function (e) {
          $(this).val() || $(this).prop("value", 1);
        }),
        e.off("keydown", ".qty__adjust > input"),
        e.on("keydown", ".qty__adjust > input", function (e) {
          var t = $(this).val();
          13 !== e.keyCode || t || $(this).prop("value", 1);
        });
    },
  };
function onYouTubeIframeAPIReady() {
  ProductVideo.loadVideos(ProductVideo.hosts.youtube),
    (window.isYoutubeAPILoaded = !0);
}
window.isYoutubeAPILoaded = !1;
var ProductVideo = (function () {
    var e = {},
      t = { html5: "html5", youtube: "youtube" },
      i = {
        enableVideoLooping: "enable-video-looping",
        videoId: "video-id",
        mediaId: "media-id",
      };
    function n(i) {
      if (i) {
        !(function i() {
          for (var n in e)
            if (e.hasOwnProperty(n)) {
              var o = e[n];
              if (o.nativeVideo) continue;
              o.host === t.html5 &&
                (o.element.setAttribute("controls", "controls"),
                (o.nativeVideo = !0));
            }
        })();
        return;
      }
      o(t.html5);
    }
    function o(t) {
      for (var i in e)
        if (e.hasOwnProperty(i)) {
          var n = e[i];
          n.host === t && n.ready();
        }
    }
    return {
      init: function o(s, r) {
        if (s.length) {
          var a = s.find("iframe, video")[0],
            l = s.data("mediaId");
          if (a) {
            e[l] = {
              mediaId: l,
              sectionId: r,
              host:
                ((c = a),
                "VIDEO" === c.tagName
                  ? t.html5
                  : "IFRAME" === c.tagName &&
                    /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
                      c.src
                    )
                  ? t.youtube
                  : null),
              container: s,
              element: a,
              ready: function () {
                !(function e(n) {
                  if (!n.player) {
                    var o = n.container,
                      s = o.data(i.enableVideoLooping),
                      r = o.data(i.mediaId);
                    switch (n.host) {
                      case t.html5:
                        (n.player = new Shopify.Plyr(n.element, {
                          loop: { active: s },
                          focusOnPlay: !0,
                        })),
                          n.player.on("play", function () {
                            Product.pauseOtherMedia(r);
                          });
                        break;
                      case t.youtube:
                        var a = o.data(i.videoId);
                        n.player = new YT.Player(n.element, {
                          videoId: a,
                          events: {
                            onStateChange: function (e) {
                              0 === e.data && s && e.target.seekTo(0),
                                1 === e.data && Product.pauseOtherMedia(r);
                            },
                          },
                        });
                    }
                    o.on("mediaHidden xrLaunch", function (e) {
                      n.player &&
                        (n.host === t.html5 && n.player.pause(),
                        n.host === t.youtube &&
                          n.player.pauseVideo &&
                          n.player.pauseVideo());
                    }),
                      o.on("mediaVisible", function (e) {
                        !window.isTouch &&
                          n.player &&
                          (n.host === t.html5 && n.player.play(),
                          n.host === t.youtube &&
                            n.player.playVideo &&
                            n.player.playVideo());
                      });
                  }
                })(this);
              },
            };
            var c,
              d = e[l];
            switch (d.host) {
              case t.html5:
                window.Shopify.loadFeatures([
                  { name: "video-ui", version: "1.0", onLoad: n },
                ]),
                  LibraryLoader.load("plyrShopifyStyles");
                break;
              case t.youtube:
                window.isYoutubeAPILoaded
                  ? ProductVideo.loadVideos(ProductVideo.hosts.youtube)
                  : LibraryLoader.load("youtubeSdk");
            }
          }
        }
      },
      hosts: t,
      loadVideos: o,
      removeSectionVideos: function t(i) {
        for (var n in e)
          if (e.hasOwnProperty(n)) {
            var o = e[n];
            o.sectionId === i && (o.player && o.player.destroy(), delete e[n]);
          }
      },
    };
  })(),
  ProductModel = (function () {
    var e = {},
      t = {},
      i = {},
      n = {
        mediaGroup: "[data-product-single-media-group]",
        xrButton: "[data-shopify-xr]",
      };
    function o(e) {
      if (!e) {
        for (var i in t)
          if (t.hasOwnProperty(i)) {
            var n = t[i];
            n.modelViewerUi ||
              (n.modelViewerUi = new Shopify.ModelViewerUI(n.$element)),
              s(n);
          }
      }
    }
    function s(e) {
      var t = i[e.sectionId];
      e.$container.on("mediaVisible", function () {
        t.$element.attr("data-shopify-model3d-id", e.modelId),
          Product.pauseOtherMedia(e.mediaId),
          window.isTouch || e.modelViewerUi.play();
      }),
        e.$container
          .on("mediaHidden", function () {
            t.$element.attr("data-shopify-model3d-id", t.defaultId),
              e.modelViewerUi.pause();
          })
          .on("xrLaunch", function () {
            e.modelViewerUi.pause();
          }),
        e.$element.on("shopify_model_viewer_ui_toggle_play", function () {
          Product.pauseOtherMedia(e.mediaId);
        });
    }
    return {
      init: function s(r, a) {
        (e[a] = { loaded: !1 }),
          r.each(function (e) {
            var o = $(this),
              s = o.data("media-id"),
              r = $(o.find("model-viewer")[0]),
              l = r.data("model-id");
            if (0 === e) {
              var c = o.closest(n.mediaGroup).find(n.xrButton);
              i[a] = { $element: c, defaultId: l };
            }
            t[s] = {
              modelId: l,
              mediaId: s,
              sectionId: a,
              $container: o,
              $element: r,
            };
          }),
          window.Shopify.loadFeatures([
            {
              name: "shopify-xr",
              version: "1.0",
              onLoad: function t(i) {
                if (!i) {
                  if (!window.ShopifyXR) {
                    document.addEventListener(
                      "shopify_xr_initialized",
                      function () {
                        t();
                      }
                    );
                    return;
                  }
                  for (var n in e)
                    if (e.hasOwnProperty(n)) {
                      var o = e[n];
                      if (o.loaded) continue;
                      var s = $("#ModelJson-" + n);
                      window.ShopifyXR.addModels(JSON.parse(s.html())),
                        (o.loaded = !0);
                    }
                  window.ShopifyXR.setupXRElements();
                }
              },
            },
            { name: "model-viewer-ui", version: "1.0", onLoad: o },
          ]),
          LibraryLoader.load("modelViewerUiStyles");
      },
      removeSectionModels: function i(n) {
        for (var o in t)
          t.hasOwnProperty(o) &&
            t[o].sectionId === n &&
            (t[o].modelViewerUi.destroy(), delete t[o]);
        delete e[n];
      },
    };
  })(),
  RelatedProducts = {
    init: function () {
      var e = $('[data-section-type="related-products"]'),
        t = e.data("enable-section"),
        i = e.attr("data-section-id"),
        n = e.data("product-id"),
        o = e.data("limit"),
        s =
          theme.routes.product_recommendations_url +
          "?section_id=" +
          i +
          "&limit=" +
          o +
          "&product_id=" +
          n;
      t &&
        $.get(s).done(function (t) {
          var i = $(t).find('[data-section-type="related-products"]').html();
          e.hide().html(i).slideDown("slow");
          var n = e.find(".product-block__image");
          Site.animations.animateAll(),
            Site.initReviews(),
            "contain" == theme.settings.imageBackgroundSize &&
              (Collection.setBadgePosition(n),
              $(window)
                .off("resize.products")
                .on(
                  "resize.products",
                  Reqs.debounce(Collection.setBadgePosition.bind(this, n), 50)
                ));
        });
    },
  },
  Blog = {
    selectors: {
      blogContainer: "[data-blog-container]",
      blogPosts: "[data-blog-posts]",
      blogPost: "[data-blog-post]",
      blogPostContent: "[data-post-title], [data-post-excerpt]",
    },
    classes: { blogPostHasImage: "blogModule-posts__post--has-image" },
    init: function () {
      var e = ".blog";
      this.removeAnimations(),
        $(window)
          .off(e)
          .on(
            "resize" + e,
            Reqs.debounce(this.removeAnimations.bind(this), 250)
          );
    },
    removeAnimations: function () {
      768 > (window.innerWidth || document.decumentElement.clientWidth) &&
        $(this.selectors.blogContainer).each(function () {
          Site.removeAnimationClass($(this));
        });
    },
  },
  Reqs = {
    throttle: function (e, t, i) {
      var n, o;
      return (
        t || (t = 250),
        function () {
          var s = i || this,
            r = +new Date(),
            a = arguments;
          n && r < n + t
            ? (clearTimeout(o),
              (o = setTimeout(function () {
                (n = r), e.apply(s, a);
              }, t)))
            : ((n = r), e.apply(s, a));
        }
      );
    },
    debounce: function (e, t, i) {
      var n;
      return function () {
        var o = this,
          s = arguments,
          r = function () {
            (n = null), i || e.apply(o, s);
          },
          a = i && !n;
        clearTimeout(n), (n = setTimeout(r, t)), a && e.apply(o, s);
      };
    },
    lightbox: function () {
      var e;
      (e = function (e) {
        var t,
          i,
          n,
          o,
          s,
          r,
          a = "Close",
          l = "BeforeClose",
          c = "MarkupParse",
          d = "Open",
          u = "Change",
          p = ".mfp",
          h = "mfp-ready",
          f = "mfp-removing",
          g = "mfp-prevent-close",
          m = function () {},
          v = !!window.jQuery,
          y = e(window),
          b = function (e, i) {
            t.ev.on("mfp" + e + p, i);
          },
          k = function (t, i, n, o) {
            var s = document.createElement("div");
            return (
              (s.className = "mfp-" + t),
              n && (s.innerHTML = n),
              o ? i && i.appendChild(s) : ((s = e(s)), i && s.appendTo(i)),
              s
            );
          },
          x = function (i, n) {
            t.ev.triggerHandler("mfp" + i, n),
              t.st.callbacks &&
                ((i = i.charAt(0).toLowerCase() + i.slice(1)),
                t.st.callbacks[i] &&
                  t.st.callbacks[i].apply(t, e.isArray(n) ? n : [n]));
          },
          C = function (i) {
            return (
              (i === r && t.currTemplate.closeBtn) ||
                ((t.currTemplate.closeBtn = e(
                  t.st.closeMarkup.replace("%title%", t.st.tClose)
                )),
                (r = i)),
              t.currTemplate.closeBtn
            );
          },
          w = function () {
            e.magnificPopup.instance ||
              ((t = new m()).init(), (e.magnificPopup.instance = t));
          },
          S = function () {
            var e = document.createElement("p").style,
              t = ["ms", "O", "Moz", "Webkit"];
            if (void 0 !== e.transition) return !0;
            for (; t.length; ) if (t.pop() + "Transition" in e) return !0;
            return !1;
          };
        (m.prototype = {
          constructor: m,
          init: function () {
            var i = navigator.appVersion;
            (t.isLowIE = t.isIE8 = document.all && !document.addEventListener),
              (t.isAndroid = /android/gi.test(i)),
              (t.isIOS = /iphone|ipad|ipod/gi.test(i)),
              (t.supportsTransition = S()),
              (t.probablyMobile =
                t.isAndroid ||
                t.isIOS ||
                /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(
                  navigator.userAgent
                )),
              (n = e(document)),
              (t.popupsCache = {});
          },
          open: function (i) {
            if (!1 === i.isObj) {
              (t.items = i.items.toArray()), (t.index = 0);
              var o,
                r,
                a = i.items;
              for (o = 0; o < a.length; o++)
                if (((r = a[o]).parsed && (r = r.el[0]), r === i.el[0])) {
                  t.index = o;
                  break;
                }
            } else
              (t.items = e.isArray(i.items) ? i.items : [i.items]),
                (t.index = i.index || 0);
            if (t.isOpen) return void t.updateItemHTML();
            (t.types = []),
              (s = ""),
              i.mainEl && i.mainEl.length
                ? (t.ev = i.mainEl.eq(0))
                : (t.ev = n),
              i.key
                ? (t.popupsCache[i.key] || (t.popupsCache[i.key] = {}),
                  (t.currTemplate = t.popupsCache[i.key]))
                : (t.currTemplate = {}),
              (t.st = e.extend(!0, {}, e.magnificPopup.defaults, i)),
              (t.fixedContentPos =
                "auto" === t.st.fixedContentPos
                  ? !t.probablyMobile
                  : t.st.fixedContentPos),
              t.st.modal &&
                ((t.st.closeOnContentClick = !1),
                (t.st.closeOnBgClick = !1),
                (t.st.showCloseBtn = !1),
                (t.st.enableEscapeKey = !1)),
              t.bgOverlay ||
                ((t.bgOverlay = k("bg").on("click" + p, function () {
                  t.close();
                })),
                (t.wrap = k("wrap")
                  .attr("tabindex", -1)
                  .on("click" + p, function (e) {
                    t._checkIfClose(e.target) && t.close();
                  })),
                (t.container = k("container", t.wrap))),
              (t.contentContainer = k("content")),
              t.st.preloader &&
                (t.preloader = k("preloader", t.container, t.st.tLoading));
            var l = e.magnificPopup.modules;
            for (o = 0; o < l.length; o++) {
              var u = l[o];
              t["init" + (u = u.charAt(0).toUpperCase() + u.slice(1))].call(t);
            }
            x("BeforeOpen"),
              t.st.showCloseBtn &&
                (t.st.closeBtnInside
                  ? (b(c, function (e, t, i, n) {
                      i.close_replaceWith = C(n.type);
                    }),
                    (s += " mfp-close-btn-in"))
                  : t.wrap.append(C())),
              t.st.alignTop && (s += " mfp-align-top"),
              t.fixedContentPos
                ? t.wrap.css({
                    overflow: t.st.overflowY,
                    overflowX: "hidden",
                    overflowY: t.st.overflowY,
                  })
                : t.wrap.css({ top: y.scrollTop(), position: "absolute" }),
              (!1 !== t.st.fixedBgPos &&
                ("auto" !== t.st.fixedBgPos || t.fixedContentPos)) ||
                t.bgOverlay.css({ height: n.height(), position: "absolute" }),
              t.st.enableEscapeKey &&
                n.on("keyup" + p, function (e) {
                  27 === e.keyCode && t.close();
                }),
              y.on("resize" + p, function () {
                t.updateSize();
              }),
              t.st.closeOnContentClick || (s += " mfp-auto-cursor"),
              s && t.wrap.addClass(s);
            var f = (t.wH = y.height()),
              g = {};
            if (t.fixedContentPos && t._hasScrollBar(f)) {
              var m = t._getScrollbarSize();
              m && (g.marginRight = m);
            }
            t.fixedContentPos &&
              (t.isIE7
                ? e("body, html").css("overflow", "hidden")
                : (g.overflow = "hidden"));
            var v = t.st.mainClass;
            return (
              t.isIE7 && (v += " mfp-ie7"),
              v && t._addClassToMFP(v),
              t.updateItemHTML(),
              x("BuildControls"),
              e("html").css(g),
              t.bgOverlay
                .add(t.wrap)
                .prependTo(t.st.prependTo || e(document.body)),
              (t._lastFocusedEl = document.activeElement),
              setTimeout(function () {
                t.content
                  ? (t._addClassToMFP(h), t._setFocus())
                  : t.bgOverlay.addClass(h),
                  n.on("focusin" + p, t._onFocusIn);
              }, 16),
              (t.isOpen = !0),
              t.updateSize(f),
              x(d),
              i
            );
          },
          close: function () {
            t.isOpen &&
              (x(l),
              (t.isOpen = !1),
              t.st.removalDelay && !t.isLowIE && t.supportsTransition
                ? (t._addClassToMFP(f),
                  setTimeout(function () {
                    t._close();
                  }, t.st.removalDelay))
                : t._close());
          },
          _close: function () {
            x(a);
            var i = f + " " + h + " ";
            if (
              (t.bgOverlay.detach(),
              t.wrap.detach(),
              t.container.empty(),
              t.st.mainClass && (i += t.st.mainClass + " "),
              t._removeClassFromMFP(i),
              t.fixedContentPos)
            ) {
              var o = { marginRight: "" };
              t.isIE7 ? e("body, html").css("overflow", "") : (o.overflow = ""),
                e("html").css(o);
            }
            n.off("keyup" + p + " focusin" + p),
              t.ev.off(p),
              t.wrap.attr("class", "mfp-wrap").removeAttr("style"),
              t.bgOverlay.attr("class", "mfp-bg"),
              t.container.attr("class", "mfp-container"),
              !t.st.showCloseBtn ||
                (t.st.closeBtnInside &&
                  !0 !== t.currTemplate[t.currItem.type]) ||
                (t.currTemplate.closeBtn && t.currTemplate.closeBtn.detach()),
              t.st.autoFocusLast &&
                t._lastFocusedEl &&
                e(t._lastFocusedEl).focus(),
              (t.currItem = null),
              (t.content = null),
              (t.currTemplate = null),
              (t.prevHeight = 0),
              x("AfterClose");
          },
          updateSize: function (e) {
            if (t.isIOS) {
              var i = document.documentElement.clientWidth / window.innerWidth,
                n = window.innerHeight * i;
              t.wrap.css("height", n), (t.wH = n);
            } else t.wH = e || y.height();
            t.fixedContentPos || t.wrap.css("height", t.wH), x("Resize");
          },
          updateItemHTML: function () {
            var i = t.items[t.index];
            t.contentContainer.detach(),
              t.content && t.content.detach(),
              i.parsed || (i = t.parseEl(t.index));
            var n = i.type;
            if (
              (x("BeforeChange", [t.currItem ? t.currItem.type : "", n]),
              (t.currItem = i),
              !t.currTemplate[n])
            ) {
              var s = !!t.st[n] && t.st[n].markup;
              x("FirstMarkupParse", s),
                s ? (t.currTemplate[n] = e(s)) : (t.currTemplate[n] = !0);
            }
            o &&
              o !== i.type &&
              t.container.removeClass("mfp-" + o + "-holder");
            var r = t["get" + n.charAt(0).toUpperCase() + n.slice(1)](
              i,
              t.currTemplate[n]
            );
            t.appendContent(r, n),
              (i.preloaded = !0),
              x(u, i),
              (o = i.type),
              t.container.prepend(t.contentContainer),
              x("AfterChange");
          },
          appendContent: function (e, i) {
            (t.content = e),
              e
                ? t.st.showCloseBtn &&
                  t.st.closeBtnInside &&
                  !0 === t.currTemplate[i]
                  ? t.content.find(".mfp-close").length || t.content.append(C())
                  : (t.content = e)
                : (t.content = ""),
              x("BeforeAppend"),
              t.container.addClass("mfp-" + i + "-holder"),
              t.contentContainer.append(t.content);
          },
          parseEl: function (i) {
            var n,
              o = t.items[i];
            if (
              (o.tagName
                ? (o = { el: e(o) })
                : ((n = o.type), (o = { data: o, src: o.src })),
              o.el)
            ) {
              for (var s = t.types, r = 0; r < s.length; r++)
                if (o.el.hasClass("mfp-" + s[r])) {
                  n = s[r];
                  break;
                }
              (o.src = o.el.attr("data-mfp-src")),
                o.src || (o.src = o.el.attr("href"));
            }
            return (
              (o.type = n || t.st.type || "inline"),
              (o.index = i),
              (o.parsed = !0),
              (t.items[i] = o),
              x("ElementParse", o),
              t.items[i]
            );
          },
          addGroup: function (e, i) {
            var n = function (n) {
              (n.mfpEl = this), t._openClick(n, e, i);
            };
            i || (i = {});
            var o = "click.magnificPopup";
            (i.mainEl = e),
              i.items
                ? ((i.isObj = !0), e.off(o).on(o, n))
                : ((i.isObj = !1),
                  i.delegate
                    ? e.off(o).on(o, i.delegate, n)
                    : ((i.items = e), e.off(o).on(o, n)));
          },
          _openClick: function (i, n, o) {
            if (
              (void 0 !== o.midClick
                ? o.midClick
                : e.magnificPopup.defaults.midClick) ||
              !(
                2 === i.which ||
                i.ctrlKey ||
                i.metaKey ||
                i.altKey ||
                i.shiftKey
              )
            ) {
              var s =
                void 0 !== o.disableOn
                  ? o.disableOn
                  : e.magnificPopup.defaults.disableOn;
              if (s) {
                if (e.isFunction(s)) {
                  if (!s.call(t)) return !0;
                } else if (y.width() < s) return !0;
              }
              i.type && (i.preventDefault(), t.isOpen && i.stopPropagation()),
                (o.el = e(i.mfpEl)),
                o.delegate && (o.items = n.find(o.delegate)),
                t.open(o);
            }
          },
          updateStatus: function (e, n) {
            if (t.preloader) {
              i !== e && t.container.removeClass("mfp-s-" + i),
                n || "loading" !== e || (n = t.st.tLoading);
              var o = { status: e, text: n };
              x("UpdateStatus", o),
                (e = o.status),
                (n = o.text),
                t.preloader.html(n),
                t.preloader.find("a").on("click", function (e) {
                  e.stopImmediatePropagation();
                }),
                t.container.addClass("mfp-s-" + e),
                (i = e);
            }
          },
          _checkIfClose: function (i) {
            if (!e(i).hasClass(g)) {
              var n = t.st.closeOnContentClick,
                o = t.st.closeOnBgClick;
              if (
                (n && o) ||
                !t.content ||
                e(i).hasClass("mfp-close") ||
                (t.preloader && i === t.preloader[0])
              )
                return !0;
              if (i === t.content[0] || e.contains(t.content[0], i)) {
                if (n) return !0;
              } else if (o && e.contains(document, i)) return !0;
              return !1;
            }
          },
          _addClassToMFP: function (e) {
            t.bgOverlay.addClass(e), t.wrap.addClass(e);
          },
          _removeClassFromMFP: function (e) {
            this.bgOverlay.removeClass(e), t.wrap.removeClass(e);
          },
          _hasScrollBar: function (e) {
            return (
              (t.isIE7 ? n.height() : document.body.scrollHeight) >
              (e || y.height())
            );
          },
          _setFocus: function () {
            (t.st.focus ? t.content.find(t.st.focus).eq(0) : t.wrap).focus();
          },
          _onFocusIn: function (i) {
            return i.target === t.wrap[0] || e.contains(t.wrap[0], i.target)
              ? void 0
              : (t._setFocus(), !1);
          },
          _parseMarkup: function (t, i, n) {
            var o;
            n.data && (i = e.extend(n.data, i)),
              x(c, [t, i, n]),
              e.each(i, function (i, n) {
                if (void 0 === n || !1 === n) return !0;
                if ((o = i.split("_")).length > 1) {
                  var s = t.find(p + "-" + o[0]);
                  if (s.length > 0) {
                    var r = o[1];
                    "replaceWith" === r
                      ? s[0] !== n[0] && s.replaceWith(n)
                      : "img" === r
                      ? s.is("img")
                        ? s.attr("src", n)
                        : s.replaceWith(
                            e("<img>")
                              .attr("src", n)
                              .attr("class", s.attr("class"))
                          )
                      : s.attr(o[1], n);
                  }
                } else t.find(p + "-" + i).html(n);
              });
          },
          _getScrollbarSize: function () {
            if (void 0 === t.scrollbarSize) {
              var e = document.createElement("div");
              (e.style.cssText =
                "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;"),
                document.body.appendChild(e),
                (t.scrollbarSize = e.offsetWidth - e.clientWidth),
                document.body.removeChild(e);
            }
            return t.scrollbarSize;
          },
        }),
          (e.magnificPopup = {
            instance: null,
            proto: m.prototype,
            modules: [],
            open: function (t, i) {
              return (
                w(),
                ((t = t ? e.extend(!0, {}, t) : {}).isObj = !0),
                (t.index = i || 0),
                this.instance.open(t)
              );
            },
            close: function () {
              return (
                e.magnificPopup.instance && e.magnificPopup.instance.close()
              );
            },
            registerModule: function (t, i) {
              i.options && (e.magnificPopup.defaults[t] = i.options),
                e.extend(this.proto, i.proto),
                this.modules.push(t);
            },
            defaults: {
              disableOn: 0,
              key: null,
              midClick: !1,
              mainClass: "",
              preloader: !0,
              focus: "",
              closeOnContentClick: !1,
              closeOnBgClick: !0,
              closeBtnInside: !0,
              showCloseBtn: !0,
              enableEscapeKey: !0,
              modal: !1,
              alignTop: !1,
              removalDelay: 0,
              prependTo: null,
              fixedContentPos: "auto",
              fixedBgPos: "auto",
              overflowY: "auto",
              closeMarkup:
                '<button title="%title%" type="button" class="mfp-close">&#215;</button>',
              tClose: "Close (Esc)",
              tLoading: "Loading...",
              autoFocusLast: !0,
            },
          }),
          (e.fn.magnificPopup = function (i) {
            w();
            var n = e(this);
            if ("string" == typeof i) {
              if ("open" === i) {
                var o,
                  s = v ? n.data("magnificPopup") : n[0].magnificPopup,
                  r = parseInt(arguments[1], 10) || 0;
                s.items
                  ? (o = s.items[r])
                  : ((o = n),
                    s.delegate && (o = o.find(s.delegate)),
                    (o = o.eq(r))),
                  t._openClick({ mfpEl: o }, n, s);
              } else
                t.isOpen &&
                  t[i].apply(t, Array.prototype.slice.call(arguments, 1));
            } else
              (i = e.extend(!0, {}, i)),
                v ? n.data("magnificPopup", i) : (n[0].magnificPopup = i),
                t.addGroup(n, i);
            return n;
          });
        var T,
          _,
          E,
          P = "inline",
          A = function () {
            E && (_.after(E.addClass(T)).detach(), (E = null));
          };
        e.magnificPopup.registerModule(P, {
          options: {
            hiddenClass: "hide",
            markup: "",
            tNotFound: "Content not found",
          },
          proto: {
            initInline: function () {
              t.types.push(P),
                b(a + "." + P, function () {
                  A();
                });
            },
            getInline: function (i, n) {
              if ((A(), i.src)) {
                var o = t.st.inline,
                  s = e(i.src);
                if (s.length) {
                  var r = s[0].parentNode;
                  r &&
                    r.tagName &&
                    (_ || ((_ = k((T = o.hiddenClass))), (T = "mfp-" + T)),
                    (E = s.after(_).detach().removeClass(T))),
                    t.updateStatus("ready");
                } else t.updateStatus("error", o.tNotFound), (s = e("<div>"));
                return (i.inlineElement = s), s;
              }
              return t.updateStatus("ready"), t._parseMarkup(n, {}, i), n;
            },
          },
        });
        var L,
          j = "ajax",
          I = function () {
            L && e(document.body).removeClass(L);
          },
          D = function () {
            I(), t.req && t.req.abort();
          };
        e.magnificPopup.registerModule(j, {
          options: {
            settings: null,
            cursor: "mfp-ajax-cur",
            tError: '<a href="%url%">The content</a> could not be loaded.',
          },
          proto: {
            initAjax: function () {
              t.types.push(j),
                (L = t.st.ajax.cursor),
                b(a + "." + j, D),
                b("BeforeChange." + j, D);
            },
            getAjax: function (i) {
              L && e(document.body).addClass(L), t.updateStatus("loading");
              var n = e.extend(
                {
                  url: i.src,
                  success: function (n, o, s) {
                    var r = { data: n, xhr: s };
                    x("ParseAjax", r),
                      t.appendContent(e(r.data), j),
                      (i.finished = !0),
                      I(),
                      t._setFocus(),
                      setTimeout(function () {
                        t.wrap.addClass(h);
                      }, 16),
                      t.updateStatus("ready"),
                      x("AjaxContentAdded");
                  },
                  error: function () {
                    I(),
                      (i.finished = i.loadError = !0),
                      t.updateStatus(
                        "error",
                        t.st.ajax.tError.replace("%url%", i.src)
                      );
                  },
                },
                t.st.ajax.settings
              );
              return (t.req = e.ajax(n)), "";
            },
          },
        });
        var z,
          M,
          q = function (i) {
            if (i.data && void 0 !== i.data.title) return i.data.title;
            var n = t.st.image.titleSrc;
            if (n) {
              if (e.isFunction(n)) return n.call(t, i);
              if (i.el) return i.el.attr(n) || "";
            }
            return "";
          };
        e.magnificPopup.registerModule("image", {
          options: {
            markup:
              '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
            cursor: "mfp-zoom-out-cur",
            titleSrc: "title",
            verticalFit: !0,
            tError: '<a href="%url%">The image</a> could not be loaded.',
          },
          proto: {
            initImage: function () {
              var i = t.st.image,
                n = ".image";
              t.types.push("image"),
                b(d + n, function () {
                  "image" === t.currItem.type &&
                    i.cursor &&
                    e(document.body).addClass(i.cursor);
                }),
                b(a + n, function () {
                  i.cursor && e(document.body).removeClass(i.cursor),
                    y.off("resize" + p);
                }),
                b("Resize" + n, t.resizeImage),
                t.isLowIE && b("AfterChange", t.resizeImage);
            },
            resizeImage: function () {
              var e = t.currItem;
              if (e && e.img && t.st.image.verticalFit) {
                var i = 0;
                t.isLowIE &&
                  (i =
                    parseInt(e.img.css("padding-top"), 10) +
                    parseInt(e.img.css("padding-bottom"), 10)),
                  e.img.css("max-height", t.wH - i);
              }
            },
            _onImageHasSize: function (e) {
              e.img &&
                ((e.hasSize = !0),
                z && clearInterval(z),
                (e.isCheckingImgSize = !1),
                x("ImageHasSize", e),
                e.imgHidden &&
                  (t.content && t.content.removeClass("mfp-loading"),
                  (e.imgHidden = !1)));
            },
            findImageSize: function (e) {
              var i = 0,
                n = e.img[0],
                o = function (s) {
                  z && clearInterval(z),
                    (z = setInterval(function () {
                      return n.naturalWidth > 0
                        ? void t._onImageHasSize(e)
                        : (i > 200 && clearInterval(z),
                          void (3 == ++i
                            ? o(10)
                            : 40 === i
                            ? o(50)
                            : 100 === i && o(500)));
                    }, s));
                };
              o(1);
            },
            getImage: function (i, n) {
              var o = 0,
                s = function () {
                  i &&
                    (i.img[0].complete
                      ? (i.img.off(".mfploader"),
                        i === t.currItem &&
                          (t._onImageHasSize(i), t.updateStatus("ready")),
                        (i.hasSize = !0),
                        (i.loaded = !0),
                        x("ImageLoadComplete"))
                      : 200 > ++o
                      ? setTimeout(s, 100)
                      : r());
                },
                r = function () {
                  i &&
                    (i.img.off(".mfploader"),
                    i === t.currItem &&
                      (t._onImageHasSize(i),
                      t.updateStatus(
                        "error",
                        a.tError.replace("%url%", i.src)
                      )),
                    (i.hasSize = !0),
                    (i.loaded = !0),
                    (i.loadError = !0));
                },
                a = t.st.image,
                l = n.find(".mfp-img");
              if (l.length) {
                var c = document.createElement("img");
                (c.className = "mfp-img"),
                  i.el &&
                    i.el.find("img").length &&
                    (c.alt = i.el.find("img").attr("alt")),
                  (i.img = e(c)
                    .on("load.mfploader", s)
                    .on("error.mfploader", r)),
                  (c.src = i.src),
                  l.is("img") && (i.img = i.img.clone()),
                  (c = i.img[0]).naturalWidth > 0
                    ? (i.hasSize = !0)
                    : c.width || (i.hasSize = !1);
              }
              return (
                t._parseMarkup(n, { title: q(i), img_replaceWith: i.img }, i),
                t.resizeImage(),
                i.hasSize
                  ? (z && clearInterval(z),
                    i.loadError
                      ? (n.addClass("mfp-loading"),
                        t.updateStatus(
                          "error",
                          a.tError.replace("%url%", i.src)
                        ))
                      : (n.removeClass("mfp-loading"), t.updateStatus("ready")),
                    n)
                  : (t.updateStatus("loading"),
                    (i.loading = !0),
                    i.hasSize ||
                      ((i.imgHidden = !0),
                      n.addClass("mfp-loading"),
                      t.findImageSize(i)),
                    n)
              );
            },
          },
        }),
          e.magnificPopup.registerModule("zoom", {
            options: {
              enabled: !1,
              easing: "ease-in-out",
              duration: 300,
              opener: function (e) {
                return e.is("img") ? e : e.find("img");
              },
            },
            proto: {
              initZoom: function () {
                var e,
                  i = t.st.zoom,
                  n = ".zoom";
                if (i.enabled && t.supportsTransition) {
                  var o,
                    s,
                    r = i.duration,
                    c = function (e) {
                      var t = e
                          .clone()
                          .removeAttr("style")
                          .removeAttr("class")
                          .addClass("mfp-animated-image"),
                        n = "all " + i.duration / 1e3 + "s " + i.easing,
                        o = {
                          position: "fixed",
                          zIndex: 9999,
                          left: 0,
                          top: 0,
                          "-webkit-backface-visibility": "hidden",
                        },
                        s = "transition";
                      return (
                        (o["-webkit-" + s] =
                          o["-moz-" + s] =
                          o["-o-" + s] =
                          o[s] =
                            n),
                        t.css(o),
                        t
                      );
                    },
                    d = function () {
                      t.content.css("visibility", "visible");
                    };
                  b("BuildControls" + n, function () {
                    if (t._allowZoom()) {
                      if (
                        (clearTimeout(o),
                        t.content.css("visibility", "hidden"),
                        !(e = t._getItemToZoom()))
                      )
                        return void d();
                      (s = c(e)).css(t._getOffset()),
                        t.wrap.append(s),
                        (o = setTimeout(function () {
                          s.css(t._getOffset(!0)),
                            (o = setTimeout(function () {
                              d(),
                                setTimeout(function () {
                                  s.remove(),
                                    (e = s = null),
                                    x("ZoomAnimationEnded");
                                }, 16);
                            }, r));
                        }, 16));
                    }
                  }),
                    b(l + n, function () {
                      if (t._allowZoom()) {
                        if ((clearTimeout(o), (t.st.removalDelay = r), !e)) {
                          if (!(e = t._getItemToZoom())) return;
                          s = c(e);
                        }
                        s.css(t._getOffset(!0)),
                          t.wrap.append(s),
                          t.content.css("visibility", "hidden"),
                          setTimeout(function () {
                            s.css(t._getOffset());
                          }, 16);
                      }
                    }),
                    b(a + n, function () {
                      t._allowZoom() && (d(), s && s.remove(), (e = null));
                    });
                }
              },
              _allowZoom: function () {
                return "image" === t.currItem.type;
              },
              _getItemToZoom: function () {
                return !!t.currItem.hasSize && t.currItem.img;
              },
              _getOffset: function (i) {
                var n,
                  o = (n = i
                    ? t.currItem.img
                    : t.st.zoom.opener(t.currItem.el || t.currItem)).offset(),
                  s = parseInt(n.css("padding-top"), 10),
                  r = parseInt(n.css("padding-bottom"), 10);
                o.top -= e(window).scrollTop() - s;
                var a = {
                  width: n.width(),
                  height: (v ? n.innerHeight() : n[0].offsetHeight) - r - s,
                };
                return (
                  (void 0 === M &&
                    (M =
                      void 0 !==
                      document.createElement("p").style.MozTransform),
                  M)
                    ? (a["-moz-transform"] = a.transform =
                        "translate(" + o.left + "px," + o.top + "px)")
                    : ((a.left = o.left), (a.top = o.top)),
                  a
                );
              },
            },
          });
        var O = "iframe",
          F = function (e) {
            if (t.currTemplate[O]) {
              var i = t.currTemplate[O].find("iframe");
              i.length &&
                (e || (i[0].src = "//about:blank"),
                t.isIE8 && i.css("display", e ? "block" : "none"));
            }
          };
        e.magnificPopup.registerModule(O, {
          options: {
            markup:
              '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
            srcAction: "iframe_src",
            patterns: {
              youtube: {
                index: "youtube.com",
                id: "v=",
                src: "//www.youtube.com/embed/%id%?autoplay=1",
              },
              vimeo: {
                index: "vimeo.com/",
                id: "/",
                src: "//player.vimeo.com/video/%id%?autoplay=1",
              },
              gmaps: { index: "//maps.google.", src: "%id%&output=embed" },
            },
          },
          proto: {
            initIframe: function () {
              t.types.push(O),
                b("BeforeChange", function (e, t, i) {
                  t !== i && (t === O ? F() : i === O && F(!0));
                }),
                b(a + "." + O, function () {
                  F();
                });
            },
            getIframe: function (i, n) {
              var o = i.src,
                s = t.st.iframe;
              e.each(s.patterns, function () {
                return o.indexOf(this.index) > -1
                  ? (this.id &&
                      (o =
                        "string" == typeof this.id
                          ? o.substr(
                              o.lastIndexOf(this.id) + this.id.length,
                              o.length
                            )
                          : this.id.call(this, o)),
                    (o = this.src.replace("%id%", o)),
                    !1)
                  : void 0;
              });
              var r = {};
              return (
                s.srcAction && (r[s.srcAction] = o),
                t._parseMarkup(n, r, i),
                t.updateStatus("ready"),
                n
              );
            },
          },
        });
        var H = function (e) {
            var i = t.items.length;
            return e > i - 1 ? e - i : 0 > e ? i + e : e;
          },
          W = function (e, t, i) {
            return e.replace(/%curr%/gi, t + 1).replace(/%total%/gi, i);
          };
        e.magnificPopup.registerModule("gallery", {
          options: {
            enabled: !1,
            arrowMarkup:
              '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
            preload: [0, 2],
            navigateByImgClick: !0,
            arrows: !0,
            tPrev: "Previous (Left arrow key)",
            tNext: "Next (Right arrow key)",
            tCounter: "%curr% of %total%",
          },
          proto: {
            initGallery: function () {
              var i = t.st.gallery,
                o = ".mfp-gallery";
              return (
                (t.direction = !0),
                !!i &&
                  !!i.enabled &&
                  ((s += " mfp-gallery"),
                  b(d + o, function () {
                    i.navigateByImgClick &&
                      t.wrap.on("click" + o, ".mfp-img", function () {
                        return t.items.length > 1 ? (t.next(), !1) : void 0;
                      }),
                      n.on("keydown" + o, function (e) {
                        37 === e.keyCode
                          ? t.prev()
                          : 39 === e.keyCode && t.next();
                      });
                  }),
                  b("UpdateStatus" + o, function (e, i) {
                    i.text &&
                      (i.text = W(i.text, t.currItem.index, t.items.length));
                  }),
                  b(c + o, function (e, n, o, s) {
                    var r = t.items.length;
                    o.counter = r > 1 ? W(i.tCounter, s.index, r) : "";
                  }),
                  b("BuildControls" + o, function () {
                    if (t.items.length > 1 && i.arrows && !t.arrowLeft) {
                      var n = i.arrowMarkup,
                        o = (t.arrowLeft = e(
                          n
                            .replace(/%title%/gi, i.tPrev)
                            .replace(/%dir%/gi, "left")
                        ).addClass(g)),
                        s = (t.arrowRight = e(
                          n
                            .replace(/%title%/gi, i.tNext)
                            .replace(/%dir%/gi, "right")
                        ).addClass(g));
                      o.click(function () {
                        t.prev();
                      }),
                        s.click(function () {
                          t.next();
                        }),
                        t.container.append(o.add(s));
                    }
                  }),
                  b(u + o, function () {
                    t._preloadTimeout && clearTimeout(t._preloadTimeout),
                      (t._preloadTimeout = setTimeout(function () {
                        t.preloadNearbyImages(), (t._preloadTimeout = null);
                      }, 16));
                  }),
                  void b(a + o, function () {
                    n.off(o),
                      t.wrap.off("click" + o),
                      (t.arrowRight = t.arrowLeft = null);
                  }))
              );
            },
            next: function () {
              (t.direction = !0),
                (t.index = H(t.index + 1)),
                t.updateItemHTML();
            },
            prev: function () {
              (t.direction = !1),
                (t.index = H(t.index - 1)),
                t.updateItemHTML();
            },
            goTo: function (e) {
              (t.direction = e >= t.index), (t.index = e), t.updateItemHTML();
            },
            preloadNearbyImages: function () {
              var e,
                i = t.st.gallery.preload,
                n = Math.min(i[0], t.items.length),
                o = Math.min(i[1], t.items.length);
              for (e = 1; e <= (t.direction ? o : n); e++)
                t._preloadItem(t.index + e);
              for (e = 1; e <= (t.direction ? n : o); e++)
                t._preloadItem(t.index - e);
            },
            _preloadItem: function (i) {
              if (((i = H(i)), !t.items[i].preloaded)) {
                var n = t.items[i];
                n.parsed || (n = t.parseEl(i)),
                  x("LazyLoad", n),
                  "image" === n.type &&
                    (n.img = e('<img class="mfp-img" />')
                      .on("load.mfploader", function () {
                        n.hasSize = !0;
                      })
                      .on("error.mfploader", function () {
                        (n.hasSize = !0),
                          (n.loadError = !0),
                          x("LazyLoadError", n);
                      })
                      .attr("src", n.src)),
                  (n.preloaded = !0);
              }
            },
          },
        });
        var N = "retina";
        e.magnificPopup.registerModule(N, {
          options: {
            replaceSrc: function (e) {
              return e.src.replace(/\.\w+$/, function (e) {
                return "@2x" + e;
              });
            },
            ratio: 1,
          },
          proto: {
            initRetina: function () {
              if (window.devicePixelRatio > 1) {
                var e = t.st.retina,
                  i = e.ratio;
                (i = isNaN(i) ? i() : i) > 1 &&
                  (b("ImageHasSize." + N, function (e, t) {
                    t.img.css({
                      "max-width": t.img[0].naturalWidth / i,
                      width: "100%",
                    });
                  }),
                  b("ElementParse." + N, function (t, n) {
                    n.src = e.replaceSrc(n, i);
                  }));
              }
            },
          },
        }),
          w();
      }),
        "function" == typeof define && define.amd
          ? define(["jquery"], e)
          : e(
              "object" == typeof exports
                ? require("jquery")
                : window.jQuery || window.Zepto
            );
    },
    zoom: function () {
      var e, t;
      (e = window.jQuery),
        (t = {
          url: !1,
          callback: !1,
          target: !1,
          duration: 120,
          on: "mouseover",
          touch: !0,
          onZoomIn: !1,
          onZoomOut: !1,
          magnify: 1,
        }),
        (e.zoom = function (t, i, n, o) {
          var s,
            r,
            a,
            l,
            c,
            d,
            u,
            p = e(t),
            h = p.css("position"),
            f = e(i);
          return (
            (t.style.position = /(absolute|fixed)/.test(h) ? h : "relative"),
            (t.style.overflow = "hidden"),
            (n.style.width = n.style.height = ""),
            e(n)
              .addClass("zoomImg")
              .css({
                position: "absolute",
                top: 0,
                left: 0,
                opacity: 0,
                width: n.width * o,
                height: n.height * o,
                border: "none",
                maxWidth: "none",
                maxHeight: "none",
              })
              .appendTo(t),
            {
              init: function () {
                (r = p.outerWidth()),
                  (s = p.outerHeight()),
                  i === t
                    ? ((l = r), (a = s))
                    : ((l = f.outerWidth()), (a = f.outerHeight())),
                  (c = (n.width - r) / l),
                  (d = (n.height - s) / a),
                  (u = f.offset());
              },
              move: function (e) {
                var t = e.pageX - u.left,
                  i = e.pageY - u.top;
                (i = Math.max(Math.min(i, a), 0)),
                  (t = Math.max(Math.min(t, l), 0)),
                  (n.style.left = -(t * c) + "px"),
                  (n.style.top = -(i * d) + "px");
              },
            }
          );
        }),
        (e.fn.zoom = function (i) {
          return this.each(function () {
            var n = e.extend({}, t, i || {}),
              o = (n.target && e(n.target)[0]) || this,
              s = this,
              r = e(s),
              a = document.createElement("img"),
              l = e(a),
              c = "mousemove.zoom",
              d = !1,
              u = !1;
            if (!n.url) {
              var p = s.querySelector("img");
              if (
                (p &&
                  (n.url = p.getAttribute("data-src") || p.currentSrc || p.src),
                !n.url)
              )
                return;
            }
            r.one(
              "zoom.destroy",
              function (e, t) {
                r.off(".zoom"),
                  (o.style.position = e),
                  (o.style.overflow = t),
                  (a.onload = null),
                  l.remove();
              }.bind(this, o.style.position, o.style.overflow)
            ),
              (a.onload = function () {
                function t(t) {
                  p.init(),
                    p.move(t),
                    l
                      .stop()
                      .fadeTo(
                        e.support.opacity ? n.duration : 0,
                        1,
                        !!e.isFunction(n.onZoomIn) && n.onZoomIn.call(a)
                      );
                }
                function i() {
                  l.stop().fadeTo(
                    n.duration,
                    0,
                    !!e.isFunction(n.onZoomOut) && n.onZoomOut.call(a)
                  );
                }
                var p = e.zoom(o, s, a, n.magnify);
                "grab" === n.on
                  ? r.on("mousedown.zoom", function (n) {
                      1 === n.which &&
                        (e(document).one("mouseup.zoom", function () {
                          i(), e(document).off(c, p.move);
                        }),
                        t(n),
                        e(document).on(c, p.move),
                        n.preventDefault());
                    })
                  : "click" === n.on
                  ? r.on("click.zoom", function (n) {
                      return d
                        ? void 0
                        : ((d = !0),
                          t(n),
                          e(document).on(c, p.move),
                          e(document).one("click.zoom", function () {
                            i(), (d = !1), e(document).off(c, p.move);
                          }),
                          !1);
                    })
                  : "toggle" === n.on
                  ? r.on("click.zoom", function (e) {
                      d ? i() : t(e), (d = !d);
                    })
                  : "mouseover" === n.on &&
                    (p.init(),
                    r
                      .on("mouseenter.zoom", t)
                      .on("mouseleave.zoom", i)
                      .on(c, p.move)),
                  n.touch &&
                    r
                      .on("touchstart.zoom", function (e) {
                        e.preventDefault(),
                          u
                            ? ((u = !1), i())
                            : ((u = !0),
                              t(
                                e.originalEvent.touches[0] ||
                                  e.originalEvent.changedTouches[0]
                              ));
                      })
                      .on("touchmove.zoom", function (e) {
                        e.preventDefault(),
                          p.move(
                            e.originalEvent.touches[0] ||
                              e.originalEvent.changedTouches[0]
                          );
                      })
                      .on("touchend.zoom", function (e) {
                        e.preventDefault(), u && ((u = !1), i());
                      }),
                  e.isFunction(n.callback) && n.callback.call(a);
              }),
              a.setAttribute("role", "presentation"),
              (a.alt = ""),
              (a.src = n.url);
          });
        }),
        (e.fn.zoom.defaults = t);
    },
    cookie: function () {
      /*!
       * JavaScript Cookie v2.1.0
       * https://github.com/js-cookie/js-cookie
       *
       * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
       * Released under the MIT license
       */ !(function (e) {
        if ("function" == typeof define && define.amd) define(e);
        else if ("object" == typeof exports) module.exports = e();
        else {
          var t = window.Cookies,
            i = (window.Cookies = e());
          i.noConflict = function () {
            return (window.Cookies = t), i;
          };
        }
      })(function () {
        function e() {
          for (var e = 0, t = {}; e < arguments.length; e++) {
            var i = arguments[e];
            for (var n in i) t[n] = i[n];
          }
          return t;
        }
        return (function t(i) {
          function n(t, o, s) {
            var r;
            if (arguments.length > 1) {
              if (
                "number" == typeof (s = e({ path: "/" }, n.defaults, s)).expires
              ) {
                var a = new Date();
                a.setMilliseconds(a.getMilliseconds() + 864e5 * s.expires),
                  (s.expires = a);
              }
              try {
                (r = JSON.stringify(o)), /^[\{\[]/.test(r) && (o = r);
              } catch (l) {}
              return (
                (o = i.write
                  ? i.write(o, t)
                  : encodeURIComponent(String(o)).replace(
                      /%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
                      decodeURIComponent
                    )),
                (t = (t = (t = encodeURIComponent(String(t))).replace(
                  /%(23|24|26|2B|5E|60|7C)/g,
                  decodeURIComponent
                )).replace(/[\(\)]/g, escape)),
                (document.cookie = [
                  t,
                  "=",
                  o,
                  s.expires && "; expires=" + s.expires.toUTCString(),
                  s.path && "; path=" + s.path,
                  s.domain && "; domain=" + s.domain,
                  s.secure ? "; secure" : "",
                ].join(""))
              );
            }
            t || (r = {});
            for (
              var c = document.cookie ? document.cookie.split("; ") : [],
                d = /(%[0-9A-Z]{2})+/g,
                u = 0;
              u < c.length;
              u++
            ) {
              var p = c[u].split("="),
                h = p[0].replace(d, decodeURIComponent),
                f = p.slice(1).join("=");
              '"' === f.charAt(0) && (f = f.slice(1, -1));
              try {
                if (
                  ((f = i.read
                    ? i.read(f, h)
                    : i(f, h) || f.replace(d, decodeURIComponent)),
                  this.json)
                )
                  try {
                    f = JSON.parse(f);
                  } catch (g) {}
                if (t === h) {
                  r = f;
                  break;
                }
                t || (r[h] = f);
              } catch (m) {}
            }
            return r;
          }
          return (
            (n.get = n.set = n),
            (n.getJSON = function () {
              return n.apply({ json: !0 }, [].slice.call(arguments));
            }),
            (n.defaults = {}),
            (n.remove = function (t, i) {
              n(t, "", e(i, { expires: -1 }));
            }),
            (n.withConverter = t),
            n
          );
        })(function () {});
      });
    },
  },
  apiStatus = null,
  Gmap = {
    selectors: { map: '[data-section-type="map"]' },
    init: function () {
      var e = this,
        t = [];
      $(this.selectors.map).each(function () {
        var i = this,
          n = $(i).data("api-key");
        "string" == typeof n &&
          "" !== n &&
          ("loaded" === apiStatus
            ? 0 === $('script[src*="' + n + '&"]').length
              ? $.getScript(
                  "https://maps.googleapis.com/maps/api/js?key=" + n
                ).then(function () {
                  (apiStatus = "loaded"), e.createMap(i);
                })
              : e.createMap(i)
            : (t.push(this),
              "loading" !== apiStatus &&
                ((apiStatus = "loading"),
                void 0 === window.google &&
                  $.getScript(
                    "https://maps.googleapis.com/maps/api/js?key=" + n
                  ).then(function () {
                    (apiStatus = "loaded"),
                      $.each(t, function (t, i) {
                        e.createMap(i);
                      });
                  }))));
      });
    },
    geolocate: function (e) {
      var t = $.Deferred(),
        i = new google.maps.Geocoder(),
        n =
          e.closest(this.selectors.map).data("address") ||
          "37.4439064, -122.1639733";
      return (
        i.geocode({ address: n }, function (e, i) {
          i !== google.maps.GeocoderStatus.OK && t.reject(i), t.resolve(e);
        }),
        t
      );
    },
    createMap: function (e) {
      var t = $(e).data("style"),
        i = $(e).data("zoom"),
        n = $(e).data("section-id"),
        o = $(".map--" + n),
        s = "";
      return (
        (s =
          "standard" == t
            ? []
            : "silver" == t
            ? [
                { elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
                {
                  elementType: "labels.icon",
                  stylers: [{ visibility: "off" }],
                },
                {
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#616161" }],
                },
                {
                  elementType: "labels.text.stroke",
                  stylers: [{ color: "#f5f5f5" }],
                },
                {
                  featureType: "administrative.land_parcel",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#bdbdbd" }],
                },
                {
                  featureType: "poi",
                  elementType: "geometry",
                  stylers: [{ color: "#eeeeee" }],
                },
                {
                  featureType: "poi",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#757575" }],
                },
                {
                  featureType: "poi.park",
                  elementType: "geometry",
                  stylers: [{ color: "#e5e5e5" }],
                },
                {
                  featureType: "poi.park",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#9e9e9e" }],
                },
                {
                  featureType: "road",
                  elementType: "geometry",
                  stylers: [{ color: "#ffffff" }],
                },
                {
                  featureType: "road.arterial",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#757575" }],
                },
                {
                  featureType: "road.highway",
                  elementType: "geometry",
                  stylers: [{ color: "#dadada" }],
                },
                {
                  featureType: "road.highway",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#616161" }],
                },
                {
                  featureType: "road.local",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#9e9e9e" }],
                },
                {
                  featureType: "transit.line",
                  elementType: "geometry",
                  stylers: [{ color: "#e5e5e5" }],
                },
                {
                  featureType: "transit.station",
                  elementType: "geometry",
                  stylers: [{ color: "#eeeeee" }],
                },
                {
                  featureType: "water",
                  elementType: "geometry",
                  stylers: [{ color: "#c9c9c9" }],
                },
                {
                  featureType: "water",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#9e9e9e" }],
                },
              ]
            : "retro" == t
            ? [
                { elementType: "geometry", stylers: [{ color: "#ebe3cd" }] },
                {
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#523735" }],
                },
                {
                  elementType: "labels.text.stroke",
                  stylers: [{ color: "#f5f1e6" }],
                },
                {
                  featureType: "administrative",
                  elementType: "geometry.stroke",
                  stylers: [{ color: "#c9b2a6" }],
                },
                {
                  featureType: "administrative.land_parcel",
                  elementType: "geometry.stroke",
                  stylers: [{ color: "#dcd2be" }],
                },
                {
                  featureType: "administrative.land_parcel",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#ae9e90" }],
                },
                {
                  featureType: "landscape.natural",
                  elementType: "geometry",
                  stylers: [{ color: "#dfd2ae" }],
                },
                {
                  featureType: "poi",
                  elementType: "geometry",
                  stylers: [{ color: "#dfd2ae" }],
                },
                {
                  featureType: "poi",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#93817c" }],
                },
                {
                  featureType: "poi.park",
                  elementType: "geometry.fill",
                  stylers: [{ color: "#a5b076" }],
                },
                {
                  featureType: "poi.park",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#447530" }],
                },
                {
                  featureType: "road",
                  elementType: "geometry",
                  stylers: [{ color: "#f5f1e6" }],
                },
                {
                  featureType: "road.arterial",
                  elementType: "geometry",
                  stylers: [{ color: "#fdfcf8" }],
                },
                {
                  featureType: "road.highway",
                  elementType: "geometry",
                  stylers: [{ color: "#f8c967" }],
                },
                {
                  featureType: "road.highway",
                  elementType: "geometry.stroke",
                  stylers: [{ color: "#e9bc62" }],
                },
                {
                  featureType: "road.highway.controlled_access",
                  elementType: "geometry",
                  stylers: [{ color: "#e98d58" }],
                },
                {
                  featureType: "road.highway.controlled_access",
                  elementType: "geometry.stroke",
                  stylers: [{ color: "#db8555" }],
                },
                {
                  featureType: "road.local",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#806b63" }],
                },
                {
                  featureType: "transit.line",
                  elementType: "geometry",
                  stylers: [{ color: "#dfd2ae" }],
                },
                {
                  featureType: "transit.line",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#8f7d77" }],
                },
                {
                  featureType: "transit.line",
                  elementType: "labels.text.stroke",
                  stylers: [{ color: "#ebe3cd" }],
                },
                {
                  featureType: "transit.station",
                  elementType: "geometry",
                  stylers: [{ color: "#dfd2ae" }],
                },
                {
                  featureType: "water",
                  elementType: "geometry.fill",
                  stylers: [{ color: "#b9d3c2" }],
                },
                {
                  featureType: "water",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#92998d" }],
                },
              ]
            : "dark" == t
            ? [
                { elementType: "geometry", stylers: [{ color: "#212121" }] },
                {
                  elementType: "labels.icon",
                  stylers: [{ visibility: "off" }],
                },
                {
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#757575" }],
                },
                {
                  elementType: "labels.text.stroke",
                  stylers: [{ color: "#212121" }],
                },
                {
                  featureType: "administrative",
                  elementType: "geometry",
                  stylers: [{ color: "#757575" }],
                },
                {
                  featureType: "administrative.country",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#9e9e9e" }],
                },
                {
                  featureType: "administrative.land_parcel",
                  stylers: [{ visibility: "off" }],
                },
                {
                  featureType: "administrative.locality",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#bdbdbd" }],
                },
                {
                  featureType: "poi",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#757575" }],
                },
                {
                  featureType: "poi.park",
                  elementType: "geometry",
                  stylers: [{ color: "#181818" }],
                },
                {
                  featureType: "poi.park",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#616161" }],
                },
                {
                  featureType: "poi.park",
                  elementType: "labels.text.stroke",
                  stylers: [{ color: "#1b1b1b" }],
                },
                {
                  featureType: "road",
                  elementType: "geometry.fill",
                  stylers: [{ color: "#2c2c2c" }],
                },
                {
                  featureType: "road",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#8a8a8a" }],
                },
                {
                  featureType: "road.arterial",
                  elementType: "geometry",
                  stylers: [{ color: "#373737" }],
                },
                {
                  featureType: "road.highway",
                  elementType: "geometry",
                  stylers: [{ color: "#3c3c3c" }],
                },
                {
                  featureType: "road.highway.controlled_access",
                  elementType: "geometry",
                  stylers: [{ color: "#4e4e4e" }],
                },
                {
                  featureType: "road.local",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#616161" }],
                },
                {
                  featureType: "transit",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#757575" }],
                },
                {
                  featureType: "water",
                  elementType: "geometry",
                  stylers: [{ color: "#000000" }],
                },
                {
                  featureType: "water",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#3d3d3d" }],
                },
              ]
            : "night" == t
            ? [
                { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
                {
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#746855" }],
                },
                {
                  elementType: "labels.text.stroke",
                  stylers: [{ color: "#242f3e" }],
                },
                {
                  featureType: "administrative.locality",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#d59563" }],
                },
                {
                  featureType: "poi",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#d59563" }],
                },
                {
                  featureType: "poi.park",
                  elementType: "geometry",
                  stylers: [{ color: "#263c3f" }],
                },
                {
                  featureType: "poi.park",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#6b9a76" }],
                },
                {
                  featureType: "road",
                  elementType: "geometry",
                  stylers: [{ color: "#38414e" }],
                },
                {
                  featureType: "road",
                  elementType: "geometry.stroke",
                  stylers: [{ color: "#212a37" }],
                },
                {
                  featureType: "road",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#9ca5b3" }],
                },
                {
                  featureType: "road.highway",
                  elementType: "geometry",
                  stylers: [{ color: "#746855" }],
                },
                {
                  featureType: "road.highway",
                  elementType: "geometry.stroke",
                  stylers: [{ color: "#1f2835" }],
                },
                {
                  featureType: "road.highway",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#f3d19c" }],
                },
                {
                  featureType: "transit",
                  elementType: "geometry",
                  stylers: [{ color: "#2f3948" }],
                },
                {
                  featureType: "transit.station",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#d59563" }],
                },
                {
                  featureType: "water",
                  elementType: "geometry",
                  stylers: [{ color: "#17263c" }],
                },
                {
                  featureType: "water",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#515c6d" }],
                },
                {
                  featureType: "water",
                  elementType: "labels.text.stroke",
                  stylers: [{ color: "#17263c" }],
                },
              ]
            : [
                { elementType: "geometry", stylers: [{ color: "#1d2c4d" }] },
                {
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#8ec3b9" }],
                },
                {
                  elementType: "labels.text.stroke",
                  stylers: [{ color: "#1a3646" }],
                },
                {
                  featureType: "administrative.country",
                  elementType: "geometry.stroke",
                  stylers: [{ color: "#4b6878" }],
                },
                {
                  featureType: "administrative.land_parcel",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#64779e" }],
                },
                {
                  featureType: "administrative.province",
                  elementType: "geometry.stroke",
                  stylers: [{ color: "#4b6878" }],
                },
                {
                  featureType: "landscape.man_made",
                  elementType: "geometry.stroke",
                  stylers: [{ color: "#334e87" }],
                },
                {
                  featureType: "landscape.natural",
                  elementType: "geometry",
                  stylers: [{ color: "#023e58" }],
                },
                {
                  featureType: "poi",
                  elementType: "geometry",
                  stylers: [{ color: "#283d6a" }],
                },
                {
                  featureType: "poi",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#6f9ba5" }],
                },
                {
                  featureType: "poi",
                  elementType: "labels.text.stroke",
                  stylers: [{ color: "#1d2c4d" }],
                },
                {
                  featureType: "poi.park",
                  elementType: "geometry.fill",
                  stylers: [{ color: "#023e58" }],
                },
                {
                  featureType: "poi.park",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#3C7680" }],
                },
                {
                  featureType: "road",
                  elementType: "geometry",
                  stylers: [{ color: "#304a7d" }],
                },
                {
                  featureType: "road",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#98a5be" }],
                },
                {
                  featureType: "road",
                  elementType: "labels.text.stroke",
                  stylers: [{ color: "#1d2c4d" }],
                },
                {
                  featureType: "road.highway",
                  elementType: "geometry",
                  stylers: [{ color: "#2c6675" }],
                },
                {
                  featureType: "road.highway",
                  elementType: "geometry.stroke",
                  stylers: [{ color: "#255763" }],
                },
                {
                  featureType: "road.highway",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#b0d5ce" }],
                },
                {
                  featureType: "road.highway",
                  elementType: "labels.text.stroke",
                  stylers: [{ color: "#023e58" }],
                },
                {
                  featureType: "transit",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#98a5be" }],
                },
                {
                  featureType: "transit",
                  elementType: "labels.text.stroke",
                  stylers: [{ color: "#1d2c4d" }],
                },
                {
                  featureType: "transit.line",
                  elementType: "geometry.fill",
                  stylers: [{ color: "#283d6a" }],
                },
                {
                  featureType: "transit.station",
                  elementType: "geometry",
                  stylers: [{ color: "#3a4762" }],
                },
                {
                  featureType: "water",
                  elementType: "geometry",
                  stylers: [{ color: "#0e1626" }],
                },
                {
                  featureType: "water",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#4e6d70" }],
                },
              ]),
        this.geolocate(o).then(
          function (e) {
            var t = {
                styles: s,
                center: e[0].geometry.location,
                clickableIcons: !1,
                scrollwheel: !1,
                zoomControl: !0,
                disableDefaultUI: !0,
                navigationControl: !1,
                mapTypeControl: !1,
                scaleControl: !1,
                draggable: !1,
                zoom: i,
              },
              n = new google.maps.Map(o[0], t),
              r = n.getCenter();
            new google.maps.Marker({ map: n, position: r }),
              google.maps.event.addDomListener(window, "resize", function () {
                google.maps.event.trigger(n, "resize"), n.setCenter(r);
              });
          }.bind(this)
        )
      );
    },
  },
  Popup = {
    init: function () {
      var e = this,
        t = (this.$popup = $("#popup")),
        i = t.find(".popup__close"),
        n = t.data("enabled");
      if (((this.popupTimeout = 0), n)) {
        var o = t.data("testmode"),
          s = 1e3 * parseInt(t.data("delay")),
          r = 1e3 * parseInt(t.data("reappear_time"));
        enquire.register("screen and (min-width:768px)", function () {
          Reqs.cookie(),
            o
              ? e.show(t, s, o)
              : (void 0 === Cookies.get("newsletter_delay") || 0 == r) &&
                (e.show(t, s, o), e.createCookie(r));
        }),
          $(window).on(
            "resize",
            Reqs.debounce(function () {
              var i = window.innerWidth || document.documentElement.clientWidth,
                n = t.hasClass("popup--visible");
              i < 768 && n && e.hide();
            }, 100)
          ),
          i.on("click", function () {
            t.removeClass("popup--visible");
          });
      }
    },
    show: function (e, t, i) {
      if ("shown" != sessionStorage.name) {
        if (
          ((this.popupTimeout = setTimeout(function () {
            e.addClass("popup--visible"), e.find(".popup__close").focus();
          }, t)),
          "object" == typeof localStorage)
        )
          try {
            localStorage.setItem("localStorage", 1),
              localStorage.removeItem("localStorage"),
              (sessionStorage.name = "shown");
          } catch (n) {
            (Storage.prototype._setItem = Storage.prototype.setItem),
              (Storage.prototype.setItem = function () {});
          }
      } else
        i &&
          (this.popupTimeout = setTimeout(function () {
            e.addClass("popup--visible"), e.find(".popup__close").focus();
          }, t));
    },
    hide: function () {
      clearTimeout(this.popupTimeout),
        this.$popup.removeClass("popup--visible");
    },
    createCookie: function (e) {
      0 != e && Cookies.set("newsletter_delay", "value", { expires: e });
    },
  },
  SearchTemplate = {
    init: function () {
      var e = $(".product-block__image");
      "contain" == theme.settings.imageBackgroundSize &&
        (Collection.setBadgePosition(e),
        $(window).on(
          "resize.search",
          Reqs.debounce(Collection.setBadgePosition.bind(this, e), 50)
        ));
    },
  },
  Search = {
    init: function () {
      var e = this;
      theme.settings.enableSearch &&
        ((this.searchForm = $(".nav-search .search-form")),
        (this.searchContainer = $(".nav-search-container")),
        (this.searchScroller = $(".nav-search-scroller")),
        (this.searchResultsContainer = $("#search-results")),
        (this.searchType = theme.settings.searchType),
        (this.searchOptionsPrefix = this.searchForm
          .find('input[name="options[prefix]"]')
          .val()),
        (this.searchRequest = null),
        this.searchForm.on("keyup", ".nav-search-input", function (t) {
          t.keyCode === slate.utils.keyboardKeys.ESCAPE &&
            (e.close(), Site.nav.search.close()),
            t.keyCode === slate.utils.keyboardKeys.ENTER && t.preventDefault();
          var i = $(this).val();
          i.length ? e.request(i) : e.close();
        }));
    },
    close: function () {
      this.searchResultsContainer.empty(),
        this.searchContainer.removeClass("is-searching");
    },
    request: function (e) {
      var t = this;
      null != this.searchRequest && this.searchRequest.abort(),
        this.searchResultsContainer.empty(),
        this.searchContainer.addClass("is-searching"),
        (this.searchRequest = $.ajax({
          method: "GET",
          url: theme.routes.search_url + "?view=json",
          dataType: "json",
          data: {
            q: e,
            type: t.searchType,
            options: { prefix: t.searchOptionsPrefix },
          },
        })
          .done(function (e) {
            t.displaySearchResults(e);
          })
          .fail(function (e, i, n, o) {
            t.displaySearchResults(e);
          }));
    },
    displaySearchResults: function (e) {
      var t = this.getResultsContent(e);
      this.searchResultsContainer.html(t),
        this.searchContainer.removeClass("is-searching");
      var i = $(".result__image", this.searchResultsContainer);
      "contain" == theme.settings.imageBackgroundSize &&
        (Collection.setBadgePosition(i),
        $(window).on(
          "resize.search",
          Reqs.debounce(Collection.setBadgePosition.bind(this, i), 50)
        ));
    },
    getResultsContent: function (e) {
      var t = "",
        i = "",
        n = "",
        o = "",
        s = 0,
        r = 0,
        a = 0,
        l = "",
        c = $(".nav-search-input").val(),
        d = $(".nav-search-options").val(),
        u = theme.settings.searchType;
      if (e.results)
        for (var p = 0; p < e.results.length; p++) {
          var h = e.results[p].title,
            f = e.results[p].url,
            g = slate.Currency.formatMoney(
              e.results[p].price,
              window.moneyFormat
            ),
            m = e.results[p].featured_image,
            v = e.results[p].image_aspectratio || 1,
            y = theme.icons.blank,
            b = e.results[p].object_type,
            k = !e.results[p].available,
            x = e.results[p].on_sale,
            C = "",
            w = "",
            S = " product-status-flag--" + theme.settings.productBadgeStyle,
            T = theme.settings.productBadgeStyle,
            _ = "result__item";
          "center" == theme.settings.productTitlePosition &&
            (_ += " result__item--center"),
            "product" == b
              ? ((x || k) &&
                  ((S += x ? " is-sale" : ""),
                  (S += k ? " is-sold-out" : ""),
                  (C = '<span class="product-status-flag' + S + '">'),
                  k
                    ? (w = theme.translations.sold_out)
                    : x
                    ? (w = theme.translations.on_sale)
                    : x && k && (w = theme.translations.sold_out),
                  "circle" == T && (w = w.replace(" ", "<br>")),
                  (C += w),
                  (C += "</span>")),
                s < 4 &&
                  (i +=
                    '<li class="' +
                    _ +
                    '"><div class="result__image" data-aspectratio="' +
                    v +
                    '"><a href="' +
                    f +
                    '"><img class="lazyload" alt="' +
                    h +
                    '"src="' +
                    y +
                    '"data-src="' +
                    m.replace("_1x1.", "_{width}x.") +
                    '"data-widths="[295,394,590,700,800,1000,1200,1500,1800,2000,2400]"data-aspectratio="' +
                    v +
                    '"data-sizes="auto" />' +
                    C +
                    '</a></div><h3 class="result__title"><a href="' +
                    f +
                    '">' +
                    h +
                    '</a></h3><p class="result__price">' +
                    g +
                    "</p></li>"),
                s++)
              : "page" == b
              ? (r < 10 &&
                  (n +=
                    '<li class="result__item"><h3 class="result__title"><a href="' +
                    f +
                    '">' +
                    h +
                    "</a></h3></li>"),
                r++)
              : "article" == b &&
                (a < 10 &&
                  (o +=
                    '<li class="result__item"><h3 class="result__title"><a href="' +
                    f +
                    '">' +
                    h +
                    "</a></h3></li>"),
                a++);
        }
      return (
        (i = s
          ? i
          : '<li class="result__item"><p class="result__title">' +
            theme.translations.no_results +
            "</p></li>"),
        (n = r
          ? n
          : '<li class="result__item"><p class="result__title">' +
            theme.translations.no_results +
            "</p></li>"),
        (o = a
          ? o
          : '<li class="result__item"><p class="result__title">' +
            theme.translations.no_results +
            "</p></li>"),
        (l = s
          ? '<a href="' +
            theme.routes.search_url +
            "?type=product&q=" +
            c +
            "&options[prefix]=" +
            d +
            '" class="view-all" title="' +
            theme.translations.view_all +
            '">' +
            theme.icons.arrowLong +
            "</a>"
          : ""),
        (t +=
          '<div class="results__column results__column--products"><div class="results__heading"><span>' +
          theme.translations.results_products +
          " (" +
          s +
          ")</span>" +
          l +
          '</div><ul class="results__list">' +
          i +
          "</ul></div>"),
        u.indexOf("page") > -1 &&
          (t +=
            '<div class="results__column results__column--pages"><div class="results__heading"><span>' +
            theme.translations.results_pages +
            " (" +
            r +
            ')</span></div><ul class="results__list">' +
            n +
            "</ul></div>"),
        u.indexOf("article") > -1 &&
          (t +=
            '<div class="results__column results__column--articles"><div class="results__heading"><span>' +
            theme.translations.results_articles +
            " (" +
            a +
            ')</span></div><ul class="results__list">' +
            o +
            "</ul></div>"),
        t
      );
    },
  },
  Password = {
    init: function () {
      $(".password-signup, .password-login").each(function () {
        var e = $(this);
        e.find("div.errors").length &&
          e.find("input.password, input.email").select();
      });
    },
  },
  Login = {
    init: function () {
      this.bind(),
        "#recover" == window.location.hash
          ? this.recover.show()
          : this.recover.hide();
    },
    bind: function () {
      $(".js-recoverToggle").on("click", Login.recover.show),
        $(".js-recoverCancel").on("click", Login.recover.hide);
    },
    recover: {
      show: function (e) {
        return (
          $(".js-loginForm").hide(),
          $(".js-recoverForm").show(),
          (window.location.hash = "#recover"),
          !1
        );
      },
      hide: function (e) {
        return (
          $(".js-loginForm").show(),
          $(".js-recoverForm").hide(),
          (window.location.hash = ""),
          !1
        );
      },
    },
  },
  Addresses = {
    init: function () {
      Shopify.CountryProvinceSelector &&
        new Shopify.CountryProvinceSelector(
          "AddressCountryNew",
          "AddressProvinceNew",
          { hideElement: "AddressProvinceContainerNew" }
        ),
        $(".address-country-option").each(function () {
          var e = $(this).data("form-id");
          new Shopify.CountryProvinceSelector(
            "AddressCountry_" + e,
            "AddressProvince_" + e,
            { hideElement: "AddressProvinceContainer_" + e }
          );
        }),
        (Shopify.CustomerAddress = {
          toggleForm: function (e) {
            var t = document.getElementById("EditAddress_" + e);
            return (
              (t.style.display = "none" == t.style.display ? "" : "none"), !1
            );
          },
          toggleNewForm: function () {
            var e = document.getElementById("AddAddress"),
              t = document.getElementById("js-addAddress");
            return (
              (e.style.display = "none" == e.style.display ? "" : "none"),
              (t.style.display =
                "inline-block" == t.style.display ? "none" : "inline-block"),
              !1
            );
          },
          destroy: function (e, t) {
            confirm(t || "Are you sure you wish to delete this address?") &&
              Shopify.postLink("/account/addresses/" + e, {
                parameters: { _method: "delete" },
              });
          },
        });
    },
  };
(slate.utils = {
  getParameterByName: function (e, t) {
    t || (t = window.location.href);
    var i = RegExp(
      "[?&]" + (e = e.replace(/[[\]]/g, "\\$&")) + "(=([^&#]*)|&|#|$)"
    ).exec(t);
    return i
      ? i[2]
        ? decodeURIComponent(i[2].replace(/\+/g, " "))
        : ""
      : null;
  },
  findInstance: function (e, t, i) {
    for (var n = 0; n < e.length; n++) if (e[n][t] === i) return e[n];
  },
  removeInstance: function (e, t, i) {
    for (var n = e.length; n--; )
      if (e[n][t] === i) {
        e.splice(n, 1);
        break;
      }
    return e;
  },
  compact: function (e) {
    for (var t = -1, i = null == e ? 0 : e.length, n = 0, o = []; ++t < i; ) {
      var s = e[t];
      s && (o[n++] = s);
    }
    return o;
  },
  defaultTo: function (e, t) {
    return null == e || e != e ? t : e;
  },
  keyboardKeys: {
    TAB: 9,
    ENTER: 13,
    ESCAPE: 27,
    LEFTARROW: 37,
    RIGHTARROW: 39,
  },
}),
  (slate.a11y = {
    pageLinkFocus: function (e) {
      var t = "js-focus-hidden";
      e.first()
        .attr("tabIndex", "-1")
        .focus()
        .addClass(t)
        .one("blur", function i() {
          e.first().removeClass(t).removeAttr("tabindex");
        });
    },
    focusHash: function () {
      var e = window.location.hash;
      e && document.getElementById(e.slice(1)) && this.pageLinkFocus($(e));
    },
    bindInPageLinks: function () {
      $("a[href*=#]").on(
        "click",
        function (e) {
          this.pageLinkFocus($(e.currentTarget.hash));
        }.bind(this)
      );
    },
    trapFocus: function (e) {
      var t = {
          focusin: e.namespace ? "focusin." + e.namespace : "focusin",
          focusout: e.namespace ? "focusout." + e.namespace : "focusout",
          keydown: e.namespace
            ? "keydown." + e.namespace
            : "keydown.handleFocus",
        },
        i = e.$container.find(
          $(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
          ).filter(":visible")
        ),
        n = i[0],
        o = i[i.length - 1];
      e.$elementToFocus || (e.$elementToFocus = e.$container),
        e.$container.attr("tabindex", "-1"),
        e.$elementToFocus.focus(),
        $(document).off("focusin"),
        $(document).on(t.focusout, function () {
          $(document).off(t.keydown);
        }),
        $(document).on(t.focusin, function (e) {
          (e.target === o || e.target === n) &&
            $(document).on(t.keydown, function (e) {
              var t;
              (t = e).keyCode === slate.utils.keyboardKeys.TAB &&
                (t.target !== o ||
                  t.shiftKey ||
                  (t.preventDefault(), n.focus()),
                t.target === n &&
                  t.shiftKey &&
                  (t.preventDefault(), o.focus()));
            });
        });
    },
    removeTrapFocus: function (e) {
      var t = e.namespace ? "focusin." + e.namespace : "focusin";
      e.$container &&
        e.$container.length &&
        e.$container.removeAttr("tabindex"),
        $(document).off(t);
    },
    accessibleLinks: function (e) {
      var t = document.querySelector("body"),
        i = {
          newWindow: "a11y-new-window-message",
          external: "a11y-external-message",
          newWindowExternal: "a11y-new-window-external-message",
        };
      (void 0 !== e.$links && e.$links.jquery) ||
        (e.$links = $("a[href]:not([aria-describedby])")),
        $.each(e.$links, function () {
          var e,
            t,
            n = $(this),
            o = n.attr("target"),
            s = n.attr("rel"),
            r = ((e = n), (t = window.location.hostname), e[0].hostname !== t),
            a = "_blank" === o;
          r && n.attr("aria-describedby", i.external),
            a &&
              ((void 0 === s || -1 === s.indexOf("noopener")) &&
                n.attr("rel", function (e, t) {
                  return (void 0 === t ? "" : t + " ") + "noopener";
                }),
              n.attr("aria-describedby", i.newWindow)),
            r && a && n.attr("aria-describedby", i.newWindowExternal);
        }),
        (function e(n) {
          "object" != typeof n && (n = {});
          var o = $.extend(
              {
                newWindow: "Opens in a new window.",
                external: "Opens external website.",
                newWindowExternal: "Opens external website in a new window.",
              },
              n
            ),
            s = document.createElement("ul"),
            r = "";
          for (var a in o) r += "<li id=" + i[a] + ">" + o[a] + "</li>";
          s.setAttribute("hidden", !0), (s.innerHTML = r), t.appendChild(s);
        })(e.messages);
    },
  }),
  (slate.Variants = (function () {
    function e(e) {
      (this.$container = e.$container),
        (this.product = e.product),
        (this.singleOptionSelector = e.singleOptionSelector),
        (this.originalSelectorId = e.originalSelectorId),
        (this.enableHistoryState = e.enableHistoryState),
        (this.currentVariant = this._getVariantFromOptions()),
        $(this.singleOptionSelector, this.$container).on(
          "change",
          this._onSelectChange.bind(this)
        );
    }
    return (
      (e.prototype = $.extend({}, e.prototype, {
        _getCurrentOptions: function () {
          var e = $.map(
            $(this.singleOptionSelector, this.$container),
            function (e) {
              var t = $(e),
                i = t.attr("type"),
                n = {};
              return "radio" !== i && "checkbox" !== i
                ? ((n.value = t.val()), (n.index = t.data("index")), n)
                : !!t[0].checked &&
                    ((n.value = t.val()), (n.index = t.data("index")), n);
            }
          );
          return slate.utils.compact(e);
        },
        _getVariantFromOptions: function () {
          var e = this._getCurrentOptions(),
            t = this.product.variants,
            i = !1;
          return (
            t.forEach(function (t) {
              var n = !0;
              e.forEach(function (e) {
                n && (n = e.value === t[e.index]);
              }),
                n && (i = t);
            }),
            i || null
          );
        },
        _onSelectChange: function () {
          var e = this._getVariantFromOptions();
          this.$container.trigger({ type: "variantChange", variant: e }),
            e &&
              (this._updateMasterSelect(e),
              this._updateImages(e),
              this._updatePrice(e),
              this._updateUnits(e),
              (this.currentVariant = e),
              this.enableHistoryState && this._updateHistoryState(e));
        },
        _updateImages: function (e) {
          var t = e.featured_image || {},
            i = this.currentVariant.featured_image || {};
          e.featured_image &&
            t.src !== i.src &&
            this.$container.trigger({ type: "variantImageChange", variant: e });
        },
        _updatePrice: function (e) {
          (e.price !== this.currentVariant.price ||
            e.compare_at_price !== this.currentVariant.compare_at_price) &&
            this.$container.trigger({ type: "variantPriceChange", variant: e });
        },
        _updateUnits: function (e) {
          this.$container.trigger({ type: "variantUnitChange", variant: e });
        },
        _updateHistoryState: function (e) {
          if (history.replaceState && e) {
            var t =
              window.location.protocol +
              "//" +
              window.location.host +
              window.location.pathname +
              "?variant=" +
              e.id;
            window.history.replaceState({ path: t }, "", t);
          }
        },
        _updateMasterSelect: function (e) {
          $(this.originalSelectorId, this.$container)[0].value = e.id;
        },
      })),
      e
    );
  })()),
  (slate.Currency = {
    formatMoney: function e(t, i) {
      "string" == typeof t && (t = t.replace(".", ""));
      var n = "",
        o = /\{\{\s*(\w+)\s*\}\}/,
        s = i || "${{amount}}";
      function r(e, t, i, n) {
        if (((i = i || ","), (n = n || "."), isNaN(e) || null === e)) return 0;
        var o,
          s = (e = (e / 100).toFixed(t)).split(".");
        return (
          s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) +
          (s[1] ? n + s[1] : "")
        );
      }
      switch (s.match(o)[1]) {
        case "amount":
          n = r(t, 2);
          break;
        case "amount_no_decimals":
          n = r(t, 0);
          break;
        case "amount_with_comma_separator":
          n = r(t, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          n = r(t, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          n = r(t, 0, " ");
          break;
        case "amount_with_apostrophe_separator":
          n = r(t, 2, "'");
      }
      return s.replace(o, n);
    },
  });
var Disclosure = (function () {
  var e = {
      disclosureList: "[data-disclosure-list]",
      disclosureToggle: "[data-disclosure-toggle]",
      disclosureInput: "[data-disclosure-input]",
      disclosureOptions: "[data-disclosure-option]",
    },
    t = { listVisible: "disclosure-list--visible" };
  function i(e) {
    (this.$container = e),
      (this.cache = {}),
      this._cacheSelectors(),
      this._connectOptions(),
      this._connectToggle(),
      this._onFocusOut();
  }
  return (
    (i.prototype = $.extend({}, i.prototype, {
      _cacheSelectors: function () {
        this.cache = {
          $disclosureList: this.$container.find(e.disclosureList),
          $disclosureToggle: this.$container.find(e.disclosureToggle),
          $disclosureInput: this.$container.find(e.disclosureInput),
          $disclosureOptions: this.$container.find(e.disclosureOptions),
        };
      },
      _connectToggle: function () {
        this.cache.$disclosureToggle.on(
          "click",
          function (e) {
            var i = "true" === $(e.currentTarget).attr("aria-expanded");
            $(e.currentTarget).attr("aria-expanded", !i),
              this.cache.$disclosureList.toggleClass(t.listVisible),
              e.preventDefault();
          }.bind(this)
        );
      },
      _connectOptions: function () {
        this.cache.$disclosureOptions.on(
          "click",
          function (e) {
            this._submitForm($(e.currentTarget).data("value")),
              e.preventDefault();
          }.bind(this)
        );
      },
      _onFocusOut: function () {
        this.cache.$disclosureToggle.on(
          "focusout",
          function (e) {
            0 === this.$container.has(e.relatedTarget).length &&
              this._hideList();
          }.bind(this)
        ),
          this.cache.$disclosureList.on(
            "focusout",
            function (e) {
              var i = $(e.currentTarget).has(e.relatedTarget).length > 0;
              this.cache.$disclosureList.hasClass(t.listVisible) &&
                !i &&
                this._hideList();
            }.bind(this)
          ),
          this.$container.on(
            "keyup",
            function (e) {
              e.which === slate.utils.keyboardKeys.ESCAPE &&
                (this._hideList(), this.cache.$disclosureToggle.focus());
            }.bind(this)
          ),
          (this.bodyOnClick = function (e) {
            var i = this.$container.has(e.target).length > 0;
            this.cache.$disclosureList.hasClass(t.listVisible) &&
              !i &&
              this._hideList();
          }.bind(this)),
          $("body").on("click", this.bodyOnClick);
      },
      _submitForm: function (e) {
        this.cache.$disclosureInput.val(e),
          this.$container.parents("form").submit();
      },
      _hideList: function () {
        this.cache.$disclosureList.removeClass(t.listVisible),
          this.cache.$disclosureToggle.attr("aria-expanded", !1);
      },
      unload: function () {
        $("body").off("click", this.bodyOnClick),
          this.cache.$disclosureOptions.off(),
          this.cache.$disclosureToggle.off(),
          this.cache.$disclosureList.off(),
          this.$container.off();
      },
    })),
    i
  );
})();
function tablesWrap() {
  $(".rte table").each(function () {
    $(this).wrap('<div class="rte__table-wrapper" />');
  });
}
function bgset(e, t) {
  var i = "";
  return -1 != e.indexOf("blank.gif")
    ? e
    : ((i +=
        e.replace("_1x1.", "_180x.") + " 180w " + Math.round(180 / t) + "h,"),
      (i +=
        e.replace("_1x1.", "_240x.") + " 240w " + Math.round(240 / t) + "h,"),
      (i +=
        e.replace("_1x1.", "_360x.") + " 360w " + Math.round(360 / t) + "h,"),
      (i +=
        e.replace("_1x1.", "_540x.") + " 540w " + Math.round(540 / t) + "h,"),
      (i +=
        e.replace("_1x1.", "_720x.") + " 720w " + Math.round(720 / t) + "h,"),
      (i +=
        e.replace("_1x1.", "_900x.") + " 900w " + Math.round(900 / t) + "h,"),
      (i +=
        e.replace("_1x1.", "_1080x.") +
        " 1080w " +
        Math.round(1080 / t) +
        "h,"),
      (i +=
        e.replace("_1x1.", "_1296x.") +
        " 1296w " +
        Math.round(1296 / t) +
        "h,"),
      (i +=
        e.replace("_1x1.", "_1512x.") +
        " 1512w " +
        Math.round(1512 / t) +
        "h,"),
      (i +=
        e.replace("_1x1.", "_1728x.") +
        " 1728w " +
        Math.round(1728 / t) +
        "h,"),
      (i +=
        e.replace("_1x1.", "_1950x.") +
        " 1950w " +
        Math.round(1950 / t) +
        "h,"),
      (i += e + " 2048w " + Math.round(2048 / t) + "h"));
}
function readHeights() {
  let e = {};
  return (
    (e.windowHeight = window.innerHeight),
    (e.announcementHeight = getHeight('[data-section-type*="announcement"]')),
    (e.footerHeight = getHeight('[data-section-type*="footer"]')),
    (e.headerHeight = getHeight("[data-header-height]")),
    (e.headerInitialHeight = getHeight(
      "[data-header-height]:not(.header--has-scrolled)"
    )),
    e
  );
}
function setVarsOnResize() {
  document.addEventListener("theme:resize", resizeVars), setVars();
}
function setVars() {
  let {
    windowHeight: e,
    announcementHeight: t,
    headerHeight: i,
    headerInitialHeight: n,
    footerHeight: o,
  } = readHeights();
  document.documentElement.style.setProperty("--header-height", `${i}px`),
    document.documentElement.style.setProperty(
      "--header-initial-height",
      `${n}px`
    ),
    document.documentElement.style.setProperty(
      "--announcement-height",
      `${t}px`
    ),
    document.documentElement.style.setProperty("--footer-height", `${o}px`),
    document.documentElement.style.setProperty("--content-full", `${e - i}px`),
    document.documentElement.style.setProperty(
      "--content-min",
      `${e - i - o}px`
    );
}
function resizeVars() {
  let {
    windowHeight: e,
    announcementHeight: t,
    headerHeight: i,
    footerHeight: n,
  } = readHeights();
  document.documentElement.style.setProperty("--header-height", `${i}px`),
    document.documentElement.style.setProperty(
      "--announcement-height",
      `${t}px`
    ),
    document.documentElement.style.setProperty("--footer-height", `${n}px`),
    document.documentElement.style.setProperty("--content-full", `${e - i}px`),
    document.documentElement.style.setProperty(
      "--content-min",
      `${e - i - n}px`
    );
}
function getHeight(e) {
  let t = document.querySelector(e);
  return t ? t.clientHeight : 0;
}
function dispatch() {
  document.dispatchEvent(new CustomEvent("theme:resize", { bubbles: !0 }));
}
function resizeListener() {
  window.addEventListener(
    "resize",
    Reqs.debounce(function () {
      dispatch();
    }, 50)
  );
}
(theme.StoreAvailability = (function () {
  var e = {
    body: "body",
    storeAvailabilityModal: "[data-store-availability-modal]",
    storeAvailabilityModalOpen: "[data-store-availability-modal-open]",
    storeAvailabilityModalProductTitle:
      "[data-store-availability-modal-product-title]",
  };
  function t(e) {
    this.container = e;
  }
  return (
    (t.prototype = Object.assign({}, t.prototype, {
      updateContent: function (e, t) {
        this._fetchStoreAvailabilities(e, t);
      },
      clearContent: function () {
        this.container.innerHTML = "";
      },
      _initModal: function () {
        return new theme.Modals(
          "StoreAvailabilityModal",
          "store-availability-modal",
          {
            close: ".js-modal-close-store-availability-modal",
            closeModalOnClick: !0,
            openClass: "store-availabilities-modal--active",
            scrollIntoView: !0,
          }
        );
      },
      _fetchStoreAvailabilities: function (t, i) {
        this.clearContent();
        var n = this;
        fetch("/variants/" + t + "/?section_id=store-availability")
          .then(function (e) {
            return e.text();
          })
          .then(function (t) {
            if ("" !== t.trim()) {
              var o = document.querySelector(e.body),
                s = o.querySelector(e.storeAvailabilityModal);
              if (
                (s && s.remove(),
                (n.container.innerHTML = t),
                (n.container.innerHTML =
                  n.container.firstElementChild.innerHTML),
                n.container.querySelector(e.storeAvailabilityModalOpen))
              ) {
                (n.modal = n._initModal()), n._updateProductTitle(i);
                var s = n.container.querySelector(e.storeAvailabilityModal);
                s && o.appendChild(s);
              }
            }
          });
      },
      _updateProductTitle: function (t) {
        this.container.querySelector(
          e.storeAvailabilityModalProductTitle
        ).textContent = t;
      },
    })),
    t
  );
})()),
  (theme.Modals = (function () {
    function e(e, t, i) {
      if (((this.modal = document.getElementById(e)), !this.modal)) return !1;
      (this.nodes = {
        parents: [document.querySelector("html"), document.body],
      }),
        (this.config = Object.assign(
          {
            close: ".js-modal-close",
            open: ".js-modal-open-" + t,
            openClass: "modal--is-active",
            openBodyClass: "modal--is-visible",
            closeModalOnClick: !1,
            scrollIntoView: !1,
          },
          i
        )),
        (this.modalIsOpen = !1),
        (this.focusOnOpen = this.config.focusOnOpen
          ? document.getElementById(this.config.focusOnOpen)
          : this.modal),
        (this.openElement = document.querySelector(this.config.open)),
        this.init();
    }
    return (
      (e.prototype.init = function () {
        this.openElement.addEventListener("click", this.open.bind(this)),
          this.modal
            .querySelector(this.config.close)
            .addEventListener("click", this.closeModal.bind(this));
      }),
      (e.prototype.open = function (e) {
        var t = this,
          i = !1;
        if (!this.modalIsOpen) {
          e ? e.preventDefault() : (i = !0),
            e && e.stopPropagation && e.stopPropagation(),
            this.modalIsOpen && !i && this.closeModal(),
            this.modal.classList.add(this.config.openClass),
            this.nodes.parents.forEach(function (e) {
              e.classList.add(t.config.openBodyClass);
            }),
            (this.modalIsOpen = !0);
          var n = document.querySelector(".store-availabilities-list");
          scrollLock.disablePageScroll(n),
            slate.a11y.trapFocus({
              $container: $(this.modal),
              $elementToFocus: $(this.focusOnOpen),
            }),
            this.config.scrollIntoView && this.scrollIntoView(),
            this.bindEvents();
        }
      }),
      (e.prototype.closeModal = function () {
        if (this.modalIsOpen) {
          document.activeElement.blur(),
            this.modal.classList.remove(this.config.openClass);
          var e = this,
            t = document.querySelector(".store-availabilities-list");
          scrollLock.enablePageScroll(t),
            this.nodes.parents.forEach(function (t) {
              t.classList.remove(e.config.openBodyClass);
            }),
            (this.modalIsOpen = !1),
            slate.a11y.removeTrapFocus({ $container: $(this.modal) }),
            this.openElement.focus(),
            this.unbindEvents();
        }
      }),
      (e.prototype.bindEvents = function () {
        (this.keyupHandler = this.keyupHandler.bind(this)),
          (this.clickHandler = this.clickHandler.bind(this)),
          document.body.addEventListener("keyup", this.keyupHandler),
          document.body.addEventListener("click", this.clickHandler);
      }),
      (e.prototype.unbindEvents = function () {
        document.body.removeEventListener("keyup", this.keyupHandler),
          document.body.removeEventListener("click", this.clickHandler);
      }),
      (e.prototype.keyupHandler = function (e) {
        27 === e.keyCode && this.closeModal();
      }),
      (e.prototype.clickHandler = function (e) {
        this.config.closeModalOnClick &&
          !this.modal.contains(e.target) &&
          this.closeModal();
      }),
      (e.prototype.scrollIntoView = function () {
        this.focusOnOpen.scrollIntoView({ behavior: "smooth" });
      }),
      e
    );
  })()),
  (theme.Helpers = {
    cookiesEnabled: function e() {
      var t = navigator.cookieEnabled;
      return (
        t ||
          ((document.cookie = "testcookie"),
          (t = -1 !== document.cookie.indexOf("testcookie"))),
        t
      );
    },
    setCookie: function e(t, i, n) {
      var o = "";
      if (n) {
        var s = new Date();
        s.setTime(s.getTime() + 864e5 * n),
          (o = "; expires=" + s.toUTCString());
      }
      document.cookie = t + "=" + (i || "") + o + "; path=/";
    },
    getCookie: function e(t) {
      var i = document.cookie.split("; ").find(function (e) {
        return e.startsWith(t);
      });
      return i ? i.split("=")[1] : null;
    },
  }),
  window.addEventListener("load", () => {
    setVarsOnResize();
  }),
  resizeListener();
